webpackJsonp([9],{

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_RUNTIME_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_LOCALE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_LOCALE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_LOCALE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RUNTIME_MOBILE_SIDEBAR_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RUNTIME_LOADING_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RUNTIME_MODAL; });
/* eslint-disable import/prefer-default-export */

// action types
var SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
var SET_LOCALE_START = 'SET_LOCALE_START';
var SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
var SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';

// runtime variables
var RUNTIME_MOBILE_SIDEBAR_VISIBLE = 'RUNTIME_MOBILE_SIDEBAR_VISIBLE';
var RUNTIME_LOADING_DATA = 'RUNTIME_LOADING_DATA';
var RUNTIME_MODAL = 'RUNTIME_MODAL';

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCombinations */
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeDiacriticsAndCase;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
function getCombinations(optionsArray) {
  var result = [];
  var f = function f(prefix, options) {
    for (var i = 0; i < options.length; i += 1) {
      result.push([].concat(_toConsumableArray(prefix), [options[i]]));
      f([].concat(_toConsumableArray(prefix), [options[i]]), options.slice(i + 1));
    }
  };
  f([], optionsArray);
  return result;
}

function normalizeDiacriticsAndCase(str) {
  return typeof str === 'string' ? str.normalize('NFD').replace(/’/g, "'").replace(/[\u0300-\u036f]/g, '').toUpperCase() : null;
}

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (group, siteId) {
  return [{
    iconClass: 'left-nav-icons left-nav-icons--skp',
    title: 'MYSKP',
    to: null,
    links: [{
      iconClass: '',
      title: 'Home',
      to: ['home'],
      links: false
    },
    // {
    //   iconClass: '',
    //   title: 'Clubskp',
    //   to: ['rewards'],
    //   links: false,
    // },
    // {
    //   iconClass: '',
    //   title: 'How it Works',
    //   to: ['about'],
    //   links: false,
    // },
    // {
    //   iconClass: '',
    //   title: 'News',
    //   to: ['news'],
    //   links: false,
    // },
    // {
    //   iconClass: '',
    //   title: 'Education',
    //   to: ['education'],
    //   links: false,
    // },
    {
      iconClass: '',
      title: 'Products',
      target: '_blank',
      to: siteId === 'ca' ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html' : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
      links: false
    }]
  }];
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes_client__ = __webpack_require__(908);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_universal_router___default.a(__WEBPACK_IMPORTED_MODULE_1__routes_client__["a" /* default */], {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load(context, params).then(function (action) {
        return action.default(context, params);
      });
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return null;
  }
}));

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultLocale; });
/* unused harmony export sanitizeHtmlOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return modules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return groupOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return states; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return etl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sites; });
/* unused harmony export port */
/* unused harmony export host */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return googleAPIKey; });
/* unused harmony export meQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_big_calendar__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_money__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_etl_sales_salesPayloadTransform__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_etl_sales_salesColumnsConfig__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_etl_products_productsPayloadTransform__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configs_etl_masterproducts_masterProductsPayloadTransform__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configs_etl_products_productsColumnsConfig__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__configs_etl_reps_repsColumnsConfig__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__configs_etl_reps_repsPayloadTransform__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configs_etl_salons_salonsColumnsConfig__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_etl_salons_salonsPayloadTransform__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configs_etl_masterproducts_masterProductsColumnsConfig__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__configs_etl_kpis_kpisColumnsConfig__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_groups__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__configs_allowedTags__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__configs_statesByCountry__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__configs_sites__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__configs_sidebar_cmdctrl__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__configs_sidebar_beautyerp__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__configs_sidebar_clubskp__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__configs_sidebar_clubskpLoggedIn__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__configs_sidebar_clubskpLoggedInSalon__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__configs_sidebar_etl__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__configs_sidebar_filevault__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__configs_sidebar_messenger__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__configs_sidebar_advisornet__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__configs_sidebar_salondb__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__core_utils__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */








// import productsBrandTransform from './configs/etl/products/productsBrandTransform';

















// import mytrackerSidebar from "./configs/sidebar/mytracker";
// import poeSidebar from "./configs/sidebar/poe";











__WEBPACK_IMPORTED_MODULE_2_js_money___default.a.addCurrencies({
  POINTS: {
    symbol: 'Points',
    label: 'Point',
    symbol_native: 'P',
    decimal_digits: 0,
    rounding: 0,
    code: 'POINTS',
    name_plural: 'Points'
  }
});

/* eslint-disable max-len */

// export const routerOptions = {
//   baseUrl: '',
// };

var defaultLocale = 'en-CA';

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
Object(__WEBPACK_IMPORTED_MODULE_1_react_big_calendar__["a" /* momentLocalizer */])(__WEBPACK_IMPORTED_MODULE_0_moment___default.a); // or globalizeLocalizer

var sanitizeHtmlOptions = __WEBPACK_IMPORTED_MODULE_15__configs_allowedTags__["a" /* default */];

var modules = [{
  label: 'LOYALTY',
  value: 'loyalty',
  route: 'control-index'
}, { label: 'CMDCTRL', value: 'cmdctrl', route: 'control-index' }, { label: 'ETL', value: 'etl', route: 'etl' }, { label: 'FILEVAULT', value: 'filevault', route: 'filevault-index' }, { label: 'POE', value: 'poe', route: 'poe-index' }, {
  label: 'PRINTCENTER',
  value: 'printcenter',
  route: 'redirect',
  routeParams: { scope: 'printcenter' }
  // query:
  //   '?filters%5B0%5D%5Bkey%5D=data.category&filters%5B0%5D%5Boperator%5D=strIs&filters%5B0%5D%5Bvalue%5D=Print%20Center%20-%20Customizable',
}, {
  label: 'ADVISRONET',
  value: 'advisornet',
  route: function route(userData) {
    var groupOptions = ((userData || {}).group || {}).options || [];
    return groupOptions.includes('user.advisornet.education') || groupOptions.includes('user.manager.advisornet') ? 'advisornet-calendar' : 'advisornet-index';
  }
}, { label: 'MYTRACKER', value: 'mytracker', route: 'mytracker-index' }, { label: 'MESSENGER', value: 'messenger', route: 'messenger-index' }, { label: 'SALONDB', value: 'salondb', route: 'salondb-index' }];

var groupOptions = __WEBPACK_IMPORTED_MODULE_14__configs_groups__["a" /* default */];

var states = __WEBPACK_IMPORTED_MODULE_16__configs_statesByCountry__["a" /* default */];

var isStagingOrDev = false;
if (true) {
  var hostname = (window.location || {}).hostname || '';
  isStagingOrDev = !!(hostname.includes('dev') || hostname.includes('localhost'));
} else {
  var mongoUri = (process.env || {}).MONGO_URI || '';
  isStagingOrDev = !!mongoUri.includes('dev');
}

// https://basecamp.com/2211488/projects/11325432/todos/248761859?enlarge=227206611#attachment_227206611
var etl = {
  isStagingOrDev: isStagingOrDev,
  fileContentTypes: ['text/comma-separated-values', 'text/csv', 'application/csv', 'application/excel', 'application/vnd.ms-excel', 'application/vnd.msexcel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.google-apps.spreadsheet', 'application/octet-stream'],
  importTypes: {
    masterproducts: {
      label: 'Master Products',
      etlSteps: [{
        step: 'objectTransform',
        payload: {
          transform: function transform(obj, ctx) {
            //eslint-disable-line
            var newObject = _extends({}, obj);
            if (!newObject.$set) {
              newObject.$set = {};
            }
            newObject.$set.dm = new Date();

            if (newObject.$set.n) {
              newObject.$set.n_text = Object(__WEBPACK_IMPORTED_MODULE_28__core_utils__["a" /* normalizeDiacriticsAndCase */])(newObject.$set.n);
            }

            if (!newObject.$setOnInsert) {
              newObject.$setOnInsert = {};
            }
            newObject.$setOnInsert.e = true;
            newObject.$setOnInsert.dc = new Date();

            // __tmp is used to store temporary data we may need
            delete newObject.__tmp; //eslint-disable-line
            // console.dir(newObject, { depth: 999, color: true });
            return newObject;
          }
        }
      }, {
        step: 'collect',
        payload: {
          count: 1000
        }
      }, {
        step: 'payloadTransform',
        payload: __WEBPACK_IMPORTED_MODULE_6__configs_etl_masterproducts_masterProductsPayloadTransform__["a" /* default */]
      },
      // {
      //   step: 'inspect',
      // },
      {
        step: 'mongoBulkUpdate',
        payload: {
          mapperName: 'masterProduct',
          updateKeys: ['$set.idh'],
          upsert: true
        }
      }],
      cols: __WEBPACK_IMPORTED_MODULE_12__configs_etl_masterproducts_masterProductsColumnsConfig__["a" /* default */]
    },
    // kpis: {
    //   label: 'KPIs',
    //   etlSteps: [
    //     {
    //       step: 'objectTransform',
    //       payload: {
    //         transform: (obj, ctx) => {
    //                  //eslint-disable-line
    //           const newObject = { ...obj };
    //           if (!newObject.$set) {
    //             newObject.$set = {};
    //           }
    //           newObject.$set.dm = new Date();

    //           if (!newObject.$setOnInsert) {
    //             newObject.$setOnInsert = {};
    //           }
    //           newObject.$setOnInsert.e = true;
    //           newObject.$setOnInsert.dc = new Date();

    //           // __tmp is used to store temporary data we may need
    //                  delete newObject.__tmp; //eslint-disable-line
    //           // console.dir(newObject, { depth: 999, color: true });
    //           return newObject;
    //         },
    //       },
    //     },
    //     {
    //       step: 'collect',
    //       payload: {
    //         count: 1000,
    //       },
    //     },
    //     {
    //       step: 'mongoBulkUpdate',
    //       payload: {
    //         mapperName: 'kpi',
    //         updateKeys: [
    //           '$set.targetYear',
    //           '$set.distributor',
    //           '$set.recordType',
    //           '$set.recordValue',
    //         ],
    //         upsert: true,
    //       },
    //     },
    //   ],
    //   cols: kpisColumnsConfig,
    // },
    products: {
      label: 'Products Import',
      etlSteps: [{
        step: 'collect',
        payload: {
          count: 1000
        }
      }, {
        step: 'payloadTransform',
        payload: __WEBPACK_IMPORTED_MODULE_5__configs_etl_products_productsPayloadTransform__["a" /* default */]
      },
      // {
      //   step: 'payloadTransform',
      //   payload: productsBrandTransform,
      // },
      // add brand columns
      {
        step: 'mongoBulkUpdate',
        payload: {
          mapperName: 'distributorProduct',
          updateKeys: ['$set.distributor', '$set.ext_id'],
          upsert: true
        }
      }],
      cols: __WEBPACK_IMPORTED_MODULE_7__configs_etl_products_productsColumnsConfig__["a" /* default */]
    },
    reps: {
      label: 'Reps Import',
      etlSteps: [{
        step: 'payloadTransform',
        payload: __WEBPACK_IMPORTED_MODULE_9__configs_etl_reps_repsPayloadTransform__["a" /* default */]
      },
      // {
      //   step: 'objectTransform',
      //   payload: {
      //     transform: (obj, { Types, siteId }) => {
      //       const newObject = { ...obj };
      //       if (!newObject.$set) {
      //         newObject.$set = {};
      //       }
      //       newObject.$set.distributor = Types.ObjectId(newObject.__tmp.dist_id);   //eslint-disable-line
      //       newObject.$set.dm = new Date();
      //
      //       const nameChunks = newObject.__tmp.n.split(/\s+/);
      //       const nameArray = [nameChunks.shift(), nameChunks.join(' ')];
      //       newObject.$set.firstname = nameArray[0];
      //       newObject.$set.lastname = nameArray[1];
      //       newObject.$set.group = Types.ObjectId(
      //         siteConfigs[siteId].dscGroup,
      //       );
      //       newObject.$set.email = newObject.__tmp.email;
      //       newObject.$set.username = newObject.__tmp.email;
      //
      //       if (!newObject.$setOnInsert) {
      //         newObject.$setOnInsert = {};
      //       }
      //       newObject.$setOnInsert.e = true;
      //       newObject.$setOnInsert.dc = new Date();
      //
      //       // __tmp is used to store temporary data we may need
      //       delete newObject.__tmp;  //eslint-disable-line
      //       // console.dir(newObject, { depth: 999, color: true });
      //       return newObject;
      //     },
      //   },
      // },
      {
        step: 'collect',
        payload: {
          count: 1000
        }
      }, {
        step: 'mongoBulkUpdate',
        payload: {
          mapperName: 'user',
          updateKeys: ['$set.email'], // potential issue here since we have 2 unique ID's - email
          upsert: true
        }
      }],
      cols: __WEBPACK_IMPORTED_MODULE_8__configs_etl_reps_repsColumnsConfig__["a" /* default */]
    },
    salons: {
      label: 'Salons Import',
      etlSteps: [{
        step: 'collect',
        payload: {
          count: 100
        }
      }, {
        step: 'payloadTransform',
        payload: __WEBPACK_IMPORTED_MODULE_11__configs_etl_salons_salonsPayloadTransform__["a" /* default */]
      }, {
        step: 'mongoBulkUpdate',
        payload: {
          mapperName: 'salon',
          updateKeys: ['$noop.ref.distributor', '$noop.ref.ext_id'],
          upsert: true
        }
      }],
      cols: __WEBPACK_IMPORTED_MODULE_10__configs_etl_salons_salonsColumnsConfig__["a" /* default */]
    },
    sales: {
      label: 'Sales Import',
      etlSteps: [{
        step: 'collect',
        payload: {
          count: 1000
        }
      }, {
        step: 'payloadTransform',
        payload: __WEBPACK_IMPORTED_MODULE_3__configs_etl_sales_salesPayloadTransform__["a" /* default */]
      }, {
        step: 'mongoBulkUpdate',
        payload: {
          mapperName: 'distributorSale',
          updateKeys: ['$set.distributor', '$set.ext_salon_id', '$set.date', '$set.ext_id', '$set.ext_prod_id'],
          upsert: true
        }
      }],
      cols: __WEBPACK_IMPORTED_MODULE_4__configs_etl_sales_salesColumnsConfig__["a" /* default */]
    }
  }
};

var colors = ['#d00f18', '#303030', '#888888', '#b6b6b6', '#c8c8c8', '#f8c5cb', '#f3a3ac'];

// autoredirection based upon languages parameter below.
// will not try to negotiate site if languages parameter not set
// suffix determines db name suffix
var sites = __WEBPACK_IMPORTED_MODULE_17__configs_sites__["a" /* default */];

var port = process.env.PORT || 3000;
var host = process.env.WEBSITE_HOSTNAME || 'localhost:' + port;
//
// export const analytics = {
//   google: {
//     trackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
//   },
// };

var googleAPIKey = 'AIzaSyB15RD6TNCoUWbTg6qcICkJcrZguLx77X0';

var meQuery = '{\n  me {\n    session {\n      localeId siteId\n    }\n    pointsBalance\n    user {\n      _id email username firstname lastname states salon {\n        _id n\n      } group {\n        _id n options modules\n      } timezone avatar\n      { media\n        { _id }\n      }\n      data {\n        dailyrate prepdailyrate hourlyrate\n      }\n    }\n    cart {\n      _id items {\n        _id qty product {\n          ... on Reward { _id n type }\n        }\n      }\n    }\n    wishlist {\n      _id items {\n        _id product {\n          ... on Reward { _id n type }\n        }\n      }\n    }\n    unreadMessages {\n      page pages total docs {\n        _id subject message dc\n        from {\n          user {\n            firstname lastname avatar { media { _id }}\n          }\n        }\n      }\n    }\n  }\n}';

var sidebar = {
  loyalty: _extends({}, __WEBPACK_IMPORTED_MODULE_19__configs_sidebar_beautyerp__["a" /* default */], { to: ['loyalty-index'] }),
  // clubskpLoggedIn: clubskpLoggedInSidebar,
  // clubskpLoggedInSalon: clubskpLoggedInSalonSidebar,
  // messenger: messengerSidebar,
  // advisornet: advisornetSidebar,
  // new
  cmdctrl: __WEBPACK_IMPORTED_MODULE_18__configs_sidebar_cmdctrl__["a" /* default */],
  etl: _extends({}, __WEBPACK_IMPORTED_MODULE_19__configs_sidebar_beautyerp__["a" /* default */], { to: ['etl-index'] }),
  filevault: _extends({}, __WEBPACK_IMPORTED_MODULE_19__configs_sidebar_beautyerp__["a" /* default */], { to: ['filevault-index'] }),
  // poe: { ...beautyerpSidebar, to: ['poe-index'] },
  salondb: _extends({}, __WEBPACK_IMPORTED_MODULE_19__configs_sidebar_beautyerp__["a" /* default */], { to: ['salondb-index'] }),
  mytracker: _extends({}, __WEBPACK_IMPORTED_MODULE_19__configs_sidebar_beautyerp__["a" /* default */], { to: ['mytracker-index'] })
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(220);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */



// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])());

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GraphQLService = function () {
  function GraphQLService() {
    _classCallCheck(this, GraphQLService);
  }

  _createClass(GraphQLService, [{
    key: 'buildServiceTree',
    value: function buildServiceTree(schema) {
      return {
        queries: this._buildServiceTree(schema._queryType._fields, ''),
        mutations: {}
      };
    }
  }, {
    key: '_buildServiceTree',
    value: function _buildServiceTree(fields, fullParentPath) {
      var output = [];
      for (var fieldKey in fields) {
        if (fields.hasOwnProperty(fieldKey)) {
          var node = {};
          node.name = fields[fieldKey].type.name;
          node.path = fieldKey;
          node.fullPath = fullParentPath != '' ? fullParentPath + '.' + fieldKey : fieldKey;
          if (fields[fieldKey].hasOwnProperty('type') && fields[fieldKey].type.hasOwnProperty('_fields')) {
            node.fields = this._buildServiceTree(fields[fieldKey].type._fields, node.fullPath);
          }
          output.push(node);
        }
      }
      return output;
    }
  }, {
    key: 'escapeInputArg',
    value: function escapeInputArg(arg) {
      var _this = this;

      // open object/array
      var outputStr = '';

      if (arg == null) {
        outputStr += 'null';
      } else if (arg instanceof Date) {
        outputStr += arg.getTime();
      } else if (Array.isArray(arg)) {
        outputStr += '[';
        arg.map(function (arrayItem, ii) {
          outputStr += _this.escapeInputArg(arrayItem);
          outputStr += ii != arg.length - 1 ? ',' : '';
        });
        outputStr += ']';
      } else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
        outputStr += '{';
        Object.keys(arg).map(function (property, ii) {
          outputStr += ' ' + property + ': ';
          outputStr += _this.escapeInputArg(arg[property]);
          outputStr += ii != Object.keys(arg).length - 1 ? ',' : '';
        });
        outputStr += '}';
      } else {
        outputStr += JSON.stringify(arg);
      }

      return outputStr;
    }
  }, {
    key: 'buildQueryKeys',
    value: function buildQueryKeys(obj) {
      // console.log('obj', obj);
      var keys = '';
      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          // TODO:  fix this - not all arrays should be treate
          if (obj[property] && Array.isArray(obj[property])) {
            keys += ' ' + property;
          } else if (obj[property] && _typeof(obj[property]) === 'object' && !(obj[property] instanceof Date)) {
            var objKey = ' { ' + this.buildQueryKeys(obj[property]) + ' } ';
            objKey = objKey == ' {  } ' ? '' : objKey;
            keys += ' ' + property + objKey;
          } else {
            keys += ' ' + property;
          }
        }
      }
      return keys;
    }

    // createGQLQuery(obj){
    //   return Object.keys(obj).map((k) => {
    //     let query = `${k}`;
    //     let element = obj[k];
    //     if (element) {
    //       if (element.aliasFor) {
    //         query = `${k}:${element.aliasFor}`;
    //       }
    //       if (element.fragment) {
    //         query = `fragment ${k} on ${element.fragment}`;
    //       }
    //       if (element.args) {
    //         let args = Object.keys(element.args).map((argKey) => {
    //           let argVar = "", processed = false;
    //
    //           if(element.processArgs)
    //           {
    //             if(element.processArgs[argKey]) {
    //               argVar = element.processArgs[argKey](element.args[argKey]);
    //               processed = true;
    //             }
    //           }
    //           if (!processed) {
    //             if (typeof element.args[argKey] === "object") {
    //               argVar = JSON.stringify(element.args[argKey]).replace(/\"([^(\")"]+)\":/g,"$1:");
    //             } else {
    //               argVar = `"${element.args[argKey]}"`;
    //             }
    //           }
    //           return `${argKey}:${argVar}`;
    //         }).join();
    //         query = `${query}(${args})`;
    //       }
    //       if (element.fields) {
    //         let fields = createGQLQuery(element.fields);
    //         query = `${query}{${fields}}`;
    //       }
    //     }
    //     return query;
    //   }).join();
    // }

  }]);

  return GraphQLService;
}();

/* harmony default export */ __webpack_exports__["a"] = (GraphQLService);

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPageViewEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTrackingEvent;
function getPageViewEvent(_ref) {
  var siteId = _ref.siteId,
      data = _ref.data;

  return {
    type: 'PAGE_VIEW',
    data: data,
    siteId: siteId
  };
}

function getTrackingEvent(_ref2) {
  var type = _ref2.type,
      siteId = _ref2.siteId,
      data = _ref2.data;

  return {
    type: type,
    data: data,
    siteId: siteId
  };
}
//
// export function getSignInEvent() {
//   return {
//     type: 'SIGN_IN',
//     data: {},
//   };
// }
//
// export function getSignOutEvent() {
//   return {
//     type: 'SIGN_OUT',
//     data: {},
//   };
// }
//
// export function getAccountCreatedEvent() {
//   return {
//     type: 'ACCOUNT_CREATED',
//     data: {},
//   };
// }
//
// export function getAddCartEvent(url) {
//   return {
//     type: 'ADD_CART',
//     data: {
//       url,
//     },
//   };
// }

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(431);
module.exports = __webpack_require__(633);


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var readyStates = new Set(['complete', 'loaded', 'interactive']);

function loadMainClient() {
  var main = __webpack_require__(634).default; // eslint-disable-line global-require
  main();
}

function run() {
  // Run the application when both DOM is ready and page content is loaded
  if (readyStates.has(document.readyState) && document.body) {
    loadMainClient();
  } else {
    document.addEventListener('DOMContentLoaded', loadMainClient, false);
  }
}

if (!global.Intl) {
  // You can show loading banner here

  __webpack_require__.e/* require.ensure */(7).then((function (require) {
    // and require them here
    __webpack_require__(427);
    // TODO: This is bad. You should only require one language dynamically
    /* @intl-code-template require('intl/locale-data/jsonp/${lang}.js'); */
    __webpack_require__(428);
    __webpack_require__(429);
    /* @intl-code-template-end */
    run();
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
} else {
  run();
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__(635);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(3);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(97);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(640);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(405);
var qs_lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);

// EXTERNAL MODULE: ./node_modules/history/esm/history.js + 4 modules
var esm_history = __webpack_require__(220);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js + 1 modules
var index_es = __webpack_require__(44);

// EXTERNAL MODULE: ./node_modules/react-tracker/build/index.js
var build = __webpack_require__(413);
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// EXTERNAL MODULE: ./node_modules/react-intl/locale-data/en.js
var en = __webpack_require__(662);
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./node_modules/react-intl/locale-data/fr.js
var fr = __webpack_require__(663);
var fr_default = /*#__PURE__*/__webpack_require__.n(fr);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(64);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(407);

// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var _apollo_client = __webpack_require__(122);

// CONCATENATED MODULE: ./src/core/createApolloClient/createApolloClient.client.js
// import ApolloClient, { createNetworkInterface } from 'apollo-client';

// const client = new ApolloClient({
//   networkInterface: createNetworkInterface({
//     uri: '/graphql',
//     opts: {
//       // Additional fetch options like `credentials` or `headers`
//       credentials: 'include',
//     },
//   }),
//   queryDeduplication: true,
//   reduxRootSelector: state => state.apollo,
// });



var clients = {};

function createApolloClient(options) {
  var siteId = (options || {}).siteId || '';
  if (clients[siteId] != null) {
    return clients[siteId];
  }
  var client = new _apollo_client["ApolloClient"]({
    link: new _apollo_client["HttpLink"]({
      uri: '/' + siteId + '/graphql',
      credentials: 'include'
    }),
    cache: new _apollo_client["InMemoryCache"]()
  });
  clients[siteId] = client;
  return clients[siteId];
}
// CONCATENATED MODULE: ./src/components/App.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */








var ContextType = _extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired,
  // Universal HTTP client
  fetch: prop_types_default.a.func.isRequired
}, es["a" /* Provider */].childContextTypes, {
  // Apollo Client
  client: prop_types_default.a.object.isRequired,
  // ReactIntl
  intl: index_es["c" /* IntlProvider */].childContextTypes.intl,
  socket: prop_types_default.a.oneOfType([prop_types_default.a.bool, prop_types_default.a.object]),
  url: prop_types_default.a.object.isRequired,
  routeParams: prop_types_default.a.object.isRequired,
  path: prop_types_default.a.string.isRequired,
  query: prop_types_default.a.object.isRequired,
  trackEvent: prop_types_default.a.func.isRequired
});

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App_App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }

    // NOTE: This methods are not needed if you update URL by setLocale action.
    //
    //  componentDidMount() {
    //    const store = this.props.context && this.props.context.store;
    //    if (store) {
    //      this.lastLocale = store.getState().intl.locale;
    //      this.unsubscribe = store.subscribe(() => {
    //        const state = store.getState();
    //        const { newLocale, locale } = state.intl;
    //        if (!newLocale && this.lastLocale !== locale) {
    //          this.lastLocale = locale;
    //          this.forceUpdate();
    //        }
    //      });
    //    }
    //  }
    //
    //  componentWillUnmount() {
    //    if (this.unsubscribe) {
    //      this.unsubscribe();
    //      this.unsubscribe = null;
    //    }
    //  }

  }, {
    key: 'render',
    value: function render() {
      return this.props.context.routeParams.siteId ? _jsx(_apollo_client["ApolloProvider"], {
        client: createApolloClient({
          siteId: this.props.context.routeParams.siteId
        })
      }, void 0, this.props.children) : this.props.children;
    }
  }]);

  return App;
}(react_default.a.PureComponent);

App_App.childContextTypes = ContextType;


/* harmony default export */ var components_App = (App_App);
// CONCATENATED MODULE: ./src/createFetch.js
var createFetch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie,
      authorization = _ref.authorization;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'POST', // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: createFetch__extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, cookie ? { Cookie: cookie } : null, authorization ? { Authorization: authorization } : null)
  };

  return function (url, options) {
    return url.endsWith('/graphql') || url.startsWith('/api') ? fetch('' + baseUrl + url, createFetch__extends({}, defaults, options, {
      headers: createFetch__extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };
}

/* harmony default export */ var src_createFetch = (createFetch);
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__(152);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(904);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(120);

// CONCATENATED MODULE: ./src/reducers/runtime.js
var runtime__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case constants["g" /* SET_RUNTIME_VARIABLE */]:
      return runtime__extends({}, state, _defineProperty({}, action.payload.name, action.payload.value));
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/intl.js
var intl__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function intl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function intl_intl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  if (state === null) {
    return {
      initialNow: Date.now()
    };
  }

  switch (action.type) {
    case constants["e" /* SET_LOCALE_START */]:
      {
        var locale = state[action.payload.locale] ? action.payload.locale : state.locale;
        return intl__extends({}, state, {
          locale: locale,
          newLocale: action.payload.locale
        });
      }

    case constants["f" /* SET_LOCALE_SUCCESS */]:
      {
        return intl__extends({}, state, {
          locale: action.payload.locale,
          newLocale: null,
          messages: intl__extends({}, state.messages, intl__defineProperty({}, action.payload.locale, action.payload.messages))
        });
      }

    case constants["d" /* SET_LOCALE_ERROR */]:
      {
        return intl__extends({}, state, {
          newLocale: null
        });
      }

    default:
      {
        return state;
      }
  }
}
// CONCATENATED MODULE: ./src/reducers/session.js
var session__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function session() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'SET_MOBILE_SIDEBAR_VISIBILITY':
      throw new Error('Deprecated');
    case 'SET_GLOBAL_LOADING_INDICATOR':
      throw new Error('Deprecated');
    case 'GET_USER_DATA':
      // return state.set('USER_DATA', action.value);
      return session__extends({}, state, {
        USER_DATA: action.value
      });
    case 'SET_LOCALE':
      // return state.set('LOCALE', action.value);
      return session__extends({}, state, {
        LOCALE: action.value
      });
    case 'SET_CART':
      return session__extends({}, state, {
        CART: action.value
      });
    case 'SET_WISHLIST':
      return session__extends({}, state, {
        WISHLIST: action.value
      });
    case 'SET_ME_DATA':
      return session__extends({}, state, {
        POINTS_BALANCE: action.value.pointsBalance,
        USER_DATA: action.value.user,
        LOCALE: action.value.session.localeId,
        SITEID: action.value.session.siteId,
        UNREADMESSAGES: action.value.unreadMessages,
        APPS: action.value.apps,
        CART: action.value.cart && action.value.cart.items ? action.value.cart.items : [],
        WISHLIST: action.value.wishlist && action.value.wishlist.items ? action.value.wishlist.items : []
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/user.js
function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/index.js






function createRootReducer(_ref) {
  var apolloClient = _ref.apolloClient;

  return Object(redux_es["c" /* combineReducers */])({
    // apollo: apolloClient.reducer(),
    user: user,
    runtime: runtime,
    intl: intl_intl,
    session: session
  });
}
// CONCATENATED MODULE: ./src/store/createHelpers.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var graphqlRequestDeprecatedMessage = '`graphqlRequest` has been deprecated.\nYou should use Apollo: `client.query({ query, variables...})` or `client.mutate()`\nDon\'t forget to enclose your query to gql`\u2026` tag or import *.graphql file.\nSee docs at http://dev.apollodata.com/core/apollo-client-api.html#ApolloClient\\.query';

function createGraphqlRequest(apolloClient) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(queryOrString, variables) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var skipCache, query, gql, isMutation;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (false) {
                // eslint-disable-next-line no-console
                console.error(graphqlRequestDeprecatedMessage);
              }

              skipCache = options.skipCache;
              query = queryOrString;

              if (!(typeof queryOrString === 'string')) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return new Promise(function(resolve) { resolve(); }).then((function (require) {
                return __webpack_require__(900);
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            case 6:
              gql = _context.sent;

              query = gql([queryOrString]);

            case 8:
              if (!skipCache) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return', apolloClient.networkInterface.query({ query: query, variables: variables }));

            case 10:
              isMutation = false;

              if (query.definitions) {
                isMutation = query.definitions.some(function (definition) {
                  return definition && definition.operation === 'mutation';
                });
              }

              if (!isMutation) {
                _context.next = 14;
                break;
              }

              return _context.abrupt('return', apolloClient.mutate({ mutation: query, variables: variables }));

            case 14:
              return _context.abrupt('return', apolloClient.query({ query: query, variables: variables }));

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function graphqlRequest(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return graphqlRequest;
  }();
}

function createHelpers(_ref2) {
  var apolloClient = _ref2.apolloClient,
      fetch = _ref2.fetch,
      history = _ref2.history;

  return {
    client: apolloClient,
    history: history,
    fetch: fetch,
    // @deprecated('Use `client` instead')
    apolloClient: apolloClient,
    // @deprecated('Use `client.query()` or `client.mutate()` instead')
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(905);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ./src/store/logger/logger.client.js


function logger_client_createLogger() {
  return Object(redux_logger["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js






function configureStore(initialState, config) {
  var helpers = createHelpers(config);
  var apolloClient = config.apolloClient;


  var middleware = [redux_thunk_es["a" /* default */].withExtraArgument(helpers)];

  var enhancer = void 0;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = redux_es["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  var rootReducer = createRootReducer({
    apolloClient: apolloClient
  });

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = Object(redux_es["d" /* createStore */])(rootReducer, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../reducers', function () {
      return (
        // Don't forget to remove `()` if you change reducers back to normal rootReducer.
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default({ apolloClient: apolloClient }))
      );
    });
  }

  return store;
}
// CONCATENATED MODULE: ./src/DOMUtils.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector(tagName + '[' + keyName + '="' + keyValue + '"]');
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}

function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}

function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}

function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}
// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(406);

// EXTERNAL MODULE: ./src/router.js
var router = __webpack_require__(264);

// EXTERNAL MODULE: ./src/configPublic.js
var configPublic = __webpack_require__(404);

// CONCATENATED MODULE: ./src/actions/intl.js
var _templateObject = _taggedTemplateLiteral(['\n          query intl($locale: String!) {\n            intl(locale: $locale) {\n              id\n              message\n            }\n          }\n        '], ['\n          query intl($locale: String!) {\n            intl(locale: $locale) {\n              id\n              message\n            }\n          }\n        ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function intl__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable import/prefer-default-export */





// import queryIntl from './intl.graphql';

function getIntlFromState(state) {
  var intl = state && state.intl || {};
  var initialNow = intl.initialNow,
      locale = intl.locale,
      messages = intl.messages;

  var localeMessages = messages && messages[locale] || {};
  var provider = new index_es["c" /* IntlProvider */]({
    initialNow: initialNow,
    locale: locale,
    messages: localeMessages,
    defaultLocale: configPublic["b" /* defaultLocale */]
  });
  return provider.getChildContext().intl;
}

function getIntl() {
  return function (dispatch, getState) {
    return getIntlFromState(getState());
  };
}

function setLocale(_ref) {
  var _this = this;

  var locale = _ref.locale;

  return function () {
    var _ref2 = intl__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref3) {
      var client = _ref3.client,
          history = _ref3.history;
      var intlData, messages, maxAge;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: constants["e" /* SET_LOCALE_START */],
                payload: {
                  locale: locale
                }
              });

              _context.prev = 1;
              _context.next = 4;
              return client.query({
                query: Object(_apollo_client["gql"])(_templateObject),
                variables: { locale: locale }
              });

            case 4:
              intlData = _context.sent;

              // console.info({ intlData });
              messages = ((intlData.data || {}).intl || []).reduce(function (msgs, msg) {
                msgs[msg.id] = msg.message; // eslint-disable-line no-param-reassign
                return msgs;
              }, {});

              dispatch({
                type: constants["f" /* SET_LOCALE_SUCCESS */],
                payload: {
                  locale: locale,
                  messages: messages
                }
              });

              // remember locale for every new request
              if (true) {
                maxAge = 3650 * 24 * 3600; // 10 years in seconds

                document.cookie = 'lang=' + locale + ';path=/;max-age=' + maxAge;
                history.push('?lang=' + locale);
              }

              // return bound intl instance at the end
              return _context.abrupt('return', getIntlFromState(getState()));

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](1);

              dispatch({
                type: constants["d" /* SET_LOCALE_ERROR */],
                payload: {
                  locale: locale,
                  error: _context.t0
                }
              });
              return _context.abrupt('return', null);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 11]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// EXTERNAL MODULE: ./src/service/GraphQLService.js
var GraphQLService = __webpack_require__(412);

// CONCATENATED MODULE: ./src/tracking/listeners/index.js


var graphQLService = new GraphQLService["a" /* default */]();

// eslint-disable-next-line no-unused-vars
/* harmony default export */ var listeners = (function (fetch) {
  return function (event, eventsHistory) {
    // console.info('event', event, eventsHistory);

    fetch('/' + event.siteId + '/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: 'mutation { webeventMutation( data:\n         ' + graphQLService.escapeInputArg({
          page: window.location.href,
          referrer: window.document.referrer,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          event: event.type,
          data: JSON.stringify(event.data)
        }) + '  ) }'
      }),
      credentials: 'include'
    }).then(function (response) {
      return (
        // console.info('response', response);
        // if (response.status !== 200) throw new Error(response.statusText);
        response.json()
      );
    }).then(function (json) {
      return json;
    });
  };
});
// EXTERNAL MODULE: ./src/tracking/events/index.js
var events = __webpack_require__(414);

// CONCATENATED MODULE: ./src/client.js
/* harmony export (immutable) */ __webpack_exports__["default"] = main;
var client__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref = client__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location, action) {
    var route;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };
            // Delete stored scroll position for next page if any
            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            context.intl = client_store.dispatch(getIntl());
            _context.prev = 4;

            Array.from(document.getElementsByClassName('top-nav-icons--loading')).forEach(function (elm) {
              return elm.classList.add('is-show');
            });

            // Traverses the list of routes in the order they are defined until
            // it finds the first route that matches provided URL path string
            // and whose action method returns anything other than `undefined`.
            _context.next = 8;
            return router["a" /* default */].resolve(client__extends({}, context, {
              path: location.pathname,
              query: qs_lib_default.a.parse(location.search.substring(1)), // queryString.parse(location.search, { arrayFormat: 'bracket' }),
              locale: client_store.getState().intl.locale
            }));

          case 8:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return');

          case 11:

            context.routeParams = route.routeParams || {};
            context.path = location.pathname;
            context.query = qs_lib_default.a.parse(location.search.substring(1));

            if (!route.redirect) {
              _context.next = 17;
              break;
            }

            if (route.redirect.startsWith('http')) {
              window.location.href = route.redirect;
            } else {
              src_history["a" /* default */].replace(route.redirect);
            }
            return _context.abrupt('return');

          case 17:

            appInstance = react_dom_default.a.hydrate(client__jsx(components_App, {
              context: context
            }, void 0, route.component), container, function () {
              return onRenderComplete(route, location);
            });

            Array.from(document.getElementsByClassName('top-nav-icons--loading')).forEach(function (elm) {
              return elm.classList.remove('is-show');
            });
            _context.next = 27;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](4);

            if (true) {
              _context.next = 25;
              break;
            }

            throw _context.t0;

          case 25:

            console.error(_context.t0);

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 27:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 21]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */









// This is so bad: requiring all locale if they are not needed?
/* @intl-code-template import ${lang} from 'react-intl/locale-data/${lang}'; */


/* @intl-code-template-end */











var url = __webpack_require__(918).default;

// if (process.env.NODE_ENV !== 'production') {
var originalConsoleError = console.error;
if (console.error === originalConsoleError) {
  console.error = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args && args.length && typeof args[0] === 'string' && args[0].indexOf('[React Intl] Missing message:') === 0) {
      return;
    }
    originalConsoleError.call.apply(originalConsoleError, [console].concat(args));
  };
}

var originalConsoleWarnings = console.warn;
if (console.warn === originalConsoleWarnings) {
  console.warn = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (args && args.length && typeof args[0] === 'string' && (args[0].indexOf('Warning: componentWillMount') === 0 || args[0].indexOf('Warning: componentWillReceiveProps') === 0 || args[0].indexOf('Warning: componentWillUpdate') === 0)) {
      return;
    }
    originalConsoleWarnings.call.apply(originalConsoleWarnings, [console].concat(args));
  };
}
// }

var client_apolloClient = createApolloClient();

/* @intl-code-template addLocaleData(${lang}); */
Object(index_es["d" /* addLocaleData */])(en_default.a);
Object(index_es["d" /* addLocaleData */])(fr_default.a);
/* @intl-code-template-end */

/* eslint-disable global-require */

// Universal HTTP client
var client_fetch = src_createFetch(self.fetch, {
  baseUrl: window.App.apiUrl
});

// Initialize a new Redux store
// http://redux.js.org/docs/basics/UsageWithReact.html
var client_store = configureStore(window.App.state, {
  apolloClient: client_apolloClient,
  fetch: client_fetch,
  history: src_history["a" /* default */]
});

var tracker = new build["Tracker"]([listeners(client_fetch)]);

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len3 = arguments.length, styles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      styles[_key3] = arguments[_key3];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // For react-apollo
  client: client_apolloClient,
  store: client_store,
  storeSubscription: null,
  // Universal HTTP client
  fetch: client_fetch,
  // intl instance as it can be get with injectIntl
  intl: client_store.dispatch(getIntl()),
  url: url,
  trackEvent: tracker.trackEvent
};

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

var onRenderComplete = function initialRenderComplete(rte) {
  tracker.trackEvent(Object(events["a" /* getPageViewEvent */])({
    data: Object.assign({ landing: true }, rte.trackingData || {}),
    siteId: ((rte || {}).routeParams || {}).siteId
  }));
  var elem = document.getElementById('css');
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;

    updateMeta('description', route.description);
    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    // updateCustomMeta('og:url', route.canonicalUrl);
    // updateCustomMeta('og:image', route.imageUrl);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var scrollX = 0;
    var scrollY = 0;
    var pos = scrollPositionsHistory[location.key];
    if (pos) {
      scrollX = pos.scrollX;
      scrollY = pos.scrollY;
    } else {
      var targetHash = location.hash.substr(1);
      if (targetHash) {
        var target = document.getElementById(targetHash);
        if (target) {
          scrollY = window.pageYOffset + target.getBoundingClientRect().top;
        }
      }
    }

    // Restore the scroll position if it was saved into the state
    // or scroll to the given #hash anchor
    // or scroll to top of the page
    window.scrollTo(scrollX, scrollY);

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    tracker.trackEvent(Object(events["a" /* getPageViewEvent */])({
      data: rte.trackingData || null,
      siteId: ((route || {}).routeParams || {}).siteId
    }));
    if (window.ga) {
      window.ga('send', 'pageview', Object(esm_history["b" /* createPath */])(location));
    }
  };
};

var container = document.getElementById('app');
var appInstance = void 0;
var currentLocation = src_history["a" /* default */].location;

var isHistoryObserved = false;
function main() {
  // Handle client-side navigation by using HTML5 History API
  // For more information visit https://github.com/mjackson/history#readme
  currentLocation = src_history["a" /* default */].location;
  if (!isHistoryObserved) {
    isHistoryObserved = true;
    src_history["a" /* default */].listen(onLocationChange);
  }
  onLocationChange(currentLocation);
}

// globally accesible entry point
window.RSK_ENTRY = main;

// Enable Hot Module Replacement (HMR)
if (false) {
  url = require('./core/url').default;
  module.hot.accept('./router', function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }
  });
}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  transform: function transform(chunk, _ref) {
    var Types = _ref.Types,
        Promise = _ref.Promise,
        Mappers = _ref.Mappers,
        Logger = _ref.Logger;
    return new Promise(function (resolve) {
      var salonMapper = Mappers('salon');
      var userMapper = Mappers('user');
      var distributorProductMapper = Mappers('distributorProduct');
      var distributorMongoId = null;
      var queryBuilderCache = {
        salons: {},
        reps: {},
        distProducts: {},
        masterProducts: {},
        masterProductBrands: {}
      };
      chunk.forEach(function (obj) {
        if (distributorMongoId == null) {
          distributorMongoId = new Types.ObjectId(obj.__tmp.dist_id);
        }
        queryBuilderCache.salons[obj.$set.ext_salon_id] = null;

        queryBuilderCache.reps[obj.$set.ext_rep_id] = {
          dist_ext_id: obj.$set.ext_rep_id
        };

        queryBuilderCache.distProducts[obj.$set.ext_prod_id] = {
          ext_id: obj.$set.ext_prod_id
        };
      });

      return Promise.map(Object.keys(queryBuilderCache.salons), function (ext_id) {
        return salonMapper.findOne({
          ref: {
            $elemMatch: {
              distributor: distributorMongoId,
              ext_id: ext_id
            }
          }
        }).lean().select('_id ref').exec().then(function (salon) {
          console.info({ salon: salon, ext_id: ext_id });
          if (salon != null) {
            queryBuilderCache.salons[ext_id] = salon._id;
          } else {
            delete queryBuilderCache.salons[ext_id];
          }
        });
      }, { concurrency: 100 }).then(function (results) {
        // console.info('queryBuilderCache.salons[ext_id]', queryBuilderCache.salons)
        // console.info('results', results);
        // then find all sales reps
        // reps query
        var repExtIDQueryFragment = Object.keys(queryBuilderCache.reps).map(function (key) {
          return queryBuilderCache.reps[key];
        });
        var repQuery = {
          $and: [{ distributor: distributorMongoId }, { $or: repExtIDQueryFragment }]
        };
        return userMapper.find(repQuery).lean().select('distributor dist_ext_id').exec();
      }).then(function (reps) {
        queryBuilderCache.reps = {};
        reps.forEach(function (rep) {
          queryBuilderCache.reps[rep.dist_ext_id] = rep._id;
        });
        // reps query
        var productExtIDQueryFragment = Object.keys(queryBuilderCache.distProducts).map(function (key) {
          return queryBuilderCache.distProducts[key];
        });
        var productQuery = {
          $and: [{ distributor: distributorMongoId }, { $or: productExtIDQueryFragment }]
        };
        return distributorProductMapper.find(productQuery).select('_id ext_id master_product brand').populate('master_product').lean().exec();
      }).then(function (products) {
        queryBuilderCache.distProducts = {};
        products.forEach(function (product) {
          queryBuilderCache.distProducts[product.ext_id] = product._id;
          if (product.master_product != null) {
            queryBuilderCache.masterProducts[product.ext_id] = product.master_product._id;
            queryBuilderCache.masterProductBrands[product.ext_id] = product.master_product.brand;
          }
        });

        // Logger.info(queryBuilderCache);
        var salonBulkOps = [];
        var newChunk = chunk.map(function (obj) {
          var newObject = _extends({}, obj);
          // console.info('salon newObject', newObject);
          if (!newObject.$set) {
            newObject.$set = {};
          }
          newObject.$set.distributor = new Types.ObjectId(newObject.__tmp.dist_id);
          newObject.$set.dm = new Date();

          if (!newObject.$setOnInsert) {
            newObject.$setOnInsert = {};
          }
          newObject.$setOnInsert.e = true;
          newObject.$setOnInsert.dc = new Date();

          // __tmp is used to store temporary data we may need
          delete newObject.__tmp;

          var alerts = newObject.$set.alerts;
          // assign salon
          if (newObject.$set.ext_salon_id in queryBuilderCache.salons) {
            newObject.$set.salon = queryBuilderCache.salons[newObject.$set.ext_salon_id];
          } else {
            alerts.push({ code: 'salon-ext-id-invalid', level: 'warning' });
          }

          // assign distrobutor product
          if (newObject.$set.ext_prod_id in queryBuilderCache.distProducts) {
            newObject.$set.dist_prod = queryBuilderCache.distProducts[newObject.$set.ext_prod_id];
          } else {
            alerts.push({
              code: 'distributor-ext-id-invalid',
              level: 'warning'
            });
          }

          // assign master product
          if (newObject.$set.ext_prod_id in queryBuilderCache.masterProducts) {
            newObject.$set.master_product = queryBuilderCache.masterProducts[newObject.$set.ext_prod_id];
          } else {
            alerts.push({
              code: 'master-product-idh-invalid',
              level: 'warning'
            });
          }

          // assign master product brand
          if (newObject.$set.ext_prod_id in queryBuilderCache.masterProductBrands) {
            newObject.$set.brand = queryBuilderCache.masterProductBrands[newObject.$set.ext_prod_id];
          } else {
            alerts.push({
              code: 'master-product-brand-invalid',
              level: 'warning'
            });
          }

          // assign rep
          if (newObject.$set.ext_rep_id in queryBuilderCache.reps) {
            newObject.$set.user = queryBuilderCache.reps[newObject.$set.ext_rep_id];
          } else {
            alerts.push({
              code: 'distributor-rep-ext-id-invalid',
              level: 'warning'
            });
          }
          newObject.$set.alerts = alerts;

          if (newObject.$set.ext_salon_id in queryBuilderCache.salons && newObject.$set.ext_rep_id in queryBuilderCache.reps) {
            salonBulkOps.push({
              updateOne: {
                filter: {
                  _id: queryBuilderCache.salons[newObject.$set.ext_salon_id],
                  ref: {
                    $elemMatch: {
                      distributor: newObject.$set.distributor,
                      ext_id: obj.$set.ext_salon_id,
                      $or: [{ last_sale: { $gt: newObject.$set.date } }, { last_sale: { $exists: false } }]
                    }
                  }
                },
                update: {
                  $set: {
                    'ref.$.dsc': queryBuilderCache.reps[newObject.$set.ext_rep_id],
                    'ref.$.last_sale': newObject.$set.date
                  }
                }
              }
            });
          }
          return newObject;
        });
        if (salonBulkOps.length > 0) {
          salonMapper.bulkWrite(salonBulkOps).then(function (res) {
            // do nothing
          });
        }
        return resolve({ chunk: newChunk });
      });
    });
  }
});

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ext_id: {
    label: 'Transaction ID',
    required: true,
    valueKeys: ['$set', 'ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'transaction-id-invalid',
      alertLevel: 'critical'
    }]
  },
  n: {
    label: 'Product Name',
    required: false,
    valueKeys: ['$set', 'n'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'product-name-invalid',
      alertLevel: 'critical'
    }]
  },
  date: {
    label: 'Transaction Date',
    required: true,
    valueKeys: ['$set', 'date'],
    filters: ['trim', 'date'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'transaction-date-invalid',
      alertLevel: 'critical'
    },
    // {
    //   validator: 'matchRegexp',
    //   type: 'pre',
    //   params: [
    //     /((19|20)\d\d)-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])/,
    //   ],
    //   alertCode: 'transaction-date-invalid',
    //   alertLevel: 'critical',
    // },
    {
      validator: 'isDate',
      type: 'pre',
      params: [],
      alertCode: 'transaction-date-invalid',
      alertLevel: 'critical'
    }]
  },
  ext_salon_id: {
    label: 'Distributor Salon ID',
    required: true,
    valueKeys: ['$set', 'ext_salon_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'salon-id-invalid',
      alertLevel: 'critical'
    }]
  },
  ext_rep_id: {
    label: 'Distributor Rep ID',
    required: true,
    valueKeys: ['$set', 'ext_rep_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'rep-id-invalid',
      alertLevel: 'critical'
    }]
  },
  ext_prod_id: {
    label: 'Distributor Product ID',
    required: true,
    valueKeys: ['$set', 'ext_prod_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'product-id-invalid',
      alertLevel: 'critical'
    }]
  },
  qty: {
    label: 'Qty Sold',
    required: true,
    valueKeys: ['$set', 'qty'],
    filters: ['trim', 'integer'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'qty-invalid',
      alertLevel: 'critical'
    }, {
      validator: 'isInt',
      type: 'pre',
      params: [],
      alertCode: 'qty-invalid',
      alertLevel: 'critical'
    }]
  },
  total: {
    label: 'Total Amount',
    required: true,
    valueKeys: ['$set', 'total'],
    filters: ['money'],
    validators: [{
      validator: 'isMoneyDecimal',
      type: 'pre',
      params: [],
      alertCode: 'product-price-invalid',
      alertLevel: 'critical'
    }]
  }
});

/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  transform: function transform(chunk, _ref) {
    var Types = _ref.Types,
        Promise = _ref.Promise,
        Mappers = _ref.Mappers,
        Logger = _ref.Logger;
    return new Promise(function (resolve) {
      var masterProductMapper = Mappers('masterProduct');
      var distributorMongoId = null;
      var queryBuilderCache = {
        masterProducts: {}
      };
      chunk.forEach(function (obj) {
        if (distributorMongoId == null) {
          distributorMongoId = new Types.ObjectId(obj.__tmp.dist_id); //eslint-disable-line
        }
        queryBuilderCache.masterProducts[obj.$set.idh] = {
          idh: obj.$set.idh
        };
      });

      var idhQueryFragment = Object.keys(queryBuilderCache.masterProducts).map(function (key) {
        return queryBuilderCache.masterProducts[key];
      });
      var masterProductQuery = { $or: idhQueryFragment };

      masterProductMapper.find(masterProductQuery).lean().select('_id idh').exec().then(function (masterProducts) {
        queryBuilderCache.masterProducts = {};
        masterProducts.forEach(function (masterProduct) {
          queryBuilderCache.masterProducts[masterProduct.idh] = masterProduct._id; //eslint-disable-line
        });

        var newChunk = chunk.map(function (obj) {
          var newObject = _extends({}, obj);
          if (!newObject.$set) {
            newObject.$set = {};
          }

          newObject.$set.distributor = new Types.ObjectId(newObject.__tmp.dist_id); //eslint-disable-line
          newObject.$set.dm = new Date();

          if (!newObject.$setOnInsert) {
            newObject.$setOnInsert = {};
          }
          newObject.$setOnInsert.e = true;
          newObject.$setOnInsert.dc = new Date();

          delete newObject.__tmp; //eslint-disable-line

          var alerts = newObject.$set.alerts;

          if (newObject.$set.idh in queryBuilderCache.masterProducts) {
            newObject.$set.master_product = queryBuilderCache.masterProducts[newObject.$set.idh];
          } else {
            alerts.push({ code: 'master-product-idh-invalid', level: 'warning' });
          }
          newObject.$set.alerts = alerts;
          return newObject;
        });
        return resolve({ chunk: newChunk });
      });
    });
  }
});

/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* harmony default export */ __webpack_exports__["a"] = ({
  // eslint-disable-next-line no-unused-vars
  transform: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(chunk, _ref2) {
      var Types = _ref2.Types,
          Promise = _ref2.Promise,
          Mappers = _ref2.Mappers,
          Logger = _ref2.Logger;
      var brandMapper, brands, newChunk;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              brandMapper = Mappers('brand');
              _context.next = 3;
              return brandMapper.find({}).lean().select('_id n');

            case 3:
              brands = _context.sent;
              newChunk = chunk.map(function (obj) {
                var newObject = _extends({}, obj);
                if (!newObject.$set) {
                  newObject.$set = {};
                }

                if (!newObject.$setOnInsert) {
                  newObject.$setOnInsert = {};
                }

                newObject.$setOnInsert.e = true;
                newObject.$setOnInsert.dc = new Date();

                var brand = brands.find(function (b) {
                  return ('' + b.n).toUpperCase() === ('' + newObject.$set.brand).toUpperCase();
                });
                var alerts = newObject.$set.alerts || [];
                if (brand != null) {
                  newObject.$set.brand = brand._id;
                } else {
                  newObject.$set.brand = null;
                  alerts.push({
                    code: 'brand-invalid',
                    level: 'warning'
                  });
                }
                newObject.$set.alerts = alerts;
                return newObject;
              });
              return _context.abrupt('return', { chunk: newChunk });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function transform(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }()
});

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ext_id: {
    label: 'Product ID',
    required: true,
    valueKeys: ['$set', 'ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'product-id-invalid',
      alertLevel: 'critical'
    }]
  },
  // brand: {
  //   label: 'Brand',
  //   required: false,
  //   valueKeys: ['$set', 'brand'],
  //   filters: ['trim', 'uppercase'],
  //   validators: [
  //     // {
  //     //   validator: 'isExistyAndNotEmptyString',
  //     //   type: 'pre',
  //     //   params: [],
  //     //   alertCode: 'brand-invalid',
  //     //   alertLevel: 'critical',
  //     // },
  //   ],
  //   // lookup: {
  //   //   mapper: '',
  //   // },
  // },
  idh: {
    label: 'SKP IDH#',
    required: false,
    valueKeys: ['$set', 'idh'],
    filters: ['trim', 'uppercase'],
    validators: []
  },
  n: {
    label: 'Product Name',
    required: true,
    valueKeys: ['$set', 'n'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'product-name-invalid',
      alertLevel: 'critical'
    }]
  },
  price: {
    label: 'Wholesale Price',
    required: false,
    valueKeys: ['$set', 'price'],
    filters: ['money'],
    validators: [{
      validator: 'isMoneyDecimal',
      type: 'pre',
      params: [],
      alertCode: 'product-price-invalid',
      alertLevel: 'critical'
    }]
  },
  ext_product_family: {
    label: 'Product Family',
    required: false,
    valueKeys: ['$set', 'data.family'],
    filters: ['trim'],
    validators: []
  },
  ext_product_category: {
    label: 'Product Category',
    required: false,
    valueKeys: ['$set', 'data.cat_l1'],
    filters: ['trim'],
    validators: []
  },
  ext_product_subcategory: {
    label: 'Product Subcategory',
    required: false,
    valueKeys: ['$set', 'data.cat_l2'],
    filters: ['trim'],
    validators: []
  },
  desc: {
    label: 'Product Description',
    required: false,
    valueKeys: ['$set', 'desc'],
    filters: ['trim'],
    validators: []
  }
});

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ext_id: {
    label: 'Sales Rep ID',
    required: true,
    valueKeys: ['$set', 'dist_ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'rep-id-invalid',
      alertLevel: 'critical'
    }]
  },
  n: {
    label: 'Sales Rep Name',
    required: true,
    valueKeys: ['__tmp', 'n'],
    filters: ['trim'],
    validators: []
  },
  email: {
    label: 'Sales Rep Email',
    required: true,
    valueKeys: ['__tmp', 'email'],
    filters: ['trim', 'lowercase'],
    validators: [{
      validator: 'isEmail',
      type: 'post',
      params: [],
      alertCode: 'email-invalid',
      alertLevel: 'critical'
    }, {
      validator: 'isExistyAndNotEmptyString',
      type: 'post',
      params: [],
      alertCode: 'email-invalid',
      alertLevel: 'critical'
    }]
  },
  rep_region: {
    label: 'Sales Rep Region',
    required: false,
    valueKeys: ['$set', 'data.dist_rgn_l1'],
    filters: ['trim'],
    validators: []
  },
  rep_subregion: {
    label: 'Sales Rep Subregion',
    required: false,
    valueKeys: ['$set', 'data.dist_rgn_l2'],
    filters: ['trim'],
    validators: []
  },
  channels: {
    label: 'Sales Channel',
    required: false,
    valueKeys: ['$set', 'data.channel'],
    filters: ['trim'],
    validators: []
  }
});

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  transform: function transform(chunk, _ref) {
    var Types = _ref.Types,
        Promise = _ref.Promise,
        Mappers = _ref.Mappers,
        Logger = _ref.Logger;
    return new Promise(function (resolve) {
      var groupMapper = Mappers('group');
      groupMapper.findOne({ options: 'user.is.salesRep' }).lean().select('_id').exec().then(function (group) {
        var newObject = _extends({}, chunk);
        if (!newObject.$set) {
          newObject.$set = {};
        }
        newObject.$set.distributor = new Types.ObjectId(newObject.__tmp.dist_id); //eslint-disable-line
        newObject.$set.dm = new Date();

        var nameChunks = newObject.__tmp.n.split(/\s+/);
        var nameArray = [nameChunks.shift(), nameChunks.join(' ')];
        newObject.$set.firstname = nameArray[0];
        newObject.$set.lastname = nameArray[1];
        newObject.$set.group = group._id;
        newObject.$set.email = newObject.__tmp.email;
        newObject.$set.username = newObject.__tmp.email;

        if (!newObject.$setOnInsert) {
          newObject.$setOnInsert = {};
        }
        newObject.$setOnInsert.firstname_text = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils__["a" /* normalizeDiacriticsAndCase */])(nameArray[0]);
        newObject.$setOnInsert.lastname_text = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils__["a" /* normalizeDiacriticsAndCase */])(nameArray[1]);
        newObject.$setOnInsert.fullname_text = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils__["a" /* normalizeDiacriticsAndCase */])(nameArray[0] + ' ' + nameArray[1]);
        newObject.$setOnInsert.e = true;
        newObject.$setOnInsert.dc = new Date();

        // __tmp is used to store temporary data we may need
        delete newObject.__tmp;
        return resolve({ chunk: newObject });
      });
    });
  }
});

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ext_id: {
    label: 'Salon ID',
    required: true,
    valueKeys: ['__tmp', 'ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'salon-id-invalid',
      alertLevel: 'critical'
    }]
    // lookup: {
    //   mapper: '',
    // },
  },
  n: {
    label: 'Salon Name',
    required: true,
    valueKeys: ['$setOnInsert', 'n'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'salon-name-invalid',
      alertLevel: 'critical'
    }]
  },
  ext_salon_str1: {
    label: 'Salon Street 1',
    required: false,
    valueKeys: ['address', 'str1'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'address-invalid',
      alertLevel: 'warning'
    }]
  },
  ext_salon_str2: {
    label: 'Salon Street 2',
    required: false,
    valueKeys: ['address', 'str2'],
    filters: ['trim'],
    validators: []
  },
  ext_salon_city: {
    label: 'Salon City',
    required: false,
    valueKeys: ['address', 'city'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'address-invalid',
      alertLevel: 'warning'
    }]
  },
  ext_salon_postal: {
    label: 'Salon Postal',
    required: false,
    valueKeys: ['address', 'postal'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'address-invalid',
      alertLevel: 'warning'
    }]
  },
  ext_salon_state: {
    label: 'Salon State',
    required: false,
    valueKeys: ['address', 'state'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'address-invalid',
      alertLevel: 'warning'
    }]
  },
  ext_salon_country: {
    label: 'Salon Country',
    required: false,
    valueKeys: ['address', 'country'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'address-invalid',
      alertLevel: 'warning'
    }]
  },
  phone: {
    label: 'Salon Phone',
    required: false,
    valueKeys: ['$set', 'phone'],
    filters: ['trim'],
    validators: []
  },
  contact: {
    label: 'Salon Contact',
    required: false,
    valueKeys: ['$set', 'contact'],
    filters: ['trim'],
    validators: []
  }
  // below removed because it was Distributor specific but saved as global
  // ext_salon_region: {
  //   label: 'Salon Region Level 1',
  //   required: false,
  //   valueKeys: ['$set', 'data.rgn_l1'],
  //   filters: ['trim'],
  //   validators: [],
  // },
  // ext_salon_subregion: {
  //   label: 'Salon Region Level 2',
  //   required: false,
  //   valueKeys: ['$set', 'data.rgn_l2'],
  //   filters: ['trim'],
  //   validators: [],
  // },
});

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslXXint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  transform: function transform(chunk, _ref) {
    var Types = _ref.Types,
        Promise = _ref.Promise,
        Mappers = _ref.Mappers,
        Logger = _ref.Logger,
        ServiceFactory = _ref.ServiceFactory;
    return new Promise(function (resolve) {
      var salonMapper = Mappers('salon');
      var distributorMongoId = null;
      var queryBuilderCache = {
        salons: {},
        addressesNeedingGeocode: [],
        refByDist: {}
      };
      chunk.forEach(function (obj) {
        if (distributorMongoId == null) {
          distributorMongoId = new Types.ObjectId(obj.__tmp.dist_id); //eslint-disable-line
        }
        // query to bulk lookup addresses that alreayd have geocoding
        queryBuilderCache.salons[obj.__tmp.ext_id] = {
          'ref.ext_id': obj.__tmp.ext_id
        };
        // push all address to array and then remove if already geocoded down below
        queryBuilderCache.addressesNeedingGeocode.push(_extends({
          input_id: obj.__tmp.ext_id
        }, obj.address));
      });

      var salonExtIDQueryFragment = Object.keys(queryBuilderCache.salons).map(function (key) {
        return queryBuilderCache.salons[key];
      });
      var salonQuery = {
        $and: [{ 'ref.distributor': distributorMongoId }, { $or: salonExtIDQueryFragment }]
      };

      salonMapper.find(salonQuery).lean().select('_id ref').exec().then(function (salons) {
        // remove each one of these from the array to geocode salon address because already geocoded
        salons.forEach(function (salon) {
          var ref = salon.ref.find(function (ref2) {
            return ref2.distributor.toString() === distributorMongoId.toString();
          });
          var hasUniqueAddressId = (salon.address || {}).unique_id != null;
          queryBuilderCache.refByDist[ref.distributor + '-' + ref.ext_id] = salon.ref;
          queryBuilderCache.addressesNeedingGeocode = queryBuilderCache.addressesNeedingGeocode.filter(function (obj) {
            return obj.input_id === (ref || {}).ext_id && hasUniqueAddressId;
          });
        });
        // start disable address geocoding
        // const geocodeService = new ServiceFactory('geocode', []);
        // const promises = queryBuilderCache.addressesNeedingGeocode.map(adr =>
        //   geocodeService.sanitize([adr]),
        // );
        // return Promise.all(promises);
        return [];
        // end disable address geocoding
      }).then(function (geocodedAddresses) {
        var geocodedAddressesFormatted = [];
        geocodedAddresses.forEach(function (geocodedAddress) {
          if (geocodedAddress) {
            geocodedAddress.forEach(function (geocodedAddress2) {
              if (geocodedAddress2) {
                geocodedAddressesFormatted.push(geocodedAddress2);
              }
            });
          }
        });
        var newChunk = chunk.map(function (obj) {
          var newObject = _extends({}, obj);
          if (!newObject.$set) {
            newObject.$set = {};
          }
          newObject.$set.dm = new Date();

          if (!newObject.$setOnInsert) {
            newObject.$setOnInsert = {};
          }
          newObject.$setOnInsert.status = 'approved';
          newObject.$setOnInsert.e = true;

          newObject.$setOnInsert.dc = new Date();

          if (newObject.$setOnInsert.n) {
            newObject.$setOnInsert.n_text = Object(__WEBPACK_IMPORTED_MODULE_0__core_utils__["a" /* normalizeDiacriticsAndCase */])(newObject.$setOnInsert.n);
          }

          // if (!newObject.$addToSet) {
          //   newObject.$addToSet = {};
          // }

          // cleanup ref
          var newRef = queryBuilderCache.refByDist[distributorMongoId + '-' + newObject.__tmp.ext_id] || [];
          // add new value and remove later on if duplicate
          newRef.push({
            distributor: new Types.ObjectId(newObject.__tmp.dist_id), //eslint-disable-line
            ext_id: newObject.__tmp.ext_id //eslint-disable-line
          });

          var groupedRef = newRef.reduce(function (r, a) {
            // eslint-disable-next-line no-param-reassign
            var key = a.distributor + '-' + a.ext_id;
            // eslint-disable-next-line no-param-reassign
            r[key] = r[key] || [];
            r[key].push(a);
            return r;
          }, Object.create(null));
          var cleanRef = Object.keys(groupedRef).map(function (itmKey) {
            return groupedRef[itmKey].reduce(function (a, b) {
              return a.last_sale <= b.last_sale || a.last_sale == null ? b : a;
            });
          });
          console.info({ newRef: newRef, groupedRef: groupedRef, cleanRef: cleanRef });
          newObject.$set.ref = cleanRef;
          newObject.$noop = {
            ref: {
              distributor: new Types.ObjectId(newObject.__tmp.dist_id), //eslint-disable-line
              ext_id: newObject.__tmp.ext_id //eslint-disable-line
            }
          };

          // check if in need of geocode
          var alerts = newObject.$set.alerts || [];

          // then check if it had positive geocode value
          var geocodedAddress = geocodedAddressesFormatted.find(function (add) {
            return add.input_id === newObject.__tmp.ext_id;
          });

          if (geocodedAddress) {
            delete geocodedAddress.input_id;
            newObject.$set.address = geocodedAddress;
          } else {
            newObject.$set.address = _extends({}, newObject.address);
            alerts.push({
              code: 'address-invalid',
              level: 'warning'
            });
          }

          newObject.$set.alerts = alerts;
          delete newObject.address;
          delete newObject.__tmp; //eslint-disable-line
          // console.info('newObject', newObject);
          return newObject;
        });
        // console.dir(newChunk, { depth: 999 });

        return resolve({ chunk: newChunk });
      });
    });
  }
});

/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  brand: {
    label: 'Brand',
    required: true,
    valueKeys: ['$set', 'brand'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'brand-invalid',
      alertLevel: 'critical'
    }]
    // lookup: {
    //   mapper: '',
    // },
  },
  idh: {
    label: 'IDH #',
    required: true,
    valueKeys: ['$set', 'idh'],
    filters: ['trim', 'uppercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'product-id-invalid',
      alertLevel: 'critical'
    }]
    // lookup: {
    //   mapper: '',
    // },
  },
  n: {
    label: 'Product Name',
    required: true,
    valueKeys: ['$set', 'n'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'product-name-invalid',
      alertLevel: 'critical'
    }]
  },
  family: {
    label: 'Product Family',
    required: true,
    valueKeys: ['$set', 'family'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'family-invalid',
      alertLevel: 'critical'
    }]
  },
  sub_family: {
    label: 'Product Sub-Family',
    required: true,
    valueKeys: ['$set', 'sub_family'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'sub-family-invalid',
      alertLevel: 'critical'
    }]
  },
  market: {
    label: 'Market',
    required: true,
    valueKeys: ['$set', 'market'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'market-invalid',
      alertLevel: 'critical'
    }]
  },
  market_segment: {
    label: 'Market Segment',
    required: true,
    valueKeys: ['$set', 'market_segment'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'market-segment-invalid',
      alertLevel: 'critical'
    }]
  },
  open_stock: {
    label: 'Is Open Stock?',
    required: false,
    valueKeys: ['$set', 'open_stock'],
    filters: ['trim', 'boolean'],
    validators: []
  },
  holiday_special: {
    label: 'Is Holiday Special?',
    required: false,
    valueKeys: ['$set', 'holiday_special'],
    filters: ['trim', 'boolean'],
    validators: []
  },
  key_initiative: {
    label: 'Is Key Initiative?',
    required: false,
    valueKeys: ['$set', 'key_initiative'],
    filters: ['trim', 'boolean'],
    validators: []
  },
  year_round_deal: {
    label: 'Is Year Round Deal?',
    required: false,
    valueKeys: ['$set', 'year_round_deal'],
    filters: ['trim', 'boolean'],
    validators: []
  }
});

/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  targetYear: {
    label: 'Target Year',
    required: true,
    valueKeys: ['$set', 'targetYear'],
    filters: ['trim', 'integer'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'target-year-invalid',
      alertLevel: 'critical'
    }]
  },
  distributor: {
    label: 'Distirbutor ID',
    required: true,
    valueKeys: ['$set', 'distributor'],
    filters: ['mongoObjectId'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'distributor-id-invalid',
      alertLevel: 'critical'
    }]
    // lookup: {
    //   mapper: '',
    // },
  },
  recordType: {
    label: 'Type',
    required: true,
    valueKeys: ['$set', 'recordType'],
    filters: ['trim', 'lowercase'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'type-invalid',
      alertLevel: 'critical'
    }]
  },
  recordValue: {
    label: 'Record Value',
    required: true,
    valueKeys: ['$set', 'recordValue'],
    filters: ['trim'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'record-value-invalid',
      alertLevel: 'critical'
    }]
  },
  targetValue: {
    label: 'Target Value',
    required: true,
    valueKeys: ['$set', 'targetValue'],
    filters: ['trim', 'float'],
    validators: [{
      validator: 'isExistyAndNotEmptyString',
      type: 'pre',
      params: [],
      alertCode: 'target-value-invalid',
      alertLevel: 'critical'
    }]
  }
});

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  label: 'User Requires State/Province Association',
  value: 'user.requires.states'
}, {
  label: 'User Requires Brand Association',
  value: 'user.requires.brands'
}, {
  label: 'User Is Distributor Employee (Previously "User Requires Distributor Association")',
  value: 'user.requires.distributor'
}, {
  label: 'User Has Restricted Distributor Access (Henkel Employee)',
  value: 'user.requires.distributorRestriction'
}, {
  label: 'User Is Distributor Manager (Employed By Distributor)',
  value: 'user.is.distributormanager'
}, {
  label: 'User Requires Vendor No.',
  value: 'user.requires.vendornum'
}, {
  label: 'User Requires Salon Association (Caution! Only one group can have this selected.)',
  value: 'user.requires.salon'
}, {
  label: 'User Assignable to Salon',
  value: 'user.assignable.salon'
}, {
  label: 'Sales Rep (Caution! Only one group can have this selected.)',
  value: 'user.is.salesRep'
}, {
  label: 'Advisornet Manager',
  value: 'user.manager.advisornet'
}, {
  label: 'Advisornet - Performs Education Activities',
  value: 'user.advisornet.education'
}, {
  label: 'Advisornet - Can Submit Expenses',
  value: 'user.advisornet.expenses'
}, {
  label: 'Advisornet - Expenses Requires Activity',
  value: 'user.advisornet.expenses.requires.activity'
}, {
  label: 'Advisornet - Expenses Requires Location',
  value: 'user.advisornet.expenses.requires.location'
}, {
  label: 'Advisornet - Expenses Requires Distributor',
  value: 'user.advisornet.expenses.requires.distributor'
},
// {
//   label: 'Advisornet - Expenses Requires Type',
//   value: 'user.advisornet.expenses.requires.type',
// },
{
  label: 'Advisornet - Expenses Requires Days Worked',
  value: 'user.advisornet.expenses.requires.daysworked'
}, {
  label: 'Advisornet - Expenses Requires Hours Worked',
  value: 'user.advisornet.expenses.requires.hoursworked'
}, {
  label: 'Messenger - Can Send Group/Bulk Messages',
  value: 'user.messenger.sendBulk'
}, {
  label: 'Messenger - Can Send Direct Message (Dynamic user filters still apply)',
  value: 'user.messenger.sendDirect'
}, {
  label: 'Messenger - Can Send Direct Distributor User Messages',
  value: 'user.messenger.sendToDistributorUser'
}, {
  label: 'Messenger - Can Send Direct Education User Messages',
  value: 'user.messenger.sendToEducationUser'
}, {
  label: 'Messenger - Can Send Direct Salon Messages',
  value: 'user.messenger.sendToSalons'
}, {
  label: 'Mytracker - Can Export Data',
  value: 'user.mytracker.canExport'
}, {
  label: 'Mytracker - Executive Reporting',
  value: 'user.mytracker.executiveReporting'
}, {
  label: 'Mytracker - ClubH Dashboard',
  value: 'user.mytracker.loyaltyDashboard'
}, {
  label: 'POE - Can Export Expenses',
  value: 'user.poe.canExportExpenses'
}, {
  label: 'SalonDB - Full Access',
  value: 'user.salondb.fullAccess'
}, {
  label: 'SalonDB - Can Export Data',
  value: 'user.salondb.canExport'
}, {
  label: 'SalonDB - Can Merge Accounts',
  value: 'user.salondb.canMerge'
}]);

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol', 'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'img', 'button', 'iframe', 'sub', 'sup', 's'],
  allowedAttributes: {
    a: ['style', 'href', 'name', 'target', 'class'],
    img: ['style', 'src', 'height', 'width', 'data-type', 'data-id', 'data-name', 'class'],
    div: ['style', 'id', 'class'],
    button: ['style', 'type'],
    span: ['style', 'class', 'contenteditable'],
    th: ['colspan', 'style'],
    td: ['style'],
    iframe: ['src', 'allowfullscreen', 'class', 'width', 'height', 'frameborder'],
    p: ['style', 'class']
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
  // URL schemes we permit
  allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
  allowedSchemesByTag: {},
  allowProtocolRelative: true
});

/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  US: [{
    label: 'Alabama',
    value: 'AL'
  }, {
    label: 'Alaska',
    value: 'AK'
  }, {
    label: 'American Samoa',
    value: 'AS'
  }, {
    label: 'Arizona',
    value: 'AZ'
  }, {
    label: 'Arkansas',
    value: 'AR'
  }, {
    label: 'California',
    value: 'CA'
  }, {
    label: 'Colorado',
    value: 'CO'
  }, {
    label: 'Connecticut',
    value: 'CT'
  }, {
    label: 'Delaware',
    value: 'DE'
  }, {
    label: 'District Of Columbia',
    value: 'DC'
  }, {
    label: 'Federated States Of Micronesia',
    value: 'FM'
  }, {
    label: 'Florida',
    value: 'FL'
  }, {
    label: 'Georgia',
    value: 'GA'
  }, {
    label: 'Guam',
    value: 'GU'
  }, {
    label: 'Hawaii',
    value: 'HI'
  }, {
    label: 'Idaho',
    value: 'ID'
  }, {
    label: 'Illinois',
    value: 'IL'
  }, {
    label: 'Indiana',
    value: 'IN'
  }, {
    label: 'Iowa',
    value: 'IA'
  }, {
    label: 'Kansas',
    value: 'KS'
  }, {
    label: 'Kentucky',
    value: 'KY'
  }, {
    label: 'Louisiana',
    value: 'LA'
  }, {
    label: 'Maine',
    value: 'ME'
  }, {
    label: 'Marshall Islands',
    value: 'MH'
  }, {
    label: 'Maryland',
    value: 'MD'
  }, {
    label: 'Massachusetts',
    value: 'MA'
  }, {
    label: 'Michigan',
    value: 'MI'
  }, {
    label: 'Minnesota',
    value: 'MN'
  }, {
    label: 'Mississippi',
    value: 'MS'
  }, {
    label: 'Missouri',
    value: 'MO'
  }, {
    label: 'Montana',
    value: 'MT'
  }, {
    label: 'Nebraska',
    value: 'NE'
  }, {
    label: 'Nevada',
    value: 'NV'
  }, {
    label: 'New Hampshire',
    value: 'NH'
  }, {
    label: 'New Jersey',
    value: 'NJ'
  }, {
    label: 'New Mexico',
    value: 'NM'
  }, {
    label: 'New York',
    value: 'NY'
  }, {
    label: 'North Carolina',
    value: 'NC'
  }, {
    label: 'North Dakota',
    value: 'ND'
  }, {
    label: 'Northern Mariana Islands',
    value: 'MP'
  }, {
    label: 'Ohio',
    value: 'OH'
  }, {
    label: 'Oklahoma',
    value: 'OK'
  }, {
    label: 'Oregon',
    value: 'OR'
  }, {
    label: 'Palau',
    value: 'PW'
  }, {
    label: 'Pennsylvania',
    value: 'PA'
  }, {
    label: 'Puerto Rico',
    value: 'PR'
  }, {
    label: 'Rhode Island',
    value: 'RI'
  }, {
    label: 'South Carolina',
    value: 'SC'
  }, {
    label: 'South Dakota',
    value: 'SD'
  }, {
    label: 'Tennessee',
    value: 'TN'
  }, {
    label: 'Texas',
    value: 'TX'
  }, {
    label: 'Utah',
    value: 'UT'
  }, {
    label: 'Vermont',
    value: 'VT'
  }, {
    label: 'Virgin Islands',
    value: 'VI'
  }, {
    label: 'Virginia',
    value: 'VA'
  }, {
    label: 'Washington',
    value: 'WA'
  }, {
    label: 'West Virginia',
    value: 'WV'
  }, {
    label: 'Wisconsin',
    value: 'WI'
  }, {
    label: 'Wyoming',
    value: 'WY'
  }],
  CA: [{
    label: 'Alberta',
    value: 'AB'
  }, {
    label: 'British Columbia',
    value: 'BC'
  }, {
    label: 'Manitoba',
    value: 'MB'
  }, {
    label: 'New Brunswick',
    value: 'NB'
  }, {
    label: 'Newfoundland and Labrador',
    value: 'NL'
  }, {
    label: 'Nova Scotia',
    value: 'NS'
  }, {
    label: 'Northwest Territories',
    value: 'NT'
  }, {
    label: 'Nunavut',
    value: 'NU'
  }, {
    label: 'Ontario',
    value: 'ON'
  }, {
    label: 'Prince Edward Island',
    value: 'PE'
  }, {
    label: 'Quebec',
    value: 'QC'
  }, {
    label: 'Saskatchewan',
    value: 'SK'
  }, {
    label: 'Yukon',
    value: 'YT'
  }]
});

/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Site_CA_TermsPrivacy__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Site_CA_TermsPrivacyFr__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Site_CA_TermsPrint__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Site_CA_TermsAdditional__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Site_CA_TermsAdditionalFr__ = __webpack_require__(757);







var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({
  emailTerms: {
    'id': 'ca.emailTerms',
    'defaultMessage': 'Terms of Use & Privacy Policy'
  },
  emailAdditionalTerms: {
    'id': 'ca.emailAdditionalTerms',
    'defaultMessage': 'Additional Terms of Use & Privacy Supplement'
  },
  emailPrintcenterTerms: {
    'id': 'ca.emailPrintcenterTerms',
    'defaultMessage': 'PrintCenter Terms of Use & Privacy Policy'
  },

  english: {
    'id': 'ca.english',
    'defaultMessage': 'English'
  },
  french: {
    'id': 'ca.french',
    'defaultMessage': 'French'
  },

  shippingStandard: {
    'id': 'ca.shippingStandard',
    'defaultMessage': 'Standard Delivery (5 to 7 business days to most delivery locations in Canada)'
  },
  shippingDownload: {
    'id': 'ca.shippingDownload',
    'defaultMessage': 'Digital Download'
  },

  generalTerms: {
    'id': 'ca.generalTerms',
    'defaultMessage': 'Terms of Use and Privacy Policy'
  },
  additionalTerms: {
    'id': 'ca.additionalTerms',
    'defaultMessage': 'MYSKP Additional Terms of Use and Privacy Supplement'
  },
  printCenterTerms: {
    'id': 'ca.printCenterTerms',
    'defaultMessage': 'Print Center Terms'
  },

  footerTrending: {
    'id': 'ca.footerTrending',
    'defaultMessage': 'Trending'
  },
  footerEducation: {
    'id': 'ca.footerEducation',
    'defaultMessage': 'Education'
  },
  footerProducts: {
    'id': 'ca.footerProducts',
    'defaultMessage': 'Products'
  },
  footerMobileApps: {
    'id': 'ca.footerMobileApps',
    'defaultMessage': 'Mobile Apps'
  },
  footerHelp: {
    'id': 'ca.footerHelp',
    'defaultMessage': 'Help'
  },

  footerLatestInnovations: {
    'id': 'ca.footerLatestInnovations',
    'defaultMessage': 'Latest Innovations'
  },
  footerEssentialLooks: {
    'id': 'ca.footerEssentialLooks',
    'defaultMessage': 'Essential Looks'
  },
  // footerASKBrouchure: {
  //   id: 'ca.footerASKBrouchure',
  //   defaultMessage: 'ASK Brouchure',
  //   description: 'ca.footerASKBrouchure',
  // },
  footerEAcademy: {
    'id': 'ca.footerEAcademy',
    'defaultMessage': 'eAcademy'
  },
  footerSeminars: {
    'id': 'ca.footerSeminars',
    'defaultMessage': 'Seminars'
  },
  footerHairColor: {
    'id': 'ca.footerHairColor',
    'defaultMessage': 'Hair Color'
  },
  footerHairCare: {
    'id': 'ca.footerHairCare',
    'defaultMessage': 'Hair Care'
  },
  footerHairStyling: {
    'id': 'ca.footerHairStyling',
    'defaultMessage': 'Hair Styling'
  },
  footerHouseOfColor: {
    'id': 'ca.footerHouseOfColor',
    'defaultMessage': 'House of Color'
  },
  footerHairExpert: {
    'id': 'ca.footerHairExpert',
    'defaultMessage': 'Hair Expert'
  },
  footerFaq: {
    'id': 'ca.footerFaq',
    'defaultMessage': 'FAQ'
  },
  footerSupport: {
    'id': 'ca.footerSupport',
    'defaultMessage': 'Support'
  },
  footerContact: {
    'id': 'ca.footerContact',
    'defaultMessage': 'Contact'
  },
  hairdressingSchool: {
    'id': 'salondb.edit.hairdressingSchool',
    'defaultMessage': 'Hairdressing School'
  },
  homeSalon: {
    'id': 'salondb.edit.homeSalon',
    'defaultMessage': 'Home Salon'
  },
  retailOutlet: {
    'id': 'salondb.edit.retailOutlet',
    'defaultMessage': 'Retail Outlet'
  },
  distributorStore: {
    'id': 'salondb.edit.distributorStore',
    'defaultMessage': 'Distributor Store'
  },
  vipSalon: {
    'id': 'salondb.edit.vipSalon',
    'defaultMessage': 'VIP Salon'
  },
  traditionalSalon: {
    'id': 'salondb.edit.traditionalSalon',
    'defaultMessage': 'Traditional Salon'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'ca',
  suffix: 'ca',
  email: {
    defaultFrom: 'notifications@henkelbeautypro.com',
    defaultReplyTo: ['hello@clubh.ca'],
    clubhFrom: 'hello@clubh.ca',
    clubhReplyTo: ['hello@clubh.ca']
  },
  orderCc: ['hello@clubh.ca'],
  printCenterCc: ['printcenter@clubh.ca'],
  userSignupBcc: ['signups-ca@henkelbeautypro.com'],
  label: 'Canada',
  klaviyoListId: process.env.APP_ENV === 'master' ? 'WvJ4rS' : 'VAgXRU',
  company: 'Henkel Canada Corporation',
  companyShort: 'Henkel Canada Corporation',
  emailFooterLinks: [
  // do not prepend host name
  {
    label: 'Terms of Use & Privacy Policy',
    // label: intl.formatMessage(messages.emailTerms),
    href: '/ca/#terms'
  }, {
    label: 'Additional Terms of Use & Privacy Supplement',
    // label: intl.formatMessage(messages.emailAdditionalTerms),
    href: '/ca/#additional-terms'
  }, {
    label: 'PrintCenter Terms of Use & Privacy Policy',
    // label: intl.formatMessage(messages.emailPrintcenterTerms),
    href: '/ca/#printcenter-terms'
  }],
  flag: 'icon-flag--canada',
  locales: {
    'en-CA': {
      label: 'English'
    },
    'fr-CA': {
      label: 'French'
    }
  },
  localesIntl: function localesIntl(intl) {
    return {
      'en-CA': {
        label: intl.formatMessage(messages.english)
      },
      'fr-CA': {
        label: intl.formatMessage(messages.french)
      }
    };
  },

  countries: [{ label: 'Canada', value: 'CA', threeChar: 'CAN', default: true }],
  social: {
    facebook: 'https://www.facebook.com/clubhrewards',
    instagram: 'https://www.instagram.com/clubhrewards',
    // twitter: 'https://twitter.com/SKPprofessional',
    // pinterest: 'http://pinterest.com/Schwarzkopfpro',
    youtube: 'https://www.youtube.com/@ClubHrewards',
    tiktok: 'https://www.tiktok.com/clubhrewards'
  },
  baseCurrency: 'CAD',
  shippingOptions: {
    'flatrate-standard': {
      label: 'Standard Delivery (5 to 7 business days to most delivery locations in Canada) ',
      // label: intl.formatMessage(messages.shippingStandard),
      amount: 0
    },
    'digital-download': {
      label: 'Digital Download',
      // label: intl.formatMessage(messages.shippingDownload),
      amount: 0
    }
  },
  shippingPrintCenter: {
    amount: 1500
  },
  currencies: [{
    code: 'CAD',
    label: 'CAD'
  }, {
    code: 'POINTS',
    label: 'Points'
  }],
  units: {
    distance: {
      label: 'Kilometer',
      abbrev: 'Km'
    }
  },
  contact: {
    address: {
      str1: '2515 Meadowpine Blvd',
      city: 'Mississauga',
      state: 'ON',
      postal: 'L5N 6C3',
      country: 'CANADA'
    },
    phone: '905-816-4631',
    fax: '905-826-8611',
    email: 'clubskp@henkelbeautypro.com',
    website: 'henkelbeautypro.com',
    support: ''
  },
  loyalty: {
    tz: 'America/Los_Angeles',
    rollingExpiry: [13, 'months'] // passed into moment.subtract(...rollingExpiry)
    // DEPRECATED
    // pointsExpireMoment: {
    //   month: 1, // jan = 0, dec = 11
    //   date: 1,
    //   startOf: 'day',
    //   tz: 'America/Los_Angeles',
    // },
  },
  taxRates: {
    CA: {
      AB: 0.05,
      BC: 0.12,
      MB: 0.13,
      NB: 0.15,
      NL: 0.15,
      NS: 0.15,
      NT: 0.05,
      NU: 0.05,
      ON: 0.13,
      PE: 0.15,
      QC: 0.14975,
      SK: 0.1,
      YT: 0.05
    }
  },
  terms: function terms(intl) {
    return {
      // generalTerms is a required field
      generalTerms: {
        label: intl.formatMessage(messages.generalTerms),
        component: intl.locale === 'fr-CA' ? __WEBPACK_IMPORTED_MODULE_2__components_Site_CA_TermsPrivacyFr__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__components_Site_CA_TermsPrivacy__["a" /* default */],
        props: []
      },
      additionalTerms: {
        label: intl.formatMessage(messages.additionalTerms),
        component: intl.locale === 'fr-CA' ? __WEBPACK_IMPORTED_MODULE_5__components_Site_CA_TermsAdditionalFr__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__components_Site_CA_TermsAdditional__["a" /* default */],
        props: []
      },
      printCenterTerms: {
        label: intl.formatMessage(messages.printCenterTerms),
        component: __WEBPACK_IMPORTED_MODULE_3__components_Site_CA_TermsPrint__["a" /* default */],
        props: []
      }
    };
  },
  salonCategories: function salonCategories(intl) {
    return [{
      value: '',
      label: ''
    }, {
      value: 'Hairdressing School',
      label: intl.formatMessage(messages.hairdressingSchool)
    }, {
      value: 'Home Salon',
      label: intl.formatMessage(messages.homeSalon)
    }, {
      value: 'Retail Outlet',
      label: intl.formatMessage(messages.retailOutlet)
    }, {
      value: 'Distributor Store',
      label: intl.formatMessage(messages.distributorStore)
    }, {
      value: 'VIP Salon',
      label: intl.formatMessage(messages.vipSalon)
    }, {
      value: 'Traditional Salon',
      label: intl.formatMessage(messages.traditionalSalon)
    }];
  },
  footer: function footer(intl) {
    return [
      // {
      //   label: intl.formatMessage(messages.footerTrending),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerLatestInnovations),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/latest-innovations.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerEssentialLooks),
      //       to: 'https://www.essentiallooks.com/',
      //     },
      //     // {
      //     //   label: 'Essential Looks',
      //     //   to: 'http://www.schwarzkopf-professional.ca/skp/ca/en/home.html',
      //     // },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerEducation),
      //   links: [
      //     // {
      //     //   label: intl.formatMessage(messages.footerASKBrouchure),
      //     //   to:
      //     //     'https://myskp-printcenter.nyc3.digitaloceanspaces.com/ask/ASK_Academy_Brochure_CAN.pdf',
      //     // },
      //     {
      //       label: intl.formatMessage(messages.footerEAcademy),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/education/ask-education-eacademy.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerSeminars),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/education/seminars.html',
      //     },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerProducts),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerHairColor),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/color.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerHairCare),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/care.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerHairStyling),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/styling.html',
      //     },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerMobileApps),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerHouseOfColor),
      //       to:
      //         'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/color/house-of-color.html',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerEssentialLooks),
      //       to: 'https://www.essentiallooks.com/',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerHairExpert),
      //       to:
      //         'https://www.schwarzkopf-professional.ca/en/home/products/care/hair-expert.html',
      //     },
      //     // {
      //     //   label: 'ASK Academy',
      //     //   to:
      //     //     'http://www.schwarzkopf-professional.ca/skp/ca/en/home/education/ask.html',
      //     // },
      //   ],
      // },
      // {
      //   label: intl.formatMessage(messages.footerHelp),
      //   links: [
      //     {
      //       label: intl.formatMessage(messages.footerFaq),
      //       to: 'https://myskp-ca.zendesk.com/hc/en-us',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerSupport),
      //       to: 'https://myskp-ca.zendesk.com/hc/en-us/requests/new',
      //     },
      //     {
      //       label: intl.formatMessage(messages.footerContact),
      //       to: 'https://myskp-ca.zendesk.com/hc/en-us/requests/new',
      //     },
      //   ],
      // },
    ];
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx('p', {}, void 0, 'Effective Date: November 14, 2017');

var _ref2 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Introduction'));

var _ref3 = _jsx('p', {}, void 0, 'Thank you for visiting a website, mobile app or other online service(\u201CService\u201D)\xA0that belongs to and is operated by Henkel Corporation or one of its subsidiary or affiliated companies\xA0(\u201CHenkel\u201D, \u201CUs\u201D, \u201CWe\u201D, \u201COur\u201D).');

var _ref4 = _jsx('p', {}, void 0, 'These Terms of Use\xA0(\u201CTerms\u201D) affect your legal rights, responsibilities and obligations and govern your use of the Service, are legally binding, limit Henkel\u2019s liability to you and require you to indemnify us and, in certain jurisdictions, to settle certain disputes through individual arbitration.');

var _ref5 = _jsx('p', {}, void 0, 'If you do not wish to be bound by these Terms and any Additional Terms, do not use the Service and uninstall Service downloads and applications.');

var _ref6 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Additional Terms'));

var _ref7 = _jsx('p', {}, void 0, 'In some instances, additional or different terms, posted on the Service, apply to your use of certain parts of the Service (individually and collectively\xA0\u201CAdditional Terms\u201D).\xA0 To the extent there is a conflict between these Terms and any Additional Terms, these Terms will control unless the Additional Terms expressly state otherwise.');

var _ref8 = _jsx('p', {}, void 0, 'Updates to these Terms and Additional Terms');

var _ref9 = _jsx('p', {}, void 0, 'We may prospectively change these Terms and Additional Terms by posting new or changed terms on the Service as more fully explained [Section 13].');

var _ref10 = _jsx('h2', {}, void 0, 'Full Terms of Use');

var _ref11 = _jsx('br', {});

var _ref12 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Ownership and Operation'));

var _ref13 = _jsx('p', {}, void 0, 'The Service and all of its content (\u201CContent\u201D), including all copyrights, patents, trademarks, service marks, trade names and all other intellectual property rights therein (\u201CIntellectual Property\u201D), are owned or controlled by Henkel, Our licensors, and certain other third parties.\xA0 All right, title, and interest in and to the Content and Intellectual Property available via the Service is the property of Henkel, Our licensors or certain other third parties, and is protected by U.S. and international copyright, trademark, trade dress, patent and/or other intellectual property and unfair competition rights and laws to the fullest extent possible.\xA0 Henkel owns the copyright in the selection, compilation, assembly, arrangement, and enhancement of the Content on the Service.\xA0 Henkel, in its sole discretion without advance notice or liability, may immediately suspend or terminate the availability of the Service and/or content (and any elements and features of them), in whole or in part, for any reason, in Henkel\u2019s sole discretion, and without advance notice or liability.');

var _ref14 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Intended Geographic Scope'));

var _ref15 = _jsx('p', {}, void 0, 'The Service and its Content are controlled from within the United States of America and Canada. Access to the Service from territories where its Content is illegal is prohibited. Those who choose to access the Service from outside the United States and Canada are responsible for compliance with all local laws applicable to them with respect to the Content and operation of the Service. You are responsible for complying with all applicable trade regulations and laws both foreign and domestic.\xA0 Except as authorized by U.S. and Canadian law, you agree and warrant not to export or re-export the software to any county, or to any person, entity, or end-user subject to U.S. and/or Canadian export controls or sanctions.');

var _ref16 = _jsx('p', {}, void 0, 'The brands / products shown on the Service are examples of the brands / products available from companies of Henkel worldwide. Henkel does not warrant that a brand / product shown is also available in your country.');

var _ref17 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Privacy'));

var _ref18 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Limited Permission to Access and Use the Service'));

var _ref19 = _jsx('p', {}, void 0, 'It is Henkel policy to enforce its Intellectual Property rights to the fullest extent of the law, including seeking criminal sanctions. Your right to use the Service and Content is subject to your strict compliance with these Terms and the Additional Terms. Your right to access and use the Service and the Intellectual Property shall automatically terminate upon any violations. These rights are non-exclusive, limited, and revocable by Us at any time in our sole discretion without advance notice or liability. As your right to access and use the Service and the content is personal to you, you may not assign nor transfer your right; any attempt to do so is void. You may, for your personal, non-commercial, lawful use only (collectively, the following are the\xA0\u201CHenkel Licensed Elements\u201D):');

var _ref20 = _jsx('p', {}, void 0, 'Display, view, use, and play the Content on a computer, mobile or other internet enabled or permitted device (\u201CDevice\u201D) and/or print one copy of the Content (excluding source and object code in raw form or otherwise) as it is displayed to you;');

var _ref21 = _jsx('p', {}, void 0, 'Stream the Content using any of the widgets and/or other digital streaming internet video players, if any, provided on the Service;');

var _ref22 = _jsx('p', {}, void 0, 'Subject to any applicable Additional Terms, if the Service includes a \u201CSend to Friend,\u201D social media sharing or similar tool that allows you to initiate and send to one or more of your contacts a communication that includes content, or to post Our content to Third-Party Services or your own site or online service, and the tool is operational, use the tool to do so; provided, however, that you do not do so in any manner that violates applicable law or third-party rights or reflects negativity on Us, and only send to recipients you have permission to contact;');

var _ref23 = _jsx('p', {}, void 0, 'If the Service includes a \u201CDownload\u201D link next to a piece of content (including, without limitation, an image, an icon, a wallpaper, a music track, a video, a trailer, an RSS feed), you may only download a single copy of such content to a single Device;');

var _ref24 = _jsx('p', {}, void 0, 'Download, install and use one copy of any software, including apps, that We make available on or through the Service (\u201CSoftware\u201D) on your Device in machine-executable object code form only and make one additional copy for back-up purposes; provided, however, that you understand and agree that (i) by allowing you to download the Software, Henkel does not transfer title to the Software to you (i.e., you own the medium on which the Software is recorded, but the Software\u2019s owner (which may be Henkel\xA0 and/or its third-party Software licensor) will retain full and complete title to such Software); (ii) you may not copy, modify, adapt, translate into any language, distribute, or create derivative works based on the Software, except as expressly authorized in these Terms or applicable Additional Terms, without the prior written consent of Henkel: (iii) you may not assign, rent, lease, or lend the Software to any person or entity and any attempt by you to sublicense, transfer, or assign the Software will be void and of no effect; and (iv) you may not decompile, disassemble, reverse engineer, or attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques, or algorithms of the Software by any means whatsoever, except to the extent the foregoing restriction is prohibited by applicable law;');

var _ref25 = _jsx('p', {}, void 0, 'If made available to you, obtain a registered personal account (and/or related username and password) on the Service and interact with the Service in connection therewith;');

var _ref26 = _jsx('p', {}, void 0, 'Link to the Service from a website or other online service, so long as: (a) the links only incorporate text, and do not use any Henkel names, logos, or images, (b) the links and the content on your website do not suggest any affiliation with Henkel or cause any other confusion, and (c) the links and the content on your website do not portray Henkel or its products or services in a false, misleading, derogatory, or otherwise offensive manner, and do not contain content that is unlawful, offensive, obscene, lewd, lascivious, filthy, violent, threatening, harassing, or abusive, or that violate any right of any third-party or are otherwise objectionable to Henkel. Henkel reserves the right to suspend or prohibit linking to the Service for any reason, in its sole discretion, without advance notice or any liability of any kind to you or any third-party, and;');

var _ref27 = _jsx('p', {}, void 0, 'Use any other functionality expressly provided by Henkel on or through the Service for use by users, subject to these Terms (including, without limitation, functionality to create and/or post User-Generated Content (as defined below)) and any applicable Additional Terms. Any unauthorized use or abuse of these intellectual property or works is expressly prohibited and constitutes a violation of trademark law, copyright law, other intellectual property rights or unfair competition law.');

var _ref28 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Service and Content Restrictions'));

var _ref29 = _jsx('p', {}, void 0, 'Service Use Restrictions. You agree that you will not: (i) use the Service for any political or commercial purpose (including, without limitation, for purposes of advertising, soliciting funds, collecting product prices, and selling products); (ii) use any meta tags or any other \u201Chidden text\u201D utilizing any Intellectual Property; (iii) engage in any activities through or in connection with the Service that seek to attempt to or do harm any individuals or entities or are unlawful, offensive, obscene, lewd, lascivious, filthy, violent, threatening, harassing, or abusive, or that violate any right of any third-party, or are otherwise objectionable to Henkel; (iv) decompile, disassemble, reverse engineer, or attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques, or algorithms of the Service by any means whatsoever or modify any Service source or object code or any Software or other products, services, or processes accessible through any portion of the Service; (v) engage in any activity that interferes with a user\u2019s access to the Service or the proper operation of the Service, or otherwise causes harm to the Service, Henkel, or other users of the Service; (vi) interfere with or circumvent any security feature (including any digital rights management mechanism, device or other content protection or access control measure) of the Service or any feature that restricts or enforces limitations on use of or access to the Service, the Content, or the UGC; (vii) harvest or otherwise collect or store any information (including personally identifiable information about other users of the Service, including email addresses, without the express consent of such users); (viii) attempt to gain unauthorized access to the Service, other computer systems or networks connected to the Service, through password mining or any other means; or (ix) otherwise violate these Terms or any applicable Additional Terms.');

var _ref30 = _jsx('p', {}, void 0, 'Content Use Restrictions. You also agree that, in using the Service, you: (i) will not monitor, gather, copy, or distribute the Content (except as may be a result of standard search engine activity or use of a standard browser) on the Service by using any robot, rover, \u201Cbot\u201D, spider, scraper, crawler, spyware, engine, device, software, extraction tool, or any other automatic device, utility, or manual process of any kind; (ii) will not frame or utilize framing techniques to enclose any such content (including any images, text, or page layout); (iii) will keep intact all trademark, copyright, and other Intellectual Property and other notices contained in such content; (iv) will not use such content in a manner that suggests an unauthorized association with any of Our or Our licensors\u2019 products, services, or brands; (v) will not make any modifications to such content (other than to the extent of your specifically permitted by Us, if applicable); (vi) will not copy, modify, reproduce, archive, sell, lease, rent, exchange, create derivative works from, publish by hard copy or electronic means, publicly perform, display, disseminate, distribute, broadcast, retransmit, circulate or transfer to any third-party or on any third-party application or website, or otherwise use or exploit such content in any way for any purpose except as specifically permitted by these Terms or any applicable Additional Terms or with the prior written consent of an officer of Henkel or, in the case of content from a licensor, the owner of the content; and (vii) will not insert any code or product to manipulate such content in any way that adversely affects any user experience or the Service.');

var _ref31 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'User-Generated Content'));

var _ref32 = _jsx('p', {}, void 0, 'General. Henkel may now, or in the future, offer users of the Service the opportunity to create, build, post, upload, display, publish, distribute, transmit, broadcast, or otherwise make available on or submit through the Service, or on or in response to Our pages or posts on any third-party platforms or in connection with any of Our promotions by any media or manner, or otherwise submit to Us (e.g., on Our Facebook or other social media pages, in response to Our tweets, through a sweepstakes or contest, or by otherwise sending it to Us) (collectively,\xA0\u201Csubmit\u201D) messages, text, illustrations, files, images, graphics, photos, comments, responses, sounds, music, videos, information, content, ratings, reviews, data, questions, suggestions, personally identifiable information, or other information or materials and the ideas contained therein (collectively, but excluding Henkel Licensed Elements included therein, \u201CUser-Generated Content\u201D or \u201CUGC\u201D).\xA0 You may submit UGC through your profile, forums, blogs, message boards, social networking environments, content creation and posting tools, gameplay, social communities, contact Us tools, email, and other communications functionality.\xA0 Except to the extent of the rights and license you grant in these Terms and, subject to any applicable Additional Terms, you retain whatever legally cognizable right, title, and interest that you have in your UGC.');

var _ref33 = _jsx('strong', {}, void 0, '!Syntax Error, ^');

var _ref34 = _jsx('p', {}, void 0, 'In your communications with Henkel, please keep in mind that We do not seek any unsolicited ideas or materials for products or services, or even suggested improvements to products or services, including, without limitation, ideas, concepts, inventions, or designs for music, websites, apps, books, scripts, screenplays, motion pictures, television shows, theatrical productions, software or otherwise (collectively,\xA0\u201CUnsolicited Ideas and Materials\u201D).\xA0 Any Unsolicited Ideas and Materials you submit are deemed UGC and licensed to Us as set forth below.\xA0 In addition, Henkel retains all of the rights held by members of the general public with regard to your Unsolicited Ideas and Materials. Henkel\u2019s receipt of your Unsolicited Ideas and Materials is not an admission by Henkel of their novelty, priority, or originality, and it does not impair Henkel\u2019s right to contest existing or future intellectual property rights relating to your Unsolicited Ideas and Materials.');

var _ref35 = _jsx('p', {}, void 0, 'Representations and Warranties Related to Your UGC. Each time you submit any UGC, you represent and warrant that you are at least the age of majority in the jurisdiction in which you reside and are the parent or legal guardian, or have all proper consents from the parent or legal guardian, of any minor who is depicted in or contributed to any UGC you submit, and that, as to that UGC, (a) you are the sole author and owner of the intellectual property and other rights to the UGC, or you have a lawful right to submit the UGC and grant Henkel the rights to it that you are granting by these Terms and any applicable Additional Terms, all without any Henkel obligation to obtain consent of any third-party and without creating any obligation or liability of Henkel (b) the UGC is accurate; (c) the UGC does not and, as to Henkel\u2019s permitted uses and exploitation set forth in these Terms, will not, infringe any intellectual property or other right of any third-party or any applicable law or regulation; and (d) the UGC will not violate these Terms or any applicable Additional Terms, or cause injury or harm to any person.');

var _ref36 = _jsx('p', {}, void 0, 'Enforcement.\xA0\xA0Henkel has no obligation to monitor or enforce your Intellectual Property rights to your UGC, but you grant Us the right to protect and enforce Our rights to your UGC, including initiating actions in your name and on your behalf (at Henkel\u2019s cost and expense, to which you hereby consent and irrevocably appoint Henkel as your attorney-in-fact, with the power of substitution and delegation, which appointment is coupled with an interest).');

var _ref37 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'DMCA Copyright Policy and Copyright Agent'));

var _ref38 = _jsx('p', {}, void 0, 'Henkel respects the Intellectual Property rights of others and expects users of its Service to do the same.\xA0 Henkel may remove content that in its sole discretion appears to infringe the Intellectual Property rights of others.\xA0 In addition, Henkel, in its sole and absolute discretion, may terminate the accounts of users who infringe the Intellectual Property rights of others.');

var _ref39 = _jsx('p', {}, void 0, 'If you believe that a user of the Service has infringed your copyright rights, please notify Henkel\u2019s Copyright Agent (contact information below) and provide the following information: (a) a physical or electronic signature of the person authorized to act on behalf of the owner of the copyright right; (b) an identification of the copyright protected property claimed to have been infringed; (c) a detailed description of the material that you claim is infringing, so that We may locate it, including the URL where the infringing material appears; (d) your address, telephone number, and email address; (e) a statement by you that you have a good faith belief that the allegedly infringing use is not authorized by the copyright owner, its agent, or the law; and (f) a statement by you, made under penalty of perjury, that the foregoing information is accurate and that you are authorized to act on behalf of the owner of the copyright(s) involved.');

var _ref40 = _jsx('br', {});

var _ref41 = _jsx('br', {});

var _ref42 = _jsx('br', {});

var _ref43 = _jsx('br', {});

var _ref44 = _jsx('br', {});

var _ref45 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Links and Third-Party Services'));

var _ref46 = _jsx('p', {}, void 0, 'We are not responsible for third parties or their content, advertisement(s), apps or sites (\u201CThird-Party Services\u201D).\xA0 For instance, portions of the Service may be integrated into or linked to third-party sites, platforms and apps that We do not control. Similarly, We may make ads and third-party content or services, which We also may not control, available to you on or via Our Service.\xA0 This may include the ability to register or sign in to Our Services using Facebook Connect or other third-party tools, and to post content on third-party sites and services using their plug-ins made available on Our Services.\xA0 Use caution when dealing with third parties and consult their terms of use and privacy policies.\xA0 We take no responsibility for Third-Party Services. In addition, while Henkel may provide you with a link to a third party web site, it is understood that Henkel does not endorse, approve, sponsor or support such sites.');

var _ref47 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Disclaimer of Warranties'));

var _ref48 = _jsx('p', {}, void 0, 'We strive to accurately describe Our products or services offered on the Service; however, We do not warrant that such specifications, pricing, or other content on the Service is complete, accurate, reliable, current, or error-free and products may not be available in all areas.\xA0 For online orders, if available, Additional Terms apply.');

var _ref49 = _jsx('p', {}, void 0, 'AS PERMITTED BY APPLICABLE LAW, THE MATERIALS AND INFORMATION ON THE SERVICE, AND ANY MATERIALS MADE AVAILABLE THROUGH THE SERVICE, ARE PROVIDED \u201CAS IS\u201D, \u201CAS AVAILABLE\u201D, AND \u201CWITH ALL FAULTS\u201D BASIS AND WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, HENKEL AND ITS DIRECT AND INDIRECT PARENTS, SUBSIDIARIES, AFFILIATES, AND EACH OF THEIR RESPECTIVE EMPLOYEES, DIRECTORS, MEMBERS, MANAGERS, SHAREHOLDERS, AGENTS, VENDORS, LICENSORS, LICENSEES, CONTRACTORS, CUSTOMERS, SUCCESSORS, AND ASSIGNS\xA0(COLLECTIVELY, \u201CHENKEL PARTIES\u201D) DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.');

var _ref50 = _jsx('p', {}, void 0, 'AS PERMITTED BY APPLICABLE LAW, HENKEL PARTIES DISCLAIM ALL LIABILITY AND ASSUME NO RESPONSIBILITY FOR THE RESULTS OF ANY DEFECTS OR INACCURACIES THAT MAY EXIST IN THE SERVICE OR FROM ITS OPERATION. HENKEL MAKES NO WARRANTY THAT\xA0(I) THE OPERATION OF THE SERVICE WILL MEET THE USER\xB4S REQUIREMENTS;\xA0(II) ACCESS TO THE SERVICE WILL BE UNINTERRUPTED, TIMELY, SECURE, FREE OF VIRUSES, WORMS, TROJAN HORSES OR OTHER HARMFUL COMPONENTS, OR BE FREE OF DEFECTS OR ERRORS;\xA0(III) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE WILL BE ACCURATE OR RELIABLE; OR\xA0(IV) DEFECTS WILL BE CORRECTED. YOU\xA0(AND NOT HENKEL) ASSUME THE ENTIRE COST OF ALL SERVICING, REPAIR, OR CORRECTION THAT MAY BE NECESSARY FOR YOUR COMPUTER EQUIPMENT AND SOFTWARE AS A RESULT OF ANY VIRUSES, ERRORS OR ANY OTHER PROBLEMS WHATSOEVER YOU MAY HAVE AS A RESULT OF VISITING THE SERVICE.');

var _ref51 = _jsx('p', {}, void 0, 'NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR LIMIT\xA0(I) ANY EXPRESS, WRITTEN PRODUCT WARRANTY OR RELATED DISCLAIMERS THAT ARE PROVIDED BY HENKEL OR ITS SUPPLIERS WITH REGARD TO A PHYSICAL PRODUCT SOLD BY HENKEL, OR ANY WARRANTY ON A PHYSICAL PRODUCT TO THE EXTENT REQUIRED BY APPLICABLE LAW;\xA0(II) HENKEL PARTIES\u2019 LIABILITY\xA0 FOR PERSONAL INJURY TO YOU CAUSED BY HENKEL PARTIES TO THE EXTENT NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW; OR\xA0(III) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST HENKEL PARTIES THAT IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW.');

var _ref52 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Limitation of Liability'));

var _ref53 = _jsx('p', {}, void 0, 'AS PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES, WHETHER DUE TO NEGLIGENCE OR OTHERWISE, SHALL HENKEL PARTIES BE LIABLE FOR ANY DAMAGES OR INJURY, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR OTHER DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF DATA OR PROFIT, THAT MAY RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE SERVICE OR ANY MATERIALS IN THE SERVICE, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THE SERVICE OR INFORMATION AVAILABLE IN THE SERVICE.\xA0 THESE INCLUDE, BUT ARE NOT LIMITED TO, DAMAGES OR INJURY CAUSED BY ERROR, OMISSION, INTERRUPTION, DEFECT, FAILURE OF PERFORMANCE, DELAY IN OPERATION OR TRANSMISSION, LINE FAILURE OR COMPUTER VIRUS, WORM, TROJAN HORSE OR OTHER HARMFUL COMPONENT. INCLUDING FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. AS PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL A HENKEL PARTIES\u2019 TOTAL LIABILITY TO YOU FOR DAMAGES, LOSSES, AND/OR CAUSES OF ACTION ARISING OUT OF THE SERVICE EXCEED THE GREATER OF ONE HUNDRED DOLLARS\xA0($100), OR THE AMOUNT YOU HAVE PAID HENKEL IN CONNECTION WITH A PRODUCT OR SERVICE UNDERLYING THE CLAIM, AND ANY CLAIM OR CAUSE OF ACTION YOU MAY HAVE WITH RESPECT TO THE SERVICE\xA0(INCLUDING BUT NOT LIMITED TO THE PURCHASE OF HENKEL PRODUCTS) MUST BE COMMENCED WITHIN ONE\xA0(1) YEAR AFTER THE CLAIM OR CAUSE OF ACTION ARISES.');

var _ref54 = _jsx('p', {}, void 0, 'NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR LIMIT\xA0(I) ANY EXPRESS, WRITTEN PRODUCT WARRANTY OR RELATED DISCLAIMERS THAT ARE PROVIDED BY HENKEL OR ITS SUPPLIERS WITH REGARD TO A PHYSICAL PRODUCT SOLD BY HENKEL TO YOU, OR ANY WARRANTY ON A PHYSICAL PRODUCT TO THE EXTENT REQUIRED BY APPLICABLE LAW;\xA0(II) HENKEL PARTIES\u2019 LIABILITY FOR PERSONAL INJURY TO YOU CAUSED BY HENKEL PARTIES TO THE EXTENT NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW; OR\xA0(III) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST HENKEL PARTIES THAT IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW.');

var _ref55 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Arbitration and Dispute Terms'));

var _ref56 = _jsx('p', {}, void 0, 'Forum Selection/Jurisdiction.\xA0 For users for are not individual residents of the province of Quebec, Jurisdiction and venue for any controversy, allegation, or claim arising out of or relating to the Service, the Content, your UGC, these Terms, or any applicable Additional Terms, (collectively,\xA0\u201CDispute\u201D) shall be in Wilmington, Delaware. Each party submits to personal jurisdiction and venue in Wilmington, Delaware for any and all purposes.');

var _ref57 = _jsx('p', {}, void 0, 'Pre-Arbitration Notification. Henkel and you agree that it would be advantageous to discuss and hopefully resolve any Disputes before formal proceedings are initiated; provided, however, that Henkel need not do so in circumstances where its claims of Intellectual Property rights are concerned (\u201CIP Disputes,\u201D\xA0with all other disputes referred to as\xA0\u201CGeneral Disputes\u201D). The party making a claim \u2013 whether you or Henkel \u2013 shall send a letter to the other side briefly summarizing the claim and the request for relief. If Henkel is making a claim, the letter shall be sent, via email, to the email address listed in your Henkel account, if applicable. If no such information exists or if such information is not current, then We have no notification or delay obligations under this Section 11(b). If you are making a claim, the letter shall be sent to Henkel Corporation, One Henkel Way, Rocky Hill, CT 06067 (Attn: General Counsel). If the Dispute is not resolved within sixty (60) days after notification, the claimant may proceed to initiate proceedings as set forth in this Section 11, or permitted by the applicable law. Either you or Henkel however, may seek provisional remedies (such as preliminary injunctive relief, subject to Section 11(d)) before the expiration of this sixty (60)-day period.');

var _ref58 = _jsx('p', {}, void 0, 'Limitation on Injunctive Relief. AS PERMITTED BY APPLICABLE LAW, IF YOU CLAIM THAT YOU HAVE INCURRED ANY LOSS, DAMAGES, OR INJURIES IN CONNECTION WITH YOUR USE OF THE SERVICE, THEN THE LOSSES, DAMAGES, AND INJURIES WILL NOT BE DEEMED IRREPARABLE OR SUFFICIENT TO ENTITLE YOU TO AN INJUNCTION OR TO OTHER EQUITABLE RELIEF OF ANY KIND.\xA0 THIS MEANS\xA0(WITHOUT LIMITATION) THAT, IN CONNECTION WITH YOUR CLAIM, YOU AGREE THAT YOU WILL NOT SEEK, AND THAT YOU WILL NOT BE PERMITTED TO OBTAIN, ANY COURT OR OTHER ACTION THAT MAY INTERFERE WITH OR PREVENT THE DEVELOPMENT OR EXPLOITATION OF THE SERVICE, OR ANY ASPECT THEREOF, OR INTELLECTUAL PROPERTY OWNED, LICENSED, USED, OR CONTROLLED BY ANY HENKEL PARTY\xA0(INCLUDING YOUR LICENSED UGC) OR A LICENSOR OF ANY HENKEL PARTY.');

var _ref59 = _jsx('p', {}, void 0, 'Governing Law.\xA0For users for are not individual residents of the province of Quebec, these Terms and any applicable Additional Terms, General Disputes and IP Disputes, and any other claim brought by you against Henkel or by Henkel against you pursuant to this Section 11, or otherwise related to the Service, Content, Henkel Licensed Elements, UGC or other Henkel products or services, will be governed by, construed, and resolved in accordance with, the laws of the State of Delaware, U.S.A., without regard to its conflicts of law provisions that might apply the laws of another jurisdiction.\xA0 This Section 11 shall be governed solely by the Federal Arbitration Act, 9 U.S.C. \xA71, et seq., and not by the law of any state, and is enforceable pursuant to its terms on a self-executing basis. You and Henkel agree that We intend that this Section 11 satisfies the \u201Cwriting\u201D requirement of the Federal Arbitration Act.\xA0 This Section 11 can only be amended by mutual agreement.\xA0 Either party may seek enforcement of this Section 11 in any court of competent jurisdiction. The arbitrator shall determine any and all challenges to the arbitrability of a claim.');

var _ref60 = _jsx('p', {}, void 0, 'Class Action Waiver. As permitted by applicable law, and for users who are not individual residents of the province of Quebec, both you and Henkel waive the right to bring any Dispute as a class, consolidated, representative, collective, or private attorney general action, or to participate in a class, consolidated, representative, collective, or private attorney general action regarding any Dispute brought by anyone else. Notwithstanding any provision in the JAMS Comprehensive Arbitration Rules and Procedures to the contrary, the arbitrator shall not have the authority or any jurisdiction to hear the arbitration as a class, consolidated, representative, or private attorney general action or to consolidate, join, or otherwise combine the Disputes of different persons into one proceeding. Notwithstanding the arbitration provision set forth above, if the provision regarding waiver of class, collective, representative, and private attorney general claims of this Section 11 is found to be void or otherwise unenforceable, any such class, collective, representative, or private attorney general claims must be heard and determined through an appropriate court proceeding, and not in arbitration.');

var _ref61 = _jsx('p', {}, void 0, 'Jury Waiver. AS PERMITTED BY APPLICABLE LAW, THE PARTIES HEREBY WAIVE THEIR RIGHT TO JURY TRIAL WITH RESPECT TO ALL CLAIMS AND ISSUES ARISING UNDER, IN CONNECTION WITH, TOUCHING UPON OR RELATING TO THESE TERMS, THE BREACH THEREOF AND/OR THE SCOPE OF THE PROVISIONS OF THIS SECTION, WHETHER SOUNDING IN CONTRACT OR TORT, AND INCLUDING ANY CLAIM FOR FRAUDULENT INDUCEMENT THEREOF.');

var _ref62 = _jsx('p', {}, void 0, 'Small Claims Matters.\xA0\xA0Notwithstanding the foregoing, either of us may bring qualifying claim of General Dispute (but not IP Disputes) in small claims court, subject to Section 11(f).');

var _ref63 = _jsx('p', {}, void 0, 'Supersede.\xA0The provisions of this Section 11 shall supersede any inconsistent provisions of any prior agreement between the parties. This Section 11 shall remain in full force and effect notwithstanding any termination of your use of the Service or these Terms.');

var _ref64 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Downloaded Software'));

var _ref65 = _jsx('p', {}, void 0, 'If you download software from the Service, the software and all files, images and data relating to the software is subject to the license terms in the software license that accompanies or is provided with the software. You may only use the software pursuant to the terms of such software license. You do not own the downloaded software, and Henkel does not transfer ownership of the software to you. You may not redistribute, sell, decompile, reverse engineer, disassemble, or otherwise reduce the software to a human-perceivable form.');

var _ref66 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Update to Terms'));

var _ref67 = _jsx('p', {}, void 0, 'It is your responsibility to review the posted Terms and any applicable Additional Terms each time you use this\xA0\xA0SERVICE YOU ARE ENTERING INTO A NEW AGREEMENT WITH US ON THE THEN APPLICABLE TERMS AND CONDITIONS AND YOU AGREE THAT WE MAY NOTIFY YOU OF NEW TERMS BY POSTING THEM ON THE SERVICE\xA0(OR IN ANY OTHER REASONABLE MANNER OF NOTICE WHICH WE ELECT), AND THAT YOUR USE OF THE SERVICE AFTER SUCH NOTICE CONSTITUTES YOUR GOING FORWARD AGREEMENT TO THE NEW TERMS FOR YOUR NEW USE AND TRANSACTIONS.\xA0Any new Terms or Additional Terms will be effective as to new use and transactions as of the time that We post them, or such later date as may be specified in them or in other notice to you. In the event any notice to you of new, revised, or additional terms is determined by a tribunal to be insufficient, the prior agreement shall continue until sufficient notice to establish a new agreement occurs. You can reject any new, revised or additional terms by discontinuing use of the Service.');

var _ref68 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Forward-looking Statements'));

var _ref69 = _jsx('p', {}, void 0, 'The Service may contain statements that involve Henkel\xB4s intentions, expectations or predictions. Such statements reflect the views of Henkel as of the date made with respect to future events and are subject to risks and uncertainties. These statements could be inaccurate or could become inaccurate as a result of developments occurring after their respective dates. Henkel disclaims any intention or obligation to update or revise these statements.');

var _ref70 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Severability/No Waiver, Entire Agreement'));

var _ref71 = _jsx('p', {}, void 0, 'If any provision of these Terms shall be found to be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from these Terms and shall not affect the validity and enforceability of any remaining provisions. No failure on the part of Henkel to enforce these Terms shall constitute a waiver of any of Henkel\xB4s rights under these Terms, whether for past or future actions on the part of any person. These Terms shall be the entire agreement between Henkel and you with respect to the subject matter hereto, and supersede all prior or contemporaneous understandings regarding such subject matter. No amendment to or modification of this Terms will be binding unless provided as an update by Henkel to this document, or signed in writing by an authorized officer of\xA0Henkel.');

var _ref72 = _jsx('h2', {}, void 0, 'Privacy Statement');

var _ref73 = _jsx('br', {});

var _ref74 = _jsx('p', {}, void 0, 'Thank you for visiting a website, mobile app or other online service\xA0(\u201CService\u201D) that belongs to Us and is operated by Henkel Corporation or one of its subsidiary or affiliated companies\xA0(\u201CHenkel\u201D, \u201CUs\u201D, \u201CWe\u201D, \u201COur\u201D).\xA0 This Privacy Statement outlines the information Henkel may be collecting and how We use and protect that information.');

var _ref75 = _jsx('p', {}, void 0, _jsx('i', {}, void 0, 'Effective as of:\xA0\xA0November 14, 2017'));

var _ref76 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Scope'));

var _ref77 = _jsx('p', {}, void 0, 'This Privacy Statement applies to your use of any Service\xA0(e.g., website, mobile app or internet-connected product) that posts a link to, or otherwise provides notice of the applicability of, this Privacy Statement, regardless of how you access or use it. It does not apply to information We obtain in Our capacity as an employer except with respect to employment applications and inquiries received via the Service. This Privacy Statement applies to Our collection, use and disclosure of information about you through the Service and does not apply to Our activities off of the Service or third party websites accessible via hyperlinks found on a Henkel Service.');

var _ref78 = _jsx('p', {}, void 0, 'For certain aspects of the Service, there may be additional notices about information practices and choices. Please read those additional privacy disclosures to understand how they apply to you.');

var _ref79 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Revisions'));

var _ref80 = _jsx('p', {}, void 0, 'Henkel reserves the right to change this Privacy Statement prospectively effective upon the posting of the revised Privacy Statement and your use of the Service indicates your consent to the privacy statement posted at the time of use.\xA0 However, We will not use your previously collected Henkel-Collected PI\xA0(defined below), to the extent it is not collected under the new privacy statement, in a manner materially different than represented at the time it was collected without your consent. To the extent any provision of this Privacy Statement is found by a competent tribunal to be invalid or unenforceable, such provision shall be severed to the extent necessary for the remainder to be valid and enforceable.');

var _ref81 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information Collected'));

var _ref82 = _jsx('p', {}, void 0, 'You can visit Our Service without telling Us who you are or revealing personal information about yourself, however, doing so may render certain Henkel service\u2019s unavailable to you. You may, however, choose to provide (\u201CPersonal Information\u201D) (defined as information that identifies you personally, such as your first and last name, e-mail address, phone number, address, and full payment account number).');

var _ref83 = _jsx('p', {}, void 0, 'The types of information that Henkel may collect about you include, but are not limited to:');

var _ref84 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Contact information\xA0(such as name, address, city, state, province/territory, Postal/ZIP code, email address and telephone number).'));

var _ref85 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Product preferences.'));

var _ref86 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\u201CDemographic information\u201D such as age range, gender, date of birth, marital status, Postal/ZIP code, and household composition). Except to the extent required by applicable law, Demographic Information is\xA0\u201Cnon-Personal Information\u201D\xA0(i.e., data that is not Personal Information under this Privacy Statement).'));

var _ref87 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\u201CUsage Information\u201D such as IP address, device identifier, browser type, operating system, information about your use of the Service, and data regarding network connected hardware (e.g., computer or mobile device). Except to the extent required by applicable law, or to the extent Usage Information is combined by or on behalf of Henkel with Personal Information, Henkel does not consider Usage Information (including, without limitation, unique device identifiers) to be Personal Information or Henkel-Collected PI.'));

var _ref88 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Social Security Number (\u201CSSN\u201D)(in limited circumstances Henkel may collect SSN, for example if you win a sweepstakes or receive compensation that must be reported for government tax purposes).'));

var _ref89 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Photographs and videos\xA0(e.g., that are submitted by customers via websites such as part of contests or sweepstakes).'));

var _ref90 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Employment application information\xA0(such as SSN, Driver\u2019s license, financial information, background screening, and gender or race [as permitted by law]).'));

var _ref91 = _jsx('p', {}, void 0, 'If you choose to participate in the Service activities such as website registrations, contests, sweepstakes, questionnaires, surveys, consumer service contacts, product purchases, mobile applications, social media platforms, or through Our Career Center or employment inquiries, Henkel will collect the Personal Information that you provide (\u201CHenkel-Collected PI\u201D). We may enhance or merge the information that you provide to Us directly with information from other sources, including third parties for the purposes described below. To the extent any information is combined by or on behalf of Henkel with Henkel-Collected-PI, Henkel will treat the combined data as Henkel-Collected PI under this Privacy Statement.');

var _ref92 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information Use'));

var _ref93 = _jsx('p', {}, void 0, 'We collect, maintain and use your Henkel-Collected-PI, other Personal Information, and other information, for purposes not inconsistent with this Privacy Statement or any written statements We make at the time of collection, such as for:');

var _ref94 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'establishing and verifying the identity and eligibility of users;'));

var _ref95 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'opening, maintaining, administering and servicing users profiles, accounts or memberships;'));

var _ref96 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'processing, servicing or enforcing transactions and sending related communications;'));

var _ref97 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'providing products, services and support to users;'));

var _ref98 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'conducting sweepstakes, surveys and contests, and providing the results thereof;'));

var _ref99 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'operating and improving the Service, including tailoring it to users\u2018 preferences;'));

var _ref100 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'providing users with product or service updates;'));

var _ref101 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'sending promotional notices, offers or other targeted marketing, and other information;'));

var _ref102 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'responding to your questions, inquiries, comments and instructions;'));

var _ref103 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'maintaining the security and integrity of Our systems;'));

var _ref104 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'understanding consumer preferences across multiple brands;'));

var _ref105 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'maintaining customer relationships;'));

var _ref106 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'evaluating product performance and safety;'));

var _ref107 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'complying with policies, procedures and legal requirements; and'));

var _ref108 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'improving or products and services and Our other business purposes.'));

var _ref109 = _jsx('br', {});

var _ref110 = _jsx('p', {}, void 0, 'Information that you provide when applying for a job or an internship via Our Careers Center is used to provide you with information about employment opportunities, to administer the application process and consider you for employment. Where applicable, in conjunction with laws and regulations enforced by the Equal Employment Opportunity Commission (\u201CEEOC\u201D), the Office of Federal Contract Compliance Programs (\u201COFCCP\u201D) and similar state and local regulatory agencies, We may ask you to provide Us with self-identifying information (such as veteran status, gender and ethnicity). Providing such self-identifying information is voluntary, but if you do provide Us with such information, We may submit that information, to the EEOC, the OFCCP and similar state and local regulatory agencies or otherwise use or disclose it for business-related purposes, including, without limitation, responding to information requests, fulfilling regulatory reporting requirements and defending against employment related complaints.');

var _ref111 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information You Disclose Publicly or to Others'));

var _ref112 = _jsx('p', {}, void 0, 'Additionally, the Service may offer you the option to send a communication to a friend or other contact. If so, Henkel relies on you to only send to people that have given you permission to do so. The recipient\u2019s Personal Information you provide (e.g., name, e-mail address) will be used to facilitate the communication, but not used by Henkel for any other marketing purpose unless Henkel obtains consent from that person. Your full name, contact information and message may be included in the communication.\xA0 For residents of Canada, you may only provide us with the contact information of friends with whom you have had direct voluntary two way communications, and with whom it is reasonable to conclude you have a personal relationship considering shared interests, experiences, opinions and other relevant factors. You may only provide email addresses of family members to whom you are related by marriage, a common-law partnership, or parent-child relationship, and with whom you have had direct voluntary two way communications.');

var _ref113 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Technology Logging, Cookies, and Related Techniques'));

var _ref114 = _jsx('p', {}, void 0, 'When you interact with Our Service, your browser or device may communicate with the technology that We use as part of Our Service. For example, as you use Our Service, your browser communicates with Our technology, which in turn keeps records of your interactivity and requests for services and content to assist Us in managing and improving the utility of Our Service, and to conduct research and analysis on its use. The types of such Usage Information may include your Internet Protocol (IP) address, browser type, URL, requests made, pages visited, activities conducted on the page, day and time of visit and related technical usage information.');

var _ref115 = _jsx('p', {}, void 0, 'Cookies and other tracking technologies now and hereafter developed (\u201CTracking Technologies\u201D) may be used to collect information about interactions with the Service or e-mails, including information about your browsing and purchasing behavior, to authenticate you to the Service, to analyze how the Service is used, to link information about how you use the Service with your account, and to help tailor Our services. We use these technical means and so do Our Affiliates, business partners, and Service Providers. To help Us measure Service activity and provide a better user experience, We may allow Our Service Providers or business partners to compile information such as that identified above from Tracking Technologies. We may also allow Our third party advertising and personalization partners to collect and use this information to develop personalized content and appropriate advertising (including for companies not affiliated with Us) based on your visits over time on Henkel and non-Henkel websites, apps and other online services. You may see these advertisements on other websites, apps and online services. This information may also be used to evaluate Our and third party online advertising campaigns or to tailor promotions and other marketing messages to you on Our Service and other websites apps and online services.');

var _ref116 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Data Sharing and Storage'));

var _ref117 = _jsx('p', {}, void 0, 'Henkel may disclose your information to third parties to the extent not inconsistent with this Privacy Statement or other written statements made by Us at the time of collection, and not prohibited by applicable law, including without limitation as follows:');

var _ref118 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Henkel\u2019s agents, vendors, consultants, and other service providers (collectively\xA0\u201CService Providers\u201D) may receive, or be given access to your information, including, without limitation, Henkel-Collected-PI and other Personal Information, Demographic Information, and Usage Information, in connection with their work on Henkel\u2019s behalf, provided however, Henkel does not authorize its Service Providers to use Henkel-Collected-PI to send you direct marketing messages other than related to Henkel and Henkel Affiliates absent your consent. For more information on choices Service Providers may offer you see Section 11.'));

var _ref119 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'We reserve the right to release your Henkel-Collected-PI and other Personal Information if required to do so by law, search warrant, subpoena, court order or upon request of government authorities.'));

var _ref120 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'We may provide your Henkel-Collected-PI and other Personal Information, and other information, to third parties in connection with the reorganization, merger, sale, joint venture, assignment, transfer, or other disposition of all or any portion of Our business, assets, or stock, including any such activities associated with a bankruptcy or similar proceeding.'));

var _ref121 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Henkel may share your Personal Information with its affiliated companies and subsidiaries (\u201CAffiliates\u201D), and other third parties, some of which may be located outside of the United States, for marketing and other business activities, subject to certain rights of residents of California and Connecticut\xA0 [see Section 12].'));

var _ref122 = _jsx('br', {});

var _ref123 = _jsx('p', {}, void 0, 'Your Personal Information may be stored for a reasonable amount of time in Henkel databases, some of which are located outside of the United States and Canada, and will be automatically transferred to these databases for storage and maintenance. The Service is based in the U.S., intended for residents of the U.S. and Canada and for persons outside Canada, the information Henkel and its Service Providers collect via the Service is governed by U.S. law. If you are accessing the Service from outside of the U.S., please be aware that information collected through the Service may be transferred to, processed, stored, and used in the U.S. Data protection laws in the U.S. may be different from those of your country of residence and provide a lower level of consumer protection, and information transferred to the U.S. may be accessed by U.S. governments and law enforcement in accordance with U.S. laws. Your use of the Service, or provision of any information via the Service, therefore constitutes your consent to the transfer to and from, processing, usage, sharing, and storage of your information, including Personal Information, in the U.S. as set forth in this Privacy Statement.');

var _ref124 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Third-Party Content, Third-Party Services, Social Features, Advertising and Analytics'));

var _ref125 = _jsx('p', {}, void 0, 'The Service may include hyperlinks to, or include on or in connection with, the Service (e.g., apps and plug-ins), websites, locations, platforms, applications or services operated by third parties (\u201CThird-Party Service(s)\u201D). These Third-Party Services may use their own cookies, web beacons, and other Tracking Technologies to independently collect information about you and may solicit Personal Information from you.\xA0 Henkel is not responsible for the privacy practices or the content of the Third-Party Services. Please note that the privacy statements applicable to such Third-Party Services may differ significantly from the Henkel Privacy Statement, so We advise you to read them carefully before using those services. You agree that Henkel shall not be held liable for any actions by or content of such Third-Party Services.');

var _ref126 = _jsx('p', {}, void 0, 'Certain functionalities on the Service permit interactions that you initiate between the Service and certain Third-Party Services, such as third party social networks (\u201CSocial Features\u201D).\xA0 Examples of Social Features include: enabling you to send content such as contacts and photos between the Service and a Third-Party Service; \u201Cliking\u201D or \u201Csharing\u201D Henkel\u2019s content; logging in to the Service using your Third-Party Service account (e.g., using Facebook Connect to sign-in to the Service); and to otherwise connect the Service to a Third-Party Service (e.g., to pull or push information to or from the Service). If you use Social Features, and potentially other Third-Party Services, information you post or provide access to may be publicly displayed on the Service (see\xA0Section 5)\xA0or by the Third-Party Service that you use. Similarly, if you post information on a third-party service that references the Service (e.g., by using a hashtag associated with Henkel or other Henkel Affiliates in a tweet or status update), you agree that your post may be used on or in connection with the Service or otherwise by Henkel or other Henkel Affiliates. Also, both Henkel and the third party may have access to certain information about you and your use of the Service and any Third-Party Service.');

var _ref127 = _jsx('p', {}, void 0, 'Henkel may engage and work with Service Providers and other third parties to serve advertisements on the Service and/or on third-party services.\xA0 Some of these ads may be tailored to your interest based on your browsing of the Service and elsewhere on the internet, sometimes referred to as \u201Cinterest-based advertising\u201D and \u201Conline behavioral advertising\u201D (\u201CInterest-based Advertising\u201D), which may include sending you an ad on a Third-Party Service after you have left the Service (i.e., \u201Cretargeting\u201D).\xA0 As an example, the Service may employ a \u201CDoubleClick id-Cookie,\u201D which may assign a pseudonymized identifier to, among other things, track DoubleClick advertising. DoubleClick is a service provided by Google.\xA0For information on your ability to opt-out of Interest-based Advertising see section 11 below.');

var _ref128 = _jsx('p', {}, void 0, 'Henkel may use Google Analytics, Adobe Analytics or other Service Providers for analytics services.\xA0 These analytics services may use cookies and other Tracking Technologies to help Henkel analyze Service users and how they use the Service.\xA0 Information generated by these services (e.g., your IP address and other Usage Information) may be transmitted to and stored by these Service Providers on servers in the U.S. (or elsewhere) and these Service Providers may use this information for purposes such as evaluating your use of the Service, compiling statistic reports on the Service\u2019s activity, and providing other services relating to Service activity and other Internet usage.');

var _ref129 = _jsx('p', {}, void 0, 'Except to the extent We combine information We receive from Service Providers, Third-Party Services, or other third parties with Henkel-Collected PI, in which case Henkel will treat the combined information as Henkel-Collected PI under this Privacy Statement, data obtained by Henkel from a third party, even in association with the Service, is not subject to Henkel\u2019s limitations regarding Henkel-Collected PI under this Privacy Statement, however such data remains subject to any restrictions imposed on Henkel by the third party, if any.\xA0 Otherwise, the information collected, stored, and shared by third parties remains subject to their privacy policies and practices, including whether they continue to share information with Henkel, the types of information shared, and your choices on what is visible to others on Third-Party Services.');

var _ref130 = _jsx('br', {});

var _ref131 = _jsx('p', {}, void 0, 'Henkel is not responsible for and makes no representations regarding the policies or business practices of any third parties, including, without limitation, analytics Service Providers and Third-Party Services associated with the Service, and encourages you to familiarize yourself with and consult their privacy policies and terms of use.\xA0 See Section 11\xA0for more on certain choices offered by some third parties regarding their data collection and use, including regarding Interest-based Advertising and analytics.');

var _ref132 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Security and Monitoring'));

var _ref133 = _jsx('p', {}, void 0, 'Henkel will take reasonable precautions to protect your Personal Information\xA0(excluding public UGC) from loss, misuse or alteration. Personal Information may be accessed by persons within Our organization, or Our third party service providers, who require such access to carry out the purposes indicated above, or such other purposes as may be permitted or required by the applicable law. Please be aware, however, that any email or other transmission you send through the Internet cannot be completely protected against unauthorized interception and that the internet and online digital storage are not completely secure and We do not guarantee the security of your information collected through the Service.');

var _ref134 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Children'));

var _ref135 = _jsx('p', {}, void 0, 'The Service is intended for a general audience and not directed to children less than 13 years of age. Henkel does not intend to collect personal information as defined by the U.S. Children\u2019s Online Privacy Protection Act (\u201CCOPPA\u201D) (\u201CChildren\u2019s Personal Information\u201D) in a manner that is not permitted by COPPA. If We obtain knowledge that We have collected Children\u2019s Personal Information in a manner not permitted by COPPA or other applicable law, We will remove such data to the extent required by COPPA or such other applicable law.');

var _ref136 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Your Choices Regarding Your Personal Information'));

var _ref137 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Tracking Technologies Generally'));

var _ref138 = _jsx('p', {}, void 0, 'Some App-related Tracking Technologies in connection with non-browser usage (e.g., most functionality of a mobile app) can only be disabled by uninstalling the app. To uninstall an app, follow the instructions from your operating system or handset manufacturer.');

var _ref139 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Analytics and Advertising Tracking Technologies'));

var _ref140 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Mobile Apps'));

var _ref141 = _jsx('p', {}, void 0, 'With respect to Henkel\u2019s mobile apps\xA0(\u201Capps\u201D), you can stop all collection of data generated by use of the app by uninstalling the app.\xA0 Also, you may be able to exercise specific privacy choices, such as enabling or disabling certain features\xA0(e.g., location-based services, push notifications, accessing calendar/contacts/phots, etc.), by adjusting the permissions in your mobile device and/or the app\u2019s settings. Beware that if GPS precise location services are disabled, other means of establishing or estimating location\xA0(e.g., connecting to or proximity to wi-fi, Bluetooth, beacons, or Our networks) may persist.\xA0 See also the prior section regarding the DAA\u2019s mobile Interest-based Advertising choices.');

var _ref142 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Communications'));

var _ref143 = _jsx('p', {}, void 0, 'You can opt out of receiving certain promotional communications\xA0(emails or text messaging) from Henkel at any time by\xA0(i) for promotional e-mails, following the instructions provided in emails to click on the unsubscribe link, or if available by changing your communication preferences by logging onto your account; and\xA0(ii) for text messages, following the instructions provided in text messages from Henkel to text the word, \u201CSTOP\u201D; and\xA0(iii) for app push notifications turn off push notifications on the settings of your device and/or the app, as applicable.\xA0 Please note that your opt-out is limited to the e-mail address or phone number used and will not affect subsequent subscriptions.\xA0 If you opt-out of only certain communications, other subscription communications may continue.\xA0 Even if you opt out of receiving promotional communications, Henkel may, subject to applicable law, continue to send you non-promotional communications, such as those about your account, transactions, servicing, or Our ongoing business relations.');

var _ref144 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Careers Center'));

var _ref145 = _jsx('p', {}, void 0, 'If you have created a resume using Our Careers Center you may access, review, correct, update, change or delete your account profile information or resume at any time. Simply log into your account, go to your profile or resume, and make the necessary changes. You may delete your resume from Our online database at any time by accessing your account; provided, however, that We reserve the right to maintain a copy\xA0(a) as required by applicable law; and\xA0(b) for so long as reasonably necessary for record keeping purposes except to the extent prohibited by applicable law.');

var _ref146 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Your California and Connecticut Privacy Rights'));

var _ref147 = _jsx('p', {}, void 0, 'Attention: Henkel Privacy Inquiries', _jsx('br', {}), 'Communications Department', _jsx('br', {}), 'Henkel Corporation', _jsx('br', {}), 'One Henkel Way', _jsx('br', {}), 'Rocky Hill, CT 06067');

var _ref148 = _jsx('p', {}, void 0, 'Requests must include \u201CCalifornia Privacy Rights Request\u201D in the first line of the description and include your name, street address, city, state, and ZIP code.\xA0 Please note that Henkel is only required to respond to one request per customer each year, and Henkel is not required to respond to requests made by means other than through the provided e-mail address or mail address.');

var _ref149 = _jsx('p', {}, void 0, 'Connecticut Rights:Connecticut law requires any person or entity that collects Social Security numbers from Connecticut residents in the course of business to create a privacy protection policy and to publish or display it publicly.\xA0 It is Our policy to protect the confidentiality of Social Security numbers in Our possession from misuse and improper disclosure by maintaining and enforcing policies and physical and electronic safeguards against misuse and improper disclosure.\xA0 Unlawful disclosure of Social Security numbers is prohibited, and access to them is limited to personnel who need access to such information in order to perform their job functions.');

var _ref150 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Mobile Applications Privacy Statement'));

var _ref151 = _jsx('p', {}, void 0, 'Henkel has developed certain mobile applications that you may download to your mobile device. When you download a mobile application there may be an opportunity for you to provide Us with or for Us to obtain information about you such as contact information, product preferences, photographs, or other information. In addition, We may obtain information about the mobile device, such as device ID and operating system, and app usage. Information obtained through a mobile application will be used in accordance with this Privacy Statement and may be subject to additional terms posted within the mobile application.');

var _ref152 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Accessing and Changing Information'));

var _ref153 = _jsx('p', {}, void 0, 'Henkel may provide web pages or other mechanisms allowing you to delete, correct, or update some of the Henkel-Collected PI, and potentially certain other information about you (e.g., profile and account information). You may also request access to your Personal Information and to request a correction to it if you believe it is inaccurate using the contact information provided below. We may require you to verify your identity before allowing you to access your information. Henkel will make good faith efforts to make requested changes in Henkel\u2019s then-active databases as soon as practicable, but it is not always possible to completely change, remove or delete all of your information or public postings from Henkel\u2019s databases Further, We reserve the right to retain data (a) as required by applicable law; and (b) for so long as reasonably necessary to fulfill the purposes for which the data is retained except to the extent prohibited by applicable law.');

var _ref154 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Questions'));

var _ref155 = _jsx('p', {}, void 0, 'Henkel Privacy Inquiries', _jsx('br', {}), 'Compliance Officer', _jsx('br', {}), 'Henkel Corporation', _jsx('br', {}), 'One Henkel Way', _jsx('br', {}), 'Rocky Hill, CT 06067');

var TermsPrivacy = function TermsPrivacy() {
  return _jsx('div', {}, void 0, _ref, _ref2, _ref3, _ref4, _jsx('p', {}, void 0, 'By visiting or otherwise using the Service in any manner, you agree to the then posted Terms and any applicable Additional Terms (defined below), to be bound by them, and that you have read and understood them.\xA0 You also acknowledge, agree and consent to Our data practices as described in Our', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), '.'), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref12, _ref13), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref14, _ref15, _ref16), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref17, _jsx('p', {}, void 0, 'By visiting or otherwise using the Service in any manner, you agree to the then posted', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), '\xA0and consent to data practices as described therein.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref18, _ref19, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref20), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref21), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref22), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref23), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref24), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref25), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref26), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref27))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref28, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref29), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref30))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref31, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref32), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Non-Confidentiality of Your User-Generated Content.\xA0Except as otherwise described in the Service\u2019s posted\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), ', or any applicable Additional Terms, you agree that (a) your UGC will be treated as non-confidential and non-proprietary by Us \u2013 regardless of whether you mark them \u201Cconfidential,\u201D \u201Cproprietary,\u201D or the like \u2013 and will not be returned, and (b) to the maximum extent not prohibited by applicable law, Henkel does not assume any obligation of any kind to you or any third-party with respect to your UGC.\xA0 Upon request, you will provide documentation necessary to authenticate rights to such content and verify your compliance with these Terms or any applicable Additional Terms. You acknowledge that the Internet and', ' ', _ref33, 'mobile communications may be insecure and subject to breaches of security; according, you acknowledge and agree that your UGC is submitted at your own risk.'), _ref34), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'License to Henkel of Your UGC. Except as otherwise described in any applicable Additional Terms (such as a promotion\u2019s official rules), which specifically govern the submission of your UGC, or in Our', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), ', you hereby grant Henkel the non-exclusive, unrestricted, unconditional, unlimited, worldwide, irrevocable, perpetual, and cost-free right and license to use, copy, record, distribute, reproduce, disclose, sell, re-sell, sublicense (through multiple levels), display, publicly perform, transmit, publish, broadcast, translate, make derivative works of, and otherwise use and exploit in any manner whatsoever, all or any portion of your UGC (and derivative works thereof), for any purpose whatsoever in all formats, on or through any means or medium now known or hereafter developed, and with any technology or devices now known or hereafter developed, and to advertise, market, and promote the same.\xA0 Without limitation, the granted rights include the right to: (a) configure, host, index, cache, archive, store, digitize, compress, optimize, modify, reformat, edit, adapt, publish in searchable format, and remove such UGC and combine same with other materials, and (b) use any ideas, concepts, know-how, or techniques contained in any UGC for any purposes whatsoever, including developing, producing, and marketing products and/or services.\xA0 You understand that in exercising such rights metadata, notices and content may be removed or altered, including copyright management information, and you consent thereto and represent and warrant you have all necessary authority to do so.\xA0 In order to further effect the rights and license that you grant to Henkel to your UGC, you also, as permitted by applicable law, hereby grant to Henkel and agree to grant to Henkel the unconditional, perpetual, irrevocable right to use and exploit your name, persona, and likeness in connection with any UGC, without any obligation or remuneration to you. Except as prohibited by law, you hereby waive, and you agree to waive, any moral rights (including attribution, anonymity, and integrity) that you may have in any UGC, even if it is altered or changed in a manner not agreeable to you.\xA0 To the extent not waivable, you irrevocably agree not to exercise such rights (if any) in a manner that interferes with any exercise of the granted rights.\xA0 You understand that you will not receive any fees, sums, consideration, or remuneration for any of the rights granted in this Section 6(c).')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Henkel\u2019s Exclusive Right to Manage Our Service. Henkel may, but will not have any obligation to, review, monitor, display, post, store, maintain, accept, or otherwise make use of, any of your UGC, and Henkel may, in its sole discretion, reject, delete, move, re-format, remove or refuse to post or otherwise make use of UGC without notice or any liability to you or any third-party in connection with Our operation of UGC venues in an appropriate manner.\xA0 Without limitation, We may do so to address content that comes to Our attention that We believe is offensive, obscene, lewd, lascivious, filthy, violent, harassing, threatening, abusive, illegal or otherwise objectionable or inappropriate, or to enforce the rights of third parties or these Terms or any applicable Additional Terms.\xA0 Such UGC submitted by you or others need not be maintained on the Service by Us for any period of time, and you will not have the right, once submitted, to access, archive, maintain, change, remove, or otherwise use such UGC on the Service or elsewhere, except that California minors have certain rights to have certain content about them that they have themselves posted on the Service prospectively removed from public display as provided for in the\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), '.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref35), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref36))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref37, _ref38, _ref39, _jsx('p', {}, void 0, 'Copyright Agent', _ref40, 'Henkel Corporation', _ref41, 'One Henkel Way', _ref42, 'Rocky Hill, CT 06067', _ref43, '860/571-2661', _ref44, _jsx('a', {
    href: 'mailto:CopyrightAgent@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'CopyrightAgent@henkel.com'))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref45, _ref46, _jsx('p', {}, void 0, 'If you are accessing or using the Service through Apple, Android, or any other platform, these are Third-Party Services.\xA0 If you access Our Apps via Apple, click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/new-content-item/802450',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0for Additional Terms and conditions that are applicable to you and are incorporated into the Terms by this reference.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref47, _ref48, _ref49, _ref50, _ref51), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref52, _ref53, _ref54), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref55, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref56), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref57), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Arbitration of Claims. As permitted by applicable law, and for users who are not individual residents of the province of Quebec, all actions or proceedings arising in connection with, touching upon or relating to any Dispute, or the scope of the provisions of this Section, shall be submitted to JAMS (', _jsx('a', {
    href: 'www.jamsadr.com',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.jamsadr.com'), ') for final and binding arbitration under its Comprehensive Arbitration Rules and Procedures if the matter in dispute is over $250,000 or under its Streamlined Arbitration Rules and Procedures if the matter in dispute is $250,000 or less, to be held in Delaware before a single arbitrator. The arbitrator shall be selected by mutual agreement of the parties or, if the parties cannot agree, then by striking from a list of arbitrators supplied by JAMS. We may have the right to pay the JAMS fees if required for arbitration to be enforceable. The arbitration shall be a confidential proceeding, closed to the general public; provided, however, that a party may disclose information relating to the arbitration proceedings to its and its affiliates\u2019 lawyers, insurance providers, auditors and other professional advisers. The fact that there is a dispute between the parties that is the subject of arbitration shall be confidential to the same extent. The arbitrator shall issue a written opinion stating the essential findings and conclusions upon which the arbitrator\u2019s award is based.\xA0 Neither party shall be entitled or permitted to commence or maintain any action in a court of law with respect to any matter in dispute until such matter shall have been submitted to arbitration as herein provided and then only for the enforcement of the arbitrator\u2019s award; provided, however, that prior to the appointment of the arbitrator or for remedies beyond the jurisdiction of an arbitrator, at any time, either party may seek pendente lite relief (subject to the provisions of these Terms waiving or limiting that relief) in a court of competent jurisdiction in the state of Delaware\xA0 or, if sought by Henkel such other court that may have jurisdiction over you, without thereby waiving its right to arbitration of the dispute or controversy under this Section; provided further, however, that the losing party shall have fifteen (15) business days after the issuance of the arbitrator\u2019s decision to fully comply with such decision, after which the prevailing party may enforce such decision by a petition to the courts in Wilmington, Delaware or, in the case of you, such other court having jurisdiction over you, which may be made ex parte, for confirmation and enforcement of the award.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref58), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref59), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref60), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref61), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref62), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref63))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref64, _ref65), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref66, _ref67), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref68, _ref69), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref70, _ref71)), _ref72, _ref73, _ref74, _jsx('p', {}, void 0, 'Click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0to view Our Terms of Use. California residents, see Section 12A to view your California privacy rights.'), _ref75, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref76, _ref77, _ref78, _jsx('p', {}, void 0, 'By using Our Service in any way, such as browsing or interacting, you signify that you agree with the terms of Our current Privacy Statement as posted here and Our Service Terms of Use found\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '. If you do not consent to Our practices as described in this Privacy Statement, you may and should not use Our Service.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref79, _ref80), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref81, _ref82, _ref83, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'circle' }
  }, void 0, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90), _ref91), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref92, _ref93, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref94, _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'uploading and displaying your postings and similar submitted content (\u201CUser Generated Content\u201D\xA0or\xA0\u201CUGC\u201D). (For more information on how UGC is treated under the Service\u2019s Terms of Use click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0[Section 6 of ToU]. For more on the public nature of UGC, see Section 5);')), _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108), _ref109, _ref110), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref111, _jsx('p', {}, void 0, 'The Service may permit you to post or submit UGC including, without limitation, written content, user profiles, audio or visual recordings, computer graphics, pictures, data, or other content, including Personal Information.\xA0 If you choose to submit UGC to any public area of the Service, your UGC will be considered \u201Cpublic\u201D and will be accessible by anyone, including Henkel.\xA0 Notwithstanding anything to the contrary, and subject to the applicable law, unless otherwise explicitly agreed by Us, Personal Information included in UGC is not subject to Henkel\u2019s usage or sharing limitations, or other obligations, regarding Henkel-Collected-PI or other Personal Information under this Privacy Statement or otherwise, and may be used and shared by Henkel and third parties to the fullest extent not prohibited by applicable law.\xA0 Henkel encourages you to exercise caution when making decisions about what you disclose in such public areas.\xA0 For more information on how UGC is treated under the Service\u2019s Terms of Use click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0[Section 6 of ToU].'), _ref112), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref113, _ref114, _ref115, _jsx('p', {}, void 0, 'A cookie is a small text file that is stored on a user\u2019s device, which may be session ID cookies or tracking cookies. Session cookies make it easier for you to navigate the Service and expire when you close your browser. Tracking cookies remain longer and help in understanding how you use the Service, and enhance your user experience. Cookies may remain on your hard drive for an extended period of time. If you use your browser\u2019s method of blocking or removing cookies, some but not all types of cookies may be deleted and/or blocked and as a result some features and functionalities of the Service may not work. A Flash cookie (or locally shared object) is a data file which may be placed on a device via the Adobe Flash plug-in that may be built-in to or downloaded by you to your device. HTML5 cookies can be programmed through HTML5 local storage. Flash cookies and HTML5 cookies are locally stored on your device other than in the browser and browser settings won\u2019t control them. To identify certain types of local shared objects on your device and adjust your settings, please visit:\xA0', _jsx('a', {
    href: 'www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html'), '. The Service may associate some or all of these types of cookies with your devices. Other types of Tracking Technologies may include web beacons (also known as \u201Ctracking pixels\u201D), embedded scripts, location-identifying technologies, fingerprinting, device recognition technologies, and in-app tracking methods. See Section 11 regarding certain choices regarding these activities.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref116, _ref117, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref118, _ref119, _ref120, _ref121), _ref122, _ref123), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref132, _ref133, _jsx('p', {}, void 0, 'To help protect you and others, We and Our Service Providers may (but make no commitment to) monitor use of the Service, and may collect and use related information including Henkel-Collected PI and other Personal Information for all purposes not prohibited by applicable law or inconsistent with this Privacy Statement, including, without limitation, to identify fraudulent activities and transactions; prevent abuse of and investigate and/or seek prosecution for any potential threats to or misuse of the Service; ensure compliance with the\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Terms of Use'), '\xA0and this Privacy Statement; investigate violations of or enforce these agreements; and otherwise to protect the rights and property of Henkel, our Affiliates third parties, and other users. Monitoring may result in the collection, recording, and analysis of online activity or communications through Our Service.\xA0 If you do not consent to these conditions, you must discontinue your use of the Service.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref134, _ref135, _jsx('p', {}, void 0, 'Any California residents under the age of eighteen (18) who have registered to use the Service, and who posted content or information on the Service, can request removal by contacting Henkel\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/contact-us',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0detailing where the content or information is posted and attesting that you posted it. Henkel will then make reasonable good faith efforts to remove the post from prospective public view or anonymize it so the minor cannot be individually identified to the extent required by applicable law. This removal process cannot ensure complete or comprehensive removal. For instance, third-parties may have republished or archived content by search engines and others that Henkel does not control.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref136, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref137, _jsx('p', {}, void 0, 'Regular cookies may generally be disabled or removed by tools available as part of most commercial browsers, and in some instances blocked in the future by selecting certain settings. Browsers offer different functionalities and options so you may need to set them separately. Also, tools from commercial browsers may not be effective with regard to Flash cookies (also known as locally shared objects), HTML5 cookies, or other Tracking Technologies. For information on disabling Flash cookies, go to Adobe\u2019s website\xA0', _jsx('a', {
    href: 'helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html'), '. Please be aware that if you disable or remove these technologies, some parts of the Service may not work and that when you revisit the Service your ability to limit browser-based Tracking Technologies is subject to your browser settings and limitations.'), _ref138, _jsx('p', {}, void 0, 'Your browser settings may allow you to automatically transmit a \u201CDo Not Track\u201D signal to online services you visit. Note, however, there is no consensus among industry participants as to what \u201CDo Not Track\u201D means in this context. Like many online services, Henkel currently does not alter Henkel\u2019s practices when Henkel receives a \u201CDo Not Track\u201D signal from a visitor\u2019s browser. To find out more about \u201CDo Not Track,\u201D you can visit\xA0', _jsx('a', {
    href: 'http://www.allaboutdnt.com',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.allaboutdnt.com'), ', but We are not responsible for the completeness or accuracy of this third party information. Some third parties, however, may offer you choices regarding their Tracking Technologies. One way to potentially identify cookies on Our Site is to add the free Ghostery plug-in to your browser (', _jsx('a', {
    href: 'www.ghostery.com',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.ghostery.com'), '), which according to Ghostery will display for you traditional, browser-based cookies associated with the web sites (but not mobile apps) you visit and privacy and opt-out policies and options of the parties operating those cookies. Henkel is not responsible for the completeness or accuracy of this tool or third party choice notices or mechanisms. For specific information on some of the choice options offered by third party analytics and advertising providers, see the next section.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref139, _jsx('p', {}, void 0, 'You may exercise choices regarding the use of cookies from Google Analytics by going to\xA0', _jsx('a', {
    href: 'https://tools.google.com/dlpage/gaoptout',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://tools.google.com/dlpage/gaoptout'), '\xA0or downloading the Google Analytics Opt-out Browser Add-on. You may exercise choices regarding the use of cookies from Adobe Analytics by going to\xA0', _jsx('a', {
    href: 'http://www.adobe.com/privacy/opt-out.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.adobe.com/privacy/opt-out.html'), '\xA0under the section labeled \u201CTell Our customers not to measure your use of their websites or tailor their online ads for you.\u201D You may exercise choices regarding the use of cookies from Google DoubleClick by going to\xA0', _jsx('a', {
    href: 'http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew'), '. Henkel is not responsible for effectiveness of, or compliance with, any third-parties\u2019 opt-out options or programs or the accuracy of their statements regarding their programs.'), _jsx('p', {}, void 0, 'You may choose whether to receive some Interest-based Advertising by submitting opt-outs to industry programs. Some of the advertisers and Service Providers that perform advertising-related services for Us and third parties may participate in the Digital Advertising Alliance\u2019s (\u201CDAA\u201D) Self-Regulatory Program for Online Behavioral Advertising. To learn more about how you can exercise certain choices regarding Interest-based Advertising, visit\xA0', _jsx('a', {
    href: 'http://www.aboutads.info/choices',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.aboutads.info/choices'), ', and\xA0', _jsx('a', {
    href: 'http://www.aboutads.info/appchoices',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.aboutads.info/appchoices'), '\xA0for information on the DAA\u2019s opt-out program for mobile apps. Some of these companies may also be members of the Network Advertising Initiative (\u201CNAI\u201D). To learn more about the NAI and your opt-out options for their members, see\xA0', _jsx('a', {
    href: 'http://www.networkadvertising.org/choices/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.networkadvertising.org/choices/'), '. Please be aware that, even if you are able to opt out of certain kinds of Interest-based Advertising, you may continue to receive other types of ads. Opting out only means that those selected members should no longer deliver certain Interest-based Advertising to you, but does not mean you will no longer receive any targeted content and/or ads (e.g., from other ad networks). Some companies also provide a specific opportunity to opt-out. For information on the Interest-based Advertising choices offered by DoubleClick, see\xA0', _jsx('a', {
    href: 'https://www.google.com/settings/u/0/ads/plugin?hl=en&sig=ACi0TCigvVYAN17ugYRMwQf_InKv4i5GKLPNen5UUD8qFqiWU4vtXR5jsz_uaOHdJqvhufEjezDh-Q13icRRRab9WJDGpQbwkQ',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '. Also, if your browsers are configured to reject cookies when you visit these opt-out webpages, or you subsequently erase your cookies, use of a different device or web browsers or use a non-browser-based method of access (e.g., mobile app), your browser-based opt-out may not, or may no longer, be effective. Henkel supports the ad industry\u2019s\xA0', _jsx('a', {
    href: 'www.iab.net/media/file/ven-principles-07-01-09.pdf',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, '2009 Self-regulatory Principles for Online Behavioral Advertising'), '\xA0and expects that ad networks Henkel directly engages to serve you Interest-based Advertising will do so as well, though Henkel cannot guaranty their compliance. Henkel is not responsible for effectiveness of, or compliance with, any third-parties\u2019 opt-out options or programs or the accuracy of their statements regarding their programs.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref140, _ref141), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref142, _ref143), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref144, _ref145))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref146, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'California Rights:\xA0Henkel provides California residents with the option to opt-in or opt-out to sharing of \u201Cpersonal information\u201D as defined by California\u2019s \u201CShine the Light\u201D law with third parties, other than Henkel Affiliates, for such third parties own direct marketing purposes.\xA0 California residents may exercise that opt-out, and/or request information about Henkel\u2019s compliance with the Shine the Light law, and obtain disclosure of third parties Henkel has shared information in accordance with the law for their direct marketing purposes absent your choice and the categories of information shared, by contacting Henkel\xA0', _jsx('a', {
    href: 'mailto:PrivacyNA@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'here'), '\xA0or by sending a letter to Henkel at:'), _ref147, _ref148), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref149))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref150, _ref151), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref152, _ref153), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref154, _jsx('p', {}, void 0, 'Please send Us your questions or comments regarding Our privacy practices by emailing Us at\xA0', _jsx('a', {
    href: 'mailto:PrivacyNA@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'PrivacyNA@henkel.com'), ', or sending Us a letter addressed to:'), _ref155)));
};

/* harmony default export */ __webpack_exports__["a"] = (TermsPrivacy);

/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'CONDITIONS D\u2019UTILISATION ET D\xC9CLARATION DE CONFIDENTIALIT\xC9'));

var _ref2 = _jsx('p', {}, void 0, 'Date d\u2019entr\xE9e en vigueur : 14 novembre 2017');

var _ref3 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Introduction'));

var _ref4 = _jsx('p', {}, void 0, 'Merci d\u2019utiliser un site Web, une application mobile ou un autre service en ligne (le \u201CService\u201D) qui appartient \xE0 et qui est exploit\xE9e par Henkel Corporation ou \xE0 l\u2019une de ses filiales ou soci\xE9t\xE9s affili\xE9es (\u201CHenkel\u201D, \u201Cnous\u201D, \u201Cnotre\u201D, \u201Cnos\u201D).');

var _ref5 = _jsx('p', {}, void 0, 'Les pr\xE9sentes Conditions d\u2019utilisation (les \u201CConditions\u201D) ont une incidence sur vos droits, responsabilit\xE9s et obligations juridiques et r\xE9gissent votre utilisation du Service, sont juridiquement contraignantes, limitent la responsabilit\xE9 de Henkel envers vous et exigent que vous nous indemnisiez et que, dans certaines r\xE9gions, certains litiges soient r\xE9solus \xE0 l\u2019aide de l\u2019arbitrage individuel.');

var _ref6 = _jsx('p', {}, void 0, 'Si vous ne souhaitez pas \xEAtre li\xE9 par les pr\xE9sentes Conditions et par toute Condition suppl\xE9mentaire, n\u2019utilisez pas le Service et d\xE9sinstallez les t\xE9l\xE9chargements et les applications du Service.');

var _ref7 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Conditions suppl\xE9mentaires'));

var _ref8 = _jsx('p', {}, void 0, 'Dans certains cas, des conditions suppl\xE9mentaires ou diff\xE9rentes, publi\xE9es dans le Service, s\u2019appliquent \xE0 votre utilisation de certaines parties du Service (nomm\xE9es individuellement et collectivement les \u201CConditions suppl\xE9mentaires\u201D). Dans la mesure o\xF9 il existe un conflit entre les pr\xE9sentes Conditions et toute Condition suppl\xE9mentaire, les pr\xE9sentes Conditions ont pr\xE9s\xE9ance, sauf si les Conditions suppl\xE9mentaires indiquent express\xE9ment le contraire.');

var _ref9 = _jsx('p', {}, void 0, 'Mises \xE0 jour des pr\xE9sentes Conditions et des Conditions suppl\xE9mentaires');

var _ref10 = _jsx('p', {}, void 0, 'Nous pourrions modifier de fa\xE7on prospective les pr\xE9sentes Conditions et les Conditions suppl\xE9mentaires en publiant des conditions nouvelles ou modifi\xE9es sur le Service, tel qu\u2019expliqu\xE9 plus en d\xE9tail [\xE0 la Section 13].');

var _ref11 = _jsx('h2', {}, void 0, 'Conditions d\u2019utilisation compl\xE8tes');

var _ref12 = _jsx('br', {});

var _ref13 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Propri\xE9t\xE9 et exploitation'));

var _ref14 = _jsx('p', {}, void 0, 'Le Service et tout son contenu (le \u201CContenu\u201D), y compris tous les droits d\u2019auteur, les brevets, les marques de commerce, les marques de service, les raisons sociales et tous les autres droits de propri\xE9t\xE9 intellectuelle qui s\u2019y rapportent (la \u201CPropri\xE9t\xE9 intellectuelle\u201D) appartiennent \xE0 ou sont contr\xF4l\xE9s par Henkel, nos conc\xE9dants et certains autres tiers. Tous les droits, titres et int\xE9r\xEAts concernant le Contenu et la Propri\xE9t\xE9 intellectuelle disponibles \xE0 l\u2019aide du Service sont la propri\xE9t\xE9 de Henkel, de nos conc\xE9dants ou de certains autres tiers, et sont prot\xE9g\xE9s par des droits d\u2019auteur, des marques de commerce, des emballages, des brevets et autres droits de propri\xE9t\xE9 intellectuelle et droits contre la concurrence d\xE9loyale internationaux et des \xC9tats-Unis dans la plus grande mesure possible. Henkel est propri\xE9taire du droit d\u2019auteur relatif \xE0 la s\xE9lection, \xE0 la compilation, au regroupement, \xE0 l\u2019organisation et \xE0 l\u2019am\xE9lioration du Contenu du Service. Henkel, \xE0 sa seule discr\xE9tion et sans pr\xE9avis ou responsabilit\xE9, pourrait imm\xE9diatement suspendre ou interrompre la disponibilit\xE9 du Service et/ou du Contenu (et de tout \xE9l\xE9ment et caract\xE9ristique qui lui sont associ\xE9s), en tout ou en partie, pour toute raison que ce soit.');

var _ref15 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Port\xE9e g\xE9ographique pr\xE9vue'));

var _ref16 = _jsx('p', {}, void 0, 'Le Service et son Contenu sont contr\xF4l\xE9s \xE0 partir des \xC9tats-Unis d\u2019Am\xE9rique et du Canada. L\u2019acc\xE8s au Service \xE0 partir de territoires o\xF9 son Contenu est ill\xE9gal est interdit. Les individus qui choisissent d\u2019acc\xE9der au Service \xE0 partir de l\u2019ext\xE9rieur des \xC9tats-Unis ou du Canada sont responsables de se conformer \xE0 toutes les lois locales qui leur sont applicables relativement au Contenu et \xE0 l\u2019exploitation du Service. Vous \xEAtes responsable de respecter toute la r\xE9glementation et toutes les lois commerciales applicables, autant nationales qu\u2019\xE9trang\xE8res. Sauf tel qu\u2019autoris\xE9 par les lois am\xE9ricaines et canadiennes, vous convenez et garantissez que vous n\u2019exporterez ou ne r\xE9exporterez pas le logiciel dans tout comt\xE9, ou \xE0 toute personne, toute entit\xE9 ou tout utilisateur final assujetti \xE0 des sanctions ou \xE0 des mesures de contr\xF4le d\u2019exportation am\xE9ricaines ou canadiennes.');

var _ref17 = _jsx('p', {}, void 0, 'Les marques / produits affich\xE9s dans le Service sont des exemples de marques / produits disponibles de soci\xE9t\xE9s appartenant \xE0 Henkel \xE0 l\u2019\xE9chelle mondiale. Henkel ne garantit pas qu\u2019une marque / un produit affich\xE9 est aussi disponible dans votre pays.');

var _ref18 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Confidentialit\xE9'));

var _ref19 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Permission limit\xE9e d\u2019acc\xE9der au Service et de l\u2019utiliser'));

var _ref20 = _jsx('p', {}, void 0, 'Henkel a pour politique de faire respecter ses droits de Propri\xE9t\xE9 intellectuelle dans la plus grande mesure permise par la loi, y compris la r\xE9clamation de peines criminelles. Votre droit d\u2019utiliser le Service et le Contenu est assujetti \xE0 votre conformit\xE9 stricte avec les pr\xE9sentes Conditions et les Conditions suppl\xE9mentaires. Votre droit d\u2019acc\xE9der au Service et \xE0 la Propri\xE9t\xE9 intellectuelle et de les utiliser se termine automatiquement \xE0 la suite de toute violation. Cesdits droits sont non-exclusifs, limit\xE9s et r\xE9vocables par nous en tout temps \xE0 notre seule discr\xE9tion sans pr\xE9avis et sans responsabilit\xE9 de notre part. \xC9tant donn\xE9 que votre droit d\u2019acc\xE8s et d\u2019utilisation du Service et de son contenu vous appartient personnellement, vous ne pouvez pas c\xE9der ou transf\xE9rer votre droit; toute tentative de le faire est annul\xE9e. Vous pourriez, aux fins d\u2019utilisation personnelle, non commerciale et l\xE9gale seulement (collectivement, ce qui suit constitue les \u201C\xC9l\xE9ments autoris\xE9s par Henkel\u201D) :');

var _ref21 = _jsx('p', {}, void 0, 'Afficher, consulter, utiliser et visionner le Contenu sur un ordinateur, un appareil mobile ou un autre appareil connect\xE9 \xE0 Internet (l\u2019\u201DAppareil\u201D) et/ou imprimer une copie du Contenu (\xE0 l\u2019exception de code source et de code objet en format brut ou autrement) tel qu\u2019il s\u2019affiche;');

var _ref22 = _jsx('p', {}, void 0, 'Diffuser en continu le Contenu \xE0 l\u2019aide de tout composant d\u2019interface et/ou autre lecteur vid\xE9o num\xE9rique pour diffusion en continu sur Internet, le cas \xE9ch\xE9ant, fourni sur le Service;');

var _ref23 = _jsx('p', {}, void 0, 'Sous r\xE9serve de toute Condition suppl\xE9mentaire applicable, si le Service comprend un outil d\u2019\u201DEnvoi \xE0 un ami\u201D (\u201CSend to Friend\u201D), de partage sur les m\xE9dias sociaux ou autre outil semblable qui vous permet de choisir d\u2019envoyer \xE0 un ou plusieurs de vos contacts une communication qui comprend du contenu, ou de publier notre contenu sur des services fournis par des tiers ou sur votre propre site ou service en ligne, et que l\u2019outil est fonctionnel, utilisez-le pour le faire; \xE0 condition, toutefois, que vous le fassiez sans violer la loi applicable ou les droits de tiers ou sans exprimer de n\xE9gativit\xE9 envers nous, et que vous transmettiez ledit contenu uniquement \xE0 des destinataires que vous \xEAtes autoris\xE9 \xE0 contacter;');

var _ref24 = _jsx('p', {}, void 0, 'Si le Service comprend un lien pour \u201CT\xE9l\xE9charger\u201D (\u201CDownload\u201D) \xE0 c\xF4t\xE9 d\u2019un \xE9l\xE9ment de contenu (notamment, une image, une ic\xF4ne, un fond d\u2019\xE9cran, une piste musicale, une vid\xE9o, une bande-annonce, un flux RSS), vous pouvez t\xE9l\xE9charger une seule copie dudit contenu sur un seul Appareil;');

var _ref25 = _jsx('p', {}, void 0, 'T\xE9l\xE9charger, installer et utiliser une copie de tout logiciel, y compris les applications, que nous rendons disponibles \xE0 l\u2019aide du Service (les \u201CLogiciels\u201D) sur votre Appareil sous forme de code objet ex\xE9cutable par machine seulement et effectuer une copie suppl\xE9mentaire \xE0 des fins de sauvegarde; \xE0 condition toutefois que vous compreniez et conveniez que i) en vous permettant de t\xE9l\xE9charger le Logiciel, Henkel ne vous transf\xE8re aucun titre du Logiciel (c.-\xE0-d. que le dispositif que vous utilisez pour enregistrer le Logiciel vous appartient, mais que le propri\xE9taire du Logiciel [qui pourrait \xEAtre Henkel et/ou son conc\xE9dant de logiciel tiers] conserve la totalit\xE9 du titre dudit Logiciel); ii) vous n\u2019\xEAtes pas autoris\xE9 \xE0 copier, \xE0 modifier, \xE0 adapter, \xE0 traduire en quelque langue que ce soit, \xE0 distribuer ou \xE0 cr\xE9er des \u0153uvres d\xE9riv\xE9es bas\xE9es sur le Logiciel, sauf tel qu\u2019express\xE9ment autoris\xE9 dans les pr\xE9sentes Conditions ou Modalit\xE9s suppl\xE9mentaires applicables, sans le consentement \xE9crit pr\xE9alable de Henkel; iii) vous n\u2019\xEAtes pas autoris\xE9 \xE0 c\xE9der, \xE0 louer ou \xE0 pr\xEAter le Logiciel \xE0 toute personne ou entit\xE9 et toute tentative par vous pour accorder une sous-licence, transf\xE9rer ou c\xE9der le Logiciel sera nulle et sans effet; iv) vous n\u2019\xEAtes pas autoris\xE9 \xE0 d\xE9compiler, \xE0 d\xE9sassembler, \xE0 faire de l\u2019ing\xE9nierie inverse, ou \xE0 tenter de reconstruire, d\u2019identifier ou de d\xE9couvrir tout code source, id\xE9es sous-jacentes, techniques d\u2019interface d\u2019utilisateur sous-jacentes ou algorithmes du Logiciel par quelque moyen que ce soit, sauf dans la mesure o\xF9 les restrictions susmentionn\xE9es sont interdites par la loi applicable;');

var _ref26 = _jsx('p', {}, void 0, 'Si cela vous est offert, obtenir un compte personnel enregistr\xE9 (et/ou un nom d\u2019utilisateur et un mot de passe reli\xE9s) sur le Service et interagir avec le Service subs\xE9quemment;');

var _ref27 = _jsx('p', {}, void 0, 'Fournir un lien vers le Service \xE0 partir d\u2019un site Web ou d\u2019un autre service en ligne, aux conditions suivantes : a) les liens comprennent uniquement du texte et n\u2019utilisent aucun nom, logo ou image de Henkel, b) les liens et le contenu sur votre site Web ne sugg\xE8rent aucune affiliation avec Henkel et ne causent aucune confusion, et c) les liens et le contenu sur votre site Web ne pr\xE9sentent pas Henkel ou ses produits ou services de fa\xE7on fausse, trompeuse, d\xE9sobligeante ou autrement offensante, et ne comprennent pas de contenu ill\xE9gal, offensant, obsc\xE8ne, lubrique, lascif, sale, violent, mena\xE7ant, harcelant ou abusif, ou qui viole les droits de tout tiers ou est autrement inacceptable pour Henkel. Henkel se r\xE9serve le droit de suspendre ou d\u2019interdire la cr\xE9ation de liens vers le Service pour toute raison que ce soit, \xE0 sa seule discr\xE9tion, sans pr\xE9avis ou toute responsabilit\xE9 que ce soit envers vous ou des tiers;');

var _ref28 = _jsx('p', {}, void 0, 'L\u2019utilisation de toute autre fonctionnalit\xE9 fournie express\xE9ment par Henkel sur le Service ou \xE0 l\u2019aide du Service aux fins d\u2019utilisation par des utilisateurs, assujettie aux pr\xE9sentes Conditions (notamment, la fonctionnalit\xE9 de cr\xE9er et/ou de publier du Contenu g\xE9n\xE9r\xE9 par l\u2019utilisateur [tel que d\xE9fini plus bas]) et \xE0 toute Condition suppl\xE9mentaire applicable. Toute utilisation non autoris\xE9e et tout abus desdites propri\xE9t\xE9s intellectuelles ou desdits travaux sont express\xE9ment interdits et constituent une violation des lois sur les marques de commerce, des lois sur le droit d\u2019auteur, d\u2019autres droits de propri\xE9t\xE9 intellectuelle ou des lois sur la concurrence d\xE9loyale.');

var _ref29 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Restrictions relatives au Service et au Contenu'));

var _ref30 = _jsx('p', {}, void 0, 'Restrictions relatives \xE0 l\u2019utilisation du Service. Vous convenez de ne pas : i) utiliser le Service \xE0 des fins politiques ou commerciales (notamment, \xE0 des fins de publicit\xE9, de sollicitation de fonds, d\u2019\xE9tude du prix des produits et de vente de produits); ii) utiliser des m\xE9tabalises ou tout autre \u201Ctexte cach\xE9\u201D avec une Propri\xE9t\xE9 intellectuelle; iii) effectuer des activit\xE9s en lien avec le Service qui ont pour but de tenter de nuire \xE0 des individus ou \xE0 des entit\xE9s, ou qui sont ill\xE9gales, offensantes, obsc\xE8nes, lubriques, lascives, sales, violentes, mena\xE7antes, harcelantes ou abusives, ou qui violent les droits de tout tiers ou sont autrement inacceptables pour Henkel; iv) d\xE9compiler, d\xE9sassembler, faire de l\u2019ing\xE9nierie inverse, ou tenter de reconstruire, d\u2019identifier ou de d\xE9couvrir tout code source, id\xE9es sous-jacentes, techniques d\u2019interface d\u2019utilisateur sous-jacentes ou algorithmes du Service par quelque moyen que ce soit ou modifier tout code source ou code objet du Service ou tout Logiciel ou autres produits, services ou processus accessibles dans toute partie du Service; v) effectuer toute activit\xE9 qui nuit \xE0 l\u2019acc\xE8s des utilisateurs du Service ou au bon fonctionnement du Service, ou qui nuit autrement au Service, \xE0 Henkel ou aux autres utilisateurs du Service; vi) entraver ou contourner toute fonctionnalit\xE9 de s\xE9curit\xE9 (y compris les m\xE9canismes ou appareils de gestion des droits num\xE9riques, ou d\u2019autres mesures de protection du contenu ou de contr\xF4le de l\u2019acc\xE8s) du Service ou de toute fonctionnalit\xE9 qui restreint ou applique les limitations de l\u2019utilisation ou de l\u2019acc\xE8s au Service, au Contenu ou au CGU; vii) r\xE9colter ou autrement recueillir ou stocker toute information (notamment les donn\xE9es personnelles d\u2019autres utilisateurs du Service, y compris les adresses courriel, sans le consentement explicite desdits utilisateurs); viii) tenter d\u2019acc\xE9der sans autorisation au Service, \xE0 d\u2019autres syst\xE8mes ou r\xE9seaux informatiques connect\xE9s au Service, \xE0 l\u2019aide d\u2019extraction de mots de passe ou par tout autre moyen; ou ix) violer d\u2019une autre fa\xE7on les pr\xE9sentes Conditions ou toute Modalit\xE9 suppl\xE9mentaire applicable.');

var _ref31 = _jsx('p', {}, void 0, 'Restrictions relatives \xE0 l\u2019utilisation du Contenu Vous convenez aussi, en utilisant le Service, de : i) ne pas surveiller, recueillir, copier ou distribuer le Contenu (sauf \xE0 la suite d\u2019activit\xE9s sur des moteurs de recherche courants ou \xE0 l\u2019aide de l\u2019utilisation d\u2019un navigateur courant) du Service en utilisant tout robot, \u201Crover\u201D, agent num\xE9rique, robot Web, \u201Cscraper\u201D, collecteur, logiciel espion, moteur, logiciel, outil d\u2019extraction ou tout autre appareil automatique, utilit\xE9 ou processus manuel de quelque nature que ce soit; ii) ne pas tramer ou utiliser des techniques de tramage pour isoler ledit contenu (y compris des images, du texte ou la disposition de pages); iii) garder intacts tous les droits d\u2019auteur, les marques de commerce et autres Propri\xE9t\xE9s intellectuelles et avis faisant partie dudit contenu; iv) ne pas utiliser ledit contenu d\u2019une fa\xE7on qui sugg\xE8re une association non autoris\xE9e avec des produits, services ou marques nous appartenant ou appartenant \xE0 nos conc\xE9dants; v) ne pas apporter de modifications audit contenu (autres que dans la mesure pr\xE9cis\xE9ment permise par nous, le cas \xE9ch\xE9ant); vi) ne pas copier, modifier, reproduire, archiver, vendre, louer, \xE9changer, cr\xE9er des \u0153uvres d\xE9rivatives, publier sur papier ou par voie \xE9lectronique, pr\xE9senter publiquement, afficher, diss\xE9miner, distribuer, diffuser, retransmettre, circuler ou transf\xE9rer \xE0 tout tiers ou sur toute application ou tout site Web appartenant \xE0 un tiers, ou autrement utiliser ou exploiter ledit contenu de quelque fa\xE7on que ce soit, \xE0 toute fin que ce soit, sauf tel qu\u2019express\xE9ment permis par les pr\xE9sentes Conditions ou toute Modalit\xE9 suppl\xE9mentaire applicable, ou avec le consentement \xE9crit pr\xE9alable d\u2019un agent de Henkel ou, dans le cas de contenu d\u2019un conc\xE9dant, du propri\xE9taire du contenu; et vii) ne pas ins\xE9rer de code ou de produit pour manipuler ledit contenu d\u2019une fa\xE7on qui nuirait \xE0 l\u2019exp\xE9rience de tout utilisateur ou au Service.');

var _ref32 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Contenu g\xE9n\xE9r\xE9 par les utilisateurs'));

var _ref33 = _jsx('p', {}, void 0, 'G\xE9n\xE9ralit\xE9s. Henkel pourrait, maintenant ou dans le futur, offrir aux utilisateurs du Service l\u2019occasion de cr\xE9er, de construire, de publier, de t\xE9l\xE9charger, d\u2019afficher, de publier, de distribuer, de transmettre, de diffuser ou de rendre disponible ou de soumettre, \xE0 l\u2019aide du Service ou sur ou en r\xE9ponse \xE0 nos pages ou publications sur toute plateforme de tiers ou en lien avec nos promotions sur tout m\xE9dia ou autre, ou de soumettre autrement \xE0 nous (p. ex. sur notre page Facebook ou sur d\u2019autres pages de m\xE9dias sociaux, en r\xE9ponse \xE0 nos gazouillis, lors de tirages au sort ou concours, ou en nous les envoyant d\u2019une autre fa\xE7on) (collectivement, la \u201Csoumission\u201D) des messages, du texte, des illustrations, des fichiers, des images, des graphiques, des photographies, des commentaires, des r\xE9ponses, des sons, de la musique, des vid\xE9os, de l\u2019information, du contenu, des \xE9valuations, des analyses, des donn\xE9es, des questions, des suggestions, des donn\xE9es personnelles, ou d\u2019autres informations ou d\u2019autre mat\xE9riel et les id\xE9es qu\u2019ils contiennent (collectivement appel\xE9s, \xE0 l\u2019exclusion des \xC9l\xE9ments autoris\xE9s par Henkel d\xE9crits dans les pr\xE9sentes, le \u201CContenu g\xE9n\xE9r\xE9 par l\u2019utilisateur\u201D ou \u201CCGU\u201D). Vous pourriez soumettre du CGU \xE0 l\u2019aide de votre profil, sur des forums, des blogues, des babillards \xE9lectroniques, des environnements de r\xE9seautage social, des outils de cr\xE9ation et de publication de contenu, des jeux, des communaut\xE9s sociales, les outils pour communiquer avec nous, les courriels et d\u2019autres fonctionnalit\xE9s de communication. Sauf dans la mesure des droits et des licences que vous accordez en vertu des pr\xE9sentes Conditions et, sous r\xE9serve des Conditions suppl\xE9mentaires applicables, vous conservez tous les droits, titres et int\xE9r\xEAts valides sur le plan juridique que vous poss\xE9dez pour votre CGU.');

var _ref34 = _jsx('strong', {}, void 0, '!Erreur de syntaxe, ^');

var _ref35 = _jsx('p', {}, void 0, 'Dans vos communications avec Henkel, rappelez-vous que nous ne recherchons aucune id\xE9e et aucun contenu non sollicit\xE9 pour des produits ou des services, ou m\xEAme des suggestions pour des am\xE9liorations des produits ou des services, notamment des id\xE9es, concepts, inventions ou designs pour de la musique, des sites Web, des applications, des livres, des scripts, des pi\xE8ces de th\xE9\xE2tre, des films, des \xE9missions de t\xE9l\xE9vision, des productions th\xE9\xE2trales, des logiciels ou autres (collectivement appel\xE9s \u201CLes id\xE9es et le mat\xE9riel non sollicit\xE9s\u201D, \u201CId\xE9es et mat\xE9riel non sollicit\xE9s\u201D et \u201CVos id\xE9es et votre mat\xE9riel non sollicit\xE9s\u201D). Toutes Les id\xE9es et le mat\xE9riel non sollicit\xE9s que vous soumettez sont consid\xE9r\xE9s comme du CGU et la licence nous appartient, tel qu\u2019\xE9tabli ci-dessous. De plus, Henkel poss\xE8de tous les droits d\xE9tenus par les membres du public concernant toutes Vos id\xE9es et votre mat\xE9riel non sollicit\xE9s. La r\xE9ception par Henkel de Vos id\xE9es et votre mat\xE9riel non sollicit\xE9s n\u2019est pas une reconnaissance par Henkel de leur nouveaut\xE9, de leur priorit\xE9 ou de leur originalit\xE9, et ne limite pas le droit de Henkel de contester les droits de propri\xE9t\xE9 intellectuelle existants ou futurs reli\xE9s \xE0 Vos id\xE9es et votre mat\xE9riel non sollicit\xE9s.');

var _ref36 = _jsx('p', {}, void 0, 'Repr\xE9sentations et garanties relatives \xE0 votre CGU. Chaque fois que vous soumettez du CGU, vous repr\xE9sentez et garantissez que vous avez au moins atteint l\u2019\xE2ge de la majorit\xE9 dans la r\xE9gion o\xF9 vous habitez et que vous \xEAtes le parent ou le tuteur l\xE9gal, ou que vous d\xE9tenez tous les consentements ad\xE9quats du parent ou du tuteur l\xE9gal, de tout mineur qui est illustr\xE9 dans le CGU que vous soumettez ou qui y a particip\xE9 et que, en ce qui a trait audit CGU, a) vous \xEAtes l\u2019unique auteur et propri\xE9taire de la propri\xE9t\xE9 intellectuelle et des autres droits li\xE9s au CGU, ou vous poss\xE9dez le droit l\xE9gal de soumettre le CGU et accordez \xE0 Henkel les droits en vertu des pr\xE9sentes Conditions et de toute Condition suppl\xE9mentaire applicable, sans aucune obligation de la part de Henkel d\u2019obtenir le consentement d\u2019un tiers et sans cr\xE9er d\u2019obligation ou de responsabilit\xE9 liant Henkel; b) le CGU est exact; c) le CGU n\u2019enfreint pas et, concernant les utilisations et l\u2019exploitation de Henkel \xE9tablis dans les pr\xE9sentes Conditions, n\u2019enfreindra aucun droit de propri\xE9t\xE9 intellectuelle ou les droits de tout tiers, ou toute loi ou r\xE9glementation applicable; et d) le CGU ne violera pas les pr\xE9sentes Conditions ou toute Modalit\xE9 suppl\xE9mentaire applicable, et ne causera pas de pr\xE9judice ou de dommages \xE0 quiconque.');

var _ref37 = _jsx('p', {}, void 0, 'Application. Henkel n\u2019est aucunement tenu de surveiller ou de faire appliquer vos droits de propri\xE9t\xE9 intellectuelle \xE0 votre CGU, mais vous nous donnez le droit de prot\xE9ger et d\u2019appliquer nos droits concernant votre CGU, y compris d\u2019entamer des poursuites en votre nom et pour vous (aux frais de Henkel, auxquelles vous consentez et nommez irr\xE9vocablement Henkel votre fond\xE9 de pouvoir, dot\xE9 du pouvoir de substitution et de d\xE9l\xE9gation, dont la d\xE9signation est accompagn\xE9e d\u2019un int\xE9r\xEAt).');

var _ref38 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Politique de protection du droit d\u2019auteur et agent des droits d\u2019auteur en vertu de la Digital Millennium Copyright Act (DMCA)'));

var _ref39 = _jsx('p', {}, void 0, 'Henkel respecte les droits de propri\xE9t\xE9 intellectuelle d\u2019autrui et s\u2019attend \xE0 ce que les utilisateurs de son Service fassent de m\xEAme. Henkel pourrait retirer du contenu qui, \xE0 sa seule discr\xE9tion, semble enfreindre les droits de propri\xE9t\xE9 intellectuelle d\u2019autrui. De plus, Henkel, \xE0 sa seule et absolue discr\xE9tion, pourrait fermer les comptes des utilisateurs qui enfreignent les droits de propri\xE9t\xE9 intellectuelle d\u2019autrui.');

var _ref40 = _jsx('p', {}, void 0, 'Si vous croyez qu\u2019un utilisateur du Service a enfreint vos droits d\u2019auteur, veuillez aviser l\u2019agent des droits d\u2019auteur de Henkel (voir ses coordonn\xE9es plus bas) et lui fournir l\u2019information suivante : A) la signature physique ou \xE9lectronique de la personne autoris\xE9e \xE0 agir au nom du propri\xE9taire du droit d\u2019auteur; b) une identification de la propri\xE9t\xE9 prot\xE9g\xE9e par le droit d\u2019auteur d\xE9clar\xE9e comme enfreinte; c) une description d\xE9taill\xE9e du mat\xE9riel qui, selon vous, est une violation, pour que nous puissions le localiser, y compris l\u2019URL o\xF9 le mat\xE9riel appara\xEEt; d) votre adresse, num\xE9ro de t\xE9l\xE9phone et adresse courriel; e) un \xE9nonc\xE9 par vous d\xE9clarant que vous croyez de bonne foi que l\u2019utilisation pr\xE9tendument attentatoire n\u2019est pas autoris\xE9e par le propri\xE9taire du droit d\u2019auteur, son agent ou la loi; et f) une d\xE9claration de votre part, faite sous peine de sanction ou de parjure, que l\u2019information qui pr\xE9c\xE8de est exacte et que vous \xEAtes autoris\xE9 \xE0 agir au nom du propri\xE9taire des droits d\u2019auteur concern\xE9s.');

var _ref41 = _jsx('br', {});

var _ref42 = _jsx('br', {});

var _ref43 = _jsx('br', {});

var _ref44 = _jsx('br', {});

var _ref45 = _jsx('br', {});

var _ref46 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Liens et services de tiers'));

var _ref47 = _jsx('p', {}, void 0, 'Nous ne sommes pas responsables des tiers ou de leur contenu, de leurs publicit\xE9s, applications ou sites (les \u201CServices offerts par des tiers\u201D). Par exemple, des parties du Service pourraient \xEAtre int\xE9gr\xE9es \xE0 des sites, plateformes et applications de tiers ou reli\xE9s auxdits sites, plateformes et applications, sur lesquels nous n\u2019avons pas de contr\xF4le. De m\xEAme, nous pourrions afficher de la publicit\xE9 et du contenu ou des services de tiers, que nous pourrions aussi ne pas contr\xF4ler, qui vous sont accessibles \xE0 l\u2019aide de notre Service. Cela pourrait comprendre la capacit\xE9 de s\u2019inscrire ou d\u2019ouvrir une session dans nos Services \xE0 l\u2019aide de Facebook Connect ou d\u2019autres outils de tiers, et de publier du contenu sur des sites et des services de tiers \xE0 l\u2019aide de plugiciels disponibles \xE0 l\u2019aide de nos Services. Soyez prudent lorsque vous traitez avec des tiers et consultez leurs conditions d\u2019utilisation et leurs politiques de confidentialit\xE9. Nous ne sommes aucunement responsables des Services offerts par des tiers. De plus, m\xEAme si Henkel pourrait vous fournir un lien vers un site Web de tiers, il est entendu que Henkel n\u2019endosse, n\u2019approuve, ne commandite ou ne soutient pas lesdits sites.');

var _ref48 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Exon\xE9ration de garanties'));

var _ref49 = _jsx('p', {}, void 0, 'Nous nous effor\xE7ons de d\xE9crire avec exactitude nos produits et services offerts sur le Service; toutefois, nous ne garantissons pas que les sp\xE9cifications, prix ou autre contenu sur le Service sont complets, exacts, fiables, \xE0 jour ou sans erreurs et les produits pourraient ne pas \xEAtre disponibles dans toutes les r\xE9gions. Pour les commandes en ligne, le cas \xE9ch\xE9ant, des Conditions suppl\xE9mentaires s\u2019appliquent.');

var _ref50 = _jsx('p', {}, void 0, 'TEL QUE PERMIS PAR LA LOI APPLICABLE, LE MAT\xC9RIEL ET L\u2019INFORMATION SUR LE SERVICE, ET TOUT MAT\xC9RIEL DISPONIBLE \xC0 L\u2019AIDE DU SERVICE, SONT FOURNIS \u201CTELS QUELS, TELS QUE DISPONIBLES\u201D ET \u201CAVEC TOUS SES D\xC9FAUTS\u201D, SANS GARANTIE D\u2019AUCUNE SORTE, EXPLICITE OU IMPLICITE. DANS LA PLEINE MESURE PERMISE EN VERTU DE LA LOI APPLICABLE, HENKEL ET SES SOCI\xC9T\xC9S M\xC8RES DIRECTES ET INDIRECTES, SES FILIALES, SES SOCI\xC9T\xC9S AFFILI\xC9ES, ET CHACUN DE LEURS EMPLOY\xC9S, DIRECTEURS, MEMBRES, GESTIONNAIRES, ACTIONNAIRES, REPR\xC9SENTANTS, FOURNISSEURS, CONC\xC9DANTS, TITULAIRES DE LICENCE, ENTREPRENEURS, CLIENTS, SUCCESSEURS ET CESSIONNAIRES RESPECTIFS (APPEL\xC9S COLLECTIVEMENT LES \u201CPARTIES DE HENKEL\u201D) SONT EXON\xC9R\xC9S DE TOUTE GARANTIE EXPLICITE OU IMPLICITE, NOTAMMENT TOUTE GARANTIE IMPLICITE DE QUALIT\xC9 MARCHANDE, D\u2019ADAPTATION \xC0 UN USAGE PARTICULIER, DE TITRE ET DE NON-CONTREFA\xC7ON.');

var _ref51 = _jsx('p', {}, void 0, 'TEL QUE PERMIS PAR LA LOI APPLICABLE, LES PARTIES DE HENKEL SONT EXON\xC9R\xC9ES DE TOUTE OBLIGATION ET N\u2019ASSUMENT AUCUNE RESPONSABILIT\xC9 POUR LES R\xC9SULTATS DE TOUT D\xC9FAUT OU INEXACTITUDE QUI POURRAIT EXISTER DANS LE SERVICE OU D\xC9COULANT DE SON FONCTIONNEMENT. HENKEL NE GARANTIT AUCUNEMENT QUE I) LE FONCTIONNEMENT DU SERVICE R\xC9PONDRA AUX EXIGENCES DES UTILISATEURS; II) L\u2019ACC\xC8S AU SERVICE SERA ININTERROMPU, S\xC9CURIS\xC9, EN TEMPS OPPORTUN, EXEMPT DE VIRUS, DE VERS, DE CHEVAUX DE TROIE OU D\u2019AUTRES COMPOSANTES DOMMAGEABLES, OU EXEMPT DE D\xC9FAUTS OU D\u2019ERREURS; III) LES R\xC9SULTATS POUVANT \xCATRE OBTENUS \xC0 LA SUITE DE L\u2019UTILISATION DU SERVICE SERONT EXACTS OU FIABLES; OU QUE IV) LES D\xC9FAUTS SERONT CORRIG\xC9S. VOUS (ET NON HENKEL) ASSUMEZ LA TOTALIT\xC9 DES CO\xDBTS DE TOUT ENTRETIEN, R\xC9PARATION OU CORRECTION QUI POURRAIT \xCATRE N\xC9CESSAIRE POUR VOTRE MAT\xC9RIEL INFORMATIQUE ET VOS LOGICIELS \xC0 LA SUITE DE TOUT VIRUS, ERREUR OU AUTRE PROBL\xC8ME, QUEL QU\u2019IL SOIT, QUE VOUS POURRIEZ AVOIR PARCE QUE VOUS AVEZ UTILIS\xC9 LE SERVICE.');

var _ref52 = _jsx('p', {}, void 0, 'SANS LIMITER LA PORT\xC9E DE CE QUI PR\xC9C\xC8DE, LA PR\xC9SENTE SECTION N\u2019ACCRO\xCET PAS ET NE LIMITE PAS I) TOUTE GARANTE DE PRODUIT \xC9CRITE EXPRESSE OU LES RENONCIATIONS RELI\xC9ES FOURNIES PAR HENKEL OU SES FOURNISSEURS CONCERNANT UN PRODUIT PHYSIQUE VENDU PAR HENKEL, OU TOUTE GARANTIE POUR UN PRODUIT PHYSIQUE DANS LA MESURE REQUISE PAR LA LOI APPLICABLE; II) L\u2019OBLIGATION DES PARTIES DE HENKEL POUR LE PR\xC9JUDICE PERSONNEL QUE LES PARTIES DE HENKEL VOUS ONT CAUS\xC9 DANS LA MESURE QUI N\u2019EST PAS EXON\xC9RABLE OU QUI NE PEUT PAS \xCATRE LIMIT\xC9E EN VERTU DE LA LOI APPLICABLE; OU III) TOUTE CAUSE D\u2019ACTION QUE VOUS POURRIEZ AVOIR \xC0 L\u2019ENCONTRE DES PARTIES DE HENKEL QUI N\u2019EST PAS EXON\xC9RABLE OU QUI NE PEUT PAS \xCATRE LIMIT\xC9E EN VERTU DE LA LOI APPLICABLE.');

var _ref53 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Limitation de responsabilit\xE9'));

var _ref54 = _jsx('p', {}, void 0, 'TEL QUE PERMIS PAR LA LOI APPLICABLE, EN AUCUNE CIRCONSTANCE, QUE CE SOIT D\xDB \xC0 LA N\xC9GLIGENCE OU AUTRE, LES PARTIES DE HENKEL NE PEUVENT \xCATRE TENUES RESPONSABLES DE TOUT DOMMAGE OU PR\xC9JUDICE, Y COMPRIS LES DOMMAGES DIRECTS, INDIRECTS, SP\xC9CIAUX, ACCESSOIRES, CONS\xC9CUTIFS, PUNITIFS OU AUTRES, NOTAMMENT LA PERTE DE DONN\xC9ES OU DE PROFITS, QUI POURRAIENT R\xC9SULTER DE L\u2019UTILISATION OU DE L\u2019INCAPACIT\xC9 D\u2019UTILISER LE SERVICE OU TOUT MAT\xC9RIEL DU SERVICE, D\xC9COULANT OU EN LIEN AVEC L\u2019UTILISATION OU LA PERFORMANCE DU SERVICE OU DE L\u2019INFORMATION DISPONIBLE DANS LE SERVICE. LESDITS DOMMAGES COMPRENNENT NOTAMMENT LES DOMMAGES OU LE PR\xC9JUDICE CAUS\xC9 PAR DES ERREURS, DES OMISSIONS, DES INTERRUPTIONS, DES D\xC9FAUTS, DES INEX\xC9CUTIONS, DES RETARDS DE FONCTIONNEMENT OU DE TRANSMISSION, DES D\xC9FECTUOSIT\xC9S DU R\xC9SEAU OU DES VIRUS INFORMATIQUES, VERS, CHEVAUX DE TROIE OU AUTRES COMPOSANTES DOMMAGEABLES. Y COMPRIS POUR LES DOMMAGES ACCESSOIRES OU CONS\xC9CUTIFS. TEL QUE PERMIS PAR LA LOI APPLICABLE, EN AUCUN CAS LA RESPONSABILIT\xC9 TOTALE DE HENKEL ENVERS VOUS POUR DES DOMMAGES, DES PERTES ET/OU DES CAUSES D\u2019ACTION D\xC9COULANT DU SERVICE NE PEUT D\xC9PASSER LE MONTANT LE PLUS \xC9LEV\xC9 ENTRE CENT DOLLARS (100 $), OU LE MONTANT QUE VOUS AURIEZ VERS\xC9 \xC0 HENKEL EN LIEN AVEC UN PRODUIT OU UN SERVICE SOUTENANT LA R\xC9CLAMATION, ET TOUTE R\xC9CLAMATION OU CAUSE D\u2019ACTION QUE VOUS POURRIEZ AVOIR CONCERNANT LE SERVICE (NOTAMMENT L\u2019ACHAT DE PRODUITS DE HENKEL) DOIT \xCATRE ENTAM\xC9E DANS L\u2019ANN\xC9E SUIVANT LE FAIT G\xC9N\xC9RATEUR DE LA R\xC9CLAMATION OU DE LA CAUSE D\u2019ACTION.');

var _ref55 = _jsx('p', {}, void 0, 'SANS LIMITER LA PORT\xC9E DE CE QUI PR\xC9C\xC8DE, LA PR\xC9SENTE SECTION N\u2019ACCRO\xCET PAS ET NE LIMITE PAS I) TOUTE GARANTIE DE PRODUIT \xC9CRITE EXPRESSE OU LES RENONCIATIONS CONNEXES FOURNIES PAR HENKEL OU SES FOURNISSEURS CONCERNANT UN PRODUIT PHYSIQUE VENDU PAR HENKEL \xC0 VOUS, OU TOUTE GARANTIE POUR UN PRODUIT PHYSIQUE DANS LA MESURE EXIG\xC9E PAR LA LOI APPLICABLE; II) L\u2019OBLIGATION DES PARTIES DE HENKEL POUR LE PR\xC9JUDICE PERSONNEL QUI VOUS A \xC9T\xC9 CAUS\xC9 PAR LES PARTIES DE HENKEL DANS LA MESURE QUI N\u2019EST PAS EXON\xC9RABLE OU QUI NE PEUT PAS \xCATRE LIMIT\xC9E EN VERTU DE LA LOI APPLICABLE; OU III) TOUTE CAUSE D\u2019ACTION QUE VOUS POURRIEZ AVOIR \xC0 L\u2019ENCONTRE DES PARTIES DE HENKEL, QUI N\u2019EST PAS RENONCIABLE OU QUI NE PEUT PAS \xCATRE LIMIT\xC9E EN VERTU DE LA LOI APPLICABLE.');

var _ref56 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Conditions relatives \xE0 l\u2019arbitrage et aux litiges'));

var _ref57 = _jsx('p', {}, void 0, 'S\xE9lection de l\u2019instance/juridiction. Pour les utilisateurs qui ne sont pas des r\xE9sidents de la province de Qu\xE9bec, la juridiction et l\u2019instance pour toute controverse, all\xE9gation ou r\xE9clamation d\xE9coulant du Service, du Contenu, de votre CGU, des pr\xE9sentes Conditions, ou de toute Condition suppl\xE9mentaire applicable (collectivement appel\xE9es \u201CLitige\u201D) doit avoir lieu \xE0 Wilmington, Delaware. Chaque partie se soumet \xE0 la juridiction personnelle et au tribunal de Wilmington, Delaware \xE0 toutes les fins possibles.');

var _ref58 = _jsx('p', {}, void 0, 'Avis de pr\xE9arbitrage. Henkel et vous convenez qu\u2019il serait avantageux de discuter et, id\xE9alement, de r\xE9soudre tout litige avant d\u2019entamer des proc\xE9dures officielles; \xE0 condition, toutefois, que Henkel n\u2019ait pas \xE0 le faire dans des circonstances o\xF9 ses r\xE9clamations relatives aux droits de Propri\xE9t\xE9 intellectuelle sont concern\xE9es (appel\xE9es \u201CLitiges relatifs aux droits de Propri\xE9t\xE9 intellectuelle\u201D, alors que tous les autres litiges sont appel\xE9s \u201CLitiges g\xE9n\xE9raux\u201D). La partie soumettant une r\xE9clamation - que ce soit vous ou Henkel - doit envoyer une lettre \xE0 l\u2019autre partie pour r\xE9sumer bri\xE8vement la r\xE9clamation et la demande de r\xE9paration. Si Henkel soumet une r\xE9clamation, la lettre doit \xEAtre transmise par courriel \xE0 l\u2019adresse courriel figurant dans votre compte Henkel, le cas \xE9ch\xE9ant. Si ces renseignements ne figurent pas dans votre compte ou s\u2019ils ne sont pas \xE0 jour, nous ne sommes pas tenus d\u2019envoyer un avis ou de retarder les obligations en vertu de la pr\xE9sente section 11(b). Si vous soumettez une r\xE9clamation, la lettre doit \xEAtre envoy\xE9e \xE0 la Henkel Corporation, One Henkel Way, Rocky Hill, CT 06067 (\xC0 l\u2019attention des Services juridiques). Si le Litige n\u2019est pas r\xE9solu dans les soixante (60) jours suivant l\u2019avis, le demandeur peut entamer des proc\xE9dures, tel qu\u2019\xE9tabli dans la pr\xE9sente section 11, ou tel que permis par la loi applicable. Vous ou Henkel pouvez toutefois rechercher des mesures provisionnelles (comme une injonction pr\xE9liminaire, assujettie \xE0 la section 11(d)) avant l\u2019expiration de la p\xE9riode de soixante (60) jours.');

var _ref59 = _jsx('p', {}, void 0, 'Limitation de l\u2019injonction. TEL QUE PERMIS PAR LA LOI APPLICABLE, SI VOUS D\xC9CLAREZ QUE VOUS AVEZ SUBI DES PERTES, DES DOMMAGES OU UN PR\xC9JUDICE EN LIEN AVEC VOTRE UTILISATION DU SERVICE, LES PERTES, LES DOMMAGES ET LE PR\xC9JUDICE NE SERONT PAS JUG\xC9S COMME IRR\xC9PARABLES OU SUFFISANTS POUR VOUS DONNER DROIT \xC0 UNE INJONCTION OU \xC0 UNE AUTRE FORME DE RECOURS \xC9QUITABLE DE TOUTE NATURE QUE CE SOIT. CELA SIGNIFIE (SANS LIMITATION) QUE, EN LIEN AVEC VOTRE R\xC9CLAMATION, VOUS CONVENEZ QUE VOUS NE RECHERCHEREZ, ET QUE VOUS N\u2019AUREZ PAS LE DROIT D\u2019OBTENIR, TOUTE POURSUITE EN COUR OU AILLEURS QUI POURRAIT ENTRAVER OU EMP\xCACHER LE D\xC9VELOPPEMENT OU L\u2019EXPLOITATION DU SERVICE OU DE TOUT ASPECT DE CES DERNIERS, OU DE LA PROPRI\xC9T\xC9 INTELLECTUELLE D\xC9TENUE, SOUS LICENCE, UTILIS\xC9E OU CONTR\xD4L\xC9E PAR TOUTE PARTIE DE HENKEL (Y COMPRIS VOTRE CGU SOUS LICENCE) OU \xC0 UN CONC\xC9DANT DE TOUTE PARTIE DE HENKEL.');

var _ref60 = _jsx('p', {}, void 0, 'Droit applicable. Pour les utilisateurs qui ne sont pas des r\xE9sidents individuels de la province de Qu\xE9bec, les pr\xE9sentes Conditions et toute Condition suppl\xE9mentaire applicable, les Litiges g\xE9n\xE9raux et les Litiges relatifs aux droits de Propri\xE9t\xE9 intellectuelle, et toute autre r\xE9clamation soumise par vous \xE0 l\u2019encontre de Henkel, ou par Henkel \xE0 votre encontre en vertu de la pr\xE9sente section 11, ou autrement reli\xE9 au Service, au Contenu, aux \xC9l\xE9ments autoris\xE9s par Henkel, au CGU ou \xE0 d\u2019autres produits ou services de Henkel, seront r\xE9gis par les lois de l\u2019\xC9tat du Delaware, \xC9tats-Unis, sans \xE9gard aux dispositions sur les conflits des lois qui pourraient appliquer les lois d\u2019une autre juridiction. La pr\xE9sente section 11 est r\xE9gie uniquement par la Federal Arbitration Act, 9 U.S.C. \xA71, et seq., et non par la loi de tout \xC9tat, et est ex\xE9cutable en vertu de ses modalit\xE9s sur une base automatiquement ex\xE9cutoire. Vous et Henkel convenez que nous entendons que la pr\xE9sente section 11 satisfasse l\u2019exigence \u201C\xE9crite\u201D de la Federal Arbitration Act. La pr\xE9sente section 11 peut uniquement \xEAtre modifi\xE9e d\u2019un commun accord. L\u2019une ou l\u2019autre partie peut rechercher l\u2019ex\xE9cution de la pr\xE9sente section 11 \xE0 tout tribunal de juridiction comp\xE9tente. L\u2019arbitre doit d\xE9terminer toutes les difficult\xE9s reli\xE9es \xE0 l\u2019arbitrabilit\xE9 d\u2019une r\xE9clamation.');

var _ref61 = _jsx('p', {}, void 0, 'Exon\xE9ration des recours collectifs. Dans la mesure o\xF9 la loi applicable le permet, et pour les utilisateurs qui ne sont pas des r\xE9sidents individuels de la province de Qu\xE9bec, vous et Henkel renoncez au droit de soumettre tout Litige en tant que recours collectif, action r\xE9unie, action d\xE9riv\xE9e ou action g\xE9n\xE9rale d\u2019un fond\xE9 de pouvoir, ou de participer \xE0 un recours collectif, \xE0 une action r\xE9unie, \xE0 une action d\xE9riv\xE9e ou \xE0 une action g\xE9n\xE9rale d\u2019un fond\xE9 de pouvoir concernant tout Litige soumis par toute autre personne. Sans limiter la port\xE9e de toute disposition contraire des R\xE8gles et proc\xE9dures exhaustives d\u2019arbitrage de JAMS, l\u2019arbitre ne d\xE9tient pas le pouvoir ou la comp\xE9tence d\u2019entendre l\u2019arbitrage de recours collectifs, d\u2019actions r\xE9unies, d\u2019actions d\xE9riv\xE9es ou d\u2019actions g\xE9n\xE9rales d\u2019un fond\xE9 de pouvoir ou de regrouper, de joindre ou de combiner autrement les Litiges de diff\xE9rentes personnes en une seule poursuite. Sans limiter la port\xE9e des dispositions d\u2019arbitrage susmentionn\xE9es, si la disposition relative \xE0 la renonciation \xE0 un recours collectif, \xE0 une action r\xE9unie, \xE0 une action d\xE9riv\xE9e et \xE0 une action g\xE9n\xE9rale d\u2019un fond\xE9 de pouvoir de la pr\xE9sente section 11 est d\xE9clar\xE9e nulle ou autrement inex\xE9cutable, tout recours collectif, action r\xE9unie, action d\xE9riv\xE9e ou action g\xE9n\xE9rale d\u2019un fond\xE9 de pouvoir doit \xEAtre entendue et d\xE9termin\xE9e \xE0 l\u2019aide d\u2019une proc\xE9dure judiciaire appropri\xE9e, et non par arbitrage.');

var _ref62 = _jsx('p', {}, void 0, 'Renonciation \xE0 un jury. TEL QUE PERMIS PAR LA LOI APPLICABLE, LES PARTIES RENONCENT PAR LES PR\xC9SENTES \xC0 LEUR DROIT \xC0 UN PROC\xC8S DEVANT JURY POUR TOUTES LES R\xC9CLAMATIONS ET QUESTIONS RELEVANT DES PR\xC9SENTES CONDITIONS OU RELI\xC9ES AUX PR\xC9SENTES CONDITIONS, LA VIOLATION DESDITES CONDITIONS OU LA PORT\xC9E DES DISPOSITIONS DE LA PR\xC9SENTE SECTION, QUE CE SOIT SUR LE FONDEMENT DU DROIT DES CONTRATS OU DE LA RESPONSABILIT\xC9 D\xC9LICTUELLE, ET Y COMPRIS TOUTE R\xC9CLAMATION POUR INCITATION FRAUDULEUSE DE CES DERNIERS.');

var _ref63 = _jsx('p', {}, void 0, 'Affaires des petites cr\xE9ances. Sans limiter la port\xE9e de ce qui pr\xE9c\xE8de, l\u2019une ou l\u2019autre partie peut soumettre une r\xE9clamation admissible de Litige g\xE9n\xE9ral (mais non de Litige relatif aux droits de Propri\xE9t\xE9 intellectuelle) aux petites cr\xE9ances, en vertu de la section 11(f).');

var _ref64 = _jsx('p', {}, void 0, 'Pr\xE9s\xE9ance. Les dispositions de la pr\xE9sente section 11 ont pr\xE9s\xE9ance sur toute disposition incoh\xE9rente de toute entente pr\xE9alable entre les parties. La pr\xE9sente section 11 demeure en vigueur ind\xE9pendamment de toute r\xE9siliation de votre utilisation du Service ou des pr\xE9sentes Conditions.');

var _ref65 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Logiciels t\xE9l\xE9charg\xE9s'));

var _ref66 = _jsx('p', {}, void 0, 'Si vous t\xE9l\xE9chargez des logiciels \xE0 partir du Service, les logiciels et tous les fichiers, images et donn\xE9es reli\xE9s aux logiciels sont sujets aux conditions de la licence qui accompagnent les logiciels ou sont fournies avec les logiciels. Vous pouvez uniquement utiliser les logiciels conform\xE9ment aux conditions desdites licences de logiciels. Vous n\u2019\xEAtes pas propri\xE9taire des logiciels t\xE9l\xE9charg\xE9s, et Henkel ne vous transf\xE8re pas la propri\xE9t\xE9 des logiciels. Vous n\u2019\xEAtes pas autoris\xE9 \xE0 redistribuer, \xE0 vendre, \xE0 d\xE9compiler, \xE0 faire de l\u2019ing\xE9nierie inverse, \xE0 d\xE9sassembler ou \xE0 r\xE9duire d\u2019une autre fa\xE7on les logiciels sous une forme perceptible par les humains.');

var _ref67 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Mise \xE0 jour des Conditions'));

var _ref68 = _jsx('p', {}, void 0, 'Vous \xEAtes responsable de r\xE9viser les Conditions publi\xE9es et toute Condition suppl\xE9mentaire applicable. Chaque fois que vous utilisez le pr\xE9sent SERVICE, VOUS CONCLUEZ UNE NOUVELLE ENTENTE AVEC NOUS EN VERTU DES CONDITIONS ET DES MODALIT\xC9S APPLICABLES \xC0 CE MOMENT ET VOUS CONVENEZ QUE NOUS POUVONS VOUS AVISER DE NOUVELLES CONDITIONS EN LES PUBLIANT SUR LE SERVICE (OU PAR TOUT MOYEN RAISONNABLE QUE NOUS CHOISISSONS POUR VOUS EN AVISER), ET QUE VOTRE UTILISATION DU SERVICE APR\xC8S UN TEL AVIS CONSTITUE VOTRE ACCORD CONTINU AUX NOUVELLES CONDITIONS DANS LE CADRE DE VOTRE UTILISATION ET DE VOS TRANSACTIONS FUTURES. Toute nouvelle Condition ou Modalit\xE9 suppl\xE9mentaire entrera en vigueur pour les nouvelles utilisations et transactions au moment o\xF9 nous la publions, ou \xE0 la date ult\xE9rieure indiqu\xE9e dans la nouvelle Condition ou Modalit\xE9 suppl\xE9mentaire, ou dans un autre avis qui vous a \xE9t\xE9 transmis, le cas \xE9ch\xE9ant. Si un avis \xE0 votre intention concernant des conditions nouvelles, r\xE9vis\xE9es ou suppl\xE9mentaires est d\xE9termin\xE9 par un tribunal comme \xE9tant insuffisant, l\u2019entente ant\xE9rieure doit se poursuivre jusqu\u2019\xE0 ce qu\u2019un avis suffisant pour \xE9tablir une nouvelle entente ait \xE9t\xE9 r\xE9alis\xE9. Vous pouvez rejeter toute condition nouvelle, r\xE9vis\xE9e ou suppl\xE9mentaire en cessant d\u2019utiliser le Service.');

var _ref69 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, '\xC9nonc\xE9s prospectifs'));

var _ref70 = _jsx('p', {}, void 0, 'Le Service pourrait comprendre des \xE9nonc\xE9s qui indiquent les intentions, les attentes ou les pr\xE9visions de Henkel. De tels \xE9nonc\xE9s refl\xE8tent les opinions de Henkel \xE0 la date de publication des \xE9nonc\xE9s en ce qui a trait aux \xE9v\xE9nements futurs et sont sujets aux risques et aux incertitudes. Lesdits \xE9nonc\xE9s pourraient \xEAtre inexacts ou devenir inexacts \xE0 la suite d\u2019\xE9v\xE9nements se produisant apr\xE8s leur date respective. Henkel rejette toute intention ou obligation de mettre \xE0 jour ou de r\xE9viser lesdits \xE9nonc\xE9s.');

var _ref71 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Divisibilit\xE9/absence de renonciation, entente compl\xE8te'));

var _ref72 = _jsx('p', {}, void 0, 'Si l\u2019une ou l\u2019autre des dispositions des pr\xE9sentes Conditions s\u2019av\xE8re ill\xE9gale, nulle ou inex\xE9cutable pour quelque raison que ce soit, ladite disposition sera consid\xE9r\xE9e comme divisible des pr\xE9sentes Conditions et n\u2019affectera pas la validit\xE9 et l\u2019ex\xE9cutabilit\xE9 des autres dispositions. Au cas o\xF9 Henkel omet d\u2019appliquer les pr\xE9sentes Conditions. Cela ne peut constituer une renonciation des droits de Henkel en vertu des pr\xE9sentes Conditions, pour des actions pass\xE9es ou futures de la part de toute personne. Les pr\xE9sentes Conditions constituent l\u2019entente compl\xE8te entre Henkel et vous en ce qui a trait \xE0 l\u2019objet en question, et ont pr\xE9s\xE9ance sur toutes les interpr\xE9tations ant\xE9rieures ou actuelles concernant ledit objet. Aucune modification des pr\xE9sentes Conditions ne sera liante, sauf tel qu\u2019indiqu\xE9 dans une mise \xE0 jour du pr\xE9sent document par Henkel, ou tel qu\u2019indiqu\xE9 dans un document sign\xE9 manuellement par un agent autoris\xE9 de Henkel.');

var _ref73 = _jsx('h2', {}, void 0, 'D\xE9claration de confidentialit\xE9');

var _ref74 = _jsx('br', {});

var _ref75 = _jsx('p', {}, void 0, 'Merci de visiter un site Web, une application mobile ou un autre service en ligne (le \u201CService\u201D) qui nous appartient et est exploit\xE9 par la Henkel Corporation ou l\u2019une de ses filiales ou soci\xE9t\xE9s affili\xE9es (\u201CHenkel\u201D, \u201Cnous\u201D, \u201Cnotre\u201D, \u201Cnos\u201D). Le pr\xE9sent D\xE9claration de confidentialit\xE9 d\xE9crit les renseignements que Henkel pourrait recueillir et comment nous les utilisons et les prot\xE9geons.');

var _ref76 = _jsx('p', {}, void 0, _jsx('i', {}, void 0, 'En vigueur \xE0 compter du : 14 novembre 2017'));

var _ref77 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Port\xE9e'));

var _ref78 = _jsx('p', {}, void 0, 'Le pr\xE9sent D\xE9claration de confidentialit\xE9 s\u2019applique \xE0 votre utilisation de tout Service (p. ex. site Web, application mobile ou produit connect\xE9 \xE0 Internet) qui publie un lien vers le pr\xE9sent D\xE9claration de confidentialit\xE9 ou fournit autrement un avis de son applicabilit\xE9, peu importe de quelle fa\xE7on vous y acc\xE9dez ou l\u2019utilisez. Il ne s\u2019applique pas aux renseignements que nous obtenons dans notre capacit\xE9 \xE0 titre d\u2019employeur, sauf pour les demandes d\u2019emploi et les requ\xEAtes re\xE7ues \xE0 l\u2019aide du Service. Le pr\xE9sent \xC9nonc\xE9 de confidentialit\xE9 s\u2019applique \xE0 notre collecte, utilisation et divulgation de renseignements \xE0 votre sujet \xE0 l\u2019aide du Service et ne s\u2019applique pas \xE0 nos activit\xE9s hors du Service ou sur des sites Web de tiers accessibles par les hyperliens se trouvant sur un Service de Henkel.');

var _ref79 = _jsx('p', {}, void 0, 'Pour certains aspects du Service, des avis suppl\xE9mentaires pourraient s\u2019appliquer au sujet des pratiques et des choix en mati\xE8re de confidentialit\xE9. Veuillez lire lesdites divulgations de confidentialit\xE9 suppl\xE9mentaires pour comprendre comment elles s\u2019appliquent \xE0 vous.');

var _ref80 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'R\xE9visions'));

var _ref81 = _jsx('p', {}, void 0, 'Henkel se r\xE9serve le droit de modifier le pr\xE9sent D\xE9claration de confidentialit\xE9 de mani\xE8re prospective et les modifications entrent en vigueur lors de la publication de l\u2019D\xE9claration de confidentialit\xE9 r\xE9vis\xE9; votre utilisation du Service indique que vous consentez \xE0 l\u2019d\xE9claration de confidentialit\xE9 publi\xE9 au moment de l\u2019utilisation. Toutefois, nous n\u2019utiliserons pas vos renseignements personnels pr\xE9c\xE9demment recueillis par Henkel (d\xE9finis plus bas), dans la mesure o\xF9 ils ne sont pas recueillis en vertu du nouvel d\xE9claration de confidentialit\xE9, d\u2019une mati\xE8re significativement diff\xE9rente que celle repr\xE9sent\xE9e au moment o\xF9 ils ont \xE9t\xE9 recueillis sans votre consentement. Dans la mesure o\xF9 une disposition du pr\xE9sent D\xE9claration de confidentialit\xE9 est d\xE9clar\xE9e invalide ou inex\xE9cutable par un tribunal comp\xE9tent, ladite disposition doit \xEAtre dissoci\xE9e dans la mesure n\xE9cessaire pour que le reste demeure valide et ex\xE9cutable.');

var _ref82 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Renseignements recueillis'));

var _ref83 = _jsx('p', {}, void 0, 'Vous pouvez visiter notre Service sans nous indiquer qui vous \xEAtes ou r\xE9v\xE9ler des renseignements personnels \xE0 votre sujet; toutefois, cela pourrait rendre certains services de Henkel indisponibles pour vous. Vous pouvez toutefois choisir de fournir des Renseignements personnels (d\xE9finis comme des renseignements qui vous identifient personnellement, comme votre pr\xE9nom et votre nom de famille, votre adresse courriel, votre num\xE9ro de t\xE9l\xE9phone, votre adresse et votre num\xE9ro complet de compte de paiement).');

var _ref84 = _jsx('p', {}, void 0, 'Les types de renseignements que Henkel peut recueillir \xE0 votre sujet comprennent notamment :');

var _ref85 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Vos coordonn\xE9es (comme votre nom, votre adresse, votre ville, votre \xC9tat, votre province/territoire, votre code ZIP/postal, votre adresse courriel et votre num\xE9ro de t\xE9l\xE9phone).'));

var _ref86 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Pr\xE9f\xE9rences en mati\xE8re de produits.'));

var _ref87 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Des \u201CRenseignements d\xE9mographiques\u201D comme la tranche d\u2019\xE2ge, le sexe, la date de naissance, l\u2019\xE9tat civil, le code ZIP/postal et la composition du m\xE9nage). Sauf dans la mesure requise par la loi applicable, les Renseignements d\xE9mographiques sont des \u201CRenseignements de nature non personnelle\u201D (c.-\xE0-d. des donn\xE9es qui ne sont pas consid\xE9r\xE9es comme des Renseignements personnels en vertu du pr\xE9sent D\xE9claration de confidentialit\xE9).'));

var _ref88 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Les \u201CRenseignements sur l\u2019utilisation\u201D comme l\u2019adresse IP, l\u2019identifiant de l\u2019appareil, le type de navigateur, le syst\xE8me d\u2019exploitation, les renseignements sur votre utilisation du Service et les donn\xE9es concernant le mat\xE9riel connect\xE9 au r\xE9seau (p. ex. l\u2019ordinateur ou d\u2019appareil mobile). Sauf dans la mesure exig\xE9e par la loi applicable, ou dans la mesure o\xF9 les Renseignements sur l\u2019utilisation sont combin\xE9s par Henkel ou au nom de Henkel aux Renseignements personnels, Henkel ne consid\xE8re pas les Renseignements sur l\u2019utilisation (notamment les identifiants uniques d\u2019appareils) comme des Renseignements personnels ou des Renseignements personnels recueillis par Henkel.'));

var _ref89 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Le num\xE9ro d\u2019assurance sociale (le \u201CNAS\u201D) (dans des circonstances limit\xE9es, Henkel pourrait recueillir des NAS, par exemple si vous gagnez un tirage au sort ou recevez une r\xE9mun\xE9ration qui doit \xEAtre d\xE9clar\xE9e \xE0 des fins fiscales).'));

var _ref90 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Des photographies et des vid\xE9os (p. ex. qui sont soumises par les clients \xE0 l\u2019aide de sites Web, par exemple dans le cadre de concours ou de tirages au sort).'));

var _ref91 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Les renseignements de demandes d\u2019emploi (comme le NAS, le num\xE9ro de permis de conduire, des renseignements financiers, la v\xE9rification des ant\xE9c\xE9dents, et le sexe ou la race [tel que permis par la loi]).'));

var _ref92 = _jsx('p', {}, void 0, 'Si vous choisissez de participer aux activit\xE9s du Service, comme des inscriptions sur un site Web, des concours, des tirages au sort, des questionnaires, des sondages, des contacts avec le service \xE0 la client\xE8le, des achats de produits, des applications mobiles, des plateformes de m\xE9dias sociaux, ou par le biais de notre Centre de carri\xE8res ou de requ\xEAtes sur l\u2019emploi, Henkel recueillera les Renseignements personnels que vous fournissez (les \u201CRenseignements personnels recueillis par Henkel\u201D). Nous pourrions am\xE9liorer ou fusionner les renseignements que vous nous fournissez directement avec des renseignements provenant d\u2019autres sources, y compris de tiers, aux fins d\xE9crites plus bas. Dans la mesure o\xF9 tout renseignement est combin\xE9 par Henkel ou au nom de Henkel \xE0 des Renseignements personnels recueillis par Henkel, Henkel traitera les donn\xE9es combin\xE9es comme des Renseignements personnels recueillis par Henkel en vertu du pr\xE9sent D\xE9claration de confidentialit\xE9.');

var _ref93 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Utilisation des renseignements'));

var _ref94 = _jsx('p', {}, void 0, 'Nous recueillerons, maintenons et utilisons vos Renseignements personnels recueillis par Henkel, d\u2019autres Renseignements personnels, et d\u2019autres renseignements, \xE0 des fins qui ne sont pas incompatibles avec le pr\xE9sent D\xE9claration de confidentialit\xE9 ou tout \xE9nonc\xE9 \xE9crit que nous effectuons au moment de la collecte, par exemple aux fins suivantes :');

var _ref95 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\xE9tablir et v\xE9rifier l\u2019identit\xE9 et l\u2019admissibilit\xE9 des utilisateurs;'));

var _ref96 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'ouvrir, maintenir, administrer et desservir des profils, des comptes ou l\u2019adh\xE9sion d\u2019utilisateurs;'));

var _ref97 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'traiter, desservir ou effectuer des transactions et envoyer des communications connexes;'));

var _ref98 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'fournir des produits, des services et du soutien aux utilisateurs;'));

var _ref99 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'mettre en \u0153uvre des tirages au sort, des sondages et des concours, et fournir les r\xE9sultats de ces derniers;'));

var _ref100 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'exploiter et am\xE9liorer le Service, y compris le personnaliser en fonction des pr\xE9f\xE9rences des utilisateurs;'));

var _ref101 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'fournir des mises \xE0 jour sur les produits ou les services aux utilisateurs;'));

var _ref102 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'envoyer des avis promotionnels, des offres ou d\u2019autre mat\xE9riel de marketing cibl\xE9, et d\u2019autres informations;'));

var _ref103 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'r\xE9pondre \xE0 vos questions, requ\xEAtes, commentaires et instructions;'));

var _ref104 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'maintenir la s\xE9curit\xE9 et l\u2019int\xE9grit\xE9 de nos syst\xE8mes;'));

var _ref105 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'comprendre les pr\xE9f\xE9rences des consommateurs \xE0 l\u2019\xE9chelle de nombreuses marques;'));

var _ref106 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'maintenir de bonnes relations avec les clients;'));

var _ref107 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\xE9valuer la performance et la s\xE9curit\xE9 des produits;'));

var _ref108 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'se conformer aux politiques, aux proc\xE9dures et aux exigences juridiques;'));

var _ref109 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'am\xE9liorer nos produits et nos services, ainsi que d\u2019autres fins commerciales.'));

var _ref110 = _jsx('br', {});

var _ref111 = _jsx('p', {}, void 0, 'Les renseignements que vous fournissez en pr\xE9sentant une demande d\u2019emploi ou de stage via notre Centre de carri\xE8res sont utilis\xE9s pour vous fournir de l\u2019information sur les occasions d\u2019emploi, pour administrer le processus d\u2019embauche et \xE9tudier votre candidature. Lorsque c\u2019est applicable, en combinaison avec les lois et les r\xE8glements appliqu\xE9s par la Equal Employment Opportunity Commission (la \u201CEEOC\u201D), l\u2019Office of Federal Contract Compliance Programs (l\u2019\u201DOFCCP\u201D) et les organisations de r\xE9glementation \xE9tatiques et locales semblables, nous pourrions vous demander de nous fournir des renseignements personnellement identifiables (comme le statut d\u2019ancien combattant, le sexe et l\u2019ethnicit\xE9). La fourniture de renseignements personnellement identifiables est volontaire, mais si vous nous fournissez lesdits renseignements, nous pourrions les soumettre \xE0 l\u2019EOC, \xE0 l\u2019OFCCP et \xE0 des organisations de r\xE9glementation \xE9tatiques et locales semblables, ou les utiliser ou les divulguer autrement \xE0 des fins commerciales, notamment pour r\xE9pondre \xE0 des demandes d\u2019information, r\xE9pondre \xE0 des exigences r\xE9glementaires en mati\xE8re de production de rapports et nous d\xE9fendre en cas de plaintes reli\xE9es \xE0 l\u2019emploi.');

var _ref112 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Renseignements que vous divulguez publiquement ou \xE0 autrui'));

var _ref113 = _jsx('p', {}, void 0, 'De plus, le Service pourrait vous donner la possibilit\xE9 d\u2019envoyer une communication \xE0 un ami ou \xE0 un autre contact. Dans ce cas, Henkel se fie sur vous pour envoyer des communications uniquement aux personnes qui vous ont donn\xE9 la permission de le faire. Les Renseignements personnels que vous fournissez sur le destinataire (p. ex. son nom et son adresse courriel) seront utilis\xE9s pour faciliter la communication, mais ne seront pas utilis\xE9s par Henkel \xE0 d\u2019autres fins de marketing, sauf si Henkel obtient le consentement de ladite personne. Votre nom complet, vos coordonn\xE9es et le message peuvent \xEAtre inclus dans la communication. En ce qui concerne les r\xE9sidents du Canada, vous pourriez uniquement nous fournir les coordonn\xE9es d\u2019amis avec lesquels vous avez eu des communications directes, volontaires et mutuelles, et avec lesquels il est raisonnable de conclure que vous avez une relation personnelle en tenant compte des int\xE9r\xEAts, des exp\xE9riences et des opinions partag\xE9s, et d\u2019autres facteurs pertinents. Vous pourriez fournir uniquement l\u2019adresse courriel de membres de votre famille avec lesquels vous \xEAtes li\xE9 par le mariage, une union de fait ou une relation parent-enfant, et avec lesquels vous avez eu des communications directes.');

var _ref114 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Enregistrement chronologique des donn\xE9es \xE0 l\u2019aide de la technologie, t\xE9moins et techniques reli\xE9es'));

var _ref115 = _jsx('p', {}, void 0, 'Lorsque vous interagissez avec nos Services, votre navigateur ou votre appareil pourrait communiquer avec la technologie que nous utilisons dans le cadre de notre Service. Par exemple, pendant que vous utilisez notre Service, votre navigateur communique avec notre technologie, qui enregistre par la suite vos interactions et vos demandes de services et de contenu pour nous aider \xE0 g\xE9rer et \xE0 am\xE9liorer l\u2019utilit\xE9 de notre Service, et pour effectuer de la recherche et analyser son utilisation. Les types de Renseignements sur l\u2019utilisation peuvent comprendre votre adresse de protocole Internet (adresse IP), votre type de navigateur, l\u2019URL, les demandes effectu\xE9es, les pages visit\xE9es, les activit\xE9s effectu\xE9es sur la page, le jour et l\u2019heure de la visite et des renseignements techniques reli\xE9s sur l\u2019utilisation.');

var _ref116 = _jsx('p', {}, void 0, 'Des t\xE9moins et autres technologies de suivi d\xE9velopp\xE9es maintenant et \xE0 l\u2019avenir (les \u201CTechnologies de suivi\u201D) pourraient \xEAtre utilis\xE9s pour recueillir des renseignements sur les interactions avec le Service ou les courriels, y compris des renseignements sur votre comportement de navigation et d\u2019achat, pour vous authentifier au Service, pour analyser comment le Service est utilis\xE9, pour relier les renseignements \xE0 la fa\xE7on dont vous utilisez le Service avec votre compte, et pour faciliter la personnalisation de nos services. Nous utilisons ces moyens technologiques, tout comme le font nos filiales, partenaires commerciaux et fournisseurs de services. Pour nous aider \xE0 mesurer l\u2019activit\xE9 du Service et fournir une meilleure exp\xE9rience aux utilisateurs, nous pourrions permettre \xE0 nos fournisseurs de services ou \xE0 nos partenaires commerciaux de compiler des renseignements comme les renseignements indiqu\xE9s plus haut \xE0 l\u2019aide de Technologies de suivi. Nous pourrions aussi permettre \xE0 nos partenaires de publicit\xE9 et de personnalisation tiers de recueillir et d\u2019utiliser lesdits renseignements pour cr\xE9er du contenu personnalis\xE9 et de la publicit\xE9 appropri\xE9e (y compris pour des soci\xE9t\xE9s non affili\xE9es avec nous) selon vos visites avec le temps de sites Web, d\u2019applications et d\u2019autres services en ligne appartenant ou non \xE0 Henkel. Vous pourriez voir lesdites publicit\xE9s sur d\u2019autres sites Web, applications et services en ligne. Lesdits renseignements pourraient aussi \xEAtre utilis\xE9s pour \xE9valuer nos campagnes de publicit\xE9 en ligne et celles de tiers ou pour personnaliser des promotions et d\u2019autres messages commerciaux \xE0 votre intention sur notre Service et d\u2019autres sites Web, applications et services en ligne.');

var _ref117 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Partage et stockage des donn\xE9es'));

var _ref118 = _jsx('p', {}, void 0, 'Henkel pourrait divulguer vos renseignements \xE0 des tiers dans une mesure correspondant au pr\xE9sent D\xE9claration de confidentialit\xE9 ou \xE0 d\u2019autres \xE9nonc\xE9s \xE9crits faits par nous au moment de la collecte, et dans la mesure ou ladite divulgation n\u2019est pas interdite par la loi applicable, notamment des fa\xE7ons suivantes :');

var _ref119 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Les agents, fournisseurs, consultants et autres fournisseurs de services de Henkel (collectivement appel\xE9s les \u201CFournisseurs de services\u201D) pourraient avoir acc\xE8s \xE0 vos renseignement, notamment aux Renseignements personnels recueillis par Henkel et \xE0 d\u2019autres Renseignements personnels, \xE0 des Renseignements d\xE9mographiques et \xE0 des Renseignements sur l\u2019utilisation, en lien avec leur travail au nom de Henkel, \xE0 condition toutefois que Henkel n\u2019autorise pas ses Fournisseurs de services \xE0 utiliser les Renseignements personnels recueillis par Henkel \xE0 vous envoyer directement des messages de marketing direct autres que ceux reli\xE9s \xE0 Henkel et aux filiales de Henkel sans votre consentement. Pour en savoir davantage sur les choix que les Fournisseurs de services peuvent vous offrir, consultez la section 11.'));

var _ref120 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Nous nous r\xE9servons le droit de divulguer vos Renseignements personnels recueillis par Henkel et d\u2019autres Renseignements personnels si la loi l\u2019exige, en cas de mandat de perquisition, d\u2019assignation \xE0 compara\xEEtre, d\u2019ordonnance judiciaire ou sur demande des autorit\xE9s gouvernementales.'));

var _ref121 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Nous pourrions fournir des Renseignements personnels recueillis par Henkel et d\u2019autres Renseignements personnels vous concernant \xE0 des tiers en lien avec la r\xE9organisation, la fusion, la vente, la coentreprise, la cession, le transfert ou autre disposition de la totalit\xE9 ou d\u2019une partie de notre entreprise, de nos actifs ou de notre inventaire, y compris les activit\xE9s associ\xE9es \xE0 la faillite ou \xE0 d\u2019autres proc\xE9dures semblables.'));

var _ref122 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Henkel pourrait partager vos Renseignements personnels avec ses soci\xE9t\xE9s affili\xE9es et ses filiales (les \u201CFiliales\u201D), et d\u2019autres tiers, dont certains pourraient se situer \xE0 l\u2019ext\xE9rieur des \xC9tats-Unis, \xE0 des fins de marketing et autres activit\xE9s commerciales, sous r\xE9serve de certains droits des r\xE9sidents de la Californie et du Connecticut [voir la section 12].'));

var _ref123 = _jsx('br', {});

var _ref124 = _jsx('p', {}, void 0, 'Vos Renseignements personnels pourraient \xEAtre stock\xE9s pour une dur\xE9e raisonnable dans les bases de donn\xE9es de Henkel, dont certaines se situent \xE0 l\u2019ext\xE9rieur des \xC9tats-Unis et du Canada, et seront automatiquement transf\xE9r\xE9s dans ces bases de donn\xE9es aux fins de stockage et de maintenance. Le Service est bas\xE9 aux \xC9tats-Unis, vise les r\xE9sidents des \xC9tats-Unis et du Canada et pour les personnes \xE0 l\u2019ext\xE9rieur du Canada, les renseignements recueillis par Henkel et ses Fournisseurs de services \xE0 l\u2019aide du Service sont r\xE9gis par la loi des \xC9tats-Unis. Si vous acc\xE9dez au Service \xE0 partir de l\u2019ext\xE9rieur des \xC9tats-Unis, les renseignements recueillis \xE0 l\u2019aide du Service pourraient \xEAtre transf\xE9r\xE9s, trait\xE9s, stock\xE9s et utilis\xE9s aux \xC9tats-Unis. Les lois sur la protection des donn\xE9es des \xC9tats-Unis pourraient diff\xE9rer de celles de votre pays de r\xE9sidence et fournir un niveau inf\xE9rieur de protection des consommateurs, et les renseignements transf\xE9r\xE9s aux \xC9tats-Unis pourraient \xEAtre consult\xE9s par les gouvernements et les organisations d\u2019application de la loi des \xC9tats-Unis conform\xE9ment aux lois des \xC9tats-Unis. Votre utilisation du Service, ou la fourniture de tout renseignement \xE0 l\u2019aide du Service, signifie que vous consentez au transfert, au traitement, \xE0 l\u2019utilisation, au partage et au stockage de vos renseignements, y compris vos Renseignements personnels, aux \xC9tats-Unis tel qu\u2019\xE9tabli dans le pr\xE9sent D\xE9claration de confidentialit\xE9.');

var _ref125 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Contenu de tiers, Services fournis par des tiers, Fonctionnalit\xE9s li\xE9es aux m\xE9dias sociaux, publicit\xE9 et analytique'));

var _ref126 = _jsx('p', {}, void 0, 'Le Service pourrait comprendre des hyperliens vers ou en lien avec le Service (p. ex. des applications et des plugiciels), des sites Web, des emplacements, des plateformes, des applications ou des services exploit\xE9s par des tiers (le(s) \u201CService(s) fournis par des tiers\u201D). Lesdits Services fournis par des tiers peuvent utiliser leurs propres t\xE9moins, pixels espions et autres Technologies de suivi pour recueillir de fa\xE7on ind\xE9pendante des renseignements \xE0 votre sujet et pourraient solliciter des Renseignements personnels de votre part. Henkel n\u2019est pas responsable des pratiques relatives \xE0 la confidentialit\xE9 ou du contenu des Services fournis par des tiers. Notez que les d\xE9claration de confidentialit\xE9 applicables auxdits Services fournis par des tiers peuvent \xEAtre tr\xE8s diff\xE9rents de l\u2019D\xE9claration de confidentialit\xE9 de Henkel, et nous vous avisons de les lire attentivement avant d\u2019utiliser lesdits services. Vous convenez que Henkel ne peut \xEAtre tenu responsable de toute action ou contenu desdits Services fournis par des tiers.');

var _ref127 = _jsx('p', {}, void 0, 'Certaines fonctionnalit\xE9s du Service permettent des interactions entre le Service et certains Services fournis par des tiers, comme les r\xE9seaux sociaux tiers (les \u201CFonctionnalit\xE9s li\xE9es aux m\xE9dias sociaux\u201D). Les Fonctionnalit\xE9s li\xE9es aux m\xE9dias sociaux peuvent comprendre : la possibilit\xE9 pour vous d\u2019envoyer du contenu comme des contacts et des photographies entre le Service et un Service fourni par des tiers; cliquer \u201Cj\u2019aime\u201D ou \u201Cpartager\u201D du contenu de Henkel; ouvrir une session dans le Service \xE0 l\u2019aide d\u2019un compte de Service fourni par des tiers (p. ex. utiliser Facebook Connect pour ouvrir une session dans le Service); et connecter autrement le Service \xE0 un Service fourni par des tiers (p. ex. obtenir ou transmettre de l\u2019information en provenance ou en destination du Service). Si vous utilisez les Fonctionnalit\xE9s li\xE9es aux m\xE9dias sociaux et potentiellement d\u2019autres Services fournis par des tiers, les renseignements que vous publiez ou auxquelles vous donnez acc\xE8s pourraient \xEAtre affich\xE9s publiquement sur le Service (voir la section 5) ou par le Service fourni par des tiers que vous utilisez. De m\xEAme, si vous publiez des renseignements sur un service fourni par des tiers qui fait r\xE9f\xE9rence au Service (p. ex. en utilisant un mot-clic associ\xE9 \xE0 Henkel ou \xE0 un autre Affili\xE9 de Henkel dans un gazouillis ou une mise \xE0 jour de statut), vous acceptez que votre publication puisse \xEAtre utilis\xE9e sur le Service, en lien avec le Service ou autrement par Henkel ou d\u2019autres Affili\xE9s de Henkel. De plus, Henkel et le tiers pourraient avoir acc\xE8s \xE0 certains renseignements sur vous et sur votre utilisation du Service et de tout Service fourni par des tiers.');

var _ref128 = _jsx('p', {}, void 0, 'Henkel pourrait interagir et travailler avec des Fournisseurs de services et d\u2019autres tiers pour offrir de la publicit\xE9 sur le Service et sur d\u2019autres services fournis par des tiers. Certaines de ces publicit\xE9s pourraient \xEAtre personnalis\xE9es selon vos int\xE9r\xEAts en fonction de notre navigation dans le Service et ailleurs sur Internet, ce qu\u2019on appelle parfois la \u201Cpublicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt\u201D et la \u201Cpublicit\xE9 comportementale en ligne\u201D (la \u201CPublicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt), qui pourrait comprendre l\u2019envoi de publicit\xE9s sur un Service fourni par des tiers \xE0 votre intention apr\xE8s que vous ayez quitt\xE9 le Service (c.-\xE0-d. le \u201Cciblage publicitaire\u201D). Par exemple, le Service pourrait employer un \u201CT\xE9moin d\u2019identification DoubleClick\u201D qui pourrait attribuer un identifiant pseudonymis\xE9 pour, entre autres, effectuer le suivi de la publicit\xE9 DoubleClick. DoubleClick est un service fourni par Google. Pour en savoir davantage sur votre capacit\xE9 de vous retirer de la Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt, consultez la section 11 ci-dessous.');

var _ref129 = _jsx('p', {}, void 0, 'Henkel pourrait faire appel \xE0 Google Analytics, \xE0 Adobe Analytics ou \xE0 d\u2019autres Fournisseurs de services pour l\u2019obtention de services d\u2019analytique. Lesdits services d\u2019analytique pourraient faire appel \xE0 des t\xE9moins et \xE0 d\u2019autres Technologies de suivi pour aider Henkel \xE0 analyser les utilisateurs du Service et leur fa\xE7on d\u2019utiliser le Service. Les renseignements g\xE9n\xE9r\xE9s par lesdits services (p. ex. votre adresse IP et d\u2019autres Renseignements sur l\u2019utilisation) pourraient \xEAtre transmis auxdits Fournisseurs de services et stock\xE9s par ceux-ci sur des serveurs aux \xC9tats-Unis (ou ailleurs) et lesdits Fournisseurs de services pourraient utiliser lesdits renseignements \xE0 des fins comme l\u2019\xE9valuation de votre utilisation du Service, la compilation de rapports statistiques sur l\u2019activit\xE9 du Service, et la fourniture d\u2019autres services reli\xE9s \xE0 l\u2019activit\xE9 du Service et \xE0 d\u2019autres utilisations d\u2019Internet.');

var _ref130 = _jsx('p', {}, void 0, 'Sauf dans la mesure o\xF9 nous combinons les renseignements que nous recevons des Fournisseurs de services, des Services fournis par des tiers ou d\u2019autres tiers \xE0 des Renseignements personnels recueillis par Henkel, auquel cas Henkel traitera les renseignements combin\xE9s comme des Renseignements personnels recueillis par Henkel en vertu du pr\xE9sent D\xE9claration de confidentialit\xE9, les donn\xE9es obtenues par Henkel d\u2019un tiers, m\xEAme en association avec le Service, ne sont pas assujetties aux limitations de Henkel concernant les Renseignements personnels recueillis par Henkel en vertu du pr\xE9sent D\xE9claration de confidentialit\xE9, mais lesdites donn\xE9es demeurent assujetties aux restrictions impos\xE9es \xE0 Henkel par le tiers, le cas \xE9ch\xE9ant. Sinon, les renseignements recueillis, stock\xE9s et partag\xE9s par des tiers demeurent assujettis \xE0 leurs politiques et \xE0 leurs pratiques de confidentialit\xE9, y compris s\u2019ils continuent de partager des renseignements avec Henkel, les types de renseignements partag\xE9s et vos choix concernant ce qui est visible par les autres sur les Services fournis par des tiers.');

var _ref131 = _jsx('br', {});

var _ref132 = _jsx('p', {}, void 0, 'Henkel n\u2019est pas responsable des politiques ou des pratiques commerciales des tiers et ne donne aucune repr\xE9sentation \xE0 leur sujet, notamment les Fournisseurs de services d\u2019analytique et les Services fournis par des tiers associ\xE9s au Service, et vous encourage \xE0 consulter leurs politiques de confidentialit\xE9 et leurs conditions d\u2019utilisation. Voir la section 11 pour en savoir davantage sur certains choix offerts par certains tiers concernant leur collecte et leur utilisation des donn\xE9es, y compris la Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt et l\u2019analytique.');

var _ref133 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'S\xE9curit\xE9 et surveillance'));

var _ref134 = _jsx('p', {}, void 0, 'Henkel prendra des pr\xE9cautions raisonnables pour prot\xE9ger vos Renseignements personnels (\xE0 l\u2019exception du CGU public) des pertes, mauvaises utilisations ou alt\xE9rations. Les Renseignements personnels pourraient \xEAtre consultables par des personnes appartenant \xE0 notre organisation, ou par des fournisseurs de services tiers, qui ont besoin de les consulter aux fins susmentionn\xE9es, ou \xE0 d\u2019autres fins permises ou exig\xE9es par la loi applicable. Gardez \xE0 l\u2019esprit, toutefois, que tout courriel ou autre transmission par Internet ne peut \xEAtre compl\xE8tement prot\xE9g\xE9 des interceptions non autoris\xE9es et que l\u2019Internet et le stockage num\xE9rique en ligne ne sont pas compl\xE8tement s\xE9curis\xE9s, et nous ne garantissons pas la s\xE9curit\xE9 des renseignements vous concernant recueillis \xE0 l\u2019aide du Service.');

var _ref135 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Enfants'));

var _ref136 = _jsx('p', {}, void 0, 'Le Service vise un public g\xE9n\xE9ral et n\u2019est pas destin\xE9 aux enfants de moins de 13 ans. Henkel n\u2019a pas l\u2019intention de recueillir des renseignements personnels, tels que d\xE9finis par la U.S. Children\u2019s Online Privacy Protection Act (la \u201CCOPPA\u201D) (les \u201CRenseignements personnels concernant des enfants\u201D) d\u2019une fa\xE7on qui n\u2019est pas permise par la COPPA. Si nous apprenons que nous avons recueilli des Renseignements personnels concernant des enfants d\u2019une fa\xE7on non permise par la COPPA ou une autre loi applicable, nous supprimerons lesdites donn\xE9es dans la mesure requise par la COPPA ou toute autre loi applicable.');

var _ref137 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Vos choix concernant vos Renseignements personnels'));

var _ref138 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'G\xE9n\xE9ralit\xE9s sur les Technologies de suivi'));

var _ref139 = _jsx('p', {}, void 0, 'Certaines Technologies de suivi reli\xE9es aux applications, en lien avec l\u2019utilisation non reli\xE9e \xE0 un navigateur (p. ex. la plupart des fonctionnalit\xE9s d\u2019une application mobile) peuvent uniquement \xEAtre d\xE9sactiv\xE9es en d\xE9sinstallant l\u2019application. Pour d\xE9sinstaller une application, suivez les instructions de votre syst\xE8me d\u2019exploitation ou du fabricant de votre appareil.');

var _ref140 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Technologies de suivi aux fins d\u2019analytique et de publicit\xE9'));

var _ref141 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Applications mobiles'));

var _ref142 = _jsx('p', {}, void 0, 'En ce qui concerne les applications mobiles de Henkel (les \u201Capplications\u201D), vous pouvez faire cesser toute la collecte de donn\xE9es g\xE9n\xE9r\xE9e par l\u2019utilisation de l\u2019application en d\xE9sinstallant l\u2019application. De plus, vous pourriez \xEAtre en mesure d\u2019exercer des choix pr\xE9cis en mati\xE8re de confidentialit\xE9, comme l\u2019activation ou la d\xE9sactivation de certaines fonctionnalit\xE9s (p. ex. les services g\xE9od\xE9pendants, les notifications pouss\xE9es, l\u2019acc\xE8s aux calendriers/contacts/photos, etc.) en ajustant les permissions des param\xE8tres de votre appareil mobile ou de votre application. Sachez que si les services de localisation pr\xE9cise par GPS sont d\xE9sactiv\xE9s, d\u2019autres moyens d\u2019\xE9tablir ou d\u2019estimer l\u2019emplacement (p. ex. la connexion ou la proximit\xE9 au Wi-Fi, la technologie Bluetooth, les pixels espions ou nos r\xE9seaux) pourraient persister. Consultez aussi la section pr\xE9c\xE9dente concernant les choix en mati\xE8re de Publicit\xE9 mobile cibl\xE9e par centres d\u2019int\xE9r\xEAt de la DAA.');

var _ref143 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Communications'));

var _ref144 = _jsx('p', {}, void 0, 'Vous pouvez refuser de recevoir certaines communications promotionnelles (courriels ou textos) de Henkel en tout temps des fa\xE7ons suivantes : i) pour ne plus recevoir de courriels promotionnels, suivez les instructions fournies dans les courriels afin de cliquer sur le lien de d\xE9sabonnement ou, si disponible, en modifiant vos pr\xE9f\xE9rences de communication en ouvrant une session dans votre compte; ii) pour ne plus recevoir de textos, suivez les instructions fournies dans les textos de Henkel en textant le mot \u201CSTOP\u201D; iii) pour ne plus recevoir de notifications pouss\xE9es, d\xE9sactivez les notifications pouss\xE9es dans les param\xE8tres de votre appareil ou de l\u2019application, le cas \xE9ch\xE9ant. Notez que votre refus est limit\xE9 \xE0 l\u2019adresse courriel ou au num\xE9ro de t\xE9l\xE9phone utilis\xE9 et n\u2019affectera pas les abonnements ult\xE9rieurs. Si vous choisissez de refuser uniquement certaines communications, d\u2019autres communications pourraient se poursuivre. M\xEAme si vous choisissez de refuser de recevoir des communications promotionnelles, Henkel pourrait, sous r\xE9serve de la loi applicable, continuer de vous envoyer des communications non promotionnelles, comme celles qui concernent votre compte, vos transactions, vos services ou nos relations commerciales continues.');

var _ref145 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Centre de carri\xE8res'));

var _ref146 = _jsx('p', {}, void 0, 'Si vous avez cr\xE9\xE9 un curriculum vit\xE6 \xE0 l\u2019aide de notre Centre de carri\xE8res, vous pouvez consulter, r\xE9viser, corriger, mettre \xE0 jour, modifier ou supprimer les renseignements de votre profil ou votre curriculum vit\xE6 en tout temps. Connectez-vous simplement \xE0 votre compte, allez \xE0 votre profil ou \xE0 votre curriculum vit\xE6, et apportez les modifications n\xE9cessaires. Vous pouvez supprimer votre curriculum vit\xE6 de notre base de donn\xE9es en ligne en tout temps en acc\xE9dant \xE0 votre compte; sachez toutefois que nous nous r\xE9servons le droit de conserver une copie a) tel qu\u2019exig\xE9 par la loi applicable; et b) pour aussi longtemps qu\u2019il est raisonnablement n\xE9cessaire aux fins de tenue de dossiers, sauf dans la mesure interdite par la loi applicable.');

var _ref147 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Droits de confidentialit\xE9 des r\xE9sidents de la Californie et du Connecticut'));

var _ref148 = _jsx('p', {}, void 0, 'Attention : Henkel Privacy Inquiries', _jsx('br', {}), 'Communications Department', _jsx('br', {}), 'Henkel Corporation', _jsx('br', {}), 'One Henkel Way', _jsx('br', {}), 'Rocky Hill, CT 06067');

var _ref149 = _jsx('p', {}, void 0, 'La premi\xE8re ligne de la description de la demande doit comprendre \u201CCalifornia Privacy Rights Request\u201D et indiquer votre nom, votre adresse municipale, votre ville, votre \xC9tat et votre code ZIP. Notez que Henkel ne doit r\xE9pondre qu\u2019\xE0 une seule demande par client par ann\xE9e, et que Henkel n\u2019est pas tenue de r\xE9pondre aux demandes effectu\xE9es autrement que par l\u2019adresse courriel ou l\u2019adresse postale fournies.');

var _ref150 = _jsx('p', {}, void 0, 'Droits des r\xE9sidents du Connecticut : La loi du Connecticut exige que toute personne ou entit\xE9 qui recueille des num\xE9ros d\u2019assurance sociale de r\xE9sidents du Connecticut dans le cadre de leurs activit\xE9s cr\xE9e une politique de protection de la confidentialit\xE9 et la publie ou l\u2019affiche publiquement. Notre politique est de prot\xE9ger la confidentialit\xE9 des num\xE9ros d\u2019assurance sociale en notre possession de la mauvaise utilisation et de la divulgation inad\xE9quate en maintenant et en appliquant des politiques et des mesures de protection physique et \xE9lectronique contre la mauvaise utilisation et la divulgation inad\xE9quate. La divulgation ill\xE9gale de num\xE9ros d\u2019assurance sociale est interdite, et l\u2019acc\xE8s aux num\xE9ros d\u2019assurance sociale est limit\xE9 au personnel qui a besoin d\u2019acc\xE9der auxdits renseignements pour effectuer leurs fonctions professionnelles.');

var _ref151 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'D\xE9claration de confidentialit\xE9 pour les applications mobiles'));

var _ref152 = _jsx('p', {}, void 0, 'Henkel a d\xE9velopp\xE9 certaines applications mobiles que vous pouvez t\xE9l\xE9charger dans votre appareil mobile. Lorsque vous t\xE9l\xE9chargez une application mobile, vous pourriez avoir l\u2019occasion de nous fournir des renseignements vous concernant, comme vos coordonn\xE9es, vos pr\xE9f\xE9rences en mati\xE8re de produits, des photographies ou d\u2019autres renseignements. De plus, nous pourrions obtenir des renseignements au sujet de l\u2019appareil mobile, comme l\u2019identifiant et le syst\xE8me d\u2019exploitation de l\u2019appareil, et l\u2019utilisation de l\u2019appareil. Les renseignements obtenus \xE0 l\u2019aide d\u2019une application mobile seront utilis\xE9s conform\xE9ment au pr\xE9sent D\xE9claration de confidentialit\xE9 et pourraient \xEAtre assujettis \xE0 des modalit\xE9s suppl\xE9mentaires publi\xE9es dans l\u2019application mobile.');

var _ref153 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Consultation et modification des renseignements'));

var _ref154 = _jsx('p', {}, void 0, 'Henkel pourrait fournir des pages Web ou d\u2019autres m\xE9canismes vous permettant de supprimer, de corriger ou de mettre \xE0 jour certains des Renseignements personnels recueillis par Henkel, et possiblement certains autres renseignements \xE0 votre sujet (p. ex. renseignements sur votre profil et votre compte). Vous pourriez aussi demander d\u2019acc\xE9der \xE0 vos Renseignements personnels et demander qu\u2019ils soient corrig\xE9s si vous croyez qu\u2019ils sont inexacts \xE0 l\u2019aide des coordonn\xE9es fournies plus bas. Nous pourrions exiger de v\xE9rifier votre identit\xE9 avant de vous permettre d\u2019acc\xE9der aux renseignements. Henkel exercera des efforts de bonne foi pour apporter les modifications demand\xE9es dans les bases de donn\xE9es de Henkel en service aussit\xF4t que possible, mais il n\u2019est pas toujours possible de modifier, d\u2019enlever ou de supprimer compl\xE8tement tous vos renseignements ou toutes vos publications publiques des bases de donn\xE9es de Henkel. De plus, nous nous r\xE9servons le droit de conserver des donn\xE9es a) tel qu\u2019exig\xE9 par la loi applicable; et b) pour aussi longtemps qu\u2019il est raisonnablement n\xE9cessaire de le faire, sauf dans la mesure interdite par la loi applicable.');

var _ref155 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Questions'));

var _ref156 = _jsx('p', {}, void 0, 'Henkel Privacy Inquiries', _jsx('br', {}), 'Compliance Officer', _jsx('br', {}), 'Henkel Corporation', _jsx('br', {}), 'One Henkel Way', _jsx('br', {}), 'Rocky Hill, CT 06067');

var TermsPrivacyFr = function TermsPrivacyFr() {
  return _jsx('div', {}, void 0, _ref, _ref2, _ref3, _ref4, _ref5, _jsx('p', {}, void 0, 'En visitant ou en utilisant le Service de quelque fa\xE7on que ce soit, vous acceptez les Conditions publi\xE9es \xE0 ce moment et toutes les Conditions suppl\xE9mentaires applicables (d\xE9finies plus bas), convenez d\u2019\xEAtre contraint par lesdites Conditions, et que vous les avez lues et comprises. Vous reconnaissez et acceptez nos pratiques relatives aux donn\xE9es, d\xE9crites dans notre', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), '.'), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref13, _ref14), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref15, _ref16, _ref17), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref18, _jsx('p', {}, void 0, 'En visitant le Service ou en l\u2019utilisant de toute autre fa\xE7on que ce soit, vous acceptez l\u2019', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), ' ', 'publi\xE9 \xE0 ce moment-l\xE0 et consentez aux pratiques relatives aux donn\xE9es qui y sont d\xE9crites.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref19, _ref20, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref21), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref22), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref23), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref24), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref25), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref26), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref27), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref28))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref29, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref30), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref31))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref32, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref33), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Non-confidentialit\xE9 de votre Contenu g\xE9n\xE9r\xE9 par l\u2019utilisateur. \xC0 moins d\u2019indications contraires dans l\u2019', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), 'ou toute Conditions suppl\xE9mentaire applicable, vous convenez que a) votre CGU sera trait\xE9 comme non confidentiel et non exclusif par nous, peu importe si vous indiquez qu\u2019il est \u201Cconfidentiel\u201D, \u201Cexclusif\u201D et ainsi de suite, et ne vous sera pas retourn\xE9, et b) dans la port\xE9e maximale non interdite par la loi, Henkel n\u2019accepte aucune obligation de toute nature que ce soit envers vous ou tout tiers concernant votre CGU. Sur demande, vous fournirez la documentation n\xE9cessaire pour authentifier les droits envers ledit contenu et confirmer votre respect des pr\xE9sentes Conditions ou de toute Condition suppl\xE9mentaire applicable. Vous reconnaissez que l\u2019Internet et', ' ', _ref34, 'les communications mobiles pourraient \xEAtre non s\xE9curis\xE9s et sujets \xE0 des violations de la s\xE9curit\xE9; par cons\xE9quent, vous acceptez que votre CGU soit soumis \xE0 vos propres risques.'), _ref35), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Licence \xE0 Henkel de votre CGU. \xC0 l\u2019exception d\u2019indications contraires dans toute Condition suppl\xE9mentaire applicable (comme les r\xE8gles officielles d\u2019une promotion), qui r\xE9git pr\xE9cis\xE9ment la soumission de votre CGU, ou dans notre', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), ', vous accordez par les pr\xE9sentes \xE0 Henkel les droits et la licence non exclusifs, sans restriction, inconditionnels, illimit\xE9s, mondiaux, irr\xE9vocables, perp\xE9tuels et gratuits pour utiliser, copier, enregistrer, distribuer, reproduire, divulguer, vendre, revendre, accorder des sous licences (sur plusieurs niveaux), afficher, pr\xE9senter publiquement, transmettre, publier, diffuser, traduire, produire des \u0153uvres d\xE9riv\xE9es, et autrement utiliser et exploiter de quelque mani\xE8re que ce soit, en totalit\xE9 ou en partie, votre CGU (et les \u0153uvres d\xE9riv\xE9es de votre CGU), \xE0 toutes fins que ce soit, dans tout format, par tout moyen ou m\xE9dia connu actuellement ou d\xE9velopp\xE9 dans le futur, et avec toute technologie ou appareil connu actuellement ou d\xE9velopp\xE9 dans le futur, et d\u2019annoncer, de commercialiser et promouvoir votre CGU (et les \u0153uvres d\xE9rivatives de votre CGU. Sans restriction, les droits accord\xE9s comprennent le droit de : a) configurer, h\xE9berger, indexer, mettre en m\xE9moire cache, archiver, stocker, num\xE9riser, compresser, optimiser, modifier, reformater, \xE9diter, adapter, publier en format consultable et supprimer lesdits CGU et les combiner \xE0 d\u2019autre mat\xE9riel, et b) utiliser tout concept, id\xE9e, savoir-faire ou technique contenue dans tout CGU \xE0 quelque fin que ce soit, y compris pour le d\xE9veloppement, la production et la commercialisation de produits et/ou de services. Vous comprenez que dans l\u2019exercice desdits droits, des m\xE9tadonn\xE9es, des avis et du contenu pourraient \xEAtre retir\xE9s ou alt\xE9r\xE9s, y compris de l\u2019information de gestion du droit d\u2019auteur, et vous consentez par les pr\xE9sentes, repr\xE9sentez et garantissez que vous d\xE9tenez toute l\u2019autorit\xE9 n\xE9cessaire pour le faire. Afin de donner davantage effet aux droits et \xE0 la licence que vous accordez \xE0 Henkel concernant votre CGU, vous acceptez d\u2019accorder \xE0 Henkel, dans la mesure o\xF9 la loi applicable le permet, le droit inconditionnel, perp\xE9tuel et irr\xE9vocable d\u2019utiliser et d\u2019exploiter votre nom, votre image et votre apparence en lien avec tout CGU, sans qu\u2019aucune obligation ou r\xE9mun\xE9ration ne vous soit due. Sauf lorsque la loi l\u2019interdit, vous acceptez de renoncer \xE0 tout droit moral (y compris l\u2019attribution, l\u2019anonymat et l\u2019int\xE9grit\xE9) que vous pourriez avoir concernant tout CGU, m\xEAme s\u2019il est alt\xE9r\xE9 ou modifi\xE9 d\u2019une fa\xE7on qui ne vous convient pas. Dans la mesure o\xF9 vous ne pouvez pas y renoncer, vous convenez irr\xE9vocablement de ne pas exercer lesdits droits (le cas \xE9ch\xE9ant) d\u2019une fa\xE7on qui interf\xE8re avec l\u2019exercice des droits accord\xE9s. Vous comprenez que vous ne recevrez aucuns frais, sommes, contrepartie ou r\xE9mun\xE9ration pour les droits accord\xE9s dans la pr\xE9sente section 6(c).')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Droit exclusif de Henkel de g\xE9rer notre Service. Henkel pourrait, sans en avoir l\u2019obligation, examiner, surveiller, afficher, publier, stocker, maintenir, accepter ou utiliser d\u2019une autre fa\xE7on votre CGU, en tout ou en partie, et Henkel pourrait, \xE0 sa seule discr\xE9tion, rejeter, effacer, d\xE9placer, reformater, supprimer ou refuser de publier ou d\u2019utiliser autrement votre CGU sans pr\xE9avis et sans obligation envers vous ou tout tiers en lien avec notre exploitation du CGU de fa\xE7on appropri\xE9e. Sans limitation, nous pourrions le faire pour examiner du contenu qui, selon nous, est offensant, obsc\xE8ne, lubrique, lascif, sale, violent, harcelant, mena\xE7ant, abusif, ill\xE9gal ou autrement inacceptable ou inappropri\xE9, ou pour ex\xE9cuter les droits de tiers, les pr\xE9sentes Conditions ou toute Condition suppl\xE9mentaire applicable. Le CGU soumis par vous ou d\u2019autres n\u2019est pas tenu d\u2019\xEAtre maintenu sur le Service par nous pour quelque p\xE9riode que ce soit, et vous n\u2019avez pas le droit, apr\xE8s avoir effectu\xE9 une soumission, d\u2019acc\xE9der, d\u2019archiver, de maintenir, de modifier, de retirer ou d\u2019utiliser d\u2019une autre fa\xE7on ledit CGU sur le Service ou ailleurs, \xE0 l\u2019exception des mineurs de la Californie qui poss\xE8dent certains droits envers certain contenu les concernant qu\u2019ils ont publi\xE9 eux-m\xEAmes sur le Service et retir\xE9 prospectivement de l\u2019affichage public, tel qu\u2019\xE9tabli dans l\u2019', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), '.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref36), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref37))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref38, _ref39, _ref40, _jsx('p', {}, void 0, 'Agent des droits d\u2019auteur', _ref41, 'Henkel Corporation', _ref42, 'One Henkel Way', _ref43, 'Rocky Hill, CT 06067', _ref44, '860 571-2661', _ref45, _jsx('a', {
    href: 'mailto:CopyrightAgent@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'CopyrightAgent@henkel.com'))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref46, _ref47, _jsx('p', {}, void 0, 'Si vous acc\xE9dez au Service ou l\u2019utilisez \xE0 l\u2019aide d\u2019Apple, d\u2019Android ou de toute autre plateforme, il s\u2019agit de Services offerts par des tiers. Si vous acc\xE9dez \xE0 nos applications sur Apple, cliquez', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/new-content-item/802450',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), ' ', 'pour conna\xEEtre les Conditions suppl\xE9mentaires qui sont applicables pour vous et sont int\xE9gr\xE9es aux Conditions par cette r\xE9f\xE9rence.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref48, _ref49, _ref50, _ref51, _ref52), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref53, _ref54, _ref55), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref56, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref57), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref58), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Arbitrage des r\xE9clamations. Tel que permis par la loi applicable, et pour les utilisateurs qui ne sont pas des r\xE9sidents individuels de la province de Qu\xE9bec, toutes les poursuites ou proc\xE9dures d\xE9coulant de tout Litige, ou qui y sont reli\xE9es, ou la port\xE9e des dispositions de la pr\xE9sente section, doivent \xEAtre soumises \xE0 JAMS (', _jsx('a', {
    href: 'www.jamsadr.com',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.jamsadr.com'), ' ', '- en anglais seulement) pour un arbitrage final et liant en vertu de ses R\xE8gles et proc\xE9dures exhaustives d\u2019arbitrage si la question en litige d\xE9passe 250 000 $ ou en vertu de ses R\xE8gles et proc\xE9dures simplifi\xE9es d\u2019arbitrage si la question en litige est de 250 000 $ ou moins, devant avoir lieu au Delaware devant un seul arbitre. L\u2019arbitre sera s\xE9lectionn\xE9 apr\xE8s consentement mutuel des parties ou, si les parties ne peuvent pas s\u2019entendre, en choisissant dans une liste d\u2019arbitres fournie par JAMS. Nous pourrions avoir le droit de payer les frais de JAMS si n\xE9cessaire pour que l\u2019arbitrage soit ex\xE9cutable. L\u2019arbitrage est une proc\xE9dure confidentielle, ferm\xE9e au public; \xE0 condition, toutefois, qu\u2019une partie puisse divulguer de l\u2019information reli\xE9e \xE0 la proc\xE9dure d\u2019arbitrage \xE0 ses avocats, fournisseurs d\u2019assurances, v\xE9rificateurs et autres conseillers professionnels et \xE0 ceux de ses soci\xE9t\xE9s affili\xE9es. Le fait qu\u2019un litige existe entre les parties sujettes \xE0 l\u2019arbitrage est confidentiel dans la m\xEAme mesure. L\u2019arbitre doit \xE9mettre une opinion \xE9crite \xE9non\xE7ant les constatations et les conclusions essentielles sur lesquelles la d\xE9cision de l\u2019arbitre est bas\xE9e. Aucune partie n\u2019a le doit ou n\u2019est autoris\xE9e \xE0 entamer ou \xE0 maintenir une poursuite dans une cour de justice pour toute question en litige avant que la question n\u2019ait \xE9t\xE9 soumise \xE0 l\u2019arbitrage, tel que pr\xE9vu dans les pr\xE9sentes, puis uniquement pour l\u2019application de la d\xE9cision de l\u2019arbitre; \xE0 condition toutefois qu\u2019avant la nomination de l\u2019arbitre ou pour des recours d\xE9passant la comp\xE9tence de l\u2019arbitre, en tout temps, les parties peuvent demander un recours pendant l\u2019instance (assujetti aux dispositions des pr\xE9sentes Conditions annulant ou limitant ledit recours) dans un tribunal de juridiction comp\xE9tente dans l\u2019\xC9tat du Delaware ou, sur demande de Henkel, un autre tribunal qui pourrait avoir juridiction sur vous, sans renoncer \xE0 son droit \xE0 l\u2019arbitrage du litige ou de la controverse en vertu de la pr\xE9sente section; \xE0 la condition suppl\xE9mentaire, toutefois, que la partie perdante dispose de quinze (15) jours ouvrables apr\xE8s l\u2019\xE9mission de la d\xE9cision de l\u2019arbitre pour se conformer compl\xE8tement \xE0 ladite d\xE9cision, apr\xE8s quoi la partie gagnante pourrait ex\xE9cuter ladite d\xE9cision \xE0 l\u2019aide d\u2019une requ\xEAte aux tribunaux de Wilmington, Delaware ou, dans votre cas, \xE0 un autre tribunal ayant juridiction sur vous, qui pourrait \xEAtre fait \xE0 la demande d\u2019une seule partie, aux fins de confirmation et d\u2019application de la d\xE9cision.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref59), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref60), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref61), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref62), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref63), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref64))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref65, _ref66), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref67, _ref68), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref69, _ref70), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref71, _ref72)), _ref73, _ref74, _ref75, _jsx('p', {}, void 0, 'Cliquez', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), ' ', 'pour consulter nos Conditions d\u2019utilisation. Les r\xE9sidents de la Californie peuvent consulter la section 12A pour prendre connaissance de leurs droits en mati\xE8re de confidentialit\xE9.'), _ref76, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref77, _ref78, _ref79, _jsx('p', {}, void 0, 'En utilisant notre Service de quelque fa\xE7on que ce soit, comme en naviguant ou en interagissant, vous signifiez que vous acceptez les modalit\xE9s de notre D\xE9claration de confidentialit\xE9 \xE0 jour, tel que publi\xE9 ici et des Conditions d\u2019utilisation de notre Service se trouvant', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), '. Si vous ne consentez pas \xE0 nos pratiques d\xE9crites dans le pr\xE9sent D\xE9claration de confidentialit\xE9, vous pouvez et ne devriez pas utiliser notre Service.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref80, _ref81), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref82, _ref83, _ref84, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'circle' }
  }, void 0, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91), _ref92), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref93, _ref94, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref95, _jsx('li', {}, void 0, _jsx('p', {}, void 0, 't\xE9l\xE9charger et afficher vos publications et votre contenu semblable publi\xE9 (le \u201CContenu g\xE9n\xE9r\xE9 par l\u2019utilisateur\u201D ou \u201CCGU\u201D). (Pour en savoir davantage sur la fa\xE7on dont le CGU est trait\xE9 en vertu des Conditions d\u2019utilisation du Service, cliquez', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), ' ', '[section 6 des Conditions d\u2019utilisation]. Pour en savoir davantage sur la nature publique du CGU, voir la section 5);')), _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109), _ref110, _ref111), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref112, _jsx('p', {}, void 0, 'Le Service pourrait vous permettre de publier ou de soumettre du CGU, notamment le consentement \xE9crit, les profils d\u2019utilisateur, les enregistrements audio ou visuels, les graphiques informatiques, les illustrations, les donn\xE9es ou d\u2019autre contenu, y compris les Renseignements personnels. Si vous choisissez de soumettre du CGU dans une partie publique du Service, votre CGU sera consid\xE9r\xE9 comme \u201Cpublic\u201D et sera accessible \xE0 quiconque, y compris Henkel. Nonobstant toute disposition contraire, et sous r\xE9serve de la loi applicable, \xE0 moins d\u2019entente diff\xE9rente explicite avec nous, les Renseignements personnels faisant partie du CGU ne sont pas assujettis aux limitations de l\u2019utilisation ou du partage, ou aux autres obligations, de Henkel, relativement aux Renseignements personnels recueillis par Henkel ou aux autres Renseignements personnels en vertu du pr\xE9sent D\xE9claration de confidentialit\xE9 ou autre, et pourraient \xEAtre utilis\xE9s et partag\xE9s par Henkel et des tiers dans la pleine mesure permise par la loi applicable. Henkel vous encourage \xE0 faire preuve de prudence en prenant des d\xE9cisions au sujet de ce que vous divulguez dans ces parties publiques. Pour en savoir davantage sur la fa\xE7on dont le CGU est trait\xE9 en vertu des Conditions d\u2019utilisation du Service, cliquez', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), ' ', '[section 6 des Conditions d\u2019utilisation].'), _ref113), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref114, _ref115, _ref116, _jsx('p', {}, void 0, 'Un t\xE9moin est un petit fichier texte stock\xE9 dans l\u2019appareil d\u2019un utilisateur, qui pourrait \xEAtre un t\xE9moin temporaire ou un t\xE9moin traceur. Les t\xE9moins temporaires facilitent la navigation sur le Service et expirent lorsque vous fermez votre navigateur. Les t\xE9moins traceurs restent dans votre syst\xE8me plus longtemps et nous aident \xE0 comprendre comment vous utilisez le Service et comment am\xE9liorer l\u2019exp\xE9rience des utilisateurs. Les t\xE9moins pourraient demeurer sur votre disque dur pour une p\xE9riode prolong\xE9e. Si votre navigateur bloque ou supprime les t\xE9moins, certains types de t\xE9moins pourraient \xEAtre supprim\xE9s ou bloqu\xE9s et cela peut causer le non-fonctionnement de certaines caract\xE9ristiques et fonctionnalit\xE9s du Service. Un t\xE9moin Flash (ou objet partag\xE9 localement) est un fichier de donn\xE9es qui pourrait \xEAtre install\xE9 sur un appareil \xE0 l\u2019aide de plugiciels d\u2019Adobe Flash, pouvant \xEAtre int\xE9gr\xE9 ou t\xE9l\xE9charg\xE9 par vous sur votre appareil. Les t\xE9moins HTML5 peuvent \xEAtre programm\xE9s \xE0 l\u2019aide du stockage local HTML5. Les t\xE9moins Flash et les t\xE9moins HTML5 sont stock\xE9s localement sur votre appareil ailleurs que dans le navigateur et les param\xE8tres du navigateur ne les contr\xF4leront pas. Pour identifier certains types d\u2019objets partag\xE9s localement sur votre appareil et ajuster vos param\xE8tres, veuillez visiter :', ' ', _jsx('a', {
    href: 'www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html'), ' ', '(en anglais seulement). Le Service pourrait associer certains ou tous ces types de t\xE9moins \xE0 vos appareils. D\u2019autres types de Technologies de suivi pourraient comprendre les pixels espions (aussi appel\xE9s \u201Cconnexions malignes\u201D), les scripts int\xE9gr\xE9s, les technologies d\u2019identification de l\u2019emplacement, les empreintes digitales, les technologies de reconnaissance des appareils et les m\xE9thodes de suivi int\xE9gr\xE9es aux applications. Voir la section 11 pour conna\xEEtre certains choix relativement auxdites activit\xE9s.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref117, _ref118, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref119, _ref120, _ref121, _ref122), _ref123, _ref124), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref133, _ref134, _jsx('p', {}, void 0, 'Pour favoriser votre protection et celle des autres, nous et nos fournisseurs de services pourrions (sans nous y engager) surveiller l\u2019utilisation du Service, et nous pourrions recueillir et utiliser des renseignements reli\xE9s, y compris les Renseignements personnels recueillis par Henkel et d\u2019autres Renseignements personnels \xE0 toute fin non interdite par la loi applicable ou contraire au pr\xE9sent D\xE9claration de confidentialit\xE9, notamment pour identifier des activit\xE9s et des transactions frauduleuses; pr\xE9venir les abus, faire enqu\xEAte et intenter des poursuites pour toute menace ou mauvaise utilisation potentielle du Service; assurer la conformit\xE9 avec les', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Conditions d\u2019utilisation'), ' ', 'et le pr\xE9sent D\xE9claration de confidentialit\xE9; faire enqu\xEAte sur les violations ou appliquer les pr\xE9sentes ententes; et autrement prot\xE9ger les droits et la propri\xE9t\xE9 de Henkel, de nos tiers affili\xE9s et d\u2019autres utilisateurs. La surveillance peut comprendre la collecte, l\u2019enregistrement et l\u2019analyse d\u2019activit\xE9s ou de communications en ligne \xE0 l\u2019aide de notre Service. Si vous ne consentez pas auxdites conditions, vous devez cesser d\u2019utiliser le Service.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref135, _ref136, _jsx('p', {}, void 0, 'Tout r\xE9sident de la Californie \xE2g\xE9 de moins de dix-huit (18) ans qui s\u2019est inscrit pour utiliser le Service et qui a publi\xE9 du contenu ou des renseignements sur le Service peut demander d\u2019\xEAtre retir\xE9 en communiquant avec Henkel', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/contact-us',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), ' ', 'en donnant des d\xE9tails sur l\u2019emplacement du contenu ou des renseignements publi\xE9s et en attestant qu\u2019il les a publi\xE9s. Henkel exercera les efforts raisonnables de bonne foi pour retirer la publication de la vue potentielle du public ou pour les anonymiser de fa\xE7on \xE0 ce que le mineur ne puisse pas \xEAtre identifi\xE9 dans la mesure requise par la loi applicable. Ledit processus de retrait ne peut garantir un retrait complet ou exhaustif. Par exemple, des tiers pourraient avoir republi\xE9 ou archiv\xE9 du contenu \xE0 l\u2019aide de moteurs de recherche et autres que Henkel ne contr\xF4le pas.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref137, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref138, _jsx('p', {}, void 0, 'Les t\xE9moins r\xE9guliers peuvent g\xE9n\xE9ralement \xEAtre d\xE9sactiv\xE9s ou retir\xE9s \xE0 l\u2019aide des outils disponibles dans la plupart des navigateurs commerciaux, et dans certains cas bloqu\xE9s dans le futur en s\xE9lectionnant certains param\xE8tres. Les navigateurs offrent diff\xE9rentes fonctionnalit\xE9s et options, donc vous devrez peut-\xEAtre les configurer s\xE9par\xE9ment. De plus, les outils des navigateurs commerciaux pourraient ne pas \xEAtre efficaces pour les t\xE9moins Flash (aussi appel\xE9 objet partag\xE9 localement), les t\xE9moins HTML5 ou d\u2019autres Technologies de suivi. Pour en savoir davantage sur la d\xE9sactivation des t\xE9moins Flash, rendez-vous au site Web d\u2019Adobe :', ' ', _jsx('a', {
    href: 'helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html'), ' ', '(en anglais seulement). Sachez que si vous d\xE9sactivez ou retirez lesdites technologies, certaines parties du Service pourraient ne pas fonctionner et que lorsque vous revisiterez le Service, votre capacit\xE9 de limiter les Technologies de suivi bas\xE9es sur le navigateur est sujette aux param\xE8tres et aux limitations de votre navigateur.'), _ref139, _jsx('p', {}, void 0, 'Les param\xE8tres de votre navigateur pourraient vous permettre de transmettre automatiquement un signal d\u2019interdiction de suivi aux services en ligne que vous visitez. Notez toutefois qu\u2019il n\u2019y a pas de consensus parmi les participants de l\u2019industrie sur ce que signifie une interdiction de suivi dans ce contexte. Comme beaucoup de services en ligne, Henkel ne modifie pas les pratiques de Henkel lorsque Henkel re\xE7oit un signal d\u2019interdiction de suivi du navigateur d\u2019un visiteur. Pour en savoir davantage sur l\u2019interdiction de suivi, vous pouvez visiter', ' ', _jsx('a', {
    href: 'http://www.allaboutdnt.com',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.allaboutdnt.com'), ' ', '(en anglais seulement), mais nous ne sommes pas responsables de l\u2019exhaustivit\xE9 ou de l\u2019exactitude de cette information fournie par un tiers. Toutefois, certains tiers pourraient vos donner des choix quant \xE0 leurs Technologies de suivi. Une fa\xE7on d\u2019identifier potentiellement les t\xE9moins sur notre Site est d\u2019ajouter le plugiciel gratuit Ghostery \xE0 votre navigateur (', _jsx('a', {
    href: 'www.ghostery.com/fr/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.ghostery.com/fr/'), '), qui, selon Ghostery, affichera pour vous les t\xE9moins traditionnels des navigateurs associ\xE9s aux sites Web (mais pas aux applications mobiles) que vous visitez et les politiques et options de confidentialit\xE9 et de refus des parties exploitant lesdits t\xE9moins. Henkel n\u2019est pas responsable de l\u2019exhaustivit\xE9 ou de l\u2019exactitude dudit outil ou des avis ou m\xE9canismes de choix des tiers. Pour de l\u2019information plus pr\xE9cise sur certaines des options offertes par les fournisseurs de services d\u2019analytique et de publicit\xE9 tiers, consultez la prochaine section.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref140, _jsx('p', {}, void 0, 'Vous pourriez avoir des choix concernant l\u2019utilisation de t\xE9moins de Google Analytics en vous rendant \xE0', ' ', _jsx('a', {
    href: 'https://tools.google.com/dlpage/gaoptout',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://tools.google.com/dlpage/gaoptout'), ' ', 'ou en t\xE9l\xE9chargeant l\u2019extension de refus de navigateur de Google Analytics. Vous pourriez avoir des choix concernant l\u2019utilisation de t\xE9moins d\u2019Adobe Analytics en vous rendant \xE0', ' ', _jsx('a', {
    href: 'https://www.adobe.com/ca_fr/privacy/opt-out.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://www.adobe.com/ca_fr/privacy/opt-out.html'), ' ', '\xE0 la section portant sur le refus des clients de mesurer leur utilisation de leurs sites Web ou de personnaliser la publicit\xE9 pour eux. Vous pourriez avoir des choix concernant l\u2019utilisation de t\xE9moins de Google DoubleClick en vous rendant \xE0', ' ', _jsx('a', {
    href: 'www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew'), ' ', '(en anglais seulement). Henkel n\u2019est pas responsable de l\u2019efficacit\xE9 ou de la conformit\xE9 de toute option ou de tout programme de refus de tiers ou de l\u2019exactitude de leurs \xE9nonc\xE9s concernant lesdits programmes.'), _jsx('p', {}, void 0, 'Vous pouvez choisir de recevoir certaines Publicit\xE9s cibl\xE9es par centres d\u2019int\xE9r\xEAt en soumettant des refus aux programmes de l\u2019industrie. Certains des annonceurs et des fournisseurs de service qui offrent des services li\xE9s \xE0 la publicit\xE9 pour nous et des tiers pourraient participer au Digital Advertising Alliance\u2019s (la \u201CDAA\u201D) Self-Regulatory Program for Online Behavioral Advertising. Pour en savoir davantage sur la fa\xE7on d\u2019exercer certains choix concernant la Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt, visitez', ' ', _jsx('a', {
    href: 'http://www.aboutads.info/choices',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.aboutads.info/choices'), ' ', '(en anglais seulement) et', ' ', _jsx('a', {
    href: 'http://www.aboutads.info/appchoices',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.aboutads.info/appchoices'), ' ', '(en anglais seulement) pour en savoir davantage sur le programme de rejet de la DAA. Certaines de ces soci\xE9t\xE9s pourraient aussi \xEAtre membres de la Network Advertising Initiative (la \u201CNAI\u201D). Pour en savoir davantage sur la NAI et sur vos options de refus pour les membres, visitez', ' ', _jsx('a', {
    href: 'http://www.networkadvertising.org/choices/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.networkadvertising.org/choices/'), ' ', '(en anglais seulement). Sachez que, m\xEAme si vous \xEAtes en mesure de refuser certains types de Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt, vous pourriez continuer de recevoir d\u2019autres types de publicit\xE9. Le refus signifie seulement que les membres s\xE9lectionn\xE9s ne devraient plus vous envoyer de la Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt, mais cela ne signifie pas que vous ne recevrez plus de contenu ou de publicit\xE9s cibl\xE9es (p. ex. d\u2019autres r\xE9seaux publicitaires). Certaines soci\xE9t\xE9s donnent aussi une occasion pr\xE9cise de refuser. Pour en savoir davantage sur les choix en mati\xE8re de Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt offerts par DoubleClick, cliquez', ' ', _jsx('a', {
    href: 'https://www.google.com/settings/u/0/ads/plugin?hl=en&sig=ACi0TCigvVYAN17ugYRMwQf_InKv4i5GKLPNen5UUD8qFqiWU4vtXR5jsz_uaOHdJqvhufEjezDh-Q13icRRRab9WJDGpQbwkQ',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'ici'), '. De plus, si vos navigateurs sont configur\xE9s pour refuser les t\xE9moins lorsque vous visitez ces pages Web de refus, ou si vous effacez plus tard vos t\xE9moins, utilisez un appareil ou un navigateur Web diff\xE9rent ou utilisez une m\xE9thode d\u2019acc\xE8s non bas\xE9e sur un navigateur (p. ex. une application mobile), votre refus bas\xE9 sur les navigateurs pourrait ne pas ou ne plus \xEAtre efficace. Henkel appuie les', ' ', _jsx('a', {
    href: 'www.iab.net/media/file/ven-principles-07-01-09.pdf',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, '2009 Self-regulatory Principles for Online Behavioral Advertising'), ' ', 'et s\u2019attend \xE0 ce que les r\xE9seaux publicitaires avec lesquels Henkel collabore directement pour vous offrir de la Publicit\xE9 cibl\xE9e par centres d\u2019int\xE9r\xEAt le fassent aussi, m\xEAme si Henkel ne peut pas garantir leur conformit\xE9. Henkel n\u2019est pas responsable de l\u2019efficacit\xE9 ou de la conformit\xE9 de toute option ou programme de refus de tiers ou de l\u2019exactitude de leurs \xE9nonc\xE9s concernant lesdits programmes.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref141, _ref142), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref143, _ref144), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref145, _ref146))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref147, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Droits des r\xE9sidents de la Californie : Henkel fournit aux r\xE9sidents de la Californie l\u2019option d\u2019accepter ou de refuser le partage de \u201Crenseignements personnels\u201D, tel que d\xE9fini dans la loi \u201CShine the Light\u201D avec des tiers, autres que les Affili\xE9s de Henkel, aux fins de marketing direct des tiers. Les r\xE9sidents de la Californie peuvent choisir l\u2019option de refus ou demander de l\u2019information au sujet de la conformit\xE9 de Henkel \xE0 la loi Shine the Light, et obtenir la divulgation des tiers avec lesquels Henkel a partag\xE9 des renseignements, conform\xE9ment \xE0 la loi sur le marketing direct, \xE0 d\xE9faut de votre choix et des cat\xE9gories de renseignements partag\xE9s, en communiquant avec Henkel', ' ', _jsx('a', {
    href: 'mailto:PrivacyNA@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'ici'), ' ', 'ou en envoyant une lettre \xE0 Henkel \xE0 :'), _ref148, _ref149), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref150))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref151, _ref152), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref153, _ref154), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref155, _jsx('p', {}, void 0, 'Veuillez nous envoyer vos questions ou commentaires concernant nos pratiques de confidentialit\xE9 en nous envoyant un courriel \xE0', ' ', _jsx('a', {
    href: 'mailto:PrivacyNA@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'PrivacyNA@henkel.com'), ', ou une lettre au :'), _ref156)));
};

/* harmony default export */ __webpack_exports__["a"] = (TermsPrivacyFr);

/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'ABOUT PRINTCENTER'));

var _ref2 = _jsx('p', {}, void 0, 'Loyalty has its privileges.');

var _ref3 = _jsx('p', {}, void 0, 'As a CLUBSKP member, you have access to PRINTCENTER, a user-friendly design tool that enables you to create customized print materials for your salon.');

var _ref4 = _jsx('p', {}, void 0, 'We understand that building your salon business is important to you. PRINTCENTER empowers you to market your salon professionally. This is our offer to help you promote your business with professional material to build a stronger presence in your community.');

var _ref5 = _jsx('p', {}, void 0, 'Take your client experience to the next level!');

var _ref6 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'HOW DOES IT WORK?'));

var _ref7 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'STEP ONE: CHOOSE'));

var _ref8 = _jsx('p', {}, void 0, 'Choose from an assortment of thoughtfully designed artwork templates.The best part is new and updated templates will be added on an on-going basis.');

var _ref9 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'STEP TWO: CUSTOMIZE'));

var _ref10 = _jsx('p', {}, void 0, 'Insert your salon logo, and business details. Whether you\u2019re planning an event or planning a promotion, the design portal includes clear and concise visual indicators that tell you what information is required to complete the artwork.');

var _ref11 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'STEP THREE: REVIEW'));

var _ref12 = _jsx('p', {}, void 0, 'Review the final artwork and check for errors. Make sure you love it.');

var _ref13 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'STEP FOUR: SAVE & PRINT'));

var _ref14 = _jsx('p', {}, void 0, 'If you love it, let\u2019s go to print. You have two options: 1 - print with our preferred third-party vendor, Zapplogix Inc., or 2 - download the artwork, and then take it to your local printing house to arrange printing.');

var _ref15 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'STEP FIVE: ADVERTISE!'));

var _ref16 = _jsx('p', {}, void 0, 'Use the printed artwork to advertise your business! Your use of the artwork must be in accordance with the MYSKP Terms of Use, including any time periods in which a particular artwork template may be used.');

var _ref17 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'WHY USE PRINTCENTER'));

var _ref18 = _jsx('p', {}, void 0, 'We recognize that not everyone can have a superstar marketing team to support their business.');

var _ref19 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'It\u2019s Convenient:'), ' PRINTCENTER provides your salon with professional quality & easily customizable marketing materials at the touch of a button, wherever you are.');

var _ref20 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Help Boost your Business:'), ' PRINTCENTER enables your salon to promote your business and engage your clients - gain more exposure, and help build customer loyalty.');

var _ref21 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Personalization:'), ' It\u2019s your logo, your content, your way.');

var _ref22 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'FAQ'));

var _ref23 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Do I have to be a CLUBSKP member to access the PRINTCENTER?'));

var _ref24 = _jsx('p', {}, void 0, 'a. Only salons registered on CLUBSKP have access to PRINTCENTER.');

var _ref25 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'What types of marketing materials are available on PRINTCENTER?'));

var _ref26 = _jsx('p', {}, void 0, 'a. Salons can customize loyalty cards, posters, event flyers, and more! The database is growing, there will always be more to explore.');

var _ref27 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Who is the preferred printing vendor?'));

var _ref28 = _jsx('p', {}, void 0, 'a. Zapplogix Inc.');

var _ref29 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Do I have to print with the suggested vendor?'));

var _ref30 = _jsx('p', {}, void 0, 'a. No. Once you\u2019ve completed your artwork to your satisfaction, you can download the artwork and take it to a local printer.');

var _ref31 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'How long will it take to receive my order?'));

var _ref32 = _jsx('p', {}, void 0, 'a. If you choose to use Zapplogix Inc, their delivery time is approximately 7-10 business days.');

var _ref33 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Do the materials I create on PRINTCENTER qualify for Co-op Advertising?'));

var _ref34 = _jsx('p', {}, void 0, 'a. No. To find out more about co-op advertising, talk to your local Technical Advisor.');

var _ref35 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Do I have to order a minimum quantity?'));

var _ref36 = _jsx('p', {}, void 0, 'a. Some materials are more cost efficient with a minimum order. If you have a small batch, we suggest downloading the artwork and taking it to your local printer.');

var _ref37 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Can I cancel or change my order?'));

var _ref38 = _jsx('p', {}, void 0, 'a. If you have chosen to print with Zapplogix Inc. and have placed your order, it cannot be altered or cancelled.');

var _ref39 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'I notice the Schwarzkopf Professional logo on all the artwork, can I remove it?'));

var _ref40 = _jsx('p', {}, void 0, 'a. No.');

var _ref41 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'I don\u2019t see anything I want to create on PRINTCENTER.'));

var _ref42 = _jsx('p', {}, void 0, 'a. We are open to suggestions! This tool was made for you. With your feedback, we can create and upload templates that satisfy your needs. Send us your feedback.');

var TermsPrint = function TermsPrint() {
  return _jsx('div', {}, void 0, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref23, _ref24), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref25, _ref26), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref27, _ref28), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref29, _ref30), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref31, _ref32), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref33, _ref34), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref35, _ref36), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref37, _ref38), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref39, _ref40), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref41, _ref42)));
};

/* harmony default export */ __webpack_exports__["a"] = (TermsPrint);

/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx('p', {}, void 0, 'Last updated: July 22nd, 2019');

var _ref2 = _jsx('strong', {}, void 0, 'MYSKP');

var _ref3 = _jsx('strong', {}, void 0, 'Additional Terms');

var _ref4 = _jsx('p', {}, void 0, 'By installing, downloading or otherwise using MYSKP, you are deemed to have read and agreed to be bound by our Terms of Use and these Additional Terms and agree to our Privacy Policy. If you do not agree with all of these, you may not use MYSKP.');

var _ref5 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Functions of MYSKP'));

var _ref6 = _jsx('p', {}, void 0, 'MYSKP is a suite of applications and website for the use of professional hair stylists, salons, distributors and distributor sales representatives in Canada. It serves as a sales and marketing tool by helping to facilitate inventory management (on a sell out basis), re-ordering, and sales, by allowing stylists and salons to track their inventory, purchasing, and usage history, and can assist in elevating the creative branding of SKP on a salon level. It allows SKP, and distributors and distributor sales representatives, to review the sales, product, and salon information within their supply chain, for purposes including the management of their businesses and tools to analyze performance data and help maximize sales with visualized key business metrics. It also assists SKP with incentive program management, and managing and distributor sales.');

var _ref7 = _jsx('p', {}, void 0, 'The MYSKP suite of applications includes, or may in the future include, the following features:');

var _ref8 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'CLUBSKP')), _jsx('p', {}, void 0, 'A module that allows eligible users to access their CLUBSKP account- a loyalty program that allows salons to redeem and track points from extracted sales data, in accordance with the Terms of the CLUB SKP Program. This module is set up as an e-commerce system through which points may be redeemed at the rates set by SKP from time to time, and subject to the Terms of the CLUB SKP Program'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'PRINTCENTER')), _jsx('p', {}, void 0, 'A module where salons are able to customize materials and order Advertising Materials, including branded print collateral, as further described in section 3 below. Users can either directly order online with a 3rd party vendor for fulfillment or download material directly for their own use in accordance with these Additional Terms, and any specified term, usage limits or instructions that may be provided by SKP. If you choose to order online with the 3rd party vendor, you will be required to agree to the terms of use of that 3rd party. Such online orders constitute a Third Party Service within the meaning of our Terms of Use. You understand and agree that we take no responsibility for Third-Party Services. In addition, while we may provide you with a link to a third party web site or service, it is understood that we do not endorse, approve, sponsor or support such sites or services.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'FILEVAULT')), _jsx('p', {}, void 0, 'An online repository and file sharing of branded assets including images, marketing material and videos as determined by SKP from time to time. SKP may set limits on what users are permitted to access what assets. Subject to any such limits, all assets are organized in folders with the ability for users to create their own. Certain assets can be directly downloaded at various file size or application purposes. All materials in the file vault are \u201CAdvertising Materials\u201D within the meaning of section 3 below, and may only be used in accordance with these Terms of Use, and any specified term, usage limits or instructions that may be provided by SKP.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'POE')), _jsx('p', {}, void 0, 'This is a module that is used by SKP to administer the distributor Sales Incentive program called \u201CProfile of Excellence\u201D, using information uploaded by the distributors using the ETL tool. SKP uses an ETL tool to extract all sales data from the Schwarzkopf ERP system and/or Distributor data. The module then automatically allocates incentive points and spiffs due to sales consultants, if any, and generates invoices. All stakeholders are able to track their progress as well as check their leader-board standing. SKP does not guarantee the accuracy of the leaderboard, or any point totals, and may adjust them at any time if an error is discovered.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'ADVISORNET')), _jsx('p', {}, void 0, 'Is a daily tracking and event scheduler module for education of internal technical advisor and technical supervisor stakeholders. These users may use this module to schedule, track and report their daily activities. It tracks calendar activity of SKP technical advisors and serves as a reimbursement site for costs associated with such technical advisors according to a built-in SKP approval process, and allows an automatic deployment of invoices for expense reimbursement, allowing SKP to track and reimburse SKP designated third parties, in a manner and such amounts as may have been approved by SKP. Detailed performance reporting helps all stakeholders to manage and improve the efficiency of their daily activity.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'MYTRACKER')), _jsx('p', {}, void 0, 'Allows the visual tracking by SKP of all data in MYSKP, which includes both sales and activities data. Distributors may only view their own data and that of their downstream sales consultants.'));

var _ref9 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Accessing MYSKP and Account Security'));

var _ref10 = _jsx('p', {}, void 0, 'You are responsible for:');

var _ref11 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Making all arrangements necessary for you to have access to MYSKP; and'));

var _ref12 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Ensuring that all persons who access MYSKP through your internet connection are aware of these Terms of Use and comply with them.'));

var _ref13 = _jsx('p', {}, void 0, 'To access MYSKP or some of the resources it offers, you may be asked to provide certain registration details or other information. It is a condition of your use of MYSKP that all the information you provide on MYSKP is correct, current and complete.');

var _ref14 = _jsx('p', {}, void 0, 'To access MYSKP services you will be required to register on MYSKP. All registrations are subject to the acceptance of SKP, which may be withheld or denied in our sole and absolute discretion. SKP may in its discretion set (or reset) different levels of access to MYSKP for different users and/or accounts, which may alter the content, applications, features or functions such users and/or accounts may access on MYSKP. You agree to: (a) maintain the confidentiality of any passwords or other account identifiers which you choose or that are assigned to you as a result of any registration or account creation with MYSKP; and (b) be responsible for all activities that occur under such password or account. Further, you agree to immediately notify us of any unauthorized use of your password or account in the event that the confidentiality of your password or your account is compromised. Failure to comply with this paragraph may result in immediate termination of your account. We shall not be responsible or liable, directly or indirectly, in any way for any loss or damage of any kind incurred as a result of, or in connection with, your failure to comply with this section, or for any delay in shutting down your account after you have reported a breach of security to us. You also agree to ensure that you exit from your account at the end of each session. You should use particular caution when accessing your account from a public or shared computer so that others are not able to view or record your password or other personal information or business information.');

var _ref15 = _jsx('p', {}, void 0, 'We have the right to disable any account, and/or any user name, password or other identifier, whether chosen by you or provided by us, at any time in our sole discretion including if, in our opinion, you have violated any provision of these Additional Terms, any other agreement you have with us, or we have a reasonable belief that your account has been compromised. From time to time, we may restrict access to some parts of MYSKP, or the entire MYSKP. These restrictions may apply to individual MYSKP accounts, to all MYSKP accounts or to any subset thereof.');

var _ref16 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'License To Certain Advertising Materials'));

var _ref17 = _jsx('p', {}, void 0, 'We grant you a limited, non-exclusive, personal, non-transferable, non-sub-licensable and revocable right and license to access, view and print any information and documentation made available on MYSKP, for your personal, non-commercial (other than as permitted in accordance with these Terms of Use), and informational use only to assist you in the access and use of MYSKP. Certain features of MYSKP may permit you to download SKP advertising templates and materials for use in the promotion of the availability of SKP products through your business (\u201C', _jsx('strong', {}, void 0, 'Advertising Materials'), '\u201D). We grant you a limited, non-exclusive, personal, non-transferable, non-sub-licensable and revocable right and license to access, view, print and disseminate, within Canada only, Advertising Materials made available on MYSKP, for the sole purpose of promoting the availability of SKP products through your business. All usage of the Advertising Materials must: i) be to promote the sale of SKP products; ii) be done in a manner that does not damage or disparage any SKP logos or trade-marks; iii) be done in a manner that is not confusing to the public; iv) comply with any specified term, usage limits or instructions that may be provided by SKP. This licence includes the limited ability to edit the Advertising Materials to include information respecting your business as well as any offers or promotions you choose to make in respect of it (\u201COffers\u201D), but not to edit or alter any SKP logos, trade-marks, graphic, or images, which may appear only as provided in the Advertising Materials. You, and not SKP, are responsible for any Offers you choose to make, and without limitation are responsible for ensuring their legal compliance.');

var _ref18 = _jsx('p', {}, void 0, 'Certain Advertising Materials or other materials available on MYSKP may be subject to addition usage requirements, instructions, restrictions, or limitations that differ from the above licence. For example, this may include additional territorial limitations, and/or restricted usage periods. If you choose to use any Advertising Materials or other materials available on MYSKP, you must agree to and comply with any such requirements, instructions, restrictions, or limitations. You agree that you will cease use of any Advertising Materials or other materials available on MYSKP at the request of SKP.');

var _ref19 = _jsx('p', {}, void 0, 'Except for the limited licenses and rights expressly granted to you in the Terms of Use, these Terms of Use do not grant you any other right or license in or under any patent, trademark, copyright, or other intellectual property or proprietary right. We may terminate or suspend this license at any time for any reason in our sole and absolute discretion. Any use that may suggest a community of interest or business relationship other than that between independently owned and operated businesses is also strictly prohibited.');

var _ref20 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Purchases through MYSKP'));

var _ref21 = _jsx('p', {}, void 0, 'Certain features of MYSKP may now or may in the future permit you to make purchases. You may only make purchases through MYSKP if you are over the age of legal majority in your jurisdiction of residence. Purchases will only be shipped to a valid mailing address in Canada (as determined by SKP in its sole and absolute discretion). However, please note that we may not be able to ship to all valid addresses and, in such circumstances, we reserve the right in our sole and absolute discretion to cancel your purchase transaction (\u201C', _jsx('strong', {}, void 0, 'Order'), '\u201D). In the event we are not able to ship to the shipping address you provide, we will notify you, your Order will be cancelled, and you will receive a refund in respect of your Order (unless you are able to provide an alternate eligible shipping address). We further reserve the right not to offer expedited or other forms of shipping. Unless otherwise indicated, all dollar amounts are in Canadian Dollars.');

var _ref22 = _jsx('p', {}, void 0, 'All Orders made through MYSKP are subject to these Additional Terms, as well as any other applicable terms and conditions outlined on MYSKP relating to the Order. Pricing and other terms and conditions relating to the purchase, return, refund, or delivery of your Order may be changed at any time without notice. Prices may differ from those for purchases made through other channels. You have a legal obligation to pay for any Orders indicated to be made by you. By completing an Order through MYSKP, you are agreeing to pay, in full, the prices and all applicable taxes and specified shipping and handling and other fees in relation to your Order, either by credit card or other permitted payment method.');

var _ref23 = _jsx('p', {}, void 0, 'SKP reserves the right, in its sole and absolute discretion, to change the permitted methods of payment, including without limitation, the credit cards and/or other types of payment options we are able to accept, at any time. If complete payment for your Order is not received and verified by us, your Order will not be processed. If you do not complete or improperly complete your Order it may not be accepted or acknowledged.');

var _ref24 = _jsx('p', {}, void 0, 'In order to complete an Order through MYSKP, you may be required to provide certain additional information that is required to process your Order. For example, you will be required to provide valid payment information (e.g. a valid credit card number and expiration date) to facilitate payment of your Order.');

var _ref25 = _jsx('p', {}, void 0, 'You will be billed for your Order at the time your Order is placed. You will be responsible for all applicable taxes related to your Order. Applicable taxes will be charged at the time you are billed. Applicable sales tax will also be applied to the shipping and handling, return shipping and gift packaging or other charges. Taxes may depend on delivery location.');

var _ref26 = _jsx('p', {}, void 0, 'Without limiting the generality of any other section of these Additional Terms, SKP reserves the right to limit or refuse any Order you place with us. Further, we reserve the right to verify the validity of all Orders and/or cancel any Order if we find evidence of fraud, tampering and/or any other violation of the terms and conditions of these Additional Terms, or our Terms of Use. We may, in our sole and absolute discretion, limit or cancel quantities purchased per person, per account or per Order. These restrictions may include Orders placed by or under the same account, by the same salon or business, using the same credit card, and/or Orders that use the same billing and/or shipping address. We also reserve the right, in our sole and absolute discretion, not to ship items ordered or purchased through MYSKP to certain addresses. In the event that we are unable to or choose not to ship an item, you will be notified accordingly and the amount for that item charged in relation to your Order will be reduced accordingly.');

var _ref27 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Communications on MSKP'));

var _ref28 = _jsx('p', {}, void 0, 'MYSKP allows SKP to send communications and notifications to users, and/or any particular class of users both through the MYSKP online module and/or via email notifications. Certain features of MYSKP may permit certain classes of user to communicate with other users- both through the MYSKP online module and/or via email notifications. Should you be permitted and choose to communicate with any other users, you must comply with all applicable laws in so doing, including without limitation all Canadian privacy laws, and Canada\u2019s anti-spam legislation. You must have any consents required under such laws, and must include in your messages all required content and disclosures, including without limitation any required unsubscribe mechanisms.');

var _ref29 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Indemnity'));

var _ref30 = _jsx('p', {}, void 0, 'You agree to defend, indemnify, and hold harmless SKP, and our affiliates, and the officers, directors, employees, agents and representatives of each of them, from and against any claims, actions, demands, losses, liabilities, damages, costs, suits, actions, penalties and expenses arising out of or relating, directly or indirectly, to: (i) your access to and/or use of a MYSKP, the services, and/or any component thereof, (ii) your violation of any of the terms and conditions of this agreement; (iii) your use of the Advertising Materials, including any Offers you choose to make in association therewith, and/or (iv) the infringement by you, or any third party using your account, of any intellectual property or other right of any person or entity, including without limitation if you violate the terms of any licence associated with the Advertising Materials. You agree that SKP may assume the exclusive defense and control of any matter for which you are required to indemnify SKP and you agree to cooperate, at your cost, with our defense of these claims. You agree not to settle any such matter without the prior written consent of SKP.');

var _ref31 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Electronic Notification'));

var _ref32 = _jsx('p', {}, void 0, 'To the extent that we contact you, you agree that we may do so via any electronic means, including but not limited to communications posted on MYSKP, Messenger application notifications or electronic mail.');

var _ref33 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'No Agency Relationship'));

var _ref34 = _jsx('p', {}, void 0, 'You agree that no joint venture, partnership, agency or employment relationship exists between you and SKP as a result of these Terms or Use or use of MYSKP and access to the services.');

var _ref35 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Termination'));

var _ref36 = _jsx('p', {}, void 0, 'If you breach any provision of these Additional Terms of Use (as determined by SKP in its sole and absolute discretion), then you may no longer use MYSKP, the services, or any component thereof. We may, in our sole and absolute discretion, change, suspend or terminate, temporarily or permanently, MYSKP, the services, or any component thereof or any of its features at any time, for any reason, without any notice or liability to you or any other entity. If these Terms of Use or your permission to use MYSKP is terminated by us for any reason, the agreement formed by your acceptance of these Terms of Use will nevertheless continue to apply and be binding upon you in respect of your prior use of MYSKP and anything relating to or arising from such use. If you are dissatisfied with MYSKP, the services, or any component thereof, then your sole and exclusive remedy is to discontinue using them.');

var _ref37 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Collection, Use and Disclosure of Information by MYSKP.'));

var _ref38 = _jsx('p', {}, void 0, 'If you provide us with information pertaining to a third party, such as one of your individual distributors or an individual at a salon, you represent and warrant to us that you have that party\u2019s consent to the collections, uses, and disclosures of information in this section and our Privacy Statement, and that you have the legal right to disclose and allow Henkel to use and disclose all such information for the purposes contemplated in this section and our Privacy Statement, and you have obtained all applicable consents or authorizations necessary therefor, if any. If we determine that you have violated this provision, we reserve the right to limit, or terminate, your access to MYSKP as we may determine appropriate in our sole and absolute discretion.');

var _ref39 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information Collection on MYKP.'), ' SKP collects the following identifiable information through MYSKP:');

var _ref40 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Your first and last name;'));

var _ref41 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Your Sales Rep ID (if applicable);'));

var _ref42 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Your Sales Rep Email Address (if applicable);'));

var _ref43 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Your salon name and salon owner;'));

var _ref44 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Any contact information you provide including, but not limited to, your phone number and address;'));

var _ref45 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Your email address as well as any contact information provided at the time of registering for an account on MYSKP;'));

var _ref46 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Geo-location data, should this data allow for your identification; and'));

var _ref47 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Any other identifiable personal information you choose to provide to us when using MYSKP'));

var _ref48 = _jsx('p', {}, void 0, 'For users who are distributors, MYSKP collects information you provide as follows:');

var _ref49 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Sales Table'));

var _ref50 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- TransactionID'));

var _ref51 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- TransactionDate'));

var _ref52 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonTaxID OR - SalonID'));

var _ref53 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalesRepID'));

var _ref54 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Sku/ProductID'));

var _ref55 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Product Name'));

var _ref56 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Qty'));

var _ref57 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- TotalCost'));

var _ref58 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '*If there is no unique ID for Sales Reps, please include the Sales Reps email address in the SalesRepID field'));

var _ref59 = _jsx('br', {});

var _ref60 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Product Table'));

var _ref61 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Sku/ProductID'));

var _ref62 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Henkel IDH#'));

var _ref63 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- ProductBrand'));

var _ref64 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- ProductName'));

var _ref65 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- ProductDescription'));

var _ref66 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- ProductCategory'));

var _ref67 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- ProductSubCategory'));

var _ref68 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- ProductPrice'));

var _ref69 = _jsx('br', {});

var _ref70 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Salon Table'));

var _ref71 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonID'));

var _ref72 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonTaxID'));

var _ref73 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonName'));

var _ref74 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonAddressStreet1'));

var _ref75 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonAddressStreet2'));

var _ref76 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonAddressCity'));

var _ref77 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonAddressPostal'));

var _ref78 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonAddressState'));

var _ref79 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonAddressCountry'));

var _ref80 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonRegion'));

var _ref81 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalonSubRegion'));

var _ref82 = _jsx('br', {});

var _ref83 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Sales Rep Table'));

var _ref84 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalesRepID'));

var _ref85 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalesRepName'));

var _ref86 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalesRepEmailAddress'));

var _ref87 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalesRepRegion'));

var _ref88 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- SalesRepSubRegion'));

var _ref89 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Use of Information by MYSKP'));

var _ref90 = _jsx('p', {}, void 0, 'The personal information and any other information obtained from you through your use of MYSKP may be used by SKP and its service providers for analytical purposes, including through assessing and evaluating your usage of MYSKP (including the modules and applications of MYSKP you use and how often and for how long you use them and your click stream), and for business evaluation purposes and future performance forecasting and modeling. In addition to the foregoing, SKP may use such information as is reasonably necessary for the following:');

var _ref91 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Managing your account on MYSKP;'));

var _ref92 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Providing you with the services and features available through MYSKP including preparing and providing reports on your sales, product levels and purchasing history, and those of the salons in your supply chain;'));

var _ref93 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Facilitate any purchase you choose to make using a Website, including facilitating payment for your purchase;'));

var _ref94 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Notify you when an order you have made using a Website is ready for pick-up or delivery;'));

var _ref95 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'To administer any loyalty, incentive, or rewards program we may offer and choose to allow access to through MYSKP, including allowing you to review your balance, redemption, and any rewards that you have received, in accordance with the terms of such program;'));

var _ref96 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'To create a publicly accessible listing of Salons and outer businesses, that carry SKP products, including business name and contact information;'));

var _ref97 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'To allow you to create a calendar of your scheduled events, appointments, and activities; and'));

var _ref98 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'If you choose to provide you location information, to help enable you to map and produce routes for your planned activities, such as planed visits to salons.'));

var _ref99 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Disclosure of Information by MYSKP'));

var _ref100 = _jsx('p', {}, void 0, 'Please note that SKP reserves the right to disclose your personal information, as is reasonably necessary, to a third party without your prior consent in the following events:');

var _ref101 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'If your conduct on MYSKP breaches the Terms of Use and the disclosure of such information would allow SKP to protect their legal rights and/or avail themselves of any remedies that may be available to ether of them at law;'));

var _ref102 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Should SKP deem in good faith that such disclosure is necessary to identify and/or contact any person in view of or undertake legal actions against a person to protect or enforce the rights or properties of SKP or those of other users; or'));

var _ref103 = _jsx('p', {}, void 0, 'In the event that SKP deems in good faith that the law requires or permits such disclosure, including sharing identifiable personal information with other companies and organizations for the purpose of preventing fraud, or in order to comply with any legal or regulatory requirements.');

var _ref104 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Technical Data'));

var _ref105 = _jsx('p', {}, void 0, 'You agree that SKP ', _jsx('strong', {}, void 0, 'and/'), 'or its service providers may collect and use technical data and related information, including but not limited to technical information about your device, system and application software, and peripherals, to facilitate the provision of software updates, product support and other services to you (if any) related to MYSKP. SKP or Zapplogix may use and disclose this information to third-parties, as long as it is in a form that does not personally identify you, to improve its products or to provide services or technologies to you.');

var _ref106 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Cookies'));

var _ref107 = _jsx('p', {}, void 0, 'We may use a feature on your device or browser called a \u201Ccookie\u201D and/or other similar devices. Cookies are small files that your browser places on your device\u2019s hard drive. They are used for a variety of reasons, such as tracking click streams, optimization, marketing, and load balancing. We use a combination of session and persistent cookies to enable our log-in function, shopping carts, remember items you have added to your cart, allow you to create wish lists, checkout processing and to provide use with the ability to remember and improve your experience. We may use this information to determine your general geographic location to display the correct version of MYSKP. Information tracked through these mechanisms may include, but is not limited to: (i) your IP address; (ii) the type of browser and operating system being used; and (iii) the pages of the site or application a user visits. Your browser gives you the option to reject cookies. However, setting your browser to reject cookies generally hinders the browser\u2019s performance and will adversely affect your experience while using MYSKP, and certain features may not work. To be able to make a purchase using MYSKP, the following cookies are necessary and would need to be accepted: \u2018siteId\u2019, \u2018id_token.*\u2019, \u2018gId\u2019, \u2018locale\u2019.');

var TermsAdditional = function TermsAdditional() {
  return _jsx('div', {}, void 0, _ref, _jsx('p', {}, void 0, 'Your use of the MYSKP Enterprise Suite / MYTRACKER platform and the Henkel Canada Corporation or one of its subsidiary or affiliated companies (collectively, \u201CSKP\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D) website at http://myskp.com/ca and the MYSKP Enterprise suite of applications (hereinafter collectively referred to as \u201C', _ref2, '\u201D) is subject to our', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Terms of Use and Privacy Policy'), ', as well as by this Terms of Use and Privacy Supplement (\u201C', _ref3, '\u201D).'), _ref4, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref5, _ref6, _ref7, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref8)), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref9, _ref10, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref11, _ref12), _ref13, _ref14, _ref15), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref16, _ref17, _ref18, _ref19), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref27, _ref28), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref29, _ref30), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref31, _ref32), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref33, _ref34), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref35, _ref36), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref37, _jsx('p', {}, void 0, 'Without limiting the terms of our', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), ', which applies to MYSKP in addition to this section, when you use MYSKP, you agree we may collect, use, and disclose your information as described in this section.'), _ref38)), _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref39, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47), _ref48, _ref49, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58), _ref59, _ref60, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68), _ref69, _ref70, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81), _ref82, _ref83, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref84, _ref85, _ref86, _ref87, _ref88)), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref89, _ref90, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98)), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref99, _ref100, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref101, _ref102), _ref103), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref104, _ref105), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref106, _ref107)));
};

/* harmony default export */ __webpack_exports__["a"] = (TermsAdditional);

/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'MYSKP CONDITIONS D\u2019UTILISATION ADDITIONNELLES ET SUPPL\xC9MENT VIE PRIV\xC9E'));

var _ref2 = _jsx('p', {}, void 0, 'Derni\xE8re mise \xE0 jour : 22 Juillet 2019');

var _ref3 = _jsx('strong', {}, void 0, '\u201CMYSKP\u201D');

var _ref4 = _jsx('strong', {}, void 0, 'Conditions suppl\xE9mentaires');

var _ref5 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Fonctions de MYSKP'));

var _ref6 = _jsx('p', {}, void 0, 'MYSKP est une suite d\u2019applications et un site web pour utilisation par des stylistes professionnels, salons, distributeurs et repr\xE9sentants des distributeurs au Canada. Il sert d\u2019outil de vente et de marketing en aidant \xE0 faciliter la gestion de l\u2019inventaire (sur une base de produits vendus), le placement de commandes de restockage et les ventes, en permettant aux stylistes et aux salons de suivre l\u2019historique de leur inventaire, leurs achats et leur utilisation, et peut aussi contribuer \xE0 am\xE9liorer le branding cr\xE9atif de SKP au niveau du salon. Il permet \xE0 SKP, aux distributeurs et aux repr\xE9sentants du distributeur de reviser les ventes, les informations sur le salon et les produits au sein de leur cha\xEEne d\u2019approvisionnement pour des motifs incluant la gestion de leur salon et les outils pour analyser les donn\xE9es de performance et aider \xE0 maximiser les ventes avec des unit\xE9s de mesure visuelles sur leurs donn\xE9es de rendement du salon. Il assiste aussi SKP sur la gestion de programmes incitatifs de gestion et de ventes des distributeurs.');

var _ref7 = _jsx('p', {}, void 0, 'La suite d\u2019applications de MYSKP offre, ou pourrait offrir dans le futur, les caract\xE9ristiques suivantes:');

var _ref8 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'CLUBSKP')), _jsx('p', {}, void 0, 'Un module qui permet aux utilisateurs \xE9ligibles d\u2019acc\xE9der \xE0 leur compte CLUBSKP- un programme de fid\xE9lisation permettant aux salons d\u2019\xE9changer et de faire le suivi des points d\xE9termin\xE9s par les donn\xE9es de vente, en conformit\xE9 avec les Conditions du programme CLUBSKP. Ce module est organis\xE9 comme un syst\xE8me d\u2019e-commerce \xE0 travers lequel les points peuvent \xEAtre \xE9chang\xE9s aux taux d\xE9termin\xE9s par SKP occasionnellement, et sujets aux Conditions du Programme CLUBSKP.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'CENTRE D\u2019IMPRESSION')), _jsx('p', {}, void 0, 'Un module o\xF9 les salons peuvent personnaliser du mat\xE9riel et commander du Mat\xE9riel Promotionnel, incluant des accessoires imprim\xE9s de la marque, tels que d\xE9crits plus avant dans la section 3 ci-dessous. Les utilisateurs peuvent soit commander en ligne directement avec un fournisseur tiers pour la r\xE9alisation ou t\xE9l\xE9charger le mat\xE9riel directement pour leur utilisation personelle en conformit\xE9 avec ces Conditions Additionnelles et toute autre condition sp\xE9cifi\xE9e, limites d\u2019utilisation ou instructions pouvant \xEAtre fournies par SKP. Si vous choisissez de commander en ligne avec un fournisseur tiers, vous devrez accepter les conditions d\u2019utilisation de ce tiers. Une telle commande en ligne constitue un Service par un Tiers selon la signification de nos Conditions d\u2019Utilisation. Vous comprenez et acceptez que nous n\u2019assumons aucune responsabilit\xE9 face au Service d\u2019un Tiers. De plus, alors que nous pourrions vous fournir un lien vers le site web d\u2019un tiers, il est compris que nous n\u2019endossons, n\u2019approuvons, commanditons ou supportons ces sites ou services.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'FILEVAULT')), _jsx('p', {}, void 0, 'Un d\xE9p\xF4t en ligne et partage de fichiers d\u2019actifs de marque incluant des images, du mat\xE9riel marketing et des vid\xE9os tel que d\xE9termin\xE9 par SKP occasionnellement. SKP peut fixer des limites sur ce que les utilisateurs peuvent avoir acc\xE8s. Sujet \xE0 ces limites, tous les actifs sont organis\xE9s dans des fichiers avec la possibilit\xE9 pour les utilisateurs de cr\xE9er les leurs. Certains actifs peuvent \xEAtre t\xE9l\xE9charg\xE9s directement dans diff\xE9rentes tailles de fichier ou raisons d\u2019une application. Tout le mat\xE9riel dans le fichier voute est du \u2018\u2019Mat\xE9riel Publicitaire\u2019\u2019 selon la d\xE9finition de la section 3 ci-dessous, et ne peut \xEAtre utilis\xE9 qu\u2019en conformit\xE9 avec ces Conditions d\u2019Utilisation, et toute autre condition sp\xE9cifi\xE9e, limites d\u2019utilisation ou instructions pouvant \xEAtre fournis par SKP.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'POE')), _jsx('p', {}, void 0, 'C\u2019est un module utilis\xE9 par SKP pour administrer le programme Incitaif de Ventes du distributeur appel\xE9 \u201CProfil d\u2019Excellence\u201D, utilisant l\u2019information t\xE9l\xE9vers\xE9e par les distributeurs utilisant l\u2019outil ETL. SKP utilise un outil ETL pour extraire toutes les donn\xE9es de vente \xE0 partir du syst\xE8me ERP de Schwarzkopf et/ou des donn\xE9es du Distributeur. Par la suite, le module alloue automatiquement des points et les primes dues au consultant en salon, s\u2019il y a lieu et g\xE9n\xE8re des factures. Tous les participants peuvent suivre leur progr\xE8s ainsi que v\xE9rifier le classement au tableau des meneurs. SKP ne garantit pas l\u2019exactitude du tableau des meneurs, ou tout total de points, et peut les ajuster occasionnellement si une erreur est trouv\xE9e.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'ADVISORNET')), _jsx('p', {}, void 0, 'C\u2019est un module de suivi quotidien et planificateur d\u2019\xE9v\xE8nement pour la formation ou pour les membres de l\u2019\xE9quipe d\u2019aviseurs techniques internes et superviseurs techniques. Ces utilisateurs peuvent se servir du module pour planifier, faire le suivi et produire un rapport de leurs activit\xE9s quotidiennes. Il fait le suivi des activit\xE9s \xE0 l\u2019agenda des aviseurs techniques SKP et sert de site de remboursement pour les co\xFBts associ\xE9s au travail de ces aviseurs techniques en fonction d\u2019un processus d\u2019autorisation incorpor\xE9 par SKP permettant un d\xE9ploiement automatique de factures pour le remboursement des d\xE9penses, permettant \xE0 SKP de faire le suivi et de rembourser les tiers d\xE9sign\xE9s par SKP, de la mani\xE8re et selon les montants ayant \xE9t\xE9 approuv\xE9s par SKP. Les rapports de performance d\xE9taill\xE9s aident tous les intervenants \xE0 g\xE9rer et am\xE9liorer l\u2019efficacit\xE9 e leurs activit\xE9s quotidiennes.'), _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'MYTRACKER')), _jsx('p', {}, void 0, 'Permet un suivi visuel par SKP de toutes les donn\xE9es contenues dans MYSKP, ce qui inclut tant les donn\xE9es de vente et d\u2019activit\xE9. Les distributeurs ne peuvent consulter que leurs propres donn\xE9es et celles des activit\xE9s de leurs consultants en salon.'));

var _ref9 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Acc\xE8s \xE0 MYSKP et s\xE9curit\xE9 des comptes'));

var _ref10 = _jsx('p', {}, void 0, 'Vous \xEAtes responsable de ce qui suit:');

var _ref11 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\xB7 Faire tous les arrangements n\xE9cessaires pour vous permettre d\u2019avoir acc\xE8s \xE0 MYSKP; et'));

var _ref12 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'De vous assurer que toutes les personnes qui acc\xE8dent \xE0 MYSKP via votre connection internet sont conscientes de ces Conditions d\u2019Utilisation et s\u2019y conforment.'));

var _ref13 = _jsx('p', {}, void 0, 'Pour acc\xE9der \xE0 MYSKP ou \xE0 certaines ressources qu\u2019il offre, vous pourriez devoir fournir certains d\xE9tails d\u2019inscription ou autres informations. C\u2019est une condition d\u2019utilistion de MYSKP que toute l\u2019information fournie \xE0 MYSKP est correcte, actuelle et compl\xE8te.');

var _ref14 = _jsx('p', {}, void 0, 'Pour acc\xE9der aux services de MYSKP vous devrez vous inscrire sur MYSKP. Toutes les inscriptions sont sujettes \xE0 l\u2019acceptation par SKP, et pourraient \xEAtre retenues ou refus\xE9es \xE0 notre seule et absolue discr\xE9tion. SKP peut \xE0 sa discr\xE9tion \xE9tablir (ou r\xE9\xE9tablir) diff\xE9rents niveaux d\u2019acc\xE8s \xE0 MYSKP pour diff\xE9rents utilisateurs et/ou comptes, ce qui pourrait modifier le contenu, les applications, les caract\xE9ristiques ou fonctions que ces utilisateurs et /ou comptes pourraient acc\xE9der sur MYSKP. Vous acceptez de: (a) maintenir la confidientalit\xE9 de tout mot de passe ou autre identifiant du compte, que vous avez choisi ou qui vous ont \xE9t\xE9 assign\xE9s \xE0 la suite de toute inscription ou cr\xE9ation de compte avec MYSKP; et (b) \xEAtre responsable de toutes les activit\xE9s qui se d\xE9roulent sous ce mot de passe ou compte. De plus, vous acceptez de nous aviser imm\xE9diatement de toute utilisation non-autoris\xE9e de votre mot de passe ou compte dans l\u2019\xE9ventualit\xE9 o\xF9 la confidentialit\xE9 de votre mot de passe ou de votre compte est compromise. Le d\xE9faut de se conformer \xE0 ce paragraphe pourrait entra\xEEner la fermeture imm\xE9diate de votre compte. Nous ne devons pas \xEAtre tenu responsables directement ou indirectement, de quelque mani\xE8re que ce soit pour toute perte ou dommage de toute sorte subi r\xE9sultant de , ou en lien avec, votre d\xE9faut de vous conformer \xE0 cette section, ou pour tout d\xE9lai dans la fermeture de vore compte apr\xE8s que vous nous ayez rapport\xE9 une faille de s\xE9curit\xE9. Vous acceptez aussi de vous assurer de sortir de votre compte \xE0 la fin de chaque session. Vous devriez apporter une prudence particuli\xE8re lorsque vous acc\xE9dez \xE0 votre compte via un ordinateur public ou partag\xE9 afin que les autres ne puissent voir ou enregistrer votre mot de passe ou autres informations personnelles ou d\u2019affaires.');

var _ref15 = _jsx('p', {}, void 0, 'Nous avons le droit de d\xE9sactiver votre compte et/ou tout nom d\u2019utilisateur, mot de passe ou autre identifiant, qu\u2019il soit choisi par vous ou fourni par nous, \xE0 tout moment, \xE0 notre seule discr\xE9tion incluant si, \xE0 notre opinion, vous avez viol\xE9 tout \xE9l\xE9ment de de ces Conditions Additionnelles, tout autre entente convenue avec nous, ou nous avons un motif raisonnable de croire que votre compte a \xE9t\xE9 compromis. \xC0 l\u2019occasion, nous pourrions restreindre l\u2019acc\xE8s \xE0 certaines parties de MYSKP, ou \xE0 l\u2019ensemble de MYSKP. Ces restrictions pourront s\u2019appliquer \xE0 des comptes individuels MYSKP, \xE0 tous les comptes ou \xE0 tout sous-ensemble de ceux-ci.');

var _ref16 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Licence relative \xE0 du mat\xE9riel publicitaire pr\xE9cis'));

var _ref17 = _jsx('p', {}, void 0, 'Nous vous accordons un droit et une licence limit\xE9e, non-exclusive, personnelle, non-transf\xE9rable, non-sous-licensable et r\xE9vocable d\u2019acc\xE9der voir et imprimer toute information et documentation rendus disponibles sur MYSKP, pour votre utilisation personnelle, non-commerciale (autre que si permis en conformit\xE9 avec ces Conditions d\u2019Utilisation), et informative seulement pour vous assister dans l\u2019acc\xE8s et l\u2019utilisation de MYSKP. Certaines caract\xE9ristiques de MYSKP peuvent vous permettre de t\xE9l\xE9charger des pages d\u2019annonces publicitaires pr\xEAtes \xE0 utiliser et du mat\xE9riel pour la promotion de la disponibilit\xE9 de produits SKP dans votre entreprise (\u201C', _jsx('strong', {}, void 0, 'Mat\xE9riel publicitaire'), '\u201D). Nous vous accordons un droit et une licence limit\xE9, non-exclusif, personnel, non-transf\xE9rable, non sous-licensable et r\xE9vocable d\u2019acc\xE9der, de voir, d\u2019imprimer et de diffuser, \xE0 l\u2019int\xE9rieur du Canada seulement, le Mat\xE9riel Publicitaire rendu disponible sur MYSKP, dans le seul objectif de promouvoir la disponibilit\xE9 de produits SKP dans votre entreprise. Tout utilisation de Mat\xE9riel Publicitaire doit: i) \xEAtre pour la promotion des ventes de produits SKP; ii) \xEAtre faite de mani\xE8re qui n\u2019affecte ou ne d\xE9nigre pas tout logo ou marque de commerce SKP; iii) \xEAtre faite afin de ne pas crc\xE9er de la confusion dans le public; iv) se confirmer avec toute condition sp\xE9cifi\xE9e, limites d\u2019utilisation ou instructions pouvant \xEAtre fournis par SKP. Cette licence inclut la possibilit\xE9 limit\xE9e de modifier le Mat\xE9riel Publicitaire pour y inclure des informations concernant votre entreprise ainsi que toute offre ou promotion que vous choisissez de faire en fonction de celle-ci (\u201C', _jsx('strong', {}, void 0, 'Offres'), '\u201D), mais non d\u2019alt\xE9rer ou de modifier tout logo SKP, marque de commerce, graphique ou image qui doivent appara\xEEtre seulement tels que fournis dans le Mat\xE9riel Publicitaire. Vous, et non SKP, \xEAtes responsable pour toute Offre que vous choisissez de faire, et, sans limitation \xEAtes responsable d\u2019assurer leur conformit\xE9 l\xE9gale.');

var _ref18 = _jsx('p', {}, void 0, 'Certain Mat\xE9riel Publicitaire ou autre mat\xE9riel disponible sur MYSKP peut \xEAtre sujet \xE0 des conditions d\u2019utilisation additionnelles, instructions, restrictions, ou limitations qui diff\xE8rent de la licence ci-dessus. Par exemple, cela peut inclure des limitations territoriales additionnelles et/ou des p\xE9riodes d\u2019utilisation restreintes. Si vous choisissez d\u2019utiliser tout Mat\xE9riel Publicitaire ou autre mat\xE9riel disponible sur MYSKP, vous devez accepter de et vous conformer avec toute condition, instruction, restriction, ou limitation. Vous acceptez de devoir cesser l\u2019utilisation de tout Mat\xE9riel Publicitaire ou autre');

var _ref19 = _jsx('p', {}, void 0, '\xC0 l\u2019exception des droits et licenses qui vous sont express\xE9ment accord\xE9s dans les Conditions d\u2019Utilisation, ces Conditions d\u2019Utilisation ne vous accordent aucun autre droit ou licence sur ou en lien avec tout brevet, marque de commerce, droit d\u2019auteur, ou autre propri\xE9t\xE9 intellectuelle ou droit de propri\xE9t\xE9. Nous pouvons mettre fin \xE0 cette license ou la suspendre \xE0 tout moment, pour toute raison, \xE0 notre seule et absolue discr\xE9tion. Tout utilisation pouvant sugg\xE9r\xE9 une communaut\xE9 d\u2019int\xE9r\xEAts, ou une relation d\u2019affaire est aussi strictement d\xE9fendue.');

var _ref20 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Achats \xE0 l\u2019aide de MYSKP'));

var _ref21 = _jsx('p', {}, void 0, 'Certaines caract\xE9ristiques de MYSKP peuvent maintenant ou pourront dans le futur vous permettre de faire des achats. Vous pouvez seulement faire des achats sur MYSKP si vous avez atteint l\u2019\xE2ge l\xE9gal de la majorit\xE9 dans votre juridiction de r\xE9sidence. Les achats ne seront exp\xE9di\xE9s qu\u2019\xE0 une addresse postale valide au Canada (tel que d\xE9termin\xE9 par SKP \xE0 sa seule et absolue discr\xE9tion). Toutefois, veuillez noter que nous pourrions ne pas pouvoir exp\xE9dier \xE0 certaines adresses postales valides et, dans ces circonstances, nous nous r\xE9servons le droit, \xE0 notre seule et absolue discr\xE9tion, d\u2019annuler votre achat (\u201C', _jsx('strong', {}, void 0, 'Commande'), '\u201D). Dans l\u2019\xE9ventualit\xE9 o\xF9 nous sommes incapables d\u2019exp\xE9dier \xE0 l\u2019adresse d\u2019exp\xE9dition fournie, nous vous en aviserons, votre Commande sera annul\xE9e, et vous recevrez un remboursement au montant de votre Commande (\xE0 moins que vous ne puissiez nous fournir une adresse de livraison alternative \xE9ligible). Nous nous r\xE9servons de plus le droit de ne pas offrir certaines formes d\u2019exp\xE9dition. Sauf si sp\xE9cifi\xE9 autrement, tous les montants indiqu\xE9s sont enDollars Canadiens.');

var _ref22 = _jsx('p', {}, void 0, 'Toutes les commandes effectu\xE9es via MYSKP sont sujettes \xE0 ces Conditions Additionnelles, ainsi qu\u2019\xE0 tout autre terme et condition applicables d\xE9finis sur MYSKP en lien avec les Commandes. Le prix et autres et conditions en lien avec l\u2019achat, le retour, le remboursement ou la livraison de votre Commande peuvent \xEAtre modifi\xE9s \xE0 tout moment sans avis. Les prix peuvent diff\xE9rer des prix affich\xE9s si les achats sont faits via d\u2019autres canaux. Vous avez l\u2019obligation l\xE9gale de payer pour toute Commande indiqu\xE9e comme ayant \xE9t\xE9 effectu\xE9e par vous. En compl\xE9tant une Commande sur MYSKP, vous acceptez de payer, en entier, le prix et les taxes applicables et les frais sp\xE9cifi\xE9s d\u2019exp\xE9dition et de manuntention li\xE9s \xE0 votre Commande, soit par carte de cr\xE9dit ou autre m\xE9hode de paiement autoris\xE9e.');

var _ref23 = _jsx('p', {}, void 0, 'SKP se r\xE9serve le droit, \xE0 sa seule et absolue discr\xE9tion, de changer les m\xE9thodes de paiement permises, incluant, sans limitation, par cartes de cr\xE9dit et/$ ou types de paiement que nous pouvons accepter \xE0 tout moment. Si le paiement complet pour votre Commande n\u2019est pas re\xE7u et v\xE9rifi\xE9 par nous, votre Commande ne sera pas compl\xE9t\xE9e. Si vous ne compl\xE9tez pas ou compl\xE9tez incorrectement votre Commande, elle pourrait ne pas \xEAtre accept\xE9e ou confirm\xE9e.');

var _ref24 = _jsx('p', {}, void 0, 'Afin de compl\xE9ter une Commande via MYSKP, vous pourriez devoir fournir des informations additionnelles requises pour traiter votre Commande. Par exemple, vous devrez fournir des informations pour paiment valides (ex. Un num\xE9ro de carte de cr\xE9dit valide et une date d\u2019\xE9ch\xE9ance) pour faciliter le paiement de votre Commande.');

var _ref25 = _jsx('p', {}, void 0, 'Vous serez factur\xE9 pour votre Commande au moment o\xF9 la Commande est plac\xE9e. Vous serez responsable de toutes les taxes applicables en lien avec votre Commande. Les taxes applicables seront factur\xE9es au moment de la facturation. Les taxes de vente applicables seront aussi appliqu\xE9es \xE0 la manutention et l\u2019exp\xE9dition, les frais de retour les emballages cadeau ou autres frais. Les taxes peuvent d\xE9pendre du lieu de livraison.');

var _ref26 = _jsx('p', {}, void 0, 'Sans limiter la g\xE9n\xE9ralit\xE9 de toute autre section de ces Conditions Additionnelles, SKP se r\xE9serve le droit de limiter ou refuser toute Commande plac\xE9e par vous. De plus, nous nous r\xE9servons le droit de v\xE9rifier la validit\xE9 de toute Commande et/ou d\u2019annuler toute Commande si nous trouvons des preuves de fraude, falsification et/ou toute autre violation des termes et conditions de ces Conditions Additionnelles, ou de nos Conditions d\u2019Utilisation. Nous pourrions, \xE0 notre seule et absolue discr\xE9tion, limiter ou annuler les quantit\xE9s achet\xE9es par personne, par compte ou par Commande. Ces restrictions pourraient inclure des Commandes plac\xE9es par ou via le m\xEAme compte, par le m\xEAme salon ou la m\xEAme entreprise, utilisant la m\xEAme carte de cr\xE9dit, et/ou les Commandes utilisant la m\xEAme adresse de facturation et de livraison. Nous nous r\xE9servons aussi le droit, \xE0 notre seule et absolue discr\xE9tion, de ne pas exp\xE9dier des items command\xE9s ou achet\xE9s via MYSKP \xE0 certaines adresses. Dans l\u2019\xE9ventualit\xE9 o\xF9 nous ne pourrions choisir d\u2019exp\xE9dier un item, vous en serez avis\xE9 et le montant pour cet item factur\xE9 sur votre Commande sera r\xE9duit en cons\xE9quence.');

var _ref27 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Communications sur MYSKP'));

var _ref28 = _jsx('p', {}, void 0, 'MYSKP permet \xE0 SKP de faire parvenir des communications et notifications aux utilisateurs, et/ou \xE0 toute classe particuli\xE8re d\u2019usagers tant via le portail en ligne de MYSKP et/ou via des notifications par courriel. Certaines caract\xE9ristiques de MYSKP peuvent permettre \xE0 certaines classes d\u2019utilisateurs de communiquer avec d\u2019aures utilisateurs \u2013 tant via le module en ligne de MYSKP et/ou via des notifications par courriel. Si nous vous autorisons \xE0 communiquer et que vous choisissez de communiquer avec d\u2019autre utilisateurs, vous devrez vous conformer avec toutes les lois applicables se faisant, incluant, sans limitation, toutes les lois Canadiennes sur la vie priv\xE9e, et la l\xE9gislation anti-pourriels du Canada. Vous devez avoir les consentements requis sous ces lois, et devez inclure dans vos messages toutes les d\xE9clarations obligatoires de contenu, incluant, sans limitation, tous les m\xE9canismes requis pour se d\xE9sabonner.');

var _ref29 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Indemnisation'));

var _ref30 = _jsx('p', {}, void 0, 'Vous acceptez de d\xE9fendre, d\u2019indemniser et de tenir non-responable SKP, et nos affili\xE9s, et les officiers, directeurs, employ\xE9s, agents et repr\xE9sentants de chacun de ceux-ci, de et contre toute requ\xEAte, action, demande, perte, responsabilit\xE9, dommage, co\xFBt, poursuite, action, p\xE9nalit\xE9 et d\xE9pense, survenant de ou en lien, directement ou indirectement \xE0: (i) votre acc\xE8s \xE0 et/ou utilisation d\u2019un service MYSKP, et/ou toute composante de celui-ci, (ii) votre violation de ces termes et conditions, de cette entente; (iii) votre utilisation du Mat\xE9riel Publicitaire, incluant toute Offre que vous choisissez de promouvoir en association avec cela, et/ou (iv) la violation de droits par vous de tout tiers utilisant votre compte, de toute propri\xE9t\xE9 intellectuelle ou tout autre droit de toute autre personne ou entit\xE9 incluant, sans limitation, si vous enfreignez les termes de toute licence associ\xE9e avec le Mat\xE9riel Publicitaire. Vous acceptez que SKP puisse assumer le contr\xF4le et la d\xE9fense exclusive de toute mati\xE8re pour laquelle vous devez indemniser SKP et vous acceptez de coop\xE9rer, \xE0 vos frais, \xE0 notre d\xE9fense de ces requ\xEAtes. Vous acceptez de ne pas r\xE9gler aucune de ces questions sans le consentement \xE9crit de SKP.');

var _ref31 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Avis \xE9lectroniques'));

var _ref32 = _jsx('p', {}, void 0, 'Dans l\u2019\xE9ventualit\xE9 o\xF9 nous vous contactons, vous acceptez que nous pourrions le faire via un moyen \xE9lectronique, incluant mais ne se limitant pas \xE0 des communications affich\xE9es sur MYSKP, notifications sur l\u2019application Messenger ou courrier \xE9lectronique.');

var _ref33 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Absence de relation de mandataire'));

var _ref34 = _jsx('p', {}, void 0, 'Vous acceptez qu\u2019il n\u2019existe aucun joint-venture, partenariat relation de pouvoir ou d\u2019emploi entre vous et SKP r\xE9sultant de ces Conditions d\u2019Utilisation ou l\u2019utilisation de MYSKP et l\u2019acc\xE8s \xE0 ses services.');

var _ref35 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Cessation'));

var _ref36 = _jsx('p', {}, void 0, 'Si vous transgressez toute clause de ces Conditions Additionnelles (tel que d\xE9termin\xE9 par SKP \xE0 sa seule et absolue discr\xE9tion), alors vous ne pourrez plus utiliser MYSKP, les services, ou toute composante de ceux-ci. Nous pourrions, \xE0 notre seule et absolue discr\xE9tion, changer, suspendre ou mettre fin, temporairement ou d\xE9finitivement \xE0 MYSKP, les services, ou toute composante de ceux-ci ou toute caract\xE9ristique de ceux-ci \xE0 tout moment, pour toute raison, sans avis ou responsabilit\xE9 envers vous ou toute autre entit\xE9. Si nous mettons fin \xE0 ces Conditions d\u2019Utilisation ou \xE0 votre permission d\u2019utiliser MYSKP pour toute raison, l\u2019accord form\xE9 par l\u2019acceptation de ces Conditions d\u2019Utilisation va n\xE9anmoins continuer \xE0 s\u2019appliquer et vous y serez li\xE9 dans la mesure de votre utilisation pr\xE9alable de MYSKP, des services, ou toute composante de ceux-ci, puis votre seul recours sera de cesser de les utiliser.');

var _ref37 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Collecte, utilisation et divulgation de renseignements par MYSKP.'));

var _ref38 = _jsx('p', {}, void 0, 'Si vous fournissez des informations pertinentes \xE0 un tiers, telles q\u2019un de vos distributeurs ou une personne dans un salon, vous repr\xE9sentez et nous mandatez que vous avez le consentement de cette partie \xE0 la collecte, l\u2019utilisation et le partage de l\u2019information dans cette section et notre D\xE9claration de Vie Priv\xE9e, et que vous avez le droit de r\xE9v\xE9ler et permettez \xE0 Henkel d\u2019utiliser et de r\xE9v\xE9ler cette dite information des objectifs vis\xE9s dans cette section et notre D\xE9claration de Vie Priv\xE9e et vous avez obtenu tous les consentements applicables ou autorisations n\xE9cessaires \xE0 ceux-ci, si requis. Si nous d\xE9terminons que vous avez d\xE9roger \xE0 cette clause, nous nous r\xE9servons le droit de limiter ou de terminer votre acc\xE8s \xE0 MYSKP comme nous le jugerons appropri\xE9, \xE0 notre seule et absolue discr\xE9tion.');

var _ref39 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Collecte d\u2019Information sur MYKP.'), ' SKP collecte les informations identifiables suivantes via MYSKP:');

var _ref40 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Vos noms et pr\xE9noms;'));

var _ref41 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'L\u2019Identifiant de votre Consultant en Salon (si applicable);'));

var _ref42 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'L\u2019Adresse Courriel de votre Consultant en Salon (si applicable);'));

var _ref43 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Le nom du salon et de son propri\xE9taire;'));

var _ref44 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Toute information de contact fournie par vous incluant, mais ne se limitant pas \xE0 votre num\xE9ro de t\xE9l\xE9phone et adresse;'));

var _ref45 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Votre adresse courriel ainsi que toute information de contact fournie au moment de l\u2019inscription pour un compte sur MYSKP;'));

var _ref46 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Des donn\xE9es de g\xE9o-localisation, si ces donn\xE9es peuvent permettre votre identification; et'));

var _ref47 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Toute autre information personnelle identifiable que vous choisissez de nous fournir en utilisant MYSKP'));

var _ref48 = _jsx('p', {}, void 0, 'Pour les utilisateurs qui sont des distributeurs, MYSKP collecte les informations que vous nous fournissez come suit:');

var _ref49 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Tableau des Ventes'));

var _ref50 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Identifiant de la transaction'));

var _ref51 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Date de la transaction'));

var _ref52 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Num\xE9ro de taxes du salon OU Identifiant du salon'));

var _ref53 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Identifiant du repr\xE9sentant des ventes'));

var _ref54 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Num\xE9ro d\u2019article/de produit'));

var _ref55 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Nom du produit'));

var _ref56 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Qt\xE9'));

var _ref57 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Co\xFBt total'));

var _ref58 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '*S\u2019il n\u2019y a pas d\u2019Identifiant unique pour les Consultants en Salon, veuillez inclure l\u2019adresse courriel du Consultant dans le champs Identifiant du Consultant en Salon'));

var _ref59 = _jsx('br', {});

var _ref60 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Tableau des Produit'));

var _ref61 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Num\xE9ro d\u2019article/de produit'));

var _ref62 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Henkel IDH#'));

var _ref63 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Gamme de produit'));

var _ref64 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Nom du Produit'));

var _ref65 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Description du Produit'));

var _ref66 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Cat\xE9gorie du Produit'));

var _ref67 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Sous-Cat\xE9gorie du Produit'));

var _ref68 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Prix du Produit'));

var _ref69 = _jsx('br', {});

var _ref70 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Tableau Salon'));

var _ref71 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Identifiant Salon'));

var _ref72 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Nom du Salon'));

var _ref73 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Contact Salon'));

var _ref74 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Courriel du Salon'));

var _ref75 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Civique du Salon1'));

var _ref76 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Civique du Salon 2'));

var _ref77 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Salon Ville'));

var _ref78 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Salon Code Postal'));

var _ref79 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Salon Province'));

var _ref80 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Salon Pays'));

var _ref81 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- R\xE9gion Salon'));

var _ref82 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Sous-R\xE9gion Salon'));

var _ref83 = _jsx('br', {});

var _ref84 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Tableau Consultants en Salon'));

var _ref85 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Identifiant Consultant'));

var _ref86 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Nom du Consultant'));

var _ref87 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Adresse Courriel du Consultant'));

var _ref88 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- R\xE9gion du Consultant'));

var _ref89 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '- Sous-R\xE9gion du Consultant'));

var _ref90 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Utilisation de l\u2019Information par MYSKP'));

var _ref91 = _jsx('p', {}, void 0, 'Les informations personnelles et toute autre information obtenue de vous par l\u2019utilisation de MYSKP peut \xEAtre utilis\xE9e par SKP et ses fournisseurs de services pour des fins d\u2019analyse, incluant l\u2019examen et l\u2019\xE9valuation de votre utilisation de MYSKP (incluant les modules et applications de MYSKP que vous utilisez et \xE0 quelle fr\xE9quence et pendant combien de temps vous les utilisez et cliquez sur le flux) et pour des motifs d\u2019\xE9valuation d\u2019affaires et des performances futures incluant la pr\xE9vision et la mod\xE9lisation. En plus de ce qui pr\xE9c\xE8de, SKP pourrait utiliser ces informations s\u2019il le juge raisonnablement n\xE9cessaire pour les motifs suivants:');

var _ref92 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'G\xE9rer votre compte sur MYSKP;'));

var _ref93 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Vous procurer les services et caract\xE9ristiques disponibles sur MYSKP incluant produire et pr\xE9parer des rapports sur vos ventes, niveaux de produits et historique d\u2019achat, et ceux du salon dans votre cha\xEEne d\u2019approvisionnement;'));

var _ref94 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Faciliter tout achat que vous d\xE9cider d\u2019effectuer utilisant un site web, incluant faciliter le paiement de vos achats;'));

var _ref95 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Vous aviser lorsqu\u2019une commande que vous avez plac\xE9 utilisant un site web est pr\xEAte pour la cueillette ou la livraison;'));

var _ref96 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Pour g\xE9rer tout programme de fid\xE9lisation, de r\xE9compenses ou d\u2019incitatifs, nous pourrions offrir et choisir de vous donner un acc\xE8s via MYSKP, incluant vous permettre de r\xE9viser votre solde, les \xE9changes de points et toutes les r\xE9compenses re\xE7ues en conformit\xE9 avec les conditions desdits programmes;'));

var _ref97 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Pour cr\xE9er une liste accessible au public de Salons et autres places d\u2019affaire qui revendent les produits SKP, incluant le nom de l\u2019entreprise et les informations de contact;'));

var _ref98 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Pour vous permettre de cr\xE9er un calendrier de vos \xE9v\xE8nements planifi\xE9s, rendez-vous et activit\xE9s; et'));

var _ref99 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Si vous choisissez de fournir vos informations de localisation, pour vous permettre d\u2019\xE9tablir des cartes et itin\xE9raires pour vos activit\xE9s planifi\xE9es, telles que des visites planifi\xE9es aux salons'));

var _ref100 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Divulgation d\u2019Informations par MYSKP'));

var _ref101 = _jsx('p', {}, void 0, 'Veuillez noter que SKP se r\xE9serve le droit de divulguer vos informations personnelles, si cela est raisonnablement n\xE9cessaire, \xE0 un tiers sans votre consentement pr\xE9alable dans les circonstances suivantes:');

var _ref102 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Si votre conduite sur MYSKP transgresse les Conditions d\u2019Utilisation et la divulgation de telles informations pourrait permettre \xE0 SKP de prot\xE9ger ses droits l\xE9gitimes et/ou lui permettre d\u2019avoir acc\xE8s \xE0 tout recours qui pourrait leur \xEAtre disponible l\xE9galement;'));

var _ref103 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Si SKP juge en toute bonne foi, que cette divulgation est n\xE9cessaire pour identifier et/ou contacter toute personne afin de ou instituer des actions judiciaires contre une personne pour prot\xE9ger ou faire valoir les droits de propri\xE9t\xE9 de SKP ou ceux d\u2019autres utilisateurs; ou'));

var _ref104 = _jsx('p', {}, void 0, 'Si SKP consid\xE8re de bonne foi que la loi exige ou permet ladite divulgation, y compris le partage de renseignements personnels permettant de vous identifier avec d\u2019autres entreprises et organisations pour la pr\xE9vention de la fraude, ou pour respecter toute exigence juridique ou r\xE9glementaire.');

var _ref105 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Donn\xE9es Techniques'));

var _ref106 = _jsx('p', {}, void 0, 'Vous acceptez que SKP ', _jsx('strong', {}, void 0, 'et'), '/ou ses fournisseurs de services puissent colliger et utiliser des donn\xE9es techniques et informations li\xE9es, incluant mais ne se limitant pas \xE0 des informations techniques \xE0 propos de votre syst\xE8me, et votre logiciel d\u2019application, et les p\xE9riph\xE9riques pour faciliter la production de mises \xE0 jour logicielles, de soutien du produit et autres services pour vous (si requis) en lien avec MYSKP. SKP ou Zapplogix pourront utiliser et divulguer ', _jsx('strong', {}, void 0, 'cette'), ' information \xE0 des tiers, aussi longtemps qu\u2019elle n\u2019est pas dans une forme qui permette de vous identifier personnellement, pour am\xE9liorer ses produits ou vous procurer des services ou technologies');

var _ref107 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Cookies'));

var _ref108 = _jsx('p', {}, void 0, 'Nous pourrions utiliser une caract\xE9ristique sur votre syst\xE8me ou navigateur appel\xE9 un "cookie" et/ou autre dispositif similaire. Les cookies sont de petits fichiers que votre navigateur place sur le disque dur de votre appareil. Ils sont utilis\xE9s pour une vari\xE9t\xE9 de raisons, telles que monitorer les cliques sur le flux de navigation, l\u2019optimisation, le marketing et l\u2019\xE9quilibrage de la charge. Nous utilisons une combinaison de sessions et des cookies persistents pour activer nos fonctions de connection, panier de magasinage, rappeler des items que vous avez ajout\xE9 \xE0 votre panier. Vous permettrre de cr\xE9er des listes de souhaits, le processus de fermeture de session et pour procurer l\u2019utilisation avec la possibilit\xE9 de se rappeler et d\u2019am\xE9liorer votre exp\xE9rience. Nous pourrions utiliser cette information pour d\xE9terminer votre localisation g\xE9ographique g\xE9n\xE9rale pour afficher la bonne version de MYSKP. Les informations suivies par ces m\xE9canismes peuvent inclure, mais ne se limitent pas \xE0 : (i) votre adresse IP; (ii) le type de navigateur et de syst\xE8me d\u2019op\xE9ration utilis\xE9; et (iii) les pages du site ou de l\u2019application qu\u2019un utilisateur visite. Votre navigateur vous donne l\u2019option de rejetter les cookies. Toutefois, r\xE9gler votre navigateur pour rejetter les cookies affecte g\xE9n\xE9ralement la performance du navigateur et va donc affecter \xE9galement votre exp\xE9rience d\u2019utilisation de MYSKP, et certaines caract\xE9ristiques pourraient ne pas fonctionner. Pour pouvoir effectuer un achat sur MYSKP, les cookies suivants sont n\xE9cessaires et devront \xEAtre accept\xE9s: \u2018siteId\u2019, \u2018id_token.*\u2019, \u2018gId\u2019, \u2018locale\u2019.');

var TermsAdditionalFr = function TermsAdditionalFr() {
  return _jsx('div', {}, void 0, _ref, _ref2, _jsx('p', {}, void 0, 'Votre utilisation de la plateforme MYSKP / MYTRACKER et du site Web de Henkel Canada Corporation ou de l\u2019une de ses filiales ou soci\xE9t\xE9s affili\xE9es (collectivement appel\xE9s \u201CSKP\u201D, \u201Cnous\u201D, \u201Cnotre\u201D ou \u201Cnos\u201D) \xE0 http://myskp.com/ca et \xE0 la suite d\u2019applications commerciales de MYSKP (appel\xE9e collectivement dans les pr\xE9sentes ', _ref3, ') est assujettie \xE0 nos', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Conditions d\u2019utilisation et \xE0 notre D\xE9claration de confidentialit\xE9'), ', ainsi qu\u2019au pr\xE9sent Suppl\xE9ment aux Conditions d\u2019utilisation et \xE0 la confidentialit\xE9 (les \u201C', _ref4, '\u201D).'), _jsx('p', {}, void 0, 'En installant, t\xE9l\xE9chargeant ou utilisant autrement MYSKP, vous \xEAtes r\xE9put\xE9 avoir lu et accept\xE9 d\u2019\xEAtre li\xE9 par nos Conditions d\u2019utilisation et par les pr\xE9sentes Conditions suppl\xE9mentaires et accepter notre', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), '. Si vous ne consentez pas \xE0 tout ce qui pr\xE9c\xE8de, vous ne devriez pas utiliser MYSKP.'), _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref5, _ref6, _ref7, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref8)), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref9, _ref10, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref11, _ref12), _ref13, _ref14, _ref15), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref16, _ref17, _ref18, _ref19), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref27, _ref28), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref29, _ref30), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref31, _ref32), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref33, _ref34), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref35, _ref36), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref37, _jsx('p', {}, void 0, 'Suivant les termes de notre', ' ', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'D\xE9claration de confidentialit\xE9'), ', qui s\u2019appliquent \xE0 MYSKP en plus de cette section, lorsque vous utilisez MYSKP, vous acceptez que nous pourrions recueillir, utiliser, et r\xE9v\xE9ler vos informations tel que d\xE9crit dans cette section.'), _ref38)), _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref39, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47), _ref48, _ref49, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58), _ref59, _ref60, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68), _ref69, _ref70, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82), _ref83, _ref84, _jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, _ref85, _ref86, _ref87, _ref88, _ref89)), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref90, _ref91, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99)), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref100, _ref101, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref102, _ref103), _ref104), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref105, _ref106), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref107, _ref108)));
};

/* harmony default export */ __webpack_exports__["a"] = (TermsAdditionalFr);

/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import dropdownClubskp from "./dropdownClubskp";

/* harmony default export */ __webpack_exports__["a"] = ({
  to: ['control-index'],
  logoSrc: '/assets/img/black/logo-cmdctrl.svg',
  title: [{ text: 'CMD', color: '#ec2027' }, { text: 'CTRL', color: '' }],
  links: function links(group, siteId) {
    return [
    // {
    //   icon: "home",
    //   title: "Home",
    //   to: ["mytracker"],
    //   links: false
    // },
    {
      icon: 'user',
      title: 'Users',
      to: ['control-index'],
      links: false
    }, {
      icon: 'factory',
      title: 'Brands',
      to: ['control-brands'],
      links: false
    }, {
      icon: 'transporter',
      title: 'Distributors',
      to: ['control-distributors'],
      links: false
    }, {
      icon: 'gear',
      title: 'ETL Data',
      to: null,
      links: [
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--scissors',
      //   title: 'Salons',
      //   to: ['control-salons'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--user',
      //   title: 'Dist Reps',
      //   to: ['control-reps'],
      //   links: false,
      // },
      {
        iconClass: 'left-nav-icons left-nav-icons--expenses',
        title: 'Dist Sales',
        to: ['control-sales'],
        links: false
      }, {
        iconClass: 'left-nav-icons left-nav-icons--products',
        title: 'Dist Products',
        to: ['control-products'],
        links: false
      }, {
        iconClass: 'left-nav-icons left-nav-icons--products',
        title: 'Master Products',
        to: ['control-masterproducts'],
        links: false
      }]
    }, {
      icon: 'list',
      title: 'Content',
      to: ['control-content'],
      links: false
    },
    // {
    //   icon: 'folder',
    //   title: 'Filevault',
    //   to: ['control-filevault'],
    //   links: false,
    // },
    {
      icon: 'users',
      title: 'Groups',
      to: ['control-groups'],
      links: false
    },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--policies',
    //   title: 'Policies',
    //   to: ['control-policies'],
    //   links: false,
    // },
    {
      icon: 'configurator',
      title: 'Configuration',
      to: ['control-config'],
      links: false
    }];
  }
});

/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  // to: ["mytracker-index"],
  logoSrc: "/assets/img/black/logo.svg",
  title: [{ text: "BEAUTY", color: "#ec2027" }, { text: "PRO", color: "" }],
  links: function links(group, siteId) {
    var executiveReports = (group || {}).options.includes("user.mytracker.executiveReporting") ? [{
      icon: "file",
      title: "Executive Reports",
      to: ["mytracker-reports"],
      links: false
    }, {
      icon: "arrowDownToLine",
      title: "Saved Reports",
      to: ["mytracker-saved"],
      links: false
    }] : [];

    return [
    // {
    //   icon: 'home',
    //   title: 'Home',
    //   to: ['home'],
    //   links: false,
    // },
    // {
    //   icon: 'star',
    //   title: 'POE',
    //   index: 'poe-index',
    //   to: null,
    //   links: [
    //     {
    //       icon: 'home',
    //       title: 'How It Works',
    //       to: ['poe-index'],
    //       links: false,
    //     },
    //     {
    //       icon: '',
    //       title: 'Dashboard',
    //       to: ['poe-dashboard'],
    //       links: false,
    //     },
    //     {
    //       icon: '',
    //       title: 'Performance',
    //       to: ['poe-performance'],
    //       links: false,
    //     },
    //     {
    //       icon: '',
    //       title: 'Incentives',
    //       to: ['poe-incentives'],
    //       links: false,
    //     },
    //     {
    //       icon: '',
    //       title: 'Leaderboard',
    //       to: ['poe-leaderboard'],
    //       links: false,
    //     },
    //     {
    //       icon: '',
    //       title: 'Expense Report',
    //       to: ['poe-expenses'],
    //       links: false,
    //     },
    //   ],
    // },
    {
      icon: "scissors",
      title: "Salon DB",
      index: "salondb-index",
      to: null, // #['salondb'],
      links: [{
        icon: "home",
        title: "Salon Search",
        to: ["salondb-index"],
        links: false
      }, {
        icon: "products",
        title: "Loyalty Orders",
        to: ["salondb-orders"],
        links: false
      }, {
        icon: "expenses",
        title: "Loyalty Points",
        to: ["salondb-points"],
        links: false
      }]
    }].concat(_toConsumableArray(((group || {}).modules || []).includes("mytracker") ? [{
      icon: "chartLineUp",
      title: "My Tracker",
      index: "mytracker-index",
      to: null,
      links: [{
        icon: "home",
        title: "Sales Dashboard",
        to: ["mytracker-index"],
        links: false
      }].concat(_toConsumableArray((group || {}).options.includes("user.mytracker.loyaltyDashboard") ? [{
        icon: "home",
        title: "ClubH Dashboard",
        to: ["mytracker-loyalty-dashboard"],
        links: false
      }] : []), [{
        icon: "chartLineUp",
        title: "KPI Tracker",
        to: ["mytracker-kpis"],
        links: false
      }], executiveReports)
    }] : []), _toConsumableArray(((group || {}).modules || []).includes("filevault") ? [{
      icon: "folder",
      title: "Filevault",
      index: "filevault-index",
      to: null,
      links: [{
        icon: "home",
        title: "All Files",
        to: ["filevault-index"],
        links: false
      }, {
        icon: "chartLineUp",
        title: "All Tags",
        to: ["filevault-tags"],
        links: false
      }, {
        icon: "chartLineUp",
        title: "My Collections",
        to: ["filevault-collections"],
        links: false
      }]
    }] : []), _toConsumableArray(((group || {}).modules || []).includes("etl") ? [{
      icon: "arrowUpToLineSolid",
      title: "ETL",
      to: ["etl"],
      links: false
    }] : []));
  }
});

/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(44);


var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({
  home: {
    'id': 'clubskp.home',
    'defaultMessage': 'Home'
  },
  rewards: {
    'id': 'clubskp.rewards',
    'defaultMessage': 'Clubskp'
  },
  about: {
    'id': 'clubskp.about',
    'defaultMessage': 'How It Works'
  },
  news: {
    'id': 'clubskp.news',
    'defaultMessage': 'News'
  },
  education: {
    'id': 'clubskp.education',
    'defaultMessage': 'Education'
  },
  products: {
    'id': 'clubskp.products',
    'defaultMessage': 'Products'
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ['home'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [{ text: 'MY', color: '#ec2027' }, { text: 'SKP', color: '' }],
  links: function links(group, siteId, intl) {
    return [{
      iconClass: 'left-nav-icons left-nav-icons--home',
      title: intl.formatMessage(messages.home),
      to: ['home'],
      links: false
    },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--rewards',
    //   title: intl.formatMessage(messages.rewards),
    //   target: null,
    //   to: ['rewards'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--skp',
    //   title: intl.formatMessage(messages.about),
    //   to: ['about'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--news',
    //   title: intl.formatMessage(messages.news),
    //   to: ['news'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--education',
    //   title: intl.formatMessage(messages.education),
    //   to: ['education'],
    //   links: false,
    // },
    {
      iconClass: 'left-nav-icons left-nav-icons--products',
      title: intl.formatMessage(messages.products),
      target: '_blank',
      to: siteId === 'ca' ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html' : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
      links: false
    }];
  }
});

/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(44);


var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({
  home: {
    'id': 'clubskpLoggedIn.home',
    'defaultMessage': 'Home'
  },
  rewards: {
    'id': 'clubskpLoggedIn.rewards',
    'defaultMessage': 'Clubskp'
  },
  points: {
    'id': 'clubskpLoggedIn.points',
    'defaultMessage': 'Points Earned'
  },
  orders: {
    'id': 'clubskpLoggedIn.orders',
    'defaultMessage': 'Orders'
  },
  activities: {
    'id': 'clubskpLoggedIn.activities',
    'defaultMessage': 'Activities'
  },
  content: {
    'id': 'clubskpLoggedIn.content',
    'defaultMessage': 'Member\'s Lounge'
  },
  news: {
    'id': 'clubskpLoggedIn.news',
    'defaultMessage': 'News'
  },
  education: {
    'id': 'clubskpLoggedIn.education',
    'defaultMessage': 'Education'
  },
  products: {
    'id': 'clubskpLoggedIn.products',
    'defaultMessage': 'Products'
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ['home'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [{ text: 'CLUB', color: '#ec2027' }, { text: 'SKP', color: '' }],
  links: function links(group, siteId, intl) {
    return [{
      iconClass: 'left-nav-icons left-nav-icons--home',
      title: intl.formatMessage(messages.home),
      to: ['home'],
      links: false
    },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--rewards',
    //   title: intl.formatMessage(messages.rewards),
    //   target: null,
    //   to: ['rewards'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--expenses',
    //   title: intl.formatMessage(messages.points),
    //   to: ['clubskp-points'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--products',
    //   title: intl.formatMessage(messages.orders),
    //   to: ['clubskp-orders'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--activities',
    //   title: intl.formatMessage(messages.activities),
    //   to: ['clubskp-activities'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--user',
    //   title: intl.formatMessage(messages.content),
    //   to: ['clubskp-content'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--skp',
    //   title: 'How It Works',
    //   to: ['about'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--news',
    //   title: intl.formatMessage(messages.news),
    //   to: ['news'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--education',
    //   title: intl.formatMessage(messages.education),
    //   to: ['education'],
    //   links: false,
    // },
    {
      iconClass: 'left-nav-icons left-nav-icons--products',
      title: intl.formatMessage(messages.products),
      target: '_blank',
      to: siteId === 'ca' ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html' : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
      links: false
    }];
  }
});

/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(44);


var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */])({
  home: {
    'id': 'clubskpLoggedInSalon.home',
    'defaultMessage': 'Home'
  },
  rewards: {
    'id': 'clubskpLoggedInSalon.rewards',
    'defaultMessage': 'Clubskp'
  },
  index: {
    'id': 'clubskpLoggedInSalon.index',
    'defaultMessage': 'Dashboard'
  },
  points: {
    'id': 'clubskpLoggedInSalon.points',
    'defaultMessage': 'Points Earned'
  },
  orders: {
    'id': 'clubskpLoggedInSalon.orders',
    'defaultMessage': 'Orders'
  },
  activities: {
    'id': 'clubskpLoggedInSalon.activities',
    'defaultMessage': 'Activities'
  },
  content: {
    'id': 'clubskpLoggedInSalon.content',
    'defaultMessage': 'Member\'s Lounge'
  },
  news: {
    'id': 'clubskpLoggedInSalon.news',
    'defaultMessage': 'News'
  },
  education: {
    'id': 'clubskpLoggedInSalon.education',
    'defaultMessage': 'Education'
  },
  products: {
    'id': 'clubskpLoggedInSalon.products',
    'defaultMessage': 'Products'
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ['home'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [{ text: 'CLUB', color: '#ec2027' }, { text: 'SKP', color: '' }],
  links: function links(group, siteId, intl) {
    return [{
      iconClass: 'left-nav-icons left-nav-icons--home',
      title: intl.formatMessage(messages.home),
      to: ['home'],
      links: false
    },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--rewards',
    //   title: intl.formatMessage(messages.rewards),
    //   target: null,
    //   to: ['rewards'],
    //   links: false,
    // },
    {
      iconClass: 'left-nav-icons left-nav-icons--dashboard',
      title: intl.formatMessage(messages.index),
      to: ['clubskp-index'],
      links: false
    },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--expenses',
    //   title: intl.formatMessage(messages.points),
    //   to: ['clubskp-points'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--products',
    //   title: intl.formatMessage(messages.orders),
    //   to: ['clubskp-orders'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--activities',
    //   title: intl.formatMessage(messages.activities),
    //   to: ['clubskp-activities'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--user',
    //   title: intl.formatMessage(messages.content),
    //   to: ['clubskp-content'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--skp',
    //   title: 'How It Works',
    //   to: ['about'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--news',
    //   title: intl.formatMessage(messages.news),
    //   to: ['news'],
    //   links: false,
    // },
    // {
    //   iconClass: 'left-nav-icons left-nav-icons--education',
    //   title: intl.formatMessage(messages.education),
    //   to: ['education'],
    //   links: false,
    // },
    {
      iconClass: 'left-nav-icons left-nav-icons--products',
      title: intl.formatMessage(messages.products),
      to: siteId === 'ca' ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html' : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
      links: false
    }];
  }
});

/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import dropdownClubskp from "./dropdownClubskp";

/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ["etl"],
  logoSrc: "/assets/img/black/logo.svg",
  title: [{ text: "ETL", color: "#ec2027" }, { text: "", color: "" }],
  links: function links(group, siteId) {
    return [{
      // iconClass: "left-nav-icons left-nav-icons--home",
      icon: "arrowUpToLine",
      title: "ETL",
      to: ["etl"],
      links: false
      // {
      //   iconClass: "left-nav-icons left-nav-icons--products",
      //   title: "Import Products",
      //   to: ["etl-index", { type: "products" }],
      //   links: false
      // },
      // {
      //   iconClass: "left-nav-icons left-nav-icons--user",
      //   title: "Import Reps",
      //   to: ["etl-index", { type: "reps" }],
      //   links: false
      // },
      // {
      //   iconClass: "left-nav-icons left-nav-icons--scissors",
      //   title: "Import Salons",
      //   to: ["etl-index", { type: "salons" }],
      //   links: false
      // },
      // {
      //   iconClass: "left-nav-icons left-nav-icons--expenses",
      //   title: "Import Sales",
      //   to: ["etl-index", { type: "sales" }],
      //   links: false
      // },
      // ...dropdownClubskp(group, siteId)
    }];
  }
});

/***/ }),

/***/ 764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdownClubskp__ = __webpack_require__(171);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ['filevault-index'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [{ text: 'FILE', color: '#ec2027' }, { text: 'VAULT', color: '' }],
  links: function links(group, siteId) {
    return [{
      iconClass: 'left-nav-icons left-nav-icons--filevault',
      title: 'Filevault',
      to: ['filevault-index'],
      links: false
    }].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0__dropdownClubskp__["a" /* default */])(group, siteId)));
  }
});

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdownClubskp__ = __webpack_require__(171);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ['messenger-index'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [{ text: 'MESSENGER', color: '#ec2027' }],
  links: function links(group, siteId) {
    return [{
      iconClass: 'left-nav-icons left-nav-icons--filevault',
      title: 'Notifications',
      to: ['messenger-index'],
      links: false
    }].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0__dropdownClubskp__["a" /* default */])(group, siteId)));
  }
});

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdownClubskp__ = __webpack_require__(171);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ['advisornet-index'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [{ text: 'ADVISOR', color: '#ec2027' }, { text: 'NET', color: '' }],
  links: function links(group, siteId) {
    var groupOptions = (group || {}).options || [];
    var links = [{
      iconClass: 'left-nav-icons left-nav-icons--home',
      title: 'Dashboard',
      to: ['advisornet-index'],
      links: false
    }];

    if (groupOptions.includes('user.advisornet.education') || groupOptions.includes('user.manager.advisornet')) {
      links.push({
        iconClass: 'left-nav-icons left-nav-icons--calendar',
        title: 'My Calendar',
        to: ['advisornet-calendar'],
        links: false
      });
      links.push({
        iconClass: 'left-nav-icons left-nav-icons--activities',
        title: 'Activities',
        to: ['advisornet-activities'],
        links: false
      });
      links.push({
        iconClass: 'left-nav-icons left-nav-icons--rewards',
        title: 'Leaderboard',
        to: ['advisornet-leaderboard'],
        links: false
      });
    }

    if (groupOptions.includes('user.advisornet.expenses') || groupOptions.includes('user.manager.advisornet')) {
      links.push({
        iconClass: 'left-nav-icons left-nav-icons--expenses',
        title: 'Expenses',
        to: ['advisornet-expenses'],
        links: false
      });
    }

    if (groupOptions.includes('user.manager.advisornet')) {
      links.push({
        iconClass: 'left-nav-icons left-nav-icons--kpi',
        title: 'Germany Report',
        to: ['advisornet-report'],
        links: false
      });
    }

    links.push.apply(links, _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0__dropdownClubskp__["a" /* default */])(group, siteId)));

    return links;
  }
});

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import dropdownClubskp from './dropdownClubskp';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  to: ["salondb-index"],
  logoSrc: "/assets/img/black/logo.svg",
  title: [{ text: "SALON", color: "#ec2027" }, { text: "DB", color: "" }],
  links: function links(group, siteId) {
    return [{
      // iconClass: 'left-nav-icons left-nav-icons--home',
      icon: "scissors",
      title: "Salons",
      to: ["salondb-index"],
      links: false
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--scissors',
      //   title: 'Salons',
      //   to: ['home'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--reports',
      //   title: 'Reports',
      //   to: ['home'],
      //   links: false,
      // },
      // ...dropdownClubskp(group, siteId)
    }];
  }
});

/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
var routes = {
  path: '/',
  name: 'root',
  // Keep in mind, routes are evaluated in order
  children: [{
    path: '/:siteId(ca)', // '/:siteId(us|ca)',
    name: 'site',
    children: [{
      path: '/',
      name: 'home',
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 965));
      }
    }, {
      path: '/forbidden',
      name: 'forbidden',
      load: function load() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 966));
      }
    }, {
      path: '/account',
      name: 'account',
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 967));
      }
    },
    // {
    //   path: '/help',
    //   name: 'help',
    //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/help'),
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/about'),
    // },
    // {
    //   path: '/about/:id',
    //   name: 'about-detail',
    //   load: () =>
    //     import(/* webpackChunkName: 'loyalty' */ './site/about-detail'),
    // },
    // {
    //   path: '/news',
    //   name: 'news',
    //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/news'),
    // },
    // {
    //   path: '/news/:id',
    //   name: 'news-detail',
    //   load: () =>
    //     import(/* webpackChunkName: 'loyalty' */ './site/news-detail'),
    // },
    // {
    //   path: '/education',
    //   name: 'education',
    //   load: () =>
    //     import(/* webpackChunkName: 'loyalty' */ './site/education'),
    // },
    // {
    //   path: '/education/:id',
    //   name: 'education-detail',
    //   load: () =>
    //     import(/* webpackChunkName: 'loyalty' */ './site/education-detail'),
    // },
    // {
    //   path: '/page/:slug',
    //   name: 'page',
    //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/page'),
    // },
    // {
    //   path: '/products',
    //   name: 'products',
    //   load: () =>
    //     import(/* webpackChunkName: 'loyalty' */ './site/products'),
    // },
    // {
    //   path: '/product/:id',
    //   name: 'product-detail',
    //   load: () =>
    //     import(/* webpackChunkName: 'loyalty' */ './site/product-detail'),
    // },
    {
      path: '/r/:scope',
      name: 'redirect',
      load: function load() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 968));
      }
    },
    // {
    //   path: '/tbh',
    //   name: 'tbhredirect',
    //   action(context, { siteId }) {
    //     return siteId === 'ca'
    //       ? {
    //           redirect:
    //             'https://myskp.com/ca/news/5d56f959f152488d8a061aa6',
    //         }
    //       : null;
    //   },
    // },
    // {
    //   path: '/backtobusy',
    //   name: 'backtobusy',
    //   action(context, { siteId }) {
    //     return siteId === 'ca'
    //       ? {
    //           redirect:
    //             'https://myskp.com/ca/page/5ee265950ff9043f01524272',
    //         }
    //       : null;
    //   },
    // },
    // require('./site/rewards').default,
    __webpack_require__(909).default,
    // require('./site/cart').default,
    // require('./site/advisornet').default,
    __webpack_require__(913).default, __webpack_require__(914).default, __webpack_require__(915).default, __webpack_require__(916).default,
    // require('./site/poe').default,
    // require('./site/loyalty').default,
    __webpack_require__(917).default]
  }, {
    path: '/global',
    name: 'global',
    children: [{
      path: '/',
      name: 'global-index',
      load: function load() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 969));
      }
    }]
  },
  // Wildcard routes, e.g. { path: '*', ... } (must go last)
  {
    path: '*',
    load: function load() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 970));
    }
  }],

  action: function action(_ref) {
    var _this = this;

    var next = _ref.next;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return next();

            case 2:
              route = _context.sent;


              // Provide default values for title, description etc.
              route.title = (route.title || 'Untitled Page') + ' - ' + (process.env.APP_NAME || 'Henkel Beauty Pro');
              route.description = route.description || '';

              return _context.abrupt('return', route);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ __webpack_exports__["a"] = (routes);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

/* harmony default export */ __webpack_exports__["default"] = ({
  path: '/auth',
  name: 'auth',
  children: [{
    path: '/',
    name: 'auth-index',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 920));
    }
  }, {
    path: '/reset',
    name: 'auth-forgot',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 921));
    }
  }, {
    path: '/reset/:token',
    name: 'auth-reset',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 922));
    }
  }, {
    path: '/register',
    name: 'auth-register',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 923));
    }
  }, {
    path: '/salon',
    name: 'auth-salon',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 924));
    }
  }, {
    path: '/hours',
    name: 'auth-hours',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 925));
    }
  }, {
    path: '/avatar',
    name: 'auth-avatar',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 926));
    }
  }, {
    path: '/complete',
    name: 'auth-complete',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 927));
    }
  }]
});

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 266,
	"./af.js": 266,
	"./ar": 267,
	"./ar-dz": 268,
	"./ar-dz.js": 268,
	"./ar-kw": 269,
	"./ar-kw.js": 269,
	"./ar-ly": 270,
	"./ar-ly.js": 270,
	"./ar-ma": 271,
	"./ar-ma.js": 271,
	"./ar-sa": 272,
	"./ar-sa.js": 272,
	"./ar-tn": 273,
	"./ar-tn.js": 273,
	"./ar.js": 267,
	"./az": 274,
	"./az.js": 274,
	"./be": 275,
	"./be.js": 275,
	"./bg": 276,
	"./bg.js": 276,
	"./bm": 277,
	"./bm.js": 277,
	"./bn": 278,
	"./bn-bd": 279,
	"./bn-bd.js": 279,
	"./bn.js": 278,
	"./bo": 280,
	"./bo.js": 280,
	"./br": 281,
	"./br.js": 281,
	"./bs": 282,
	"./bs.js": 282,
	"./ca": 283,
	"./ca.js": 283,
	"./cs": 284,
	"./cs.js": 284,
	"./cv": 285,
	"./cv.js": 285,
	"./cy": 286,
	"./cy.js": 286,
	"./da": 287,
	"./da.js": 287,
	"./de": 288,
	"./de-at": 289,
	"./de-at.js": 289,
	"./de-ch": 290,
	"./de-ch.js": 290,
	"./de.js": 288,
	"./dv": 291,
	"./dv.js": 291,
	"./el": 292,
	"./el.js": 292,
	"./en-au": 293,
	"./en-au.js": 293,
	"./en-ca": 294,
	"./en-ca.js": 294,
	"./en-gb": 295,
	"./en-gb.js": 295,
	"./en-ie": 296,
	"./en-ie.js": 296,
	"./en-il": 297,
	"./en-il.js": 297,
	"./en-in": 298,
	"./en-in.js": 298,
	"./en-nz": 299,
	"./en-nz.js": 299,
	"./en-sg": 300,
	"./en-sg.js": 300,
	"./eo": 301,
	"./eo.js": 301,
	"./es": 302,
	"./es-do": 303,
	"./es-do.js": 303,
	"./es-mx": 304,
	"./es-mx.js": 304,
	"./es-us": 305,
	"./es-us.js": 305,
	"./es.js": 302,
	"./et": 306,
	"./et.js": 306,
	"./eu": 307,
	"./eu.js": 307,
	"./fa": 308,
	"./fa.js": 308,
	"./fi": 309,
	"./fi.js": 309,
	"./fil": 310,
	"./fil.js": 310,
	"./fo": 311,
	"./fo.js": 311,
	"./fr": 312,
	"./fr-ca": 313,
	"./fr-ca.js": 313,
	"./fr-ch": 314,
	"./fr-ch.js": 314,
	"./fr.js": 312,
	"./fy": 315,
	"./fy.js": 315,
	"./ga": 316,
	"./ga.js": 316,
	"./gd": 317,
	"./gd.js": 317,
	"./gl": 318,
	"./gl.js": 318,
	"./gom-deva": 319,
	"./gom-deva.js": 319,
	"./gom-latn": 320,
	"./gom-latn.js": 320,
	"./gu": 321,
	"./gu.js": 321,
	"./he": 322,
	"./he.js": 322,
	"./hi": 323,
	"./hi.js": 323,
	"./hr": 324,
	"./hr.js": 324,
	"./hu": 325,
	"./hu.js": 325,
	"./hy-am": 326,
	"./hy-am.js": 326,
	"./id": 327,
	"./id.js": 327,
	"./is": 328,
	"./is.js": 328,
	"./it": 329,
	"./it-ch": 330,
	"./it-ch.js": 330,
	"./it.js": 329,
	"./ja": 331,
	"./ja.js": 331,
	"./jv": 332,
	"./jv.js": 332,
	"./ka": 333,
	"./ka.js": 333,
	"./kk": 334,
	"./kk.js": 334,
	"./km": 335,
	"./km.js": 335,
	"./kn": 336,
	"./kn.js": 336,
	"./ko": 337,
	"./ko.js": 337,
	"./ku": 338,
	"./ku.js": 338,
	"./ky": 339,
	"./ky.js": 339,
	"./lb": 340,
	"./lb.js": 340,
	"./lo": 341,
	"./lo.js": 341,
	"./lt": 342,
	"./lt.js": 342,
	"./lv": 343,
	"./lv.js": 343,
	"./me": 344,
	"./me.js": 344,
	"./mi": 345,
	"./mi.js": 345,
	"./mk": 346,
	"./mk.js": 346,
	"./ml": 347,
	"./ml.js": 347,
	"./mn": 348,
	"./mn.js": 348,
	"./mr": 349,
	"./mr.js": 349,
	"./ms": 350,
	"./ms-my": 351,
	"./ms-my.js": 351,
	"./ms.js": 350,
	"./mt": 352,
	"./mt.js": 352,
	"./my": 353,
	"./my.js": 353,
	"./nb": 354,
	"./nb.js": 354,
	"./ne": 355,
	"./ne.js": 355,
	"./nl": 356,
	"./nl-be": 357,
	"./nl-be.js": 357,
	"./nl.js": 356,
	"./nn": 358,
	"./nn.js": 358,
	"./oc-lnc": 359,
	"./oc-lnc.js": 359,
	"./pa-in": 360,
	"./pa-in.js": 360,
	"./pl": 361,
	"./pl.js": 361,
	"./pt": 362,
	"./pt-br": 363,
	"./pt-br.js": 363,
	"./pt.js": 362,
	"./ro": 364,
	"./ro.js": 364,
	"./ru": 365,
	"./ru.js": 365,
	"./sd": 366,
	"./sd.js": 366,
	"./se": 367,
	"./se.js": 367,
	"./si": 368,
	"./si.js": 368,
	"./sk": 369,
	"./sk.js": 369,
	"./sl": 370,
	"./sl.js": 370,
	"./sq": 371,
	"./sq.js": 371,
	"./sr": 372,
	"./sr-cyrl": 373,
	"./sr-cyrl.js": 373,
	"./sr.js": 372,
	"./ss": 374,
	"./ss.js": 374,
	"./sv": 375,
	"./sv.js": 375,
	"./sw": 376,
	"./sw.js": 376,
	"./ta": 377,
	"./ta.js": 377,
	"./te": 378,
	"./te.js": 378,
	"./tet": 379,
	"./tet.js": 379,
	"./tg": 380,
	"./tg.js": 380,
	"./th": 381,
	"./th.js": 381,
	"./tk": 382,
	"./tk.js": 382,
	"./tl-ph": 383,
	"./tl-ph.js": 383,
	"./tlh": 384,
	"./tlh.js": 384,
	"./tr": 385,
	"./tr.js": 385,
	"./tzl": 386,
	"./tzl.js": 386,
	"./tzm": 387,
	"./tzm-latn": 388,
	"./tzm-latn.js": 388,
	"./tzm.js": 387,
	"./ug-cn": 389,
	"./ug-cn.js": 389,
	"./uk": 390,
	"./uk.js": 390,
	"./ur": 391,
	"./ur.js": 391,
	"./uz": 392,
	"./uz-latn": 393,
	"./uz-latn.js": 393,
	"./uz.js": 392,
	"./vi": 394,
	"./vi.js": 394,
	"./x-pseudo": 395,
	"./x-pseudo.js": 395,
	"./yo": 396,
	"./yo.js": 396,
	"./zh-cn": 397,
	"./zh-cn.js": 397,
	"./zh-hk": 398,
	"./zh-hk.js": 398,
	"./zh-mo": 399,
	"./zh-mo.js": 399,
	"./zh-tw": 400,
	"./zh-tw.js": 400
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 910;

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.es.js + 1 modules
var index_es = __webpack_require__(44);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(3);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./src/components/_Site/US/TermsPrivacy.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx('p', {}, void 0, 'Effective Date: November 14, 2017');

var _ref2 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Introduction'));

var _ref3 = _jsx('p', {}, void 0, 'Thank you for visiting a website, mobile app or other online service(\u201CService\u201D)\xA0that belongs to and is operated by Henkel Corporation or one of its subsidiary or affiliated companies\xA0(\u201CHenkel\u201D, \u201CUs\u201D, \u201CWe\u201D, \u201COur\u201D).');

var _ref4 = _jsx('p', {}, void 0, 'These Terms of Use\xA0(\u201CTerms\u201D) affect your legal rights, responsibilities and obligations and govern your use of the Service, are legally binding, limit Henkel\u2019s liability to you and require you to indemnify us and, in certain jurisdictions, to settle certain disputes through individual arbitration.');

var _ref5 = _jsx('p', {}, void 0, 'If you do not wish to be bound by these Terms and any Additional Terms, do not use the Service and uninstall Service downloads and applications.');

var _ref6 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Additional Terms'));

var _ref7 = _jsx('p', {}, void 0, 'In some instances, additional or different terms, posted on the Service, apply to your use of certain parts of the Service (individually and collectively\xA0\u201CAdditional Terms\u201D).\xA0 To the extent there is a conflict between these Terms and any Additional Terms, these Terms will control unless the Additional Terms expressly state otherwise.');

var _ref8 = _jsx('p', {}, void 0, 'Updates to these Terms and Additional Terms');

var _ref9 = _jsx('p', {}, void 0, 'We may prospectively change these Terms and Additional Terms by posting new or changed terms on the Service as more fully explained [Section 13].');

var _ref10 = _jsx('h2', {}, void 0, 'Full Terms of Use');

var _ref11 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Ownership and Operation'));

var _ref12 = _jsx('p', {}, void 0, 'The Service and all of its content (\u201CContent\u201D), including all copyrights, patents, trademarks, service marks, trade names and all other intellectual property rights therein (\u201CIntellectual Property\u201D), are owned or controlled by Henkel, Our licensors, and certain other third parties.\xA0 All right, title, and interest in and to the Content and Intellectual Property available via the Service is the property of Henkel, Our licensors or certain other third parties, and is protected by U.S. and international copyright, trademark, trade dress, patent and/or other intellectual property and unfair competition rights and laws to the fullest extent possible.\xA0 Henkel owns the copyright in the selection, compilation, assembly, arrangement, and enhancement of the Content on the Service.\xA0 Henkel, in its sole discretion without advance notice or liability, may immediately suspend or terminate the availability of the Service and/or content (and any elements and features of them), in whole or in part, for any reason, in Henkel\u2019s sole discretion, and without advance notice or liability.');

var _ref13 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Intended Geographic Scope'));

var _ref14 = _jsx('p', {}, void 0, 'The Service and its Content are controlled from within the United States of America and Canada. Access to the Service from territories where its Content is illegal is prohibited. Those who choose to access the Service from outside the United States and Canada are responsible for compliance with all local laws applicable to them with respect to the Content and operation of the Service. You are responsible for complying with all applicable trade regulations and laws both foreign and domestic.\xA0 Except as authorized by U.S. and Canadian law, you agree and warrant not to export or re-export the software to any county, or to any person, entity, or end-user subject to U.S. and/or Canadian export controls or sanctions.');

var _ref15 = _jsx('p', {}, void 0, 'The brands / products shown on the Service are examples of the brands / products available from companies of Henkel worldwide. Henkel does not warrant that a brand / product shown is also available in your country.');

var _ref16 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Privacy'));

var _ref17 = _jsx('p', {}, void 0, 'By visiting or otherwise using the Service in any manner, you agree to the then posted\xA0Privacy Statement\xA0and consent to data practices as described therein.');

var _ref18 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Limited Permission to Access and Use the Service'));

var _ref19 = _jsx('p', {}, void 0, 'It is Henkel policy to enforce its Intellectual Property rights to the fullest extent of the law, including seeking criminal sanctions. Your right to use the Service and Content is subject to your strict compliance with these Terms and the Additional Terms. Your right to access and use the Service and the Intellectual Property shall automatically terminate upon any violations. These rights are non-exclusive, limited, and revocable by Us at any time in our sole discretion without advance notice or liability. As your right to access and use the Service and the content is personal to you, you may not assign nor transfer your right; any attempt to do so is void. You may, for your personal, non-commercial, lawful use only (collectively, the following are the\xA0\u201CHenkel Licensed Elements\u201D):');

var _ref20 = _jsx('p', {}, void 0, 'Display, view, use, and play the Content on a computer, mobile or other internet enabled or permitted device (\u201CDevice\u201D) and/or print one copy of the Content (excluding source and object code in raw form or otherwise) as it is displayed to you;');

var _ref21 = _jsx('p', {}, void 0, 'Stream the Content using any of the widgets and/or other digital streaming internet video players, if any, provided on the Service;');

var _ref22 = _jsx('p', {}, void 0, 'Subject to any applicable Additional Terms, if the Service includes a \u201CSend to Friend,\u201D social media sharing or similar tool that allows you to initiate and send to one or more of your contacts a communication that includes content, or to post Our content to Third-Party Services or your own site or online service, and the tool is operational, use the tool to do so; provided, however, that you do not do so in any manner that violates applicable law or third-party rights or reflects negativity on Us, and only send to recipients you have permission to contact;');

var _ref23 = _jsx('p', {}, void 0, 'If the Service includes a \u201CDownload\u201D link next to a piece of content (including, without limitation, an image, an icon, a wallpaper, a music track, a video, a trailer, an RSS feed), you may only download a single copy of such content to a single Device;');

var _ref24 = _jsx('p', {}, void 0, 'Download, install and use one copy of any software, including apps, that We make available on or through the Service (\u201CSoftware\u201D) on your Device in machine-executable object code form only and make one additional copy for back-up purposes; provided, however, that you understand and agree that (i) by allowing you to download the Software, Henkel does not transfer title to the Software to you (i.e., you own the medium on which the Software is recorded, but the Software\u2019s owner (which may be Henkel\xA0 and/or its third-party Software licensor) will retain full and complete title to such Software); (ii) you may not copy, modify, adapt, translate into any language, distribute, or create derivative works based on the Software,\xA0 except as expressly authorized in these Terms or applicable Additional Terms, without the prior written consent of Henkel: (iii) you may not assign, rent, lease, or lend the Software to any person or entity and any attempt by you to sublicense, transfer, or assign the Software will be void and of no effect; and (iv) you may not decompile, disassemble, reverse engineer, or attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques, or algorithms of the Software by any means whatsoever, except to the extent the foregoing restriction is prohibited by applicable law;');

var _ref25 = _jsx('p', {}, void 0, 'If made available to you, obtain a registered personal account (and/or related username and password) on the Service and interact with the Service in connection therewith;');

var _ref26 = _jsx('p', {}, void 0, 'Link to the Service from a website or other online service, so long as: (a) the links only incorporate text, and do not use any Henkel names, logos, or images, (b) the links and the content on your website do not suggest any affiliation with Henkel or cause any other confusion, and (c) the links and the content on your website do not portray Henkel or its products or services in a false, misleading, derogatory, or otherwise offensive manner, and do not contain content that is unlawful, offensive, obscene, lewd, lascivious, filthy, violent, threatening, harassing, or abusive, or that violate any right of any third-party or are otherwise objectionable to Henkel. Henkel reserves the right to suspend or prohibit linking to the Service for any reason, in its sole discretion, without advance notice or any liability of any kind to you or any third-party, and;');

var _ref27 = _jsx('p', {}, void 0, 'Use any other functionality expressly provided by Henkel on or through the Service for use by users, subject to these Terms (including, without limitation, functionality to create and/or post User-Generated Content (as defined below)) and any applicable Additional Terms.');

var _ref28 = _jsx('p', {}, void 0, 'Any unauthorized use or abuse of these intellectual property or works is expressly prohibited and constitutes a violation of trademark law, copyright law, other intellectual property rights or unfair competition law.');

var _ref29 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Service and Content Restrictions'));

var _ref30 = _jsx('p', {}, void 0, 'Service Use Restrictions.\xA0\xA0You agree that you will not: (i) use the Service for any political or commercial purpose (including, without limitation, for purposes of advertising, soliciting funds, collecting product prices, and selling products); (ii) use any meta tags or any other \u201Chidden text\u201D utilizing any Intellectual Property; (iii) engage in any activities through or in connection with the Service that seek to attempt to or do harm any individuals or entities or are unlawful, offensive, obscene, lewd, lascivious, filthy, violent, threatening, harassing, or abusive, or that violate any right of any third-party, or are otherwise objectionable to Henkel; (iv) decompile, disassemble, reverse engineer, or attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques, or algorithms of the Service by any means whatsoever or modify any Service source or object code or any Software or other products, services, or processes accessible through any portion of the Service; (v) engage in any activity that interferes with a user\u2019s access to the Service or the proper operation of the Service, or otherwise causes harm to the Service, Henkel, or other users of the Service; (vi) interfere with or circumvent any security feature (including any digital rights management mechanism, device or other content protection or access control measure) of the Service or any feature that restricts or enforces limitations on use of or access to the Service, the Content, or the UGC; (vii) harvest or otherwise collect or store any information (including personally identifiable information about other users of the Service, including email addresses, without the express consent of such users); (viii) attempt to gain unauthorized access to the Service, other computer systems or networks connected to the Service, through password mining or any other means; or (ix) otherwise violate these Terms or any applicable Additional Terms.');

var _ref31 = _jsx('p', {}, void 0, 'Content Use Restrictions.\xA0\xA0You also agree that, in using the Service, you: (i) will not monitor, gather, copy, or distribute the Content (except as may be a result of standard search engine activity or use of a standard browser) on the Service by using any robot, rover, \u201Cbot\u201D, spider, scraper, crawler, spyware, engine, device, software, extraction tool, or any other automatic device, utility, or manual process of any kind; (ii) will not frame or utilize framing techniques to enclose any such content (including any images, text, or page layout); (iii) will keep intact all trademark, copyright, and other Intellectual Property and other notices contained in such content; (iv) will not use such content in a manner that suggests an unauthorized association with any of Our or Our licensors\u2019 products, services, or brands; (v) will not make any modifications to such content (other than to the extent of your specifically permitted by Us, if applicable); (vi) will not copy, modify, reproduce, archive, sell, lease, rent, exchange, create derivative works from, publish by hard copy or electronic means, publicly perform, display, disseminate, distribute, broadcast, retransmit, circulate or transfer to any third-party or on any third-party application or website, or otherwise use or exploit such content in any way for any purpose except as specifically permitted by these Terms or any applicable Additional Terms or with the prior written consent of an officer of Henkel or, in the case of content from a licensor, the owner of the content; and (vii) will not insert any code or product to manipulate such content in any way that adversely affects any user experience or the Service.');

var _ref32 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'User-Generated Content'));

var _ref33 = _jsx('p', {}, void 0, 'General.\xA0 Henkel may now, or in the future, offer users of the Service the opportunity to create, build, post, upload, display, publish, distribute, transmit, broadcast, or otherwise make available on or submit through the Service, or on or in response to Our pages or posts on any third-party platforms or in connection with any of Our promotions by any media or manner, or otherwise submit to Us (e.g., on Our Facebook or other social media pages, in response to Our tweets, through a sweepstakes or contest, or by otherwise sending it to Us) (collectively,\xA0\u201Csubmit\u201D) messages, text, illustrations, files, images, graphics, photos, comments, responses, sounds, music, videos, information, content, ratings, reviews, data, questions, suggestions, personally identifiable information, or other information or materials and the ideas contained therein (collectively, but excluding Henkel Licensed Elements included therein, \u201CUser-Generated Content\u201D or \u201CUGC\u201D).\xA0 You may submit UGC through your profile, forums, blogs, message boards, social networking environments, content creation and posting tools, gameplay, social communities, contact Us tools, email, and other communications functionality.\xA0 Except to the extent of the rights and license you grant in these Terms and, subject to any applicable Additional Terms, you retain whatever legally cognizable right, title, and interest that you have in your UGC.');

var _ref34 = _jsx('p', {}, void 0, 'In your communications with Henkel, please keep in mind that We do not seek any unsolicited ideas or materials for products or services, or even suggested improvements to products or services, including, without limitation, ideas, concepts, inventions, or designs for music, websites, apps, books, scripts, screenplays, motion pictures, television shows, theatrical productions, software or otherwise (collectively,\xA0\u201CUnsolicited Ideas and Materials\u201D).\xA0 Any Unsolicited Ideas and Materials you submit are deemed UGC and licensed to Us as set forth below.\xA0 In addition, Henkel retains all of the rights held by members of the general public with regard to your Unsolicited Ideas and Materials. Henkel\u2019s receipt of your Unsolicited Ideas and Materials is not an admission by Henkel of their novelty, priority, or originality, and it does not impair Henkel\u2019s right to contest existing or future intellectual property rights relating to your Unsolicited Ideas and Materials.');

var _ref35 = _jsx('p', {}, void 0, 'Representations and Warranties Related to Your UGC.\xA0 Each time you submit any UGC, you represent and warrant that you are at least the age of majority in the jurisdiction in which you reside and are the parent or legal guardian, or have all proper consents from the parent or legal guardian, of any minor who is depicted in or contributed to any UGC you submit, and that, as to that UGC, (a) you are the sole author and owner of the intellectual property and other rights to the UGC, or you have a lawful right to submit the UGC and grant Henkel the rights to it that you are granting by these Terms and any applicable Additional Terms, all without any Henkel obligation to obtain consent of any third-party and without creating any obligation or liability of Henkel (b) the UGC is accurate; (c) the UGC does not and, as to Henkel\u2019s permitted uses and exploitation set forth in these Terms, will not, infringe any intellectual property or other right of any third-party or any applicable law or regulation; and (d) the UGC will not violate these Terms or any applicable Additional Terms, or cause injury or harm to any person.');

var _ref36 = _jsx('p', {}, void 0, 'Enforcement.\xA0\xA0Henkel has no obligation to monitor or enforce your Intellectual Property rights to your UGC, but you grant Us the right to protect and enforce Our rights to your UGC, including initiating actions in your name and on your behalf (at Henkel\u2019s cost and expense, to which you hereby consent and irrevocably appoint Henkel as your attorney-in-fact, with the power of substitution and delegation, which appointment is coupled with an interest).');

var _ref37 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'DMCA Copyright Policy and Copyright Agent'));

var _ref38 = _jsx('p', {}, void 0, 'Henkel respects the Intellectual Property rights of others and expects users of its Service to do the same.\xA0 Henkel may remove content that in its sole discretion appears to infringe the Intellectual Property rights of others.\xA0 In addition, Henkel, in its sole and absolute discretion, may terminate the accounts of users who infringe the Intellectual Property rights of others.');

var _ref39 = _jsx('p', {}, void 0, 'If you believe that a user of the Service has infringed your copyright rights, please notify Henkel\u2019s Copyright Agent (contact information below) and provide the following information: (a) a physical or electronic signature of the person authorized to act on behalf of the owner of the copyright right; (b) an identification of the copyright protected property claimed to have been infringed; (c) a detailed description of the material that you claim is infringing, so that We may locate it, including the URL where the infringing material appears; (d) your address, telephone number, and email address; (e) a statement by you that you have a good faith belief that the allegedly infringing use is not authorized by the copyright owner, its agent, or the law; and (f) a statement by you, made under penalty of perjury, that the foregoing information is accurate and that you are authorized to act on behalf of the owner of the copyright(s) involved.');

var _ref40 = _jsx('br', {});

var _ref41 = _jsx('br', {});

var _ref42 = _jsx('br', {});

var _ref43 = _jsx('br', {});

var _ref44 = _jsx('br', {});

var _ref45 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Links and Third-Party Services'));

var _ref46 = _jsx('p', {}, void 0, 'We are not responsible for third parties or their content, advertisement(s), apps or sites (\u201CThird-Party Services\u201D). For instance, portions of the Service may be integrated into or linked to third-party sites, platforms and apps that We do not control. Similarly, We may make ads and third-party content or services, which We also may not control, available to you on or via Our Service.\xA0This may include the ability to register or sign in to Our Services using Facebook Connect or other third-party tools, and to post content on third-party sites and services using their plug-ins made available on Our Services. Use caution when dealing with third parties and consult their terms of use and privacy policies.\xA0We take no responsibility for Third-Party Services. In addition, while Henkel may provide you with a link to a third party web site, it is understood that Henkel does not endorse, approve, sponsor or support such sites.');

var _ref47 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Disclaimer of Warranties'));

var _ref48 = _jsx('p', {}, void 0, 'We strive to accurately describe Our products or services offered on the Service; however, We do not warrant that such specifications, pricing, or other content on the Service is complete, accurate, reliable, current, or error-free and products may not be available in all areas.\xA0 For online orders, if available, Additional Terms apply.');

var _ref49 = _jsx('p', {}, void 0, 'AS PERMITTED BY APPLICABLE LAW, THE MATERIALS AND INFORMATION ON THE SERVICE, AND ANY MATERIALS MADE AVAILABLE THROUGH THE SERVICE, ARE PROVIDED \u201CAS IS\u201D, \u201CAS AVAILABLE\u201D, AND \u201CWITH ALL FAULTS\u201D BASIS AND WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, HENKEL AND ITS DIRECT AND INDIRECT PARENTS, SUBSIDIARIES, AFFILIATES, AND EACH OF THEIR RESPECTIVE EMPLOYEES, DIRECTORS, MEMBERS, MANAGERS, SHAREHOLDERS, AGENTS, VENDORS, LICENSORS, LICENSEES, CONTRACTORS, CUSTOMERS, SUCCESSORS, AND ASSIGNS\xA0(COLLECTIVELY, \u201CHENKEL PARTIES\u201D) DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.');

var _ref50 = _jsx('p', {}, void 0, 'AS PERMITTED BY APPLICABLE LAW, HENKEL PARTIES DISCLAIM ALL LIABILITY AND ASSUME NO RESPONSIBILITY FOR THE RESULTS OF ANY DEFECTS OR INACCURACIES THAT MAY EXIST IN THE SERVICE OR FROM ITS OPERATION. HENKEL MAKES NO WARRANTY THAT\xA0(I) THE OPERATION OF THE SERVICE WILL MEET THE USER\xB4S REQUIREMENTS;\xA0(II) ACCESS TO THE SERVICE WILL BE UNINTERRUPTED, TIMELY, SECURE, FREE OF VIRUSES, WORMS, TROJAN HORSES OR OTHER HARMFUL COMPONENTS, OR BE FREE OF DEFECTS OR ERRORS;\xA0(III) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE WILL BE ACCURATE OR RELIABLE; OR\xA0(IV) DEFECTS WILL BE CORRECTED. YOU\xA0(AND NOT HENKEL) ASSUME THE ENTIRE COST OF ALL SERVICING, REPAIR, OR CORRECTION THAT MAY BE NECESSARY FOR YOUR COMPUTER EQUIPMENT AND SOFTWARE AS A RESULT OF ANY VIRUSES, ERRORS OR ANY OTHER PROBLEMS WHATSOEVER YOU MAY HAVE AS A RESULT OF VISITING THE SERVICE.');

var _ref51 = _jsx('p', {}, void 0, 'NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR LIMIT\xA0(I) ANY EXPRESS, WRITTEN PRODUCT WARRANTY OR RELATED DISCLAIMERS THAT ARE PROVIDED BY HENKEL OR ITS SUPPLIERS WITH REGARD TO A PHYSICAL PRODUCT SOLD BY HENKEL, OR ANY WARRANTY ON A PHYSICAL PRODUCT TO THE EXTENT REQUIRED BY APPLICABLE LAW;\xA0(II) HENKEL PARTIES\u2019 LIABILITY\xA0 FOR PERSONAL INJURY TO YOU CAUSED BY HENKEL PARTIES TO THE EXTENT NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW; OR\xA0(III) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST HENKEL PARTIES THAT IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW.');

var _ref52 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Limitation of Liability'));

var _ref53 = _jsx('p', {}, void 0, 'AS PERMITTED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES, WHETHER DUE TO NEGLIGENCE OR OTHERWISE, SHALL HENKEL PARTIES BE LIABLE FOR ANY DAMAGES OR INJURY, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR OTHER DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF DATA OR PROFIT, THAT MAY RESULT FROM THE USE OF, OR THE INABILITY TO USE, THE SERVICE OR ANY MATERIALS IN THE SERVICE, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THE SERVICE OR INFORMATION AVAILABLE IN THE SERVICE.\xA0 THESE INCLUDE, BUT ARE NOT LIMITED TO, DAMAGES OR INJURY CAUSED BY ERROR, OMISSION, INTERRUPTION, DEFECT, FAILURE OF PERFORMANCE, DELAY IN OPERATION OR TRANSMISSION, LINE FAILURE OR COMPUTER VIRUS, WORM, TROJAN HORSE OR OTHER HARMFUL COMPONENT. INCLUDING FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. AS PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL A HENKEL PARTIES\u2019 TOTAL LIABILITY TO YOU FOR DAMAGES, LOSSES, AND/OR CAUSES OF ACTION ARISING OUT OF THE SERVICE EXCEED THE GREATER OF ONE HUNDRED DOLLARS\xA0($100), OR THE AMOUNT YOU HAVE PAID HENKEL IN CONNECTION WITH A PRODUCT OR SERVICE UNDERLYING THE CLAIM, AND ANY CLAIM OR CAUSE OF ACTION YOU MAY HAVE WITH RESPECT TO THE SERVICE\xA0(INCLUDING BUT NOT LIMITED TO THE PURCHASE OF HENKEL PRODUCTS) MUST BE COMMENCED WITHIN ONE\xA0(1) YEAR AFTER THE CLAIM OR CAUSE OF ACTION ARISES.');

var _ref54 = _jsx('p', {}, void 0, 'NOTWITHSTANDING THE FOREGOING, THIS SECTION DOES NOT EXPAND OR LIMIT\xA0(I) ANY EXPRESS, WRITTEN PRODUCT WARRANTY OR RELATED DISCLAIMERS THAT ARE PROVIDED BY HENKEL OR ITS SUPPLIERS WITH REGARD TO A PHYSICAL PRODUCT SOLD BY HENKEL TO YOU, OR ANY WARRANTY ON A PHYSICAL PRODUCT TO THE EXTENT REQUIRED BY APPLICABLE LAW;\xA0(II) HENKEL PARTIES\u2019 LIABILITY FOR PERSONAL INJURY TO YOU CAUSED BY HENKEL PARTIES TO THE EXTENT NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW; OR\xA0(III) ANY CAUSE OF ACTION YOU MAY HAVE AGAINST HENKEL PARTIES THAT IS NOT WAIVABLE OR CANNOT BE LIMITED UNDER APPLICABLE LAW.');

var _ref55 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Arbitration and Dispute Terms'));

var _ref56 = _jsx('p', {}, void 0, 'Forum Selection/Jurisdiction.\xA0 For users for are not individual residents of the province of Quebec, Jurisdiction and venue for any controversy, allegation, or claim arising out of or relating to the Service, the Content, your UGC, these Terms, or any applicable Additional Terms, (collectively,\xA0\u201CDispute\u201D) shall be in Wilmington, Delaware. Each party submits to personal jurisdiction and venue in Wilmington, Delaware for any and all purposes.');

var _ref57 = _jsx('p', {}, void 0, 'Pre-Arbitration Notification.\xA0\xA0Henkel and you agree that it would be advantageous to discuss and hopefully resolve any Disputes before formal proceedings are initiated; provided, however, that Henkel need not do so in circumstances where its claims of Intellectual Property rights are concerned (\u201CIP Disputes,\u201D\xA0with all other disputes referred to as\xA0\u201CGeneral Disputes\u201D). The party making a claim \u2013 whether you or Henkel \u2013 shall send a letter to the other side briefly summarizing the claim and the request for relief. If Henkel is making a claim, the letter shall be sent, via email, to the email address listed in your Henkel account, if applicable. If no such information exists or if such information is not current, then We have no notification or delay obligations under this Section 11(b).\xA0 If you are making a claim, the letter shall be sent to Henkel Corporation, One Henkel Way, Rocky Hill, CT 06067 (Attn: General Counsel). If the Dispute is not resolved within sixty (60) days after notification, the claimant may proceed to initiate proceedings as set forth in this Section 11, or permitted by the applicable law. Either you or Henkel however, may seek provisional remedies (such as preliminary injunctive relief, subject to Section 11(d)) before the expiration of this sixty (60)-day period.');

var _ref58 = _jsx('p', {}, void 0, 'Limitation on Injunctive Relief. AS PERMITTED BY APPLICABLE LAW, IF YOU CLAIM THAT YOU HAVE INCURRED ANY LOSS, DAMAGES, OR INJURIES IN CONNECTION WITH YOUR USE OF THE SERVICE, THEN THE LOSSES, DAMAGES, AND INJURIES WILL NOT BE DEEMED IRREPARABLE OR SUFFICIENT TO ENTITLE YOU TO AN INJUNCTION OR TO OTHER EQUITABLE RELIEF OF ANY KIND.\xA0 THIS MEANS\xA0(WITHOUT LIMITATION) THAT, IN CONNECTION WITH YOUR CLAIM, YOU AGREE THAT YOU WILL NOT SEEK, AND THAT YOU WILL NOT BE PERMITTED TO OBTAIN, ANY COURT OR OTHER ACTION THAT MAY INTERFERE WITH OR PREVENT THE DEVELOPMENT OR EXPLOITATION OF THE SERVICE, OR ANY ASPECT THEREOF, OR INTELLECTUAL PROPERTY OWNED, LICENSED, USED, OR CONTROLLED BY ANY HENKEL PARTY\xA0(INCLUDING YOUR LICENSED UGC) OR A LICENSOR OF ANY HENKEL PARTY.');

var _ref59 = _jsx('p', {}, void 0, 'Governing Law.\xA0For users for are not individual residents of the province of Quebec, these Terms and any applicable Additional Terms, General Disputes and IP Disputes, and any other claim brought by you against Henkel or by Henkel against you pursuant to this Section 11, or otherwise related to the Service, Content, Henkel Licensed Elements, UGC or other Henkel products or services, will be governed by, construed, and resolved in accordance with, the laws of the State of Delaware, U.S.A., without regard to its conflicts of law provisions that might apply the laws of another jurisdiction.\xA0 This Section 11 shall be governed solely by the Federal Arbitration Act, 9 U.S.C. \xA71, et seq., and not by the law of any state, and is enforceable pursuant to its terms on a self-executing basis. You and Henkel agree that We intend that this Section 11 satisfies the \u201Cwriting\u201D requirement of the Federal Arbitration Act.\xA0 This Section 11 can only be amended by mutual agreement.\xA0 Either party may seek enforcement of this Section 11 in any court of competent jurisdiction. The arbitrator shall determine any and all challenges to the arbitrability of a claim.');

var _ref60 = _jsx('p', {}, void 0, 'Class Action Waiver.\xA0 As permitted by applicable law, and for users who are not individual residents of the province of Quebec, both you and Henkel waive the right to bring any Dispute as a class, consolidated, representative, collective, or private attorney general action, or to participate in a class, consolidated, representative, collective, or private attorney general action regarding any Dispute brought by anyone else. Notwithstanding any provision in the JAMS Comprehensive Arbitration Rules and Procedures to the contrary, the arbitrator shall not have the authority or any jurisdiction to hear the arbitration as a class, consolidated, representative, or private attorney general action or to consolidate, join, or otherwise combine the Disputes of different persons into one proceeding. Notwithstanding the arbitration provision set forth above, if the provision regarding waiver of class, collective, representative, and private attorney general claims of this Section 11 is found to be void or otherwise unenforceable, any such class, collective, representative, or private attorney general claims must be heard and determined through an appropriate court proceeding, and not in arbitration.');

var _ref61 = _jsx('p', {}, void 0, 'Jury Waiver.\xA0 AS PERMITTED BY APPLICABLE LAW, THE PARTIES HEREBY WAIVE THEIR RIGHT TO JURY TRIAL WITH RESPECT TO ALL CLAIMS AND ISSUES ARISING UNDER, IN CONNECTION WITH, TOUCHING UPON OR RELATING TO THESE TERMS, THE BREACH THEREOF AND/OR THE SCOPE OF THE PROVISIONS OF THIS SECTION, WHETHER SOUNDING IN CONTRACT OR TORT, AND INCLUDING ANY CLAIM FOR FRAUDULENT INDUCEMENT THEREOF.');

var _ref62 = _jsx('p', {}, void 0, 'Small Claims Matters.\xA0\xA0Notwithstanding the foregoing, either of us may bring qualifying claim of General Dispute (but not IP Disputes) in small claims court, subject to Section 11(f).');

var _ref63 = _jsx('p', {}, void 0, 'Supersede.\xA0The provisions of this Section 11 shall supersede any inconsistent provisions of any prior agreement between the parties. This Section 11 shall remain in full force and effect notwithstanding any termination of your use of the Service or these Terms.');

var _ref64 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Downloaded Software'));

var _ref65 = _jsx('p', {}, void 0, 'If you download software from the Service, the software and all files, images and data relating to the software is subject to the license terms in the software license that accompanies or is provided with the software. You may only use the software pursuant to the terms of such software license. You do not own the downloaded software, and Henkel does not transfer ownership of the software to you. You may not redistribute, sell, decompile, reverse engineer, disassemble, or otherwise reduce the software to a human-perceivable form.');

var _ref66 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Update to Terms'));

var _ref67 = _jsx('p', {}, void 0, 'It is your responsibility to review the posted Terms and any applicable Additional Terms each time you use this\xA0\xA0SERVICE YOU ARE ENTERING INTO A NEW AGREEMENT WITH US ON THE THEN APPLICABLE TERMS AND CONDITIONS AND YOU AGREE THAT WE MAY NOTIFY YOU OF NEW TERMS BY POSTING THEM ON THE SERVICE\xA0(OR IN ANY OTHER REASONABLE MANNER OF NOTICE WHICH WE ELECT), AND THAT YOUR USE OF THE SERVICE AFTER SUCH NOTICE CONSTITUTES YOUR GOING FORWARD AGREEMENT TO THE NEW TERMS FOR YOUR NEW USE AND TRANSACTIONS.\xA0Any new Terms or Additional Terms will be effective as to new use and transactions as of the time that We post them, or such later date as may be specified in them or in other notice to you.\xA0 In the event any notice to you of new, revised, or additional terms is determined by a tribunal to be insufficient, the prior agreement shall continue until sufficient notice to establish a new agreement occurs.\xA0 You can reject any new, revised or additional terms by discontinuing use of the Service.');

var _ref68 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Forward-looking Statements'));

var _ref69 = _jsx('p', {}, void 0, 'The Service may contain statements that involve Henkel\xB4s intentions, expectations or predictions. Such statements reflect the views of Henkel as of the date made with respect to future events and are subject to risks and uncertainties. These statements could be inaccurate or could become inaccurate as a result of developments occurring after their respective dates. Henkel disclaims any intention or obligation to update or revise these statements.');

var _ref70 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Severability/No Waiver, Entire Agreement'));

var _ref71 = _jsx('p', {}, void 0, 'If any provision of these Terms shall be found to be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from these Terms and shall not affect the validity and enforceability of any remaining provisions. No failure on the part of Henkel to enforce these Terms shall constitute a waiver of any of Henkel\xB4s rights under these Terms, whether for past or future actions on the part of any person. These Terms shall be the entire agreement between Henkel and you with respect to the subject matter hereto, and supersede all prior or contemporaneous understandings regarding such subject matter. No amendment to or modification of this Terms will be binding unless provided as an update by Henkel to this document, or signed in writing by an authorized officer of\xA0Henkel.');

var _ref72 = _jsx('h2', {}, void 0, 'Privacy Statement');

var _ref73 = _jsx('p', {}, void 0, 'Thank you for visiting a website, mobile app or other online service\xA0(\u201CService\u201D) that belongs to Us and is operated by Henkel Corporation or one of its subsidiary or affiliated companies\xA0(\u201CHenkel\u201D, \u201CUs\u201D, \u201CWe\u201D, \u201COur\u201D).\xA0 This Privacy Statement outlines the information Henkel may be collecting and how We use and protect that information.');

var _ref74 = _jsx('p', {}, void 0, _jsx('i', {}, void 0, 'Effective as of:\xA0\xA0November 14, 2017'));

var _ref75 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Scope'));

var _ref76 = _jsx('p', {}, void 0, 'This Privacy Statement applies to your use of any Service\xA0(e.g., website, mobile app or internet-connected product) that posts a link to, or otherwise provides notice of the applicability of, this Privacy Statement, regardless of how you access or use it. It does not apply to information We obtain in Our capacity as an employer except with respect to employment applications and inquiries received via the Service. This Privacy Statement applies to Our collection, use and disclosure of information about you through the Service and does not apply to Our activities off of the Service or third party websites accessible via hyperlinks found on a Henkel Service.');

var _ref77 = _jsx('p', {}, void 0, 'For certain aspects of the Service, there may be additional notices about information practices and choices. Please read those additional privacy disclosures to understand how they apply to you.');

var _ref78 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Revisions'));

var _ref79 = _jsx('p', {}, void 0, 'Henkel reserves the right to change this Privacy Statement prospectively effective upon the posting of the revised Privacy Statement and your use of the Service indicates your consent to the privacy statement posted at the time of use.\xA0 However, We will not use your previously collected Henkel-Collected PI\xA0(defined below), to the extent it is not collected under the new privacy statement, in a manner materially different than represented at the time it was collected without your consent. To the extent any provision of this Privacy Statement is found by a competent tribunal to be invalid or unenforceable, such provision shall be severed to the extent necessary for the remainder to be valid and enforceable.');

var _ref80 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information Collected'));

var _ref81 = _jsx('p', {}, void 0, 'You can visit Our Service without telling Us who you are or revealing personal information about yourself, however, doing so may render certain Henkel service\u2019s unavailable to you. You may, however, choose to provide (\u201CPersonal Information\u201D) (defined as information that identifies you personally, such as your first and last name, e-mail address, phone number, address, and full payment account number).');

var _ref82 = _jsx('p', {}, void 0, 'The types of information that Henkel may collect about you include, but are not limited to:');

var _ref83 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Contact information\xA0(such as name, address, city, state, province/territory, Postal/ZIP code, email address and telephone number).'));

var _ref84 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Product preferences.'));

var _ref85 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\u201CDemographic information\u201D such as age range, gender, date of birth, marital status, Postal/ZIP code, and household composition). Except to the extent required by applicable law, Demographic Information is\xA0\u201Cnon-Personal Information\u201D\xA0(i.e., data that is not Personal Information under this Privacy Statement).'));

var _ref86 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, '\u201CUsage Information\u201D such as IP address, device identifier, browser type, operating system, information about your use of the Service, and data regarding network connected hardware (e.g., computer or mobile device). Except to the extent required by applicable law, or to the extent Usage Information is combined by or on behalf of Henkel with Personal Information, Henkel does not consider Usage Information (including, without limitation, unique device identifiers) to be Personal Information or Henkel-Collected PI.'));

var _ref87 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Social Security Number (\u201CSSN\u201D)(in limited circumstances Henkel may collect SSN, for example if you win a sweepstakes or receive compensation that must be reported for government tax purposes).'));

var _ref88 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Photographs and videos\xA0(e.g., that are submitted by customers via websites such as part of contests or sweepstakes).'));

var _ref89 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Employment application information\xA0(such as SSN, Driver\u2019s license, financial information, background screening, and gender or race [as permitted by law]).'));

var _ref90 = _jsx('p', {}, void 0, 'If you choose to participate in the Service activities such as website registrations, contests, sweepstakes, questionnaires, surveys, consumer service contacts, product purchases, mobile applications, social media platforms, or through Our Career Center or employment inquiries, Henkel will collect the Personal Information that you provide (\u201CHenkel-Collected PI\u201D). We may enhance or merge the information that you provide to Us directly with information from other sources, including third parties for the purposes described below. To the extent any information is combined by or on behalf of Henkel with Henkel-Collected-PI, Henkel will treat the combined data as Henkel-Collected PI under this Privacy Statement.');

var _ref91 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information Use'));

var _ref92 = _jsx('p', {}, void 0, 'We collect, maintain and use your Henkel-Collected-PI, other Personal Information, and other information, for purposes not inconsistent with this Privacy Statement or any written statements We make at the time of collection, such as for:');

var _ref93 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'establishing and verifying the identity and eligibility of users;'));

var _ref94 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'uploading and displaying your postings and similar submitted content (\u201CUser Generated Content\u201D\xA0or\xA0\u201CUGC\u201D). (For more information on how UGC is treated under the Service\u2019s Terms of Use click\xA0here\xA0[Section 6 of ToU]. For more on the public nature of UGC, see Section 5);'));

var _ref95 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'opening, maintaining, administering and servicing users profiles, accounts or memberships;'));

var _ref96 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'processing, servicing or enforcing transactions and sending related communications;'));

var _ref97 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'providing products, services and support to users;'));

var _ref98 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'conducting sweepstakes, surveys and contests, and providing the results thereof;'));

var _ref99 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'operating and improving the Service, including tailoring it to users\u2019 preferences;'));

var _ref100 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'providing users with product or service updates;'));

var _ref101 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'sending promotional notices, offers or other targeted marketing, and other information;'));

var _ref102 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'responding to your questions, inquiries, comments and instructions;'));

var _ref103 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'maintaining the security and integrity of Our systems;'));

var _ref104 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'understanding consumer preferences across multiple brands;'));

var _ref105 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'maintaining customer relationships;'));

var _ref106 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'evaluating product performance and safety;'));

var _ref107 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'complying with policies, procedures and legal requirements; and'));

var _ref108 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'improving or products and services and Our other business purposes.'));

var _ref109 = _jsx('p', {}, void 0, 'Information that you provide when applying for a job or an internship via Our Careers Center is used to provide you with information about employment opportunities, to administer the application process and consider you for employment. Where applicable, in conjunction with laws and regulations enforced by the Equal Employment Opportunity Commission (\u201CEEOC\u201D), the Office of Federal Contract Compliance Programs (\u201COFCCP\u201D) and similar state and local regulatory agencies, We may ask you to provide Us with self-identifying information (such as veteran status, gender and ethnicity). Providing such self-identifying information is voluntary, but if you do provide Us with such information, We may submit that information, to the EEOC, the OFCCP and similar state and local regulatory agencies or otherwise use or disclose it for business-related purposes, including, without limitation, responding to information requests, fulfilling regulatory reporting requirements and defending against employment related complaints.');

var _ref110 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Information You Disclose Publicly or to Others'));

var _ref111 = _jsx('p', {}, void 0, 'Additionally, the Service may offer you the option to send a communication to a friend or other contact. If so, Henkel relies on you to only send to people that have given you permission to do so. The recipient\u2019s Personal Information you provide (e.g., name, e-mail address) will be used to facilitate the communication, but not used by Henkel for any other marketing purpose unless Henkel obtains consent from that person. Your full name, contact information and message may be included in the communication.\xA0 For residents of Canada, you may only provide us with the contact information of friends with whom you have had direct voluntary two way communications, and with whom it is reasonable to conclude you have a personal relationship considering shared interests, experiences, opinions and other relevant factors. You may only provide email addresses of family members to whom you are related by marriage, a common-law partnership, or parent-child relationship, and with whom you have had direct voluntary two way communications.');

var _ref112 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Technology Logging, Cookies, and Related Techniques'));

var _ref113 = _jsx('p', {}, void 0, 'When you interact with Our Service, your browser or device may communicate with the technology that We use as part of Our Service. For example, as you use Our Service, your browser communicates with Our technology, which in turn keeps records of your interactivity and requests for services and content to assist Us in managing and improving the utility of Our Service, and to conduct research and analysis on its use. The types of such Usage Information may include your Internet Protocol (IP) address, browser type, URL, requests made, pages visited, activities conducted on the page, day and time of visit and related technical usage information.');

var _ref114 = _jsx('p', {}, void 0, 'Cookies and other tracking technologies now and hereafter developed (\u201CTracking Technologies\u201D) may be used to collect information about interactions with the Service or e-mails, including information about your browsing and purchasing behavior, to authenticate you to the Service, to analyze how the Service is used, to link information about how you use the Service with your account, and to help tailor Our services. We use these technical means and so do Our Affiliates, business partners, and Service Providers. To help Us measure Service activity and provide a better user experience, We may allow Our Service Providers or business partners to compile information such as that identified above from Tracking Technologies. We may also allow Our third party advertising and personalization partners to collect and use this information to develop personalized content and appropriate advertising (including for companies not affiliated with Us) based on your visits over time on Henkel and non-Henkel websites, apps and other online services. You may see these advertisements on other websites, apps and online services. This information may also be used to evaluate Our and third party online advertising campaigns or to tailor promotions and other marketing messages to you on Our Service and other websites apps and online services.');

var _ref115 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Data Sharing and Storage'));

var _ref116 = _jsx('p', {}, void 0, 'Henkel may disclose your information to third parties to the extent not inconsistent with this Privacy Statement or other written statements made by Us at the time of collection, and not prohibited by applicable law, including without limitation as follows:');

var _ref117 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Henkel\u2019s agents, vendors, consultants, and other service providers (collectively\xA0\u201CService Providers\u201D) may receive, or be given access to your information, including, without limitation, Henkel-Collected-PI and other Personal Information, Demographic Information, and Usage Information, in connection with their work on Henkel\u2019s behalf, provided however, Henkel does not authorize its Service Providers to use Henkel-Collected-PI to send you direct marketing messages other than related to Henkel and Henkel Affiliates absent your consent. For more information on choices Service Providers may offer you see Section 11.'));

var _ref118 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'We reserve the right to release your Henkel-Collected-PI and other Personal Information if required to do so by law, search warrant, subpoena, court order or upon request of government authorities.'));

var _ref119 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'We may provide your Henkel-Collected-PI and other Personal Information, and other information, to third parties in connection with the reorganization, merger, sale, joint venture, assignment, transfer, or other disposition of all or any portion of Our business, assets, or stock, including any such activities associated with a bankruptcy or similar proceeding.'));

var _ref120 = _jsx('li', {}, void 0, _jsx('p', {}, void 0, 'Henkel may share your Personal Information with its affiliated companies and subsidiaries (\u201CAffiliates\u201D), and other third parties, some of which may be located outside of the United States, for marketing and other business activities, subject to certain rights of residents of California and Connecticut\xA0 [see Section 12].'));

var _ref121 = _jsx('p', {}, void 0, 'Your Personal Information may be stored for a reasonable amount of time in Henkel databases, some of which are located outside of the United States and Canada, and will be automatically transferred to these databases for storage and maintenance. The Service is based in the U.S., intended for residents of the U.S. and Canada and for persons outside Canada, the information Henkel and its Service Providers collect via the Service is governed by U.S. law. If you are accessing the Service from outside of the U.S., please be aware that information collected through the Service may be transferred to, processed, stored, and used in the U.S. Data protection laws in the U.S. may be different from those of your country of residence and provide a lower level of consumer protection, and information transferred to the U.S. may be accessed by U.S. governments and law enforcement in accordance with U.S. laws. Your use of the Service, or provision of any information via the Service, therefore constitutes your consent to the transfer to and from, processing, usage, sharing, and storage of your information, including Personal Information, in the U.S. as set forth in this Privacy Statement.');

var _ref122 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Third-Party Content, Third-Party Services, Social Features, Advertising and Analytics'));

var _ref123 = _jsx('p', {}, void 0, 'The Service may include hyperlinks to, or include on or in connection with, the Service (e.g., apps and plug-ins), websites, locations, platforms, applications or services operated by third parties (\u201CThird-Party Service(s)\u201D). These Third-Party Services may use their own cookies, web beacons, and other Tracking Technologies to independently collect information about you and may solicit Personal Information from you.\xA0 Henkel is not responsible for the privacy practices or the content of the Third-Party Services. Please note that the privacy statements applicable to such Third-Party Services may differ significantly from the Henkel Privacy Statement, so We advise you to read them carefully before using those services. You agree that Henkel shall not be held liable for any actions by or content of such Third-Party Services.');

var _ref124 = _jsx('p', {}, void 0, 'Certain functionalities on the Service permit interactions that you initiate between the Service and certain Third-Party Services, such as third party social networks (\u201CSocial Features\u201D).\xA0 Examples of Social Features include: enabling you to send content such as contacts and photos between the Service and a Third-Party Service; \u201Cliking\u201D or \u201Csharing\u201D Henkel\u2019s content; logging in to the Service using your Third-Party Service account (e.g., using Facebook Connect to sign-in to the Service); and to otherwise connect the Service to a Third-Party Service (e.g., to pull or push information to or from the Service). If you use Social Features, and potentially other Third-Party Services, information you post or provide access to may be publicly displayed on the Service (see\xA0Section 5)\xA0or by the Third-Party Service that you use. Similarly, if you post information on a third-party service that references the Service (e.g., by using a hashtag associated with Henkel or other Henkel Affiliates in a tweet or status update), you agree that your post may be used on or in connection with the Service or otherwise by Henkel or other Henkel Affiliates. Also, both Henkel and the third party may have access to certain information about you and your use of the Service and any Third-Party Service.');

var _ref125 = _jsx('p', {}, void 0, 'Henkel may engage and work with Service Providers and other third parties to serve advertisements on the Service and/or on third-party services.\xA0 Some of these ads may be tailored to your interest based on your browsing of the Service and elsewhere on the internet, sometimes referred to as \u201Cinterest-based advertising\u201D and \u201Conline behavioral advertising\u201D (\u201CInterest-based Advertising\u201D), which may include sending you an ad on a Third-Party Service after you have left the Service (i.e., \u201Cretargeting\u201D).\xA0 As an example, the Service may employ a \u201CDoubleClick id-Cookie,\u201D which may assign a pseudonymized identifier to, among other things, track DoubleClick advertising. DoubleClick is a service provided by Google.\xA0For information on your ability to opt-out of Interest-based Advertising see section 11 below.');

var _ref126 = _jsx('p', {}, void 0, 'Henkel may use Google Analytics, Adobe Analytics or other Service Providers for analytics services.\xA0 These analytics services may use cookies and other Tracking Technologies to help Henkel analyze Service users and how they use the Service.\xA0 Information generated by these services (e.g., your IP address and other Usage Information) may be transmitted to and stored by these Service Providers on servers in the U.S. (or elsewhere) and these Service Providers may use this information for purposes such as evaluating your use of the Service, compiling statistic reports on the Service\u2019s activity, and providing other services relating to Service activity and other Internet usage. Except to the extent We combine information We receive from Service Providers, Third-Party Services, or other third parties with Henkel-Collected PI, in which case Henkel will treat the combined information as Henkel-Collected PI under this Privacy Statement, data obtained by Henkel from a third party, even in association with the Service, is not subject to Henkel\u2019s limitations regarding Henkel-Collected PI under this Privacy Statement, however such data remains subject to any restrictions imposed on Henkel by the third party, if any.\xA0 Otherwise, the information collected, stored, and shared by third parties remains subject to their privacy policies and practices, including whether they continue to share information with Henkel, the types of information shared, and your choices on what is visible to others on Third-Party Services.');

var _ref127 = _jsx('p', {}, void 0, 'Henkel is not responsible for and makes no representations regarding the policies or business practices of any third parties, including, without limitation, analytics Service Providers and Third-Party Services associated with the Service, and encourages you to familiarize yourself with and consult their privacy policies and terms of use.\xA0 See Section 11\xA0for more on certain choices offered by some third parties regarding their data collection and use, including regarding Interest-based Advertising and analytics.');

var _ref128 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Security and Monitoring'));

var _ref129 = _jsx('p', {}, void 0, 'Henkel will take reasonable precautions to protect your Personal Information\xA0(excluding public UGC) from loss, misuse or alteration. Personal Information may be accessed by persons within Our organization, or Our third party service providers, who require such access to carry out the purposes indicated above, or such other purposes as may be permitted or required by the applicable law. Please be aware, however, that any email or other transmission you send through the Internet cannot be completely protected against unauthorized interception and that the internet and online digital storage are not completely secure and We do not guarantee the security of your information collected through the Service.');

var _ref130 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Children'));

var _ref131 = _jsx('p', {}, void 0, 'The Service is intended for a general audience and not directed to children less than 13 years of age. Henkel does not intend to collect personal information as defined by the U.S. Children\u2019s Online Privacy Protection Act (\u201CCOPPA\u201D) (\u201CChildren\u2019s Personal Information\u201D) in a manner that is not permitted by COPPA. If We obtain knowledge that We have collected Children\u2019s Personal Information in a manner not permitted by COPPA or other applicable law, We will remove such data to the extent required by COPPA or such other applicable law.');

var _ref132 = _jsx('p', {}, void 0, 'Any California residents under the age of eighteen (18) who have registered to use the Service, and who posted content or information on the Service, can request removal by contacting Henkel\xA0here\xA0detailing where the content or information is posted and attesting that you posted it. Henkel will then make reasonable good faith efforts to remove the post from prospective public view or anonymize it so the minor cannot be individually identified to the extent required by applicable law. This removal process cannot ensure complete or comprehensive removal. For instance, third-parties may have republished or archived content by search engines and others that Henkel does not control.');

var _ref133 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Your Choices Regarding Your Personal Information'));

var _ref134 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Tracking Technologies Generally'));

var _ref135 = _jsx('p', {}, void 0, 'Some App-related Tracking Technologies in connection with non-browser usage (e.g., most functionality of a mobile app) can only be disabled by uninstalling the app. To uninstall an app, follow the instructions from your operating system or handset manufacturer.');

var _ref136 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Analytics and Advertising Tracking Technologies'));

var _ref137 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Mobile Apps'));

var _ref138 = _jsx('p', {}, void 0, 'With respect to Henkel\u2019s mobile apps\xA0(\u201Capps\u201D), you can stop all collection of data generated by use of the app by uninstalling the app.\xA0 Also, you may be able to exercise specific privacy choices, such as enabling or disabling certain features\xA0(e.g., location-based services, push notifications, accessing calendar/contacts/phots, etc.), by adjusting the permissions in your mobile device and/or the app\u2019s settings. Beware that if GPS precise location services are disabled, other means of establishing or estimating location\xA0(e.g., connecting to or proximity to wi-fi, Bluetooth, beacons, or Our networks) may persist.\xA0 See also the prior section regarding the DAA\u2019s mobile Interest-based Advertising choices.');

var _ref139 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Communications'));

var _ref140 = _jsx('p', {}, void 0, 'You can opt out of receiving certain promotional communications\xA0(emails or text messaging) from Henkel at any time by\xA0(i) for promotional e-mails, following the instructions provided in emails to click on the unsubscribe link, or if available by changing your communication preferences by logging onto your account; and\xA0(ii) for text messages, following the instructions provided in text messages from Henkel to text the word, \u201CSTOP\u201D; and\xA0(iii) for app push notifications turn off push notifications on the settings of your device and/or the app, as applicable.\xA0 Please note that your opt-out is limited to the e-mail address or phone number used and will not affect subsequent subscriptions.\xA0 If you opt-out of only certain communications, other subscription communications may continue.\xA0 Even if you opt out of receiving promotional communications, Henkel may, subject to applicable law, continue to send you non-promotional communications, such as those about your account, transactions, servicing, or Our ongoing business relations.');

var _ref141 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Careers Center'));

var _ref142 = _jsx('p', {}, void 0, 'If you have created a resume using Our Careers Center you may access, review, correct, update, change or delete your account profile information or resume at any time. Simply log into your account, go to your profile or resume, and make the necessary changes. You may delete your resume from Our online database at any time by accessing your account; provided, however, that We reserve the right to maintain a copy\xA0(a) as required by applicable law; and\xA0(b) for so long as reasonably necessary for record keeping purposes except to the extent prohibited by applicable law.');

var _ref143 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Your California and Connecticut Privacy Rights'));

var _ref144 = _jsx('p', {}, void 0, 'California Rights:\xA0Henkel provides California residents with the option to opt-in or opt-out to sharing of \u201Cpersonal information\u201D as defined by California\u2019s \u201CShine the Light\u201D law with third parties, other than Henkel Affiliates, for such third parties own direct marketing purposes.\xA0 California residents may exercise that opt-out, and/or request information about Henkel\u2019s compliance with the Shine the Light law, and obtain disclosure of third parties Henkel has shared information in accordance with the law for their direct marketing purposes absent your choice and the categories of information shared, by contacting Henkel\xA0here\xA0or by sending a letter to Henkel at:');

var _ref145 = _jsx('p', {}, void 0, 'Attention: Henkel Privacy Inquiries', _jsx('br', {}), 'Communications Department', _jsx('br', {}), 'Henkel Corporation', _jsx('br', {}), 'One Henkel Way', _jsx('br', {}), 'Rocky Hill, CT 06067');

var _ref146 = _jsx('p', {}, void 0, 'Requests must include \u201CCalifornia Privacy Rights Request\u201D in the first line of the description and include your name, street address, city, state, and ZIP code.\xA0 Please note that Henkel is only required to respond to one request per customer each year, and Henkel is not required to respond to requests made by means other than through the provided e-mail address or mail address.');

var _ref147 = _jsx('p', {}, void 0, 'Connecticut Rights:Connecticut law requires any person or entity that collects Social Security numbers from Connecticut residents in the course of business to create a privacy protection policy and to publish or display it publicly.\xA0 It is Our policy to protect the confidentiality of Social Security numbers in Our possession from misuse and improper disclosure by maintaining and enforcing policies and physical and electronic safeguards against misuse and improper disclosure.\xA0 Unlawful disclosure of Social Security numbers is prohibited, and access to them is limited to personnel who need access to such information in order to perform their job functions.');

var _ref148 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Mobile Applications Privacy Statement'));

var _ref149 = _jsx('p', {}, void 0, 'Henkel has developed certain mobile applications that you may download to your mobile device. When you download a mobile application there may be an opportunity for you to provide Us with or for Us to obtain information about you such as contact information, product preferences, photographs, or other information. In addition, We may obtain information about the mobile device, such as device ID and operating system, and app usage. Information obtained through a mobile application will be used in accordance with this Privacy Statement and may be subject to additional terms posted within the mobile application.');

var _ref150 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Accessing and Changing Information'));

var _ref151 = _jsx('p', {}, void 0, 'Henkel may provide web pages or other mechanisms allowing you to delete, correct, or update some of the Henkel-Collected PI, and potentially certain other information about you (e.g., profile and account information). You may also request access to your Personal Information and to request a correction to it if you believe it is inaccurate using the contact information provided below. We may require you to verify your identity before allowing you to access your information. Henkel will make good faith efforts to make requested changes in Henkel\u2019s then-active databases as soon as practicable, but it is not always possible to completely change, remove or delete all of your information or public postings from Henkel\u2019s databases Further, We reserve the right to retain data (a) as required by applicable law; and (b) for so long as reasonably necessary to fulfill the purposes for which the data is retained except to the extent prohibited by applicable law.');

var _ref152 = _jsx('p', {}, void 0, _jsx('strong', {}, void 0, 'Questions'));

var _ref153 = _jsx('p', {}, void 0, 'Please send Us your questions or comments regarding Our privacy practices by emailing Us at\xA0PrivacyNA@henkel.com, or sending Us a letter addressed to:');

var _ref154 = _jsx('p', {}, void 0, 'Henkel Privacy Inquiries', _jsx('br', {}), 'Compliance Officer', _jsx('br', {}), 'Henkel Corporation', _jsx('br', {}), 'One Henkel Way', _jsx('br', {}), 'Rocky Hill, CT 06067');

var TermsPrivacy = function TermsPrivacy() {
  return _jsx('div', {}, void 0, _ref, _ref2, _ref3, _ref4, _jsx('p', {}, void 0, 'By visiting or otherwise using the Service in any manner, you agree to the then posted Terms and any applicable Additional Terms (defined below), to be bound by them, and that you have read and understood them.\xA0 You also acknowledge, agree and consent to Our data practices as described in Our\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), '.'), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref11, _ref12), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref13, _ref14, _ref15), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref16, _ref17), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref18, _ref19, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref20), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref21), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref22), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref23), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref24), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref25), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref26), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref27, _ref28))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref29, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref30), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref31))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref32, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref33), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Non-Confidentiality of Your User-Generated Content.\xA0 Except as otherwise described in the Service\u2019s posted\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), ', or any applicable Additional Terms, you agree that (a) your UGC will be treated as non-confidential and non-proprietary by Us \u2013 regardless of whether you mark them \u201Cconfidential,\u201D \u201Cproprietary,\u201D or the like \u2013 and will not be returned, and (b) to the maximum extent not prohibited by applicable law, Henkel does not assume any obligation of any kind to you or any third-party with respect to your UGC.\xA0 Upon request, you will provide documentation necessary to authenticate rights to such content and verify your compliance with these Terms or any applicable Additional Terms. You acknowledge that the Internet and mobile communications may be insecure and subject to breaches of security; according, you acknowledge and agree that your UGC is submitted at your own risk.'), _ref34), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'License to Henkel of Your UGC.\xA0 Except as otherwise described in any applicable Additional Terms (such as a promotion\u2019s official rules), which specifically govern the submission of your UGC, or in Our\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), ', you hereby grant Henkel the non-exclusive, unrestricted, unconditional, unlimited, worldwide, irrevocable, perpetual, and cost-free right and license to use, copy, record, distribute, reproduce, disclose, sell, re-sell, sublicense (through multiple levels), display, publicly perform, transmit, publish, broadcast, translate, make derivative works of, and otherwise use and exploit in any manner whatsoever, all or any portion of your UGC (and derivative works thereof), for any purpose whatsoever in all formats, on or through any means or medium now known or hereafter developed, and with any technology or devices now known or hereafter developed, and to advertise, market, and promote the same.\xA0 Without limitation, the granted rights include the right to: (a) configure, host, index, cache, archive, store, digitize, compress, optimize, modify, reformat, edit, adapt, publish in searchable format, and remove such UGC and combine same with other materials, and (b) use any ideas, concepts, know-how, or techniques contained in any UGC for any purposes whatsoever, including developing, producing, and marketing products and/or services.\xA0 You understand that in exercising such rights metadata, notices and content may be removed or altered, including copyright management information, and you consent thereto and represent and warrant you have all necessary authority to do so.\xA0 In order to further effect the rights and license that you grant to Henkel to your UGC, you also, as permitted by applicable law, hereby grant to Henkel and agree to grant to Henkel the unconditional, perpetual, irrevocable right to use and exploit your name, persona, and likeness in connection with any UGC, without any obligation or remuneration to you. Except as prohibited by law, you hereby waive, and you agree to waive, any moral rights (including attribution, anonymity, and integrity) that you may have in any UGC, even if it is altered or changed in a manner not agreeable to you.\xA0 To the extent not waivable, you irrevocably agree not to exercise such rights (if any) in a manner that interferes with any exercise of the granted rights.\xA0 You understand that you will not receive any fees, sums, consideration, or remuneration for any of the rights granted in this Section 6(c).')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Henkel\u2019s Exclusive Right to Manage Our Service.\xA0 Henkel may, but will not have any obligation to, review, monitor, display, post, store, maintain, accept, or otherwise make use of, any of your UGC, and Henkel may, in its sole discretion, reject, delete, move, re-format, remove or refuse to post or otherwise make use of UGC without notice or any liability to you or any third-party in connection with Our operation of UGC venues in an appropriate manner.\xA0 Without limitation, We may do so to address content that comes to Our attention that We believe is offensive, obscene, lewd, lascivious, filthy, violent, harassing, threatening, abusive, illegal or otherwise objectionable or inappropriate, or to enforce the rights of third parties or these Terms or any applicable Additional Terms.\xA0 Such UGC submitted by you or others need not be maintained on the Service by Us for any period of time, and you will not have the right, once submitted, to access, archive, maintain, change, remove, or otherwise use such UGC on the Service or elsewhere, except that California minors have certain rights to have certain content about them that they have themselves posted on the Service prospectively removed from public display as provided for in the\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Privacy Statement'), '.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref35), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref36))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref37, _ref38, _ref39, _jsx('p', {}, void 0, 'Copyright Agent', _ref40, 'Henkel Corporation', _ref41, 'One Henkel Way', _ref42, 'Rocky Hill, CT 06067', _ref43, '860/571-2661', _ref44, _jsx('a', {
    href: 'mailto:CopyrightAgent@henkel.com',
    style: { textDecoration: 'underline' }
  }, void 0, 'CopyrightAgent@henkel.com'))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref45, _ref46, _jsx('p', {}, void 0, 'If you are accessing or using the Service through Apple, Android, or any other platform, these are Third-Party Services.\xA0If you access Our Apps via Apple, click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/new-content-item/802450',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0for Additional Terms and conditions that are applicable to you and are incorporated into the Terms by this reference.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref47, _ref48, _ref49, _ref50, _ref51), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref52, _ref53, _ref54), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref55, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref56), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref57), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _jsx('p', {}, void 0, 'Arbitration of Claims.\xA0\xA0As permitted by applicable law, and for users who are not individual residents of the province of Quebec, all actions or proceedings arising in connection with, touching upon or relating to any Dispute, or the scope of the provisions of this Section, shall be submitted to JAMS (', _jsx('a', {
    href: 'https://www.jamsadr.com/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.jamsadr.com'), ') for final and binding arbitration under its Comprehensive Arbitration Rules and Procedures if the matter in dispute is over $250,000 or under its Streamlined Arbitration Rules and Procedures if the matter in dispute is $250,000 or less, to be held in Delaware before a single arbitrator.\xA0The arbitrator shall be selected by mutual agreement of the parties or, if the parties cannot agree, then by striking from a list of arbitrators supplied by JAMS.\xA0We may have the right to pay the JAMS fees if required for arbitration to be enforceable. The arbitration shall be a confidential proceeding, closed to the general public; provided, however, that a party may disclose information relating to the arbitration proceedings to its and its affiliates\u2019 lawyers, insurance providers, auditors and other professional advisers. The fact that there is a dispute between the parties that is the subject of arbitration shall be confidential to the same extent. The arbitrator shall issue a written opinion stating the essential findings and conclusions upon which the arbitrator\u2019s award is based.\xA0 Neither party shall be entitled or permitted to commence or maintain any action in a court of law with respect to any matter in dispute until such matter shall have been submitted to arbitration as herein provided and then only for the enforcement of the arbitrator\u2019s award; provided, however, that prior to the appointment of the arbitrator or for remedies beyond the jurisdiction of an arbitrator, at any time, either party may seek pendente lite relief (subject to the provisions of these Terms waiving or limiting that relief) in a court of competent jurisdiction in the state of Delaware\xA0 or, if sought by Henkel such other court that may have jurisdiction over you, without thereby waiving its right to arbitration of the dispute or controversy under this Section; provided further, however, that the losing party shall have fifteen (15) business days after the issuance of the arbitrator\u2019s decision to fully comply with such decision, after which the prevailing party may enforce such decision by a petition to the courts in Wilmington, Delaware or, in the case of you, such other court having jurisdiction over you, which may be made ex parte, for confirmation and enforcement of the award.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref58), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref59), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref60), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref61), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref62), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref63))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref64, _ref65), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref66, _ref67), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref68, _ref69), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref70, _ref71)), _ref72, _ref73, _jsx('p', {}, void 0, 'Click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0to view Our Terms of Use. California residents, see Section 12A to view your California privacy rights.'), _ref74, _jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref75, _ref76, _ref77, _jsx('p', {}, void 0, 'By using Our Service in any way, such as browsing or interacting, you signify that you agree with the terms of Our current Privacy Statement as posted here and Our Service Terms of Use found\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '. If you do not consent to Our practices as described in this Privacy Statement, you may and should not use Our Service.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref78, _ref79), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref80, _ref81, _ref82, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89), _ref90), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref91, _ref92, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108), _ref109), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref110, _jsx('p', {}, void 0, 'The Service may permit you to post or submit UGC including, without limitation, written content, user profiles, audio or visual recordings, computer graphics, pictures, data, or other content, including Personal Information.\xA0 If you choose to submit UGC to any public area of the Service, your UGC will be considered \u201Cpublic\u201D and will be accessible by anyone, including Henkel.\xA0 Notwithstanding anything to the contrary, and subject to the applicable law, unless otherwise explicitly agreed by Us, Personal Information included in UGC is not subject to Henkel\u2019s usage or sharing limitations, or other obligations, regarding Henkel-Collected-PI or other Personal Information under this Privacy Statement or otherwise, and may be used and shared by Henkel and third parties to the fullest extent not prohibited by applicable law.\xA0 Henkel encourages you to exercise caution when making decisions about what you disclose in such public areas.\xA0 For more information on how UGC is treated under the Service\u2019s Terms of Use click\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'here'), '\xA0[Section 6 of ToU].'), _ref111), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref112, _ref113, _ref114, _jsx('p', {}, void 0, 'A cookie is a small text file that is stored on a user\u2019s device, which may be session ID cookies or tracking cookies. Session cookies make it easier for you to navigate the Service and expire when you close your browser. Tracking cookies remain longer and help in understanding how you use the Service, and enhance your user experience. Cookies may remain on your hard drive for an extended period of time. If you use your browser\u2019s method of blocking or removing cookies, some but not all types of cookies may be deleted and/or blocked and as a result some features and functionalities of the Service may not work. A Flash cookie (or locally shared object) is a data file which may be placed on a device via the Adobe Flash plug-in that may be built-in to or downloaded by you to your device. HTML5 cookies can be programmed through HTML5 local storage. Flash cookies and HTML5 cookies are locally stored on your device other than in the browser and browser settings won\u2019t control them. To identify certain types of local shared objects on your device and adjust your settings, please visit:\xA0', _jsx('a', {
    href: 'www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html'), '. The Service may associate some or all of these types of cookies with your devices. Other types of Tracking Technologies may include web beacons (also known as \u201Ctracking pixels\u201D), embedded scripts, location-identifying technologies, fingerprinting, device recognition technologies, and in-app tracking methods. See Section 11 regarding certain choices regarding these activities.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref115, _ref116, _jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, _ref117, _ref118, _ref119, _ref120), _ref121), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref128, _ref129, _jsx('p', {}, void 0, 'To help protect you and others, We and Our Service Providers may (but make no commitment to) monitor use of the Service, and may collect and use related information including Henkel-Collected PI and other Personal Information for all purposes not prohibited by applicable law or inconsistent with this Privacy Statement, including, without limitation, to identify fraudulent activities and transactions; prevent abuse of and investigate and/or seek prosecution for any potential threats to or misuse of the Service; ensure compliance with the\xA0', _jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'Terms of Use'), '\xA0and this Privacy Statement; investigate violations of or enforce these agreements; and otherwise to protect the rights and property of Henkel, our Affiliates third parties, and other users. Monitoring may result in the collection, recording, and analysis of online activity or communications through Our Service.\xA0 If you do not consent to these conditions, you must discontinue your use of the Service.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref130, _ref131, _ref132), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref133, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref134, _jsx('p', {}, void 0, 'Regular cookies may generally be disabled or removed by tools available as part of most commercial browsers, and in some instances blocked in the future by selecting certain settings. Browsers offer different functionalities and options so you may need to set them separately. Also, tools from commercial browsers may not be effective with regard to Flash cookies (also known as locally shared objects), HTML5 cookies, or other Tracking Technologies. For information on disabling Flash cookies, go to Adobe\u2019s website\xA0', _jsx('a', {
    href: 'helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://helpx.adobe.com/flash-player/kb/disable-third-party-local-shared.html'), '. Please be aware that if you disable or remove these technologies, some parts of the Service may not work and that when you revisit the Service your ability to limit browser-based Tracking Technologies is subject to your browser settings and limitations.'), _ref135, _jsx('p', {}, void 0, 'Your browser settings may allow you to automatically transmit a \u201CDo Not Track\u201D signal to online services you visit. Note, however, there is no consensus among industry participants as to what \u201CDo Not Track\u201D means in this context. Like many online services, Henkel currently does not alter Henkel\u2019s practices when Henkel receives a \u201CDo Not Track\u201D signal from a visitor\u2019s browser. To find out more about \u201CDo Not Track,\u201D you can visit\xA0', _jsx('a', {
    href: 'www.allaboutdnt.com/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.allaboutdnt.com'), ', but We are not responsible for the completeness or accuracy of this third party information. Some third parties, however, may offer you choices regarding their Tracking Technologies. One way to potentially identify cookies on Our Site is to add the free Ghostery plug-in to your browser (', _jsx('a', {
    href: 'www.ghostery.com/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'www.ghostery.com'), '), which according to Ghostery will display for you traditional, browser-based cookies associated with the web sites (but not mobile apps) you visit and privacy and opt-out policies and options of the parties operating those cookies. Henkel is not responsible for the completeness or accuracy of this tool or third party choice notices or mechanisms. For specific information on some of the choice options offered by third party analytics and advertising providers, see the next section.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref136, _jsx('p', {}, void 0, 'You may exercise choices regarding the use of cookies from Google Analytics by going to\xA0', _jsx('a', {
    href: 'https://tools.google.com/dlpage/gaoptout',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://tools.google.com/dlpage/gaoptout'), '\xA0or downloading the Google Analytics Opt-out Browser Add-on. You may exercise choices regarding the use of cookies from Adobe Analytics by going to\xA0', _jsx('a', {
    href: 'http://www.adobe.com/privacy/opt-out.html',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.adobe.com/privacy/opt-out.html'), '\xA0under the section labeled \u201CTell Our customers not to measure your use of their websites or tailor their online ads for you.\u201D You may exercise choices regarding the use of cookies from Google DoubleClick by going to\xA0', _jsx('a', {
    href: 'www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.google.com/settings/ads?hl=en&sig=ACi0TCgXcUy18Z6Kz1pyakm7pX-B1M877ZOZM4fyhX3MaQy-Iki2ybWNEgma-KMfvA7dEIUaKxnTeqojTguFHK3SeHycKTZ1Ew'), '. Henkel is not responsible for effectiveness of, or compliance with, any third-parties\u2019 opt-out options or programs or the accuracy of their statements regarding their programs.'), _jsx('p', {}, void 0, 'You may choose whether to receive some Interest-based Advertising by submitting opt-outs to industry programs. Some of the advertisers and Service Providers that perform advertising-related services for Us and third parties may participate in the Digital Advertising Alliance\u2019s (\u201CDAA\u201D) Self-Regulatory Program for Online Behavioral Advertising. To learn more about how you can exercise certain choices regarding Interest-based Advertising, visit\xA0', _jsx('a', {
    href: 'www.aboutads.info/choices/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.aboutads.info/choices'), ', and\xA0', _jsx('a', {
    href: 'http://www.aboutads.info/appchoices',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.aboutads.info/appchoices'), '\xA0for information on the DAA\u2019s opt-out program for mobile apps. Some of these companies may also be members of the Network Advertising Initiative (\u201CNAI\u201D). To learn more about the NAI and your opt-out options for their members, see\xA0', _jsx('a', {
    href: 'http://www.networkadvertising.org/choices/',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'http://www.networkadvertising.org/choices/'), '. Please be aware that, even if you are able to opt out of certain kinds of Interest-based Advertising, you may continue to receive other types of ads. Opting out only means that those selected members should no longer deliver certain Interest-based Advertising to you, but does not mean you will no longer receive any targeted content and/or ads (e.g., from other ad networks). Some companies also provide a specific opportunity to opt-out. For information on the Interest-based Advertising choices offered by DoubleClick, see\xA0here. Also, if your browsers are configured to reject cookies when you visit these opt-out webpages, or you subsequently erase your cookies, use of a different device or web browsers or use a non-browser-based method of access (e.g., mobile app), your browser-based opt-out may not, or may no longer, be effective. Henkel supports the ad industry\u2019s\xA0', _jsx('a', {
    href: 'www.iab.net/media/file/ven-principles-07-01-09.pdf',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, '2009 Self-regulatory Principles for Online Behavioral Advertising'), '\xA0and expects that ad networks Henkel directly engages to serve you Interest-based Advertising will do so as well, though Henkel cannot guaranty their compliance. Henkel is not responsible for effectiveness of, or compliance with, any third-parties\u2019 opt-out options or programs or the accuracy of their statements regarding their programs.')), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref137, _ref138), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref139, _ref140), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref141, _ref142))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref143, _jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref144, _ref145, _ref146), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref147))), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref148, _ref149), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref150, _ref151), _jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, _ref152, _ref153, _ref154)));
};

/* harmony default export */ var US_TermsPrivacy = (TermsPrivacy);
// CONCATENATED MODULE: ./src/components/_Site/US/TermsClubskp.js
var TermsClubskp__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var TermsClubskp__ref = TermsClubskp__jsx('p', {}, void 0, TermsClubskp__jsx('strong', {}, void 0, 'CLUBSKP PROGRAM - GENERAL TERMS'));

var TermsClubskp__ref2 = TermsClubskp__jsx('p', {}, void 0, TermsClubskp__jsx('strong', {}, void 0, 'PLEASE READ THESE TERMS OF USE CAREFULLY. BY PARTICIPATING IN THIS PROGRAM, YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO ALL OF THESE TERMS, (\u201CTERMS\u201D), AND THE SCHWARZKOPF PROFESSIONAL PRIVACY POLICY, YOU MAY NOT PARTICIPATE IN THIS PROGRAM.'));

var TermsClubskp__ref3 = TermsClubskp__jsx('strong', {}, void 0, 'PROGRAM OUTLINE AND ELIGIBILITY');

var TermsClubskp__ref4 = TermsClubskp__jsx('p', {}, void 0, 'The Schwarzkopf Professional (', TermsClubskp__jsx('strong', {}, void 0, '\u201CSKP\u201D'), ') CLUBSKP program (', TermsClubskp__jsx('strong', {}, void 0, '\u201CProgram\u201D'), ') is open only to Schwarzkopf Professional Salons (', TermsClubskp__jsx('strong', {}, void 0, '\u201CSalons\u201D'), ') located in the United States who purchase Schwarzkopf Professional products from an Authorized Schwarzkopf Professional distributor house. The Program is not open to individuals (whether a stylist or not), non-business consumers, or to any individual acting for personal, family or household, purposes.');

var TermsClubskp__ref5 = TermsClubskp__jsx('strong', {}, void 0, 'EARNING POINTS');

var TermsClubskp__ref6 = TermsClubskp__jsx('p', {}, void 0, 'The Program allows participating Salons to earn points (', TermsClubskp__jsx('strong', {}, void 0, '\u201CPoints\u201D'), ') based on the purchases by the Salon of any Schwarzkopf Professional product. The number of Points earned by the Salon is based on the ', TermsClubskp__jsx('strong', {}, void 0, '\u201CReward Level\u201D'), ' assigned to that Salon. There are three Reward Levels \u2013 S, K or P. Reward Levels are based on the total monthly Schwarzkopf Professional purchases by the Salon with their designated authorized Schwarzkopf Professional Distributor House in the prior month. Your Reward Level may fluctuate from month to month depending on your total monthly Schwarzkopf Professional purchases in the prior month. The monthly purchase range associated with each Reward Level is set out on the Program Website at [www.myskp.com] (', TermsClubskp__jsx('strong', {}, void 0, '\u201CWebsite\u201D'), '), and may be changed by Schwarzkopf Professional at any time in our sole and absolute discretion. Salons earn Points for each dollar spent by the Salon, in the United States, on any Schwarzkopf Professional product with their designated authorized Schwarzkopf Professional Distributor House. The rate at which Points are earned is determined by the Reward Level of the Salon, and is set out on the Website, and may be changed by Schwarzkopf Professional at any time in our sole and absolute discretion.');

var TermsClubskp__ref7 = TermsClubskp__jsx('p', {}, void 0, 'Points begin to accumulate only after your account has been approved by Schwarzkopf Professional\u2019s designated CLUBSKP administrator and the Salon has made Schwarzkopf Professional purchases from their chosen Authorized Schwarzkopf Professional distributor house. You may earn Points only from Schwarzkopf Professional purchases from one (1) Authorized Schwarzkopf Professional distributor house. You must designate the Authorized Schwarzkopf Professional distributor house you wish to use to participate in the Program by contacting our CLUBSKP administrator.');

var TermsClubskp__ref8 = TermsClubskp__jsx('p', {}, void 0, 'Once Salon enrollment in the Program has been approved by the CLUBSKP administrator, the Salon will receive temporary login information. It the responsibility of the Salon to change /update their password.');

var TermsClubskp__ref9 = TermsClubskp__jsx('p', {}, void 0, 'The participating Authorized Schwarzkopf Professional Distributor houses may be changed by Schwarzkopf Professional in its sole discretion.');

var TermsClubskp__ref10 = TermsClubskp__jsx('p', {}, void 0, 'When you enroll in the Program or provide us with information, you agree: (i) that you will provide complete and accurate information about the Salon as requested; and (ii) to promptly update such information as it changes to ensure that it is kept accurate and complete. You are solely responsible for the accuracy of all information that you provide to Schwarzkopf Professional, and for all activity that takes place in your account. In the event that you do not provide or update such information, or Schwarzkopf Professional has reasonable grounds to suspect that you have not provided or updated such information, Schwarzkopf Professional shall have the right, in its sole and absolute discretion, to prevent you from participating in the Program. It is your sole and absolute responsibility to keep the username, password and other information associated with your account confidential and secure. In the event that your username, password and/or account are used without your consent or that you discover any other breach of security, you agree to promptly notify us. We are not responsible for your failure to comply with this clause, or for any delay in shutting down your account after you have reported a breach of security to us. You are solely responsible for any and all activities which occur under your account.');

var TermsClubskp__ref11 = TermsClubskp__jsx('p', {}, void 0, 'All Program registrations are subject to verification at any time and for any reason. Schwarzkopf Professional reserves the right, in its sole and absolute discretion, to require proof of identity and/or eligibility (in a form acceptable to Schwarzkopf Professional \u2013 including, without limitation, government issued photo identification): (i) for the purposes of verifying a Salon\u2019s eligibility to participate in the Program; and/or (ii) for any other reason Schwarzkopf Professional deems necessary, in its sole and absolute discretion, for the purposes of administering the Program in accordance with these Terms. Failure to provide such proof to the satisfaction of Schwarzkopf Professional in a timely manner may result in the cancellation of your account and in such a case any Points associated with it may be forfeited.');

var TermsClubskp__ref12 = TermsClubskp__jsx('p', {}, void 0, 'It is the Salon\u2019s responsibility to maintain /update their credentials within their CLUBSKP profile, to remain active and redeem. This includes, but, is not limited to updating the information you have provided if there is any change to address and/or contact information you have provided.');

var TermsClubskp__ref13 = TermsClubskp__jsx('p', {}, void 0, 'Backdating of Points is not permissible.');

var TermsClubskp__ref14 = TermsClubskp__jsx('p', {}, void 0, 'Points expire on March 31st of every calendar year following the year in which they were earned, unless stipulated in writing any differently from Schwarzkopf Professional. Unused Points remaining following the termination date are forfeited.');

var TermsClubskp__ref15 = TermsClubskp__jsx('p', {}, void 0, 'If a participating Salon: i) does not make any qualifying Schwarzkopf Professional product purchases within a twelve (12) month period, or ii) does not redeem any Points within a twelve (12) month period, then Schwarzkopf Professional reserves the right, in its sole discretion, and with or without notice to the Salon, to deem the Salon account inactive, and to terminate the account and declare any Points therein void.');

var TermsClubskp__ref16 = TermsClubskp__jsx('strong', {}, void 0, 'REDEEMING POINTS');

var TermsClubskp__ref17 = TermsClubskp__jsx('p', {}, void 0, 'THRESHOLDS FOR REDEMPTION');

var TermsClubskp__ref18 = TermsClubskp__jsx('ul', {}, void 0, TermsClubskp__jsx('li', {}, void 0, TermsClubskp__jsx('p', {}, void 0, '- Salons are limited to redeeming one color chart per brand, per year.')), TermsClubskp__jsx('li', {}, void 0, TermsClubskp__jsx('p', {}, void 0, '- A minimum of 5,000 Points to a max of 90,000 Points must be redeemed at any one given time.')));

var TermsClubskp__ref19 = TermsClubskp__jsx('p', {}, void 0, 'Points may be redeemed for redemption items designated by Schwarzkopf Professional from time to time in our sole and absolute discretion. The current redemption items, and the amount of Points which must be redeemed for them are set out on the Website. Schwarzkopf Professional may change the available redemption items, or the number of Points which must be redeemed for them, at any time.');

var TermsClubskp__ref20 = TermsClubskp__jsx('p', {}, void 0, 'Redemption orders cannot be delivered to PO Boxes.');

var TermsClubskp__ref21 = TermsClubskp__jsx('p', {}, void 0, 'Orders are typically processed within one (1) week of redemptions. Standard shipping takes 2 - 4 weeks after processing.');

var TermsClubskp__ref22 = TermsClubskp__jsx('p', {}, void 0, 'If any redemption item that has been redeemed by a Salon and has become discontinued before it is delivered to the Salon, Schwarzkopf Professional will return the Point value redeemed for the discontinued redemption item back to the Salon account.');

var TermsClubskp__ref23 = TermsClubskp__jsx('p', {}, void 0, 'All redemptions are final. After a Salon has submitted a redemption request, that request may not be cancelled or revoked, and Schwarzkopf Professional will not return any Points redeemed by the Salon.');

var TermsClubskp__ref24 = TermsClubskp__jsx('strong', {}, void 0, 'GENERAL CONDITIONS');

var TermsClubskp__ref25 = TermsClubskp__jsx('p', {}, void 0, 'Points cannot be transferred to or from one member to another member.');

var TermsClubskp__ref26 = TermsClubskp__jsx('p', {}, void 0, 'At any Point Schwarzkopf Professional may issue special promotions that alter the rate at which Points are earned or redeemed, such as Point multipliers, bonus Points, or other promotional offers on certain products, services, days, or portions of any day, that change the thresholds at which Points may be redeemed or that award additional Points to a particular Salon or group of Salons. Schwarzkopf Professional may make such promotional offers to all Program participants, or any subset of them, in its sole and absolute discretion. Schwarzkopf Professional may communicate issuance of these promotional offers via\xA0the Website, and/or other means available to us. These Terms and Conditions shall apply to such offers, along with any additional terms and conditions that accompany the offer, unless you are notified otherwise.');

var TermsClubskp__ref27 = TermsClubskp__jsx('p', {}, void 0, 'Each CLUBSKP Salon membership is linked to one individual email address which will remain the primary contact for that CLUBSKP Salon member. All communications pertaining to the membership will be solely directed to the email provided.');

var TermsClubskp__ref28 = TermsClubskp__jsx('p', {}, void 0, 'Multiple locations cannot be combined. One location per account/Salon membership.');

var TermsClubskp__ref29 = TermsClubskp__jsx('p', {}, void 0, 'Schwarzkopf Professional is not responsible for any incorrect distributor data upload (e.g. a distributor failing to correctly upload Schwarzkopf Professional purchases).');

var TermsClubskp__ref30 = TermsClubskp__jsx('p', {}, void 0, 'Schwarzkopf Professional reserves the right to invalidate any Points from a Salon account if it determines that such Points were improperly credited to such Salon account or obtained fraudulently. Schwarzkopf Professional reserved the right to correct any Points balance (by either adding or removing Points), if it determines in its sole and absolute discretion that an error has occurred.');

var TermsClubskp__ref31 = TermsClubskp__jsx('p', {}, void 0, 'Points do not constitute property, do not entitle a participant to any vested right or interest, and have no cash value. Points are not redeemable for cash, transferable or assignable for any reason.');

var TermsClubskp__ref32 = TermsClubskp__jsx('p', {}, void 0, 'Points are null and void and will be rejected, and removed from the Salon\u2019s account, if not obtained in accordance with the letter and spirit of these Terms. No Point receipt or redemption will be valid if such receipt or redemption is associated with any Point deemed void for any reason, including without limitation, if: (a) the Point is not verified or recognized as being validly issued by Schwarzkopf Professional; (b) the Point is determined to have been previously entered and used; (c) the Point was obtained in a manner deemed by Schwarzkopf Professional to be fraudulent or otherwise invalid; or (d) Point is otherwise void.');

var TermsClubskp__ref33 = TermsClubskp__jsx('p', {}, void 0, 'The decisions of Schwarzkopf Professional with respect to all aspects of this Program are final and binding on all Salons without right of appeal, including, without limitation, any decisions regarding the eligibility/disqualification of Salons qualifying purchases, and/or Point earning or redemption.');

var TermsClubskp__ref34 = TermsClubskp__jsx('p', {}, void 0, 'Any abuse or attempted abuse by a Salon of the Program\u2019s privileges, or the letter and spirit of these Terms, any failure by a Salon to follow these Terms, or any misrepresentation by a Salon may subject the Salon to expulsion from the Program, including forfeiture of all Points. Without limiting the foregoing, any sales which are returned or otherwise cancelled will not qualify for the purposes of the Program and any Points awarded in respect of such purchases will be void and removed from the Salon\u2019s account.');

var TermsClubskp__ref35 = TermsClubskp__jsx('p', {}, void 0, 'These Terms constitute the entire agreement between participating Salons and Schwarzkopf Professional regarding the Program, Points, Rewards and the benefits of the Program, and supersede all previous versions.');

var TermsClubskp__ref36 = TermsClubskp__jsx('p', {}, void 0, 'Any waiver by Schwarzkopf Professional of the strict observance, performance or compliance by a Salon with any provision of these Terms, either expressly granted or by course of conduct, shall be effective only in the specific instance and shall not be deemed to be a waiver of any rights or remedies of Schwarzkopf Professional as a result of any other failure to observe, perform or comply with the provisions of these Terms. No delay or omission by Schwarzkopf Professional in exercising any right or remedy hereunder shall operate as waiver thereof or of any other right or remedy.');

var TermsClubskp__ref37 = TermsClubskp__jsx('p', {}, void 0, 'By participating in the Program, you agree to release Schwarzkopf Professional, a division of Henkel Corporation, and each of its parent companies, subsidiaries, affiliates, and suppliers and any other third party that may from time to time participate in the administration or operation of the Program, and each of their respective officers, directors, agents, representatives, employees, successors and assigns (collectively, the', ' ', TermsClubskp__jsx('strong', {}, void 0, '\u201CReleasees\u201D'), ') from any loss, liability, claim, demand, damage or expense asserted by any entity relating in any way to the Program, your participation therein and/or the use/misuse of any Points or redemption items. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, ALL ASPECTS OF THE PROGRAM ARE PROVIDED \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D, WITHOUT ANY CONDITION, REPRESENTATION OR WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT.');

var TermsClubskp__ref38 = TermsClubskp__jsx('p', {}, void 0, 'In the event that any provision in these Terms is determined to be invalid, illegal, or unenforceable, such determination shall not affect the validity and enforceability of any other remaining provisions of these Terms.');

var TermsClubskp__ref39 = TermsClubskp__jsx('p', {}, void 0, 'These Terms and any claim or dispute arising out of, relating to or in connection with these Terms or the Program contemplated hereby, whether in contract, tort or otherwise, shall be governed by and construed in accordance with the laws of California applicable therein (without regard to conflicts of laws principles). You hereby irrevocably and unconditionally consent to submit to the exclusive jurisdiction of the state and federal courts located in California for any action, suit or proceeding arising out of or relating to the transaction contemplated hereby.');

var TermsClubskp__ref40 = TermsClubskp__jsx('p', {}, void 0, 'Schwarzkopf Professional reserves the right to change, amend, modify, suspend or terminate this Program, including any part of these Terms, at any time in our sole and absolute discretion. In the event the Program or these Terms are changed, amended, modified, suspended or terminated, we will post the amended Terms or Program on the Website. Your continued participation in the Program following such notice will constitute your express consent to any change, amendment, modification, suspension or termination to these Terms or any other aspect of the Program.');

var TermsClubskp__ref41 = TermsClubskp__jsx('p', {}, void 0, 'All enquiries pertaining to the Program must be directed to the CLUBSKP administrator at', ' ', TermsClubskp__jsx('a', {
  href: 'mailto:clubskp@myskp.com'
}, void 0, 'clubskp@myskp.com'));

var TermsClubskp = function TermsClubskp() {
  return TermsClubskp__jsx('div', {}, void 0, TermsClubskp__ref, TermsClubskp__ref2, TermsClubskp__jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref3, TermsClubskp__ref4), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref5, TermsClubskp__jsx('ol', {
    type: 'a',
    style: { paddingLeft: '16px' }
  }, void 0, TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref6), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref7), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref8), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref9), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref10), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref11), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref12), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref13), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref14), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref15))), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref16, TermsClubskp__jsx('ol', {
    type: 'a',
    style: { paddingLeft: '16px' }
  }, void 0, TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref17, TermsClubskp__ref18), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref19), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref20), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref21), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref22), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref23))), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref24, TermsClubskp__jsx('ol', {
    type: 'a',
    style: { paddingLeft: '16px' }
  }, void 0, TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref25), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref26), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref27), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref28), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref29), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref30), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref31), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref32), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref33), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref34), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref35), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref36), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref37), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref38), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref39), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref40), TermsClubskp__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsClubskp__ref41)))));
};

/* harmony default export */ var US_TermsClubskp = (TermsClubskp);
// CONCATENATED MODULE: ./src/components/_Site/US/TermsAdditional.js
var TermsAdditional__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var TermsAdditional__ref = TermsAdditional__jsx('p', {}, void 0, 'Last updated: ', TermsAdditional__jsx('strong', {}, void 0, 'March 15, 2018'));

var TermsAdditional__ref2 = TermsAdditional__jsx('strong', {}, void 0, 'Additional Terms');

var TermsAdditional__ref3 = TermsAdditional__jsx('p', {}, void 0, 'By installing, downloading or otherwise using MYSKP, you are deemed to have read and agreed to be bound by our Terms of Use and these Additional Terms and agree to our Privacy Policy. If you do not agree with all of these, you may not use MYSKP.');

var TermsAdditional__ref4 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Functions of MYSKP'));

var TermsAdditional__ref5 = TermsAdditional__jsx('p', {}, void 0, 'MYSKP is a suite of applications and website for the use of professional hair stylists, salons, and SKP sales representatives and distributors in the United States. It serves as a sales and marketing tool by helping to facilitate inventory management (on a sell through / sell out basis), re-ordering, and sales, by allowing stylists and salons to track their inventory, purchasing, and usage history, and can assist in developing advertising creative. It allows SKP, and SKP sales representatives and distributors, to review the sales, product, and salon information within their supply chain, for purposes including the management of their businesses and tools to analyze performance data and help maximize sales with visualized key business metrics. It also assists SKP with incentive program management, and managing and distributor sales consultant management.');

var TermsAdditional__ref6 = TermsAdditional__jsx('p', {}, void 0, 'The MYSKP suite of applications includes, or may in the future include, the following features:');

var TermsAdditional__ref7 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'CLUBSKP'));

var TermsAdditional__ref8 = TermsAdditional__jsx('p', {}, void 0, 'A portal that allows eligible users to access their CLUBSKP account- a loyalty program that allows salons to redeem and track points from extracted sales data, in accordance with the Terms of the CLUB SKP Program. This portal is set up as an e-commerce system through which points may be redeemed at the rates set by SKP from time to time, and subject to the Terms of the CLUB SKP Program');

var TermsAdditional__ref9 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'PRINTCENTER'));

var TermsAdditional__ref10 = TermsAdditional__jsx('p', {}, void 0, 'An app where salons are able to customize materials and order Advertising Materials, including branded print collateral, as further described in section 3 below. Users can either directly order online with a 3rd party vendor for fulfillment or download material directly for their own use in accordance with these Additional Terms, and any specified term, usage limits or instructions that may be provided by SKP.');

var TermsAdditional__ref11 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'FILEVAULT'));

var TermsAdditional__ref12 = TermsAdditional__jsx('p', {}, void 0, 'An online repository and file sharing of branded assets including images, marketing material and videos as determined by SKP from time to time. SKP may set limits on what users are permitted to access what assets. Subject to any such limits, all assets are organized in folders with the ability for users to create their own. Certain assets can be directly downloaded at various file size or application purposes. All materials in the file vault are \u201CAdvertising Materials\u201D within the meaning of section 3 below, and may only be used in accordance with these Terms of Use, and any specified term, usage limits or instructions that may be provided by SKP.');

var TermsAdditional__ref13 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'POE'));

var TermsAdditional__ref14 = TermsAdditional__jsx('p', {}, void 0, 'This is an app that is used by SKP to administer the distributor Sales Incentive program called \u201CProfile of Excellence\u201D, using information uploaded by the distributors using the ETL tool. SKP uses an ETL tool to extract all sales data from the Schwarzkopf ERP system and/or Distributor data. The app then automatically allocates incentive points and spiffs due to sales consultants, if any, and generates invoices. All stakeholders are able to track their progress as well as check their leader-board standing. SKP does not guarantee the accuracy of the leaderboard, or any point totals, and may adjust them at any time if an error is discovered.');

var TermsAdditional__ref15 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'ADVISORNET'));

var TermsAdditional__ref16 = TermsAdditional__jsx('p', {}, void 0, 'A daily tracking and event scheduler app for education of internal technical advisor and technical supervisor stakeholders. These users may use this app to schedule, track and report their daily activities. It tracks calendar activity of SKP technical advisors and serves as a reimbursement site for costs associated with such technical advisors according to a built-in SKP approval process, and allows an automatic deployment of invoices for expense reimbursement, allowing SKP to track and reimburse SKP designated third parties, in a manner and such amounts as may have been approved by SKP. Detailed performance reporting helps all stakeholders to manage and improve the efficiency of their daily activity to increase ROI.');

var TermsAdditional__ref17 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'MYTRACKER'));

var TermsAdditional__ref18 = TermsAdditional__jsx('p', {}, void 0, 'Allows the visual tracking by SKP of all data in MYSKP, which includes both sales and activities data. Distributors may only view their own data and that of their downstream sales consultants.');

var TermsAdditional__ref19 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Accessing MYSKP and Account Security'));

var TermsAdditional__ref20 = TermsAdditional__jsx('p', {}, void 0, 'You are responsible for:');

var TermsAdditional__ref21 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Making all arrangements necessary for you to have access to MYSKP; and'));

var TermsAdditional__ref22 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Ensuring that all persons who access MYSKP through your internet connection are aware of these Terms of Use and comply with them.'));

var TermsAdditional__ref23 = TermsAdditional__jsx('br', {});

var TermsAdditional__ref24 = TermsAdditional__jsx('p', {}, void 0, 'To access MYSKP or some of the resources it offers, you may be asked to provide certain registration details or other information. It is a condition of your use of MYSKP that all the information you provide on MYSKP is correct, current and complete.');

var TermsAdditional__ref25 = TermsAdditional__jsx('p', {}, void 0, 'To access MYSKP services you will be required to register on MYSKP. All registrations are subject to the acceptance of SKP, which may be withheld or denied in our sole and absolute discretion. SKP may in its discretion set (or reset) different levels of access to MYSKP for different users and/or accounts, which may alter the content, applications, features or functions such users and/or accounts may access on MYSKP. You agree to: (a) maintain the confidentiality of any passwords or other account identifiers which you choose or that are assigned to you as a result of any registration or account creation with MYSKP; and (b) be responsible for all activities that occur under such password or account. Further, you agree to immediately notify us of any unauthorized use of your password or account in the event that the confidentiality of your password or your account is compromised. Failure to comply with this paragraph may result in immediate termination of your account. We shall not be responsible or liable, directly or indirectly, in any way for any loss or damage of any kind incurred as a result of, or in connection with, your failure to comply with this section, or for any delay in shutting down your account after you have reported a breach of security to us. You also agree to ensure that you exit from your account at the end of each session. You should use particular caution when accessing your account from a public or shared computer so that others are not able to view or record your password or other personal information or business information.');

var TermsAdditional__ref26 = TermsAdditional__jsx('p', {}, void 0, 'We have the right to disable any account, and/or any user name, password or other identifier, whether chosen by you or provided by us, at any time in our sole discretion including if, in our opinion, you have violated any provision of these Additional Terms, any other agreement you have with us, or we have a reasonable belief that your account has been compromised. From time to time, we may restrict access to some parts of MYSKP, or the entire MYSKP. These restrictions may apply to individual MYSKP accounts, to all MYSKP accounts or to any subset thereof.');

var TermsAdditional__ref27 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'License To Certain Advertising Materials'));

var TermsAdditional__ref28 = TermsAdditional__jsx('p', {}, void 0, 'We grant you a limited, non-exclusive, personal, non-transferable, non-sub-licensable and revocable right and license to access, view and print any information and documentation made available on MYSKP, for your personal, non-commercial (other than as permitted in accordance with these Terms of Use), and informational use only to assist you in the access and use of MYSKP. Certain features of MYSKP may permit you to download SKP advertising templates and materials for use in the promotion of the availability of SKP products through your business (\u201C', TermsAdditional__jsx('strong', {}, void 0, 'Advertising Materials'), '\u201D). We grant you a limited, non-exclusive, personal, non-transferable, non-sub-licensable and revocable right and license to access, view, print and disseminate, within the United States only, Advertising Materials made available on MYSKP, for the sole purpose of promoting the availability of SKP products through your business. All usage of the Advertising Materials must: i) be to promote the sale of SKP products; ii) be done in a manner that does not damage or disparage any SKP logos or trade-marks; iii) be done in a manner that is not confusing to the public; iv) comply with any specified term, usage limits or instructions that may be provided by SKP. This licence includes the limited ability to edit the Advertising Materials to include information respecting your business as well as any offers or promotions you choose to make in respect of it (\u201C', TermsAdditional__jsx('strong', {}, void 0, 'Offers'), '\u201D), but not to edit or alter any SKP logos, trade-marks, graphic, or images, which may appear only as provided in the Advertising Materials. You, and not SKP, are responsible for any Offers you choose to make, and without limitation are responsible for ensuring their legal compliance.');

var TermsAdditional__ref29 = TermsAdditional__jsx('p', {}, void 0, 'Certain Advertising Materials or other materials available on MYSKP may be subject to addition usage requirements, instructions, restrictions, or limitations that differ from the above licence. For example, this may include additional territorial limitations, and/or restricted usage periods. If you choose to use any Advertising Materials or other materials available on MYSKP, you must agree to and comply with any such requirements, instructions, restrictions, or limitations. You agree that you will cease use of any Advertising Materials or other materials available on MYSKP at the request of SKP.');

var TermsAdditional__ref30 = TermsAdditional__jsx('p', {}, void 0, 'Except for the limited licenses and rights expressly granted to you in the Terms of Use, these Terms of Use do not grant you any other right or license in or under any patent, trademark, copyright, or other intellectual property or proprietary right. We may terminate or suspend this license at any time for any reason in our sole and absolute discretion. Any use that may suggest a community of interest or business relationship other than that between independently owned and operated businesses is also strictly prohibited.');

var TermsAdditional__ref31 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Purchases through MYSKP'));

var TermsAdditional__ref32 = TermsAdditional__jsx('p', {}, void 0, 'Certain features of MYSKP may now or may in the future permit you to make purchases. You may only make purchases through MYSKP if you are over the age of legal majority in your jurisdiction of residence. Purchases will only be shipped to a valid mailing address in the United States (as determined by SKP in its sole and absolute discretion). However, please note that we may not be able to ship to all valid addresses and, in such circumstances, we reserve the right in our sole and absolute discretion to cancel your purchase transaction (\u201C', TermsAdditional__jsx('strong', {}, void 0, 'Order'), '\u201D). In the event we are not able to ship to the shipping address you provide, we will notify you, your Order will be cancelled, and you will receive a refund in respect of your Order (unless you are able to provide an alternate eligible shipping address). We further reserve the right not to offer expedited or other forms of shipping. Unless otherwise indicated, all dollar amounts are in United States Dollars.');

var TermsAdditional__ref33 = TermsAdditional__jsx('p', {}, void 0, 'All Orders made through MYSKP are subject to these Additional Terms, as well as any other applicable terms and conditions outlined on MYSKP relating to the Order. Pricing and other terms and conditions relating to the purchase, return, refund, or delivery of your Order may be changed at any time without notice. Prices may differ from those for purchases made through other channels. You have a legal obligation to pay for any Orders indicated to be made by you. By completing an Order through MYSKP, you are agreeing to pay, in full, the prices and all applicable taxes and specified shipping and handling and other fees in relation to your Order, either by credit card or other permitted payment method.');

var TermsAdditional__ref34 = TermsAdditional__jsx('p', {}, void 0, 'SKP reserves the right, in its sole and absolute discretion, to change the permitted methods of payment, including without limitation, the credit cards and/or other types of payment options we are able to accept, at any time. If complete payment for your Order is not received and verified by us, your Order will not be processed. If you do not complete or improperly complete your Order it may not be accepted or acknowledged.');

var TermsAdditional__ref35 = TermsAdditional__jsx('p', {}, void 0, 'In order to complete an Order through MYSKP, you may be required to provide certain additional information that is required to process your Order. For example, you will be required to provide valid payment information (e.g. a valid credit card number and expiration date) to facilitate payment of your Order.');

var TermsAdditional__ref36 = TermsAdditional__jsx('p', {}, void 0, 'You will be billed for your Order at the time your Order is placed. You will be responsible for all applicable taxes related to your Order. Applicable taxes will be charged at the time you are billed. Applicable sales tax will also be applied to the shipping and handling, return shipping and gift packaging or other charges. Taxes may depend on delivery location.');

var TermsAdditional__ref37 = TermsAdditional__jsx('p', {}, void 0, 'Without limiting the generality of any other section of these Additional Terms, SKP reserves the right to limit or refuse any Order you place with us. Further, we reserve the right to verify the validity of all Orders and/or cancel any Order if we find evidence of fraud, tampering and/or any other violation of the terms and conditions of these Additional Terms, or our Terms of Use. We may, in our sole and absolute discretion, limit or cancel quantities purchased per person, per account or per Order. These restrictions may include Orders placed by or under the same account, by the same salon or business, using the same credit card, and/or Orders that use the same billing and/or shipping address. We also reserve the right, in our sole and absolute discretion, not to ship items ordered or purchased through MYSKP to certain addresses. In the event that we are unable to or choose not to ship an item, you will be notified accordingly and the amount for that item charged in relation to your Order will be reduced accordingly.');

var TermsAdditional__ref38 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Communications on MSKP'));

var TermsAdditional__ref39 = TermsAdditional__jsx('p', {}, void 0, 'MYSKP allows SKP to send communications and notifications to users, and/or any particular class of users both through the MYSKP online portal and/or via email notifications. Certain features of MYSKP may permit certain classes of user to communicate with other users- both through the MYSKP online portal and/or via email notifications. Should you be permitted and choose to communicate with any other users, you must comply with all applicable laws in so doing, including without limitation all United States privacy laws. You must have any consents required under such laws, and must include in your messages all required content and disclosures, including without limitation any required unsubscribe mechanisms.');

var TermsAdditional__ref40 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Indemnity'));

var TermsAdditional__ref41 = TermsAdditional__jsx('p', {}, void 0, 'You agree to defend, indemnify, and hold harmless SKP, and our affiliates, and the officers, directors, employees, agents and representatives of each of them, from and against any claims, actions, demands, losses, liabilities, damages, costs, suits, actions, penalties and expenses arising out of or relating, directly or indirectly, to: (i) your access to and/or use of a MYSKP, the services, and/or any component thereof, (ii) your violation of any of the terms and conditions of this agreement; (iii) your use of the Advertising Materials, including any Offers you choose to make in association therewith, and/or (iv) the infringement by you, or any third party using your account, of any intellectual property or other right of any person or entity, including without limitation if you violate the terms of any licence associated with the Advertising Materials. You agree that SKP may assume the exclusive defense and control of any matter for which you are required to indemnify SKP and you agree to cooperate, at your cost, with our defense of these claims. You agree not to settle any such matter without the prior written consent of SKP.');

var TermsAdditional__ref42 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Electronic Notification'));

var TermsAdditional__ref43 = TermsAdditional__jsx('p', {}, void 0, 'To the extent that we contact you, you agree that we may do so via any electronic means, including but not limited to communications posted on MYSKP, Messenger application notifications or electronic mail.');

var TermsAdditional__ref44 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'No Agency Relationship'));

var TermsAdditional__ref45 = TermsAdditional__jsx('p', {}, void 0, 'You agree that no joint venture, partnership, agency or employment relationship exists between you and SKP as a result of these Terms or Use or use of MYSKP and access to the services.');

var TermsAdditional__ref46 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Termination'));

var TermsAdditional__ref47 = TermsAdditional__jsx('p', {}, void 0, 'If you breach any provision of these Additional Terms of Use (as determined by SKP in its sole and absolute discretion), then you may no longer use MYSKP, the services, or any component thereof. We may, in our sole and absolute discretion, change, suspend or terminate, temporarily or permanently, MYSKP, the services, or any component thereof or any of its features at any time, for any reason, without any notice or liability to you or any other entity. If these Terms of Use or your permission to use MYSKP is terminated by us for any reason, the agreement formed by your acceptance of these Terms of Use will nevertheless continue to apply and be binding upon you in respect of your prior use of MYSKP and anything relating to or arising from such use. If you are dissatisfied with MYSKP, the services, or any component thereof, then your sole and exclusive remedy is to discontinue using them.');

var TermsAdditional__ref48 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Collection, Use and Disclosure of Information by MYSKP.'));

var TermsAdditional__ref49 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Information Collection on MYKP.'), ' SKP collects the following identifiable information through MYSKP:');

var TermsAdditional__ref50 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Your first and last name;'));

var TermsAdditional__ref51 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Your Sales Rep ID (if applicable);'));

var TermsAdditional__ref52 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Your Sales Rep Email Address (if applicable);'));

var TermsAdditional__ref53 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Your salon name and salon owner;'));

var TermsAdditional__ref54 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Any contact information you provide including, but not limited to, your phone number and address;'));

var TermsAdditional__ref55 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Your email address as well as any contact information provided at the time of registering for an account on MYSKP;'));

var TermsAdditional__ref56 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Geo-location data, should this data allow for your identification; and'));

var TermsAdditional__ref57 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Any other identifiable personal information you choose to provide to us when using MYSKP'));

var TermsAdditional__ref58 = TermsAdditional__jsx('br', {});

var TermsAdditional__ref59 = TermsAdditional__jsx('p', {}, void 0, 'For users who are distributors, MYSKP collects information you provide as follows:');

var TermsAdditional__ref60 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Sales Table'));

var TermsAdditional__ref61 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- TransactionID'));

var TermsAdditional__ref62 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- TransactionDate'));

var TermsAdditional__ref63 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonTaxID OR - SalonID'));

var TermsAdditional__ref64 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalesRepID'));

var TermsAdditional__ref65 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Sku/ProductID'));

var TermsAdditional__ref66 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Qty'));

var TermsAdditional__ref67 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- TotalCost'));

var TermsAdditional__ref68 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Product Name'));

var TermsAdditional__ref69 = TermsAdditional__jsx('br', {});

var TermsAdditional__ref70 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Product Table'));

var TermsAdditional__ref71 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Sku/ProductID'));

var TermsAdditional__ref72 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- ProductBrand'));

var TermsAdditional__ref73 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- ProductName'));

var TermsAdditional__ref74 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- ProductDescription'));

var TermsAdditional__ref75 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- ProductCategory'));

var TermsAdditional__ref76 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- ProductSubCategory'));

var TermsAdditional__ref77 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- ProductPrice'));

var TermsAdditional__ref78 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SKP IDH#'));

var TermsAdditional__ref79 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Wholesale Price'));

var TermsAdditional__ref80 = TermsAdditional__jsx('br', {});

var TermsAdditional__ref81 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Salon Table'));

var TermsAdditional__ref82 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonID'));

var TermsAdditional__ref83 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonTaxID'));

var TermsAdditional__ref84 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonName'));

var TermsAdditional__ref85 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonAddressStreet1'));

var TermsAdditional__ref86 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonAddressStreet2'));

var TermsAdditional__ref87 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonAddressCity'));

var TermsAdditional__ref88 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonAddressPostal'));

var TermsAdditional__ref89 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonAddressState'));

var TermsAdditional__ref90 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonAddressCountry'));

var TermsAdditional__ref91 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonRegion'));

var TermsAdditional__ref92 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalonSubRegion'));

var TermsAdditional__ref93 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Salon phone number'));

var TermsAdditional__ref94 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- Salon contact information'));

var TermsAdditional__ref95 = TermsAdditional__jsx('br', {});

var TermsAdditional__ref96 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Sales Rep Table'));

var TermsAdditional__ref97 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalesRepID'));

var TermsAdditional__ref98 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalesRepName'));

var TermsAdditional__ref99 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalesRepEmailAddress'));

var TermsAdditional__ref100 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalesRepRegion'));

var TermsAdditional__ref101 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, '- SalesRepSubRegion'));

var TermsAdditional__ref102 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Use of Information by MYSKP'));

var TermsAdditional__ref103 = TermsAdditional__jsx('p', {}, void 0, 'The personal information and any other information obtained from you through your use of MYSKP may be used by SKP and its service providers for analytical purposes, including through assessing and evaluating your usage of MYSKP (including the modules and applications of MYSKP you use and how often and for how long you use them and your click stream), and for business evaluation purposes and future performance forecasting and modeling. In addition to the foregoing, SKP may use such information as is reasonably necessary for the following:');

var TermsAdditional__ref104 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Managing your account on MYSKP;'));

var TermsAdditional__ref105 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Providing you with the services and features available through MYSKP including preparing and providing reports on your sales, product levels and purchasing history, and those of the salons in your supply chain;'));

var TermsAdditional__ref106 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Facilitate any purchase you choose to make using a Website, including facilitating payment for your purchase;'));

var TermsAdditional__ref107 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Notify you when an order you have made using a Website is ready for pick-up or delivery;'));

var TermsAdditional__ref108 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'To administer any loyalty, incentive, or rewards program we may offer and choose to allow access to through MYSKP, including allowing you to review your balance, redemption, and any rewards that you have received, in accordance with the terms of such program;'));

var TermsAdditional__ref109 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'To create a publicly accessible listing of Salons and outer businesses, that carry SKP products, including business name and contact information;'));

var TermsAdditional__ref110 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'To allow you to create a calendar of your scheduled events, appointments, and activities; and'));

var TermsAdditional__ref111 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'If you choose to provide you location information, to help enable you to map and produce routes for your planned activities, such as planed visits to salons.'));

var TermsAdditional__ref112 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Disclosure of Information by MYSKP'));

var TermsAdditional__ref113 = TermsAdditional__jsx('p', {}, void 0, 'Please note that SKP reserves the right to disclose your personal information, as is reasonably necessary, to a third party without your prior consent in the following events:');

var TermsAdditional__ref114 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'If your conduct on MYSKP breaches the Terms of Use and the disclosure of such information would allow SKP to protect their legal rights and/or avail themselves of any remedies that may be available to ether of them at law;'));

var TermsAdditional__ref115 = TermsAdditional__jsx('li', {}, void 0, TermsAdditional__jsx('p', {}, void 0, 'Should SKP deem in good faith that such disclosure is necessary to identify and/or contact any person in view of or undertake legal actions against a person to protect or enforce the rights or properties of SKP or those of other users; or'));

var TermsAdditional__ref116 = TermsAdditional__jsx('br', {});

var TermsAdditional__ref117 = TermsAdditional__jsx('p', {}, void 0, 'In the event that SKP deems in good faith that the law requires or permits such disclosure, including sharing identifiable personal information with other companies and organizations for the purpose of preventing fraud, or in order to comply with any legal or regulatory requirements.');

var TermsAdditional__ref118 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Technical Data'));

var TermsAdditional__ref119 = TermsAdditional__jsx('p', {}, void 0, 'You agree that SKP ', TermsAdditional__jsx('strong', {}, void 0, 'and/'), 'or its service providers may collect and use technical data and related information, including but not limited to technical information about your device, system and application software, and peripherals, to facilitate the provision of software updates, product support and other services to you (if any) related to MYSKP. SKP or Zapplogix may use and disclose this information to third-parties, as long as it is in a form that does not personally identify you, to improve its products or to provide services or technologies to you.');

var TermsAdditional__ref120 = TermsAdditional__jsx('p', {}, void 0, TermsAdditional__jsx('strong', {}, void 0, 'Cookies'));

var TermsAdditional__ref121 = TermsAdditional__jsx('p', {}, void 0, 'We may use a feature on your device or browser called a \u201Ccookie\u201D and/or other similar devices. Cookies are small files that your browser places on your device\u2019s hard drive. They are used for a variety of reasons, such as tracking click streams, optimization, marketing, and load balancing. We use a combination of session and persistent cookies to enable our log-in function, shopping carts, remember items you have added to your cart, allow you to create wish lists, checkout processing and to provide use with the ability to remember and improve your experience. We may use this information to determine your general geographic location to display the correct version of MYSKP. Information tracked through these mechanisms may include, but is not limited to: (i) your IP address; (ii) the type of browser and operating system being used; and (iii) the pages of the site or application a user visits. Your browser gives you the option to reject cookies. However, setting your browser to reject cookies generally hinders the browser\u2019s performance and will adversely affect your experience while using MYSKP, and certain features may not work. To be able to make a purchase using MYSKP, the following cookies are necessary and would need to be accepted: \u2018siteId\u2019, \u2018id_token.*\u2019, \u2018gId\u2019, \u2018locale\u2019.');

var TermsAdditional = function TermsAdditional() {
  return TermsAdditional__jsx('div', {}, void 0, TermsAdditional__ref, TermsAdditional__jsx('p', {}, void 0, 'Your use of the MYSKP / MYTRACKER platform and Schwarzkopf Professional, a division of Henkel Corporation or one of its subsidiary or affiliated companies (collectively, \u201CSKP\u201D, \u201Cwe\u201D, \u201Cour\u201D or \u201Cus\u201D) website at http://myskp.com and the MYSKP Enterprise suite of applications (hereinafter collectively referred to as \u201CMYSKP\u201D) is subject to out', ' ', TermsAdditional__jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank'), ',', ' ', TermsAdditional__jsx('a', {
    href: 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank'), ' ', 'as well as by this Terms of Use and Privacy Supplement (\u201C', TermsAdditional__ref2, '\u201D).'), TermsAdditional__ref3, TermsAdditional__jsx('ol', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref4, TermsAdditional__ref5, TermsAdditional__ref6, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref7, TermsAdditional__ref8), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref9, TermsAdditional__ref10), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref11, TermsAdditional__ref12), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref13, TermsAdditional__ref14), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref15, TermsAdditional__ref16), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref17, TermsAdditional__ref18))), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref19, TermsAdditional__ref20, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, TermsAdditional__ref21, TermsAdditional__ref22), TermsAdditional__ref23, TermsAdditional__ref24, TermsAdditional__ref25, TermsAdditional__ref26), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref27, TermsAdditional__ref28, TermsAdditional__ref29, TermsAdditional__ref30), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref31, TermsAdditional__ref32, TermsAdditional__ref33, TermsAdditional__ref34, TermsAdditional__ref35, TermsAdditional__ref36, TermsAdditional__ref37), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref38, TermsAdditional__ref39), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref40, TermsAdditional__ref41), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref42, TermsAdditional__ref43), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref44, TermsAdditional__ref45), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref46, TermsAdditional__ref47), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref48, TermsAdditional__jsx('p', {}, void 0, 'Without limiting the terms of our privacy statement', ' ', TermsAdditional__jsx('a', {
    href: 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank',
    style: { textDecoration: 'underline' },
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, 'https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank'), ', which applies to MYSKP in addition to this section, when you use MYSKP, you agree we may collect, use, and disclose your information as described in this section.'))), TermsAdditional__jsx('ol', {
    type: 'A',
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref49, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, TermsAdditional__ref50, TermsAdditional__ref51, TermsAdditional__ref52, TermsAdditional__ref53, TermsAdditional__ref54, TermsAdditional__ref55, TermsAdditional__ref56, TermsAdditional__ref57), TermsAdditional__ref58, TermsAdditional__ref59, TermsAdditional__ref60, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__ref61, TermsAdditional__ref62, TermsAdditional__ref63, TermsAdditional__ref64, TermsAdditional__ref65, TermsAdditional__ref66, TermsAdditional__ref67, TermsAdditional__ref68), TermsAdditional__ref69, TermsAdditional__ref70, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__ref71, TermsAdditional__ref72, TermsAdditional__ref73, TermsAdditional__ref74, TermsAdditional__ref75, TermsAdditional__ref76, TermsAdditional__ref77, TermsAdditional__ref78, TermsAdditional__ref79), TermsAdditional__ref80, TermsAdditional__ref81, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__ref82, TermsAdditional__ref83, TermsAdditional__ref84, TermsAdditional__ref85, TermsAdditional__ref86, TermsAdditional__ref87, TermsAdditional__ref88, TermsAdditional__ref89, TermsAdditional__ref90, TermsAdditional__ref91, TermsAdditional__ref92, TermsAdditional__ref93, TermsAdditional__ref94), TermsAdditional__ref95, TermsAdditional__ref96, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px' }
  }, void 0, TermsAdditional__ref97, TermsAdditional__ref98, TermsAdditional__ref99, TermsAdditional__ref100, TermsAdditional__ref101)), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref102, TermsAdditional__ref103, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, TermsAdditional__ref104, TermsAdditional__ref105, TermsAdditional__ref106, TermsAdditional__ref107, TermsAdditional__ref108, TermsAdditional__ref109, TermsAdditional__ref110, TermsAdditional__ref111)), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref112, TermsAdditional__ref113, TermsAdditional__jsx('ul', {
    style: { paddingLeft: '16px', listStyle: 'disc' }
  }, void 0, TermsAdditional__ref114, TermsAdditional__ref115), TermsAdditional__ref116, TermsAdditional__ref117), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref118, TermsAdditional__ref119), TermsAdditional__jsx('li', {
    style: { marginBottom: '16px' }
  }, void 0, TermsAdditional__ref120, TermsAdditional__ref121)));
};

/* harmony default export */ var US_TermsAdditional = (TermsAdditional);
// CONCATENATED MODULE: ./src/configs/sites/us.js





var messages = Object(index_es["e" /* defineMessages */])({
  emailTerms: {
    'id': 'us.emailTerms',
    'defaultMessage': 'Henkel Terms of Use & Privacy Policy'
  },
  emailAdditionalTerms: {
    'id': 'us.emailAdditionalTerms',
    'defaultMessage': 'MYSKP Additional Terms of Use & Privacy Supplement'
  },
  emailPrintcenterTerms: {
    'id': 'us.emailPrintcenterTerms',
    'defaultMessage': 'PrintCenter Terms of Use & Privacy Policy'
  },

  english: {
    'id': 'us.english',
    'defaultMessage': 'English'
  },

  shippingStandard: {
    'id': 'us.shippingStandard',
    'defaultMessage': 'Standard Delivery (5 to 7 business days to most delivery locations in Canada)'
  },
  shippingDownload: {
    'id': 'us.shippingDownload',
    'defaultMessage': 'Digital Download'
  },

  generalTerms: {
    'id': 'us.generalTerms',
    'defaultMessage': 'Terms of Use and Privacy Policy'
  },
  additionalTerms: {
    'id': 'us.additionalTerms',
    'defaultMessage': 'MYSKP Additional Terms of Use and Privacy Supplement'
  },
  printCenterTerms: {
    'id': 'us.printCenterTerms',
    'defaultMessage': 'Clubskp Terms'
  },

  footerTrending: {
    'id': 'us.footerTrending',
    'defaultMessage': 'Trending'
  },
  footerEducation: {
    'id': 'us.footerEducation',
    'defaultMessage': 'Education'
  },
  footerProducts: {
    'id': 'us.footerProducts',
    'defaultMessage': 'Products'
  },
  footerMobileApps: {
    'id': 'us.footerMobileApps',
    'defaultMessage': 'Mobile Apps'
  },
  footerHelp: {
    'id': 'us.footerHelp',
    'defaultMessage': 'Help'
  },

  footerLatestInnovations: {
    'id': 'us.footerLatestInnovations',
    'defaultMessage': 'Latest Innovations'
  },
  footerEssentialLooks: {
    'id': 'us.footerEssentialLooks',
    'defaultMessage': 'Essential Looks'
  },
  // footerASKBrouchure: {
  //   id: 'us.footerASKBrouchure',
  //   defaultMessage: 'ASK Brouchure',
  //   description: 'us.footerASKBrouchure',
  // },
  footerEAcademy: {
    'id': 'us.footerEAcademy',
    'defaultMessage': 'eAcademy'
  },
  footerSeminars: {
    'id': 'us.footerSeminars',
    'defaultMessage': 'Seminars'
  },
  footerHairColor: {
    'id': 'us.footerHairColor',
    'defaultMessage': 'Hair Color'
  },
  footerHairCare: {
    'id': 'us.footerHairCare',
    'defaultMessage': 'Hair Care'
  },
  footerHairStyling: {
    'id': 'us.footerHairStyling',
    'defaultMessage': 'Hair Styling'
  },
  footerHouseOfColor: {
    'id': 'us.footerHouseOfColor',
    'defaultMessage': 'House of Color'
  },
  footerHairExpert: {
    'id': 'us.footerHairExpert',
    'defaultMessage': 'Hair Expert'
  },
  footerASKAcademy: {
    'id': 'us.footerASKAcademy',
    'defaultMessage': 'ASK Academy'
  },
  footerFaq: {
    'id': 'us.footerFaq',
    'defaultMessage': 'FAQ'
  },
  footerSupport: {
    'id': 'us.footerSupport',
    'defaultMessage': 'Support'
  },
  footerContact: {
    'id': 'us.footerContact',
    'defaultMessage': 'Contact'
  },

  hairdressingSchool: {
    'id': 'salondb.edit.hairdressingSchool',
    'defaultMessage': 'Hairdressing School'
  },
  homeSalon: {
    'id': 'salondb.edit.homeSalon',
    'defaultMessage': 'Home Salon'
  },
  retailOutlet: {
    'id': 'salondb.edit.retailOutlet',
    'defaultMessage': 'Retail Outlet'
  },
  distributorStore: {
    'id': 'salondb.edit.distributorStore',
    'defaultMessage': 'Distributor Store'
  },
  vipSalon: {
    'id': 'salondb.edit.vipSalon',
    'defaultMessage': 'VIP Salon'
  },
  traditionalSalon: {
    'id': 'salondb.edit.traditionalSalon',
    'defaultMessage': 'Traditional Salon'
  }
});

/* harmony default export */ var us = ({
  id: 'us',
  suffix: 'us',
  email: {
    defaultFrom: 'notifications@myskp.com',
    defaultReplyTo: ['orders-us@myskp.com']
  },
  orderCc: ['orders-us@myskp.com'],
  printCenterCc: ['printcenter-us@myskp.com'],
  userSignupBcc: ['signups-us@myskp.com'],
  label: 'United States',
  company: 'Schwarzkopf Professional, a division of Henkel USA Corporation, Inc',
  companyShort: 'Schwarzkopf Professional',
  emailFooterLinks: [
  // do not prepend host name
  {
    label: 'Henkel Terms of Use & Privacy Policy',
    href: '/us/#terms'
  }, {
    label: 'MYSKP Additional Terms of Use & Privacy Supplement',
    href: '/us/#additional-terms'
  }, {
    label: 'PrintCenter Terms of Use & Privacy Policy',
    href: '/us/#printcenter-terms'
  }],
  flag: 'icon-flag--usa',
  locales: {
    'en-US': {
      label: 'English'
    }
    // 'es-US': {
    //   label: 'Spanish',
    // },
  },
  localesIntl: function localesIntl(intl) {
    return {
      'en-US': {
        label: intl.formatMessage(messages.english)
      }
    };
  },

  countries: [{ label: 'United States', value: 'US', threeChar: 'USA', default: true }],
  social: {
    facebook: 'https://www.facebook.com/SchwarzkopfProfessionalUSA',
    instagram: 'https://www.instagram.com/schwarzkopfusa/',
    twitter: 'https://twitter.com/SchwarzkopfUSA',
    pinterest: 'https://www.pinterest.com/schwarzkopfpro/',
    youtube: 'https://www.youtube.com/user/Apassionforhair'
  },
  baseCurrency: 'USD',
  shippingOptions: {
    'flatrate-standard': {
      label: 'Standard Delivery',
      amount: 0
    },
    'digital-download': {
      label: 'Digital Download',
      amount: 0
    }
  },
  shippingPrintCenter: {
    amount: 1200
  },
  currencies: [{
    code: 'USD',
    label: 'USD'
  }, {
    code: 'POINTS',
    label: 'Points'
  }],
  units: {
    distance: {
      label: 'Mile',
      abbrev: 'mi.'
    }
  },
  contact: {
    address: {
      str1: '600 Corporate Pointe, Suite 400',
      city: 'Culver City',
      state: 'CA',
      postal: '90230',
      country: 'USA'
    },
    phone: '310-568-5400',
    fax: '310-641-4601',
    email: 'clubskp@myskp.com',
    website: 'mySKP.com',
    support: 'https://myskp-usa.zendesk.com/hc/en-us'
  },
  loyalty: {
    tz: 'America/Los_Angeles',
    rollingExpiry: [13, 'months'], // passed into moment.subtract(...rollingExpiry)
    // DEPRECATED
    pointsExpireMoment: {
      month: 3, // jan = 0, dec = 11
      date: 1,
      startOf: 'day',
      tz: 'America/Los_Angeles',
      offset: {
        startOf: ['year']
      }
    }
  },
  taxRates: {
    US: {
      CA: 0.0925
    }
  },
  terms: function terms(intl) {
    return {
      // generalTerms is a required field
      generalTerms: {
        label: intl.formatMessage(messages.generalTerms),
        component: US_TermsPrivacy,
        props: []
      },
      additionalTerms: {
        label: intl.formatMessage(messages.additionalTerms),
        component: US_TermsAdditional,
        props: []
      },
      printCenterTerms: {
        label: intl.formatMessage(messages.printCenterTerms),
        component: US_TermsClubskp,
        props: []
      }
    };
  },
  salonCategories: function salonCategories(intl) {
    return [{
      value: '',
      label: ''
    }, {
      value: 'Hairdressing School',
      label: intl.formatMessage(messages.hairdressingSchool)
    }, {
      value: 'Home Salon',
      label: intl.formatMessage(messages.homeSalon)
    }, {
      value: 'Retail Outlet',
      label: intl.formatMessage(messages.retailOutlet)
    }, {
      value: 'Distributor Store',
      label: intl.formatMessage(messages.distributorStore)
    }, {
      value: 'VIP Salon',
      label: intl.formatMessage(messages.vipSalon)
    }, {
      value: 'Traditional Salon',
      label: intl.formatMessage(messages.traditionalSalon)
    }];
  },
  footer: function footer(intl) {
    return [{
      label: intl.formatMessage(messages.footerTrending),
      links: [{
        label: intl.formatMessage(messages.footerLatestInnovations),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/latest-innovations.html'
      }, {
        label: intl.formatMessage(messages.footerEssentialLooks),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/trends/essential-looks.html'
      }]
    }, {
      label: intl.formatMessage(messages.footerEducation),
      links: [
      // {
      //   label: intl.formatMessage(messages.footerASKBrouchure),
      //   to:
      //     'https://myskp-printcenter.nyc3.digitaloceanspaces.com/ask/ASK_Academy_Brochure_USA.pdf',
      // },
      {
        label: intl.formatMessage(messages.footerEAcademy),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/education/ask-education-eacademy.html'
      }, {
        label: intl.formatMessage(messages.footerSeminars),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/education/seminars.html'
      }]
    }, {
      label: intl.formatMessage(messages.footerProducts),
      links: [{
        label: intl.formatMessage(messages.footerHairColor),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/color.html'
      }, {
        label: intl.formatMessage(messages.footerHairCare),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/care.html'
      }, {
        label: intl.formatMessage(messages.footerHairStyling),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/styling.html'
      }]
    }, {
      label: intl.formatMessage(messages.footerMobileApps),
      links: [{
        label: intl.formatMessage(messages.footerHouseOfColor),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/color/house-of-color.html'
      }, {
        label: intl.formatMessage(messages.footerEssentialLooks),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/trends/el-app-and-e-mag.html'
      }, {
        label: intl.formatMessage(messages.footerHairExpert),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/care/hair-expert-app.html'
      }, {
        label: intl.formatMessage(messages.footerASKAcademy),
        to: 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/education/your-academy.html'
      }]
    }, {
      label: intl.formatMessage(messages.footerHelp),
      links: [{
        label: intl.formatMessage(messages.footerFaq),
        to: 'https://myskp-usa.zendesk.com/hc/en-us'
      }, {
        label: intl.formatMessage(messages.footerSupport),
        to: 'https://myskp-usa.zendesk.com/hc/en-us/requests/new'
      }, {
        label: intl.formatMessage(messages.footerContact),
        to: 'https://myskp-usa.zendesk.com/hc/en-us/requests/new'
      }]
    }];
  }
});
// EXTERNAL MODULE: ./src/configs/sites/ca.js
var ca = __webpack_require__(752);

// CONCATENATED MODULE: ./src/configs/sites/index.js



/* harmony default export */ var sites = __webpack_exports__["a"] = ({
  us: us,
  ca: ca["a" /* default */]
});

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  path: '/mytracker',
  name: 'mytracker',
  children: [{
    path: '/',
    name: 'mytracker-index',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 928));
    }
  }, {
    path: '/kpis',
    name: 'mytracker-kpis',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 929));
    }
  },
  // {
  //   path: '/education',
  //   name: 'mytracker-education',
  //   load: () => import(/* webpackChunkName: 'mytracker' */ './education'),
  // },
  {
    path: '/detail/:pageKey',
    name: 'mytracker-detail',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 930));
    }
  }, {
    path: '/reports',
    name: 'mytracker-reports',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 931));
    }
  }, {
    path: '/saved',
    name: 'mytracker-saved',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 932));
    }
  }, {
    path: '/saved-edit',
    name: 'mytracker-saved-edit',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 933));
    }
  }, {
    path: '/loyalty',
    name: 'mytracker-loyalty-dashboard',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 934));
    }
  }],
  action: function action(_ref, _ref2) {
    var next = _ref.next,
        store = _ref.store,
        url = _ref.url;
    var siteId = _ref2.siteId;

    var state = store.getState();
    var modules = (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    var options = (((state.session || {}).USER_DATA || {}).group || {}).options || [];

    if (!modules.includes('mytracker')) {
      return {
        redirect: '/' + siteId + '/forbidden?redirect=' + encodeURIComponent(url || '')
      };
    }

    if (url.includes('mytracker/loyalty') && !options.includes('user.mytracker.loyaltyDashboard')) {
      return {
        redirect: '/' + siteId + '/forbidden?redirect=' + encodeURIComponent(url || '')
      };
    }
    return next();
  }
});

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  path: '/control',
  name: 'control',
  children: [{
    path: '/',
    name: 'control-index',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 935));
    }
  }, {
    path: '/brands',
    name: 'control-brands',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 936));
    }
  }, {
    path: '/distributors',
    name: 'control-distributors',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 937));
    }
  }, {
    path: '/config',
    name: 'control-config',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 938));
    }
  }, {
    path: '/config-edit',
    name: 'control-configedit',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 939));
    }
  }, {
    path: '/content',
    name: 'control-content',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 940));
    }
  }, {
    path: '/content-edit',
    name: 'control-contentedit',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 941));
    }
  }, {
    path: '/edit',
    name: 'control-edit',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 942));
    }
  }, {
    path: '/groups',
    name: 'control-groups',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 943));
    }
  }, {
    path: '/products',
    name: 'control-products',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 944));
    }
  }, {
    path: '/masterproducts',
    name: 'control-masterproducts',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 945));
    }
  },
  // {
  //   path: '/kpis',
  //   name: 'control-kpis',
  //   load: () => import(/* webpackChunkName: 'control' */ './kpis'),
  // },
  // {
  //   path: '/reps',
  //   name: 'control-reps',
  //   load: () => import(/* webpackChunkName: 'control' */ './reps'),
  // },
  {
    path: '/sales',
    name: 'control-sales',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 946));
    }
  },
  // {
  //   path: '/salons',
  //   name: 'control-salons',
  //   load: () => import(/* webpackChunkName: 'control' */ './salons'),
  // },
  // {
  //   path: '/content-temp',
  //   name: 'control-contenttemp',
  //   load: () => import(/* webpackChunkName: 'control' */ './content-temp'),
  // },
  {
    path: '/filevault',
    name: 'control-filevault',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 947));
    }
  }, {
    path: '/filevault-edit',
    name: 'control-filevaultedit',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 948));
    }
  }, {
    path: '/loyalty-bonus-points',
    name: 'loyalty-bonus-points',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 949));
    }
  }],
  action: function action(_ref, _ref2) {
    var next = _ref.next,
        store = _ref.store,
        url = _ref.url;
    var siteId = _ref2.siteId;

    var state = store.getState();
    var modules = (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('cmdctrl')) {
      return {
        redirect: '/' + siteId + '/forbidden?redirect=' + encodeURIComponent(url || '')
      };
    }
    return next();
  }
});

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  path: "/filevault",
  name: "filevault",
  children: [{
    path: "/",
    name: "filevault-index",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 950));
    }
  }, {
    path: "/tags",
    name: "filevault-tags",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 951));
    }
  }, {
    path: "/collections",
    name: "filevault-collections",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 952));
    }
  }, {
    path: "/collections/:collection",
    name: "filevault-collection",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 953));
    }
  }, {
    path: "/lightbox/:lightbox",
    name: "filevault-lightbox",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 954));
    }
  }, {
    path: "/asset/:id",
    name: "filevault-asset",
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 955));
    }
  }],
  action: function action(_ref, _ref2) {
    var next = _ref.next,
        store = _ref.store,
        url = _ref.url;
    var siteId = _ref2.siteId;

    var state = store.getState();
    var modules = (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes("filevault")) {
      return {
        redirect: "/" + siteId + "/forbidden?redirect=" + encodeURIComponent(url || "")
      };
    }
    return next();
  }
});

/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  path: '/etl',
  name: 'etl',
  children: [{
    path: '/:type(salons|products|reps|sales|masterproducts|kpis|)',
    name: 'etl-index',
    load: function load() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 956));
    }
  }],
  action: function action(_ref, _ref2) {
    var next = _ref.next,
        store = _ref.store,
        url = _ref.url;
    var siteId = _ref2.siteId;

    var state = store.getState();
    var modules = (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('etl')) {
      return {
        redirect: '/' + siteId + '/forbidden?redirect=' + encodeURIComponent(url || '')
      };
    }
    return next();
  }
});

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* harmony default export */ __webpack_exports__["default"] = ({
  path: '/salondb',
  name: 'salondb',
  children: [{
    path: '/',
    name: 'salondb-index',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 957));
    }
  }, {
    path: '/edit',
    name: 'salondb-edit',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 958));
    }
  }, {
    path: '/merge',
    name: 'salondb-merge',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 959));
    }
  }, {
    path: '/unmerge',
    name: 'salondb-unmerge',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 960));
    }
  }, {
    path: '/points',
    name: 'salondb-points',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 961));
    }
  }, {
    path: '/orders',
    name: 'salondb-orders',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 962));
    }
  }, {
    path: '/order/:id',
    name: 'salondb-order-detail',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 963));
    }
  }, {
    path: '/:id',
    name: 'salondb-dashboard',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 964));
    }
  }],
  action: function action(_ref, _ref2) {
    var next = _ref.next,
        store = _ref.store,
        url = _ref.url;
    var siteId = _ref2.siteId;

    var state = store.getState();
    var modules = (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('salondb')) {
      return {
        redirect: '/' + siteId + '/forbidden?redirect=' + encodeURIComponent(url || '')
      };
    }
    return next();
  }
});

/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router_generateUrls__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_router_generateUrls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_router_generateUrls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(264);
// import qs from 'qs';



/* harmony default export */ __webpack_exports__["default"] = ({
  getUrl: __WEBPACK_IMPORTED_MODULE_0_universal_router_generateUrls___default()(__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */], {
    pretty: true
    // stringifyQueryParams: qs.stringify,
  })
});

/***/ })

},[430]);


// WEBPACK FOOTER //
// client.713317c0.js